import React, { Component } from "react";
import {
    loading,
    NavbarAdmin,
    Modal,
    GET,
    GET_FILE,
    POST,
    PUT,
    DELETE,
    UPLOAD,
    Select,
    DatePicker,
    alert,
    company,
    Pagination,
    float,
    format_date,
    t, // นำเข้าฟังก์ชัน t
    searchCustomerRows,
    mergeCustomerPins,
    addCustomerPin,
    ActionIconButton,
    ACTION_ICONS,
} from "../../components/CustomComponent.js";
import { can } from "../../utils/permission.js";
import { getProfile } from "../../utils/localStorage";
import { activeOptions, isTechnicianActive } from "../../utils/helpers";
import { formatNumber } from "../../utils/formatting";
import TravelRouteMap from "../../components/maps/TravelRouteMap";
import GlobalSearchBox from "../../components/GlobalSearchBox.js";
import WoPickingListPanel, { WoPickingExtraPartsTable } from "../../components/WoPickingListPanel.js";
import WoWbsIssuePanel, { WoWbsPartsBoxes } from "../../components/WoWbsIssuePanel.js";
import { defaultLabels, isToggle2, isToggle3, LABEL_MAX, typeLabel } from "./checklist-templates/checklistTree";
import {
    WORK_REQUEST_UPLOAD_RULES,
    pickFilesByRule,
    compressImageFiles,
    formatText,
    formatFileSize,
    toMB,
} from "../../utils/fileUpload";

// ใช้กติกาไฟล์แนบชุดเดียวกับ work request เพื่อให้ผู้ใช้เจอเงื่อนไขเดียวกันทั้งระบบ
const IMAGE_RULE = WORK_REQUEST_UPLOAD_RULES.image;
const VIDEO_RULE = WORK_REQUEST_UPLOAD_RULES.video;

// prefix ของ uid ชั่วคราวที่ frontend ตั้งเองให้แถวอะไหล่ที่ยังไม่ได้บันทึกลง DB
// bom = ดึงมาจาก BOM, manual = เพิ่มนอก BOM, visit = ของเดิมตอน map แถวที่ backend ไม่ได้ส่ง uid มา
const TEMP_UNIT_UID_PREFIXES = ["bom_", "manual_", "visit_"];

// สาเหตุหลักที่ช่างเลือกจาก dropdown ในมือถือ - DB เก็บเป็น key ภาษาอังกฤษ ตรงกับ ROOT_CAUSES ในหน้ารายงานบริการของแอป
const ROOT_CAUSE_TYPE_LABEL_KEYS = {
    "Component Age/Wear": "root_cause_type_component_age_wear",
    "Poor Maintenance": "root_cause_type_poor_maintenance",
    "Operator Error": "root_cause_type_operator_error",
    "Manufacturing Defect": "root_cause_type_manufacturing_defect",
    Environmental: "root_cause_type_environmental",
    Unknown: "root_cause_type_unknown",
};

// แถบ "โอนอะไหล่เข้าสต็อกโครงการ (SAP)" ในแท็บอะไหล่ของ visit
// ยิง API 5 (Transfer Order) ของ SAP ผ่าน backend: POST admin/transfer-orders/visits/:uid/material-document
const SHOW_SAP_TRANSFER_ORDER = true;

// process ของใบสั่งงาน (work_orders.process_name) - งานที่มาจาก external ตั้งต้นเป็น normal_sales
// ขั้นตอนโอนอะไหล่เข้าสต็อกโครงการมีเฉพาะงานประกันโครงการ (project_warrantee) เท่านั้น
const PROCESS_PROJECT_WARRANTEE = "project_warrantee";
const PROCESS_NORMAL_SALES = "normal_sales";

// ป้ายกำกับ process + ที่มาของใบสั่งงาน ใช้ใน tooltip ข้างเลขที่ใบงาน
// โทนสี - ขายปกติ ฟ้า / ประกันโครงการ ส้ม (ชุดเดียวกับหน้าใบคำร้อง)
const PROCESS_NAME_VIEWS = {
    normal_sales: { labelKey: "process_normal_sales", icon: "\uf07a", color: "#2563EB" },
    project_warrantee: { labelKey: "process_project_warrantee", icon: "\uf3ed", color: "#B45309" },
};

// source - external = ระบบต้นทางยิง API เข้ามา / internal = สร้างในระบบเอง
// มุมมองคัมบัง/ปฏิทินไม่มีการแบ่งหน้า จึงดึงทีเดียวหลายแถว (มุมมองรายการยังแบ่งหน้าตาม page_size)
const BOARD_VIEW_PAGE_SIZE = 500;

const WORK_ORDER_SOURCE_EXTERNAL = "external";
const WORK_ORDER_SOURCE_VIEWS = {
    external: { labelKey: "wo_source_external", icon: "\uf0ec", color: "#7C3AED" },
    internal: { labelKey: "wo_source_internal", icon: "\uf015", color: "#16A34A" },
};

// ผลตรวจ checklist รายข้อ "ไม่ผ่าน" = ข้อ check ที่บันทึก fail หรือข้อ measurement ที่ค่าอยู่นอกช่วง min-max ของเทมเพลต
// กติกาเดียวกับ backend (utils/checklist-result.js) ที่ใช้ส่งอีเมลแจ้งเตือน: min >= max (เช่น 0/0) = เทมเพลตไม่ได้กำหนดช่วง
const isChecklistItemFailed = (item, templateItem) => {
    const raw = String(item?.value ?? "").trim();
    if (!raw) return false;
    if (item.input_type === "check") return raw === "fail";
    if (item.input_type !== "measurement") return false;
    const toNumber = (value) => (value === null || value === undefined || value === "" || Number.isNaN(Number(value)) ? null : Number(value));
    const num = toNumber(raw);
    const min = toNumber(templateItem?.min);
    const max = toNumber(templateItem?.max);
    if (num === null || (min === null && max === null) || (min !== null && max !== null && min >= max)) return false;
    return (min !== null && num < min) || (max !== null && num > max);
};

export default class WorkOrders extends Component {
    constructor(props) {
        super(props);
        this.state = {
            filter_search: "",
            // ISS-030: "งานของฉัน" เป็นค่าเริ่มต้น และจำค่าที่เลือกไว้
            filter_scope: localStorage.getItem("cm-wo-scope") || "mine",
            filter_technician_uid: "",
            filter_customer_uid: "",
            kanban_date_filter: "today", // "" | today | week | month (quick filter สำหรับ tab kanban) - ค่าเริ่มต้นเป็นวันนี้
            viewMode: "list", // kanban | list | calendar
            modal_create: false,
            modal_view: false,
            modal_followup: false, // State สำหรับ Modal Follow-up
            from_inspection: false, // เปิด modal มาจากหน้า Inspection Master Plan
            // เปิด modal มาจากหน้าอื่นด้วย ?return=<path> (เช่น จัดตารางงาน) - ปิด modal แล้วพากลับหน้านั้น
            // ต่างจาก from_inspection ตรงที่ไม่เปลี่ยนหน้าตา/ปุ่มใน modal เลย
            return_to: "",
            // Modal ดูเส้นทางที่ช่างเดินทางจริง (polyline จากจุด GPS ดิบ)
            modal_route_map: false,
            modal_route_points: [],
            modal_route_distance: null,

            // Options from API
            data_customer: [],
            customer_pins: [], // ลูกค้าที่ถูกอ้างถึงอยู่ ต้องคงไว้ในรายการแม้ผลค้นหาจะเปลี่ยน
            data_asset: [],
            data_work_requests: [],
            work_request_link_dirty: false,
            data_reject_reasons: [],
            data_service_types: [],
            data_priorities: [],
            data_categories: [],
            data_service_boms: [],
            data_parts: [],
            data_technicians: [],
            data_checklist_templates: [],
            data_work_orders: [],
            count: 0,
            page: 1,
            page_size: 10,
            tab: "open", // เข้าหน้ามาให้อยู่แท็บ "เปิดใหม่" ก่อน (all | open | check_in | success | rejected - filter สถานะในหน้า list table)
            summary_count: { all: 0, open: 0, check_in: 0, success: 0, rejected: 0 },
            calendar_view_date: (() => {
                const today = new Date();
                const year = today.getFullYear();
                const month = String(today.getMonth() + 1).padStart(2, "0");
                return `${year}-${month}-01`;
            })(),
            // Modal Create Form States
            create_work_request_id: "",
            create_customer_id: "",
            create_asset_id: "",
            create_contact_name: "",
            create_contact_phone: "",
            create_contact_name_2: "",
            create_contact_phone_2: "",
            create_root_cause: "",
            create_work_order_title: "",
            create_work_requisition_categories_id: "",
            create_work_requisition_service_types_id: "",
            create_work_requisition_priorities_id: "",
            create_service_bom_id: "",
            create_service_bom_parts: [],
            create_manual_part_id: "",
            create_manual_parts: [],
            text_priority_id: "",
            create_start_date: "",
            create_end_date: "",
            create_internal_remark: "",
            create_status: "open",
            // optimistic lock - เวอร์ชันใบงานที่โหลดมา ส่งกลับตอนบันทึก ถ้า DB ใหม่กว่าจะได้ 409 แล้วโหลดใหม่
            edit_row_version: null,
            edit_source: null,
            create_checklist_template_id: "",
            create_checklist_items: [],
            create_inspection_plan_id: null,
            new_checklist_description: "",
            new_checklist_input_type: "check",
            new_checklist_unit: "",
            new_checklist_min: "",
            new_checklist_max: "",
            new_checklist_label_left: "",
            new_checklist_label_right: "",
            new_checklist_required: false,
            new_checklist_errors: {},
            visits: [],
            selected_visit_date: "",
            visit_technician_search: "",
            visit_detail_tab: "technician",

            // ตัวเลือกล็อตสต็อกในแท็บอะไหล่ แยกตาม uid ของอะไหล่ -> [lot, ...]
            // โหลดรอบเดียวสำหรับอะไหล่ทุกตัวใน visit แล้วจัดกลุ่มฝั่งนี้ จะได้ไม่ต้องยิงทีละอะไหล่
            data_stock_lots: {},
            // ชุดอะไหล่ที่โหลดตัวเลือกไว้แล้ว ใช้กันโหลดซ้ำเมื่อรายการอะไหล่ไม่เปลี่ยน
            stock_lots_key: "",
            // รหัส WBS ที่มีอยู่จริงในสต็อก (ไม่ซ้ำ) ที่ขึ้นต้นด้วยรหัสโครงการของงานนี้ - ตัวเลือกช่อง "รหัส WBS"
            // WBS ของโครงการที่ผูกกับทรัพย์สินในงานนี้ (ตาราง wbs) - 1 โครงการมีได้หลาย WBS
            data_project_wbs: [],
            // uid โครงการที่โหลด data_project_wbs ไว้แล้ว ใช้กันโหลดซ้ำเมื่อโครงการไม่เปลี่ยน
            project_wbs_project_uid: "",
            visit_iat_map: {},
            visit_iat_status_map: {},
            saved_requisition_map: {},
            // ผลลัพธ์ Transfer Order ของ SAP รายกะการเข้าพื้นที่ (key = visit_date) - เก็บไว้ที่ state
            // เพราะยังไม่มีคอลัมน์เก็บเลขเอกสารใน DB จึงหายเมื่อปิด modal
            sap_transfer_map: {},
            wo_view_mode: false,
            stock_lot_info_open: false,
            stock_lot_info_rect: null,
            // tooltip เก็บรายละเอียดของเอกสารโอนเข้า VAN (WBS ฯลฯ) ไม่ให้แถบยืดจนจัดวางยาก
            sap_transfer_info_open: false,
            sap_transfer_info_rect: null,
            // tooltip อธิบายคอลัมน์ "คืน" ในตารางค่าอะไหล่ (แท็บค่าใช้จ่าย)
            return_info_open: false,
            return_info_rect: null,
            // tooltip แจกแจงที่มาของยอดค่าเดินทาง (แท็บค่าใช้จ่าย)
            travel_info_open: false,
            travel_info_rect: null,
            // tooltip บอกที่มา + process ของใบสั่งงาน (ไอคอน info ข้างเลขที่ใบงานในตาราง)
            source_info_key: null,
            source_info_rect: null,

            // ไฟล์แนบระดับ Work Order
            wo_images: [],
            wo_videos: [],
            wo_documents: [],

            // Follow-up Form States
            fu_reason: "",
            fu_detail: "",
            fu_priority: "",
            fu_date: "",
            fu_copy_info: true,

            // Active Work Order
            active_wo: null,
            edit_work_order_id: "",
            // ใบขอเบิก (PL) ของ WO ที่ WoPickingListPanel โหลดแล้วแจ้งขึ้นมา ใช้ทำตาราง "อะไหล่ที่เบิกเพิ่ม" ในแท็บอะไหล่
            pl_lists: [],
            edit_work_request_option: null,
        };
    }

    getCreateFormState = () => ({
        create_work_request_id: "",
        create_customer_id: "",
        create_asset_id: "",
        create_contact_name: "",
        create_contact_phone: "",
        create_contact_name_2: "",
        create_contact_phone_2: "",
        create_root_cause: "",
        create_work_order_title: "",
        create_work_requisition_categories_id: "",
        create_work_requisition_service_types_id: "",
        create_work_requisition_priorities_id: "",
        create_service_bom_id: "",
        create_service_bom_parts: [],
        create_manual_part_id: "",
        create_manual_parts: [],
        text_priority_id: "",
        create_start_date: "",
        create_end_date: "",
        create_internal_remark: "",
        create_status: "open",
        // optimistic lock - เวอร์ชันใบงานที่โหลดมา ส่งกลับตอนบันทึก ถ้า DB ใหม่กว่าจะได้ 409 แล้วโหลดใหม่
        edit_row_version: null,
        edit_source: null,
        create_checklist_template_id: "",
        create_checklist_items: [],
        create_inspection_plan_id: null,
        new_checklist_description: "",
        new_checklist_input_type: "check",
        new_checklist_unit: "",
        new_checklist_min: "",
        new_checklist_max: "",
        new_checklist_label_left: "",
        new_checklist_label_right: "",
        new_checklist_required: false,
        new_checklist_errors: {},
        visits: [],
        selected_visit_date: "",
        visit_technician_search: "",
        visit_iat_map: {},
        visit_iat_status_map: {},
        saved_requisition_map: {},
        sap_transfer_map: {},
        wo_view_mode: false,
        wo_images: [],
        wo_videos: [],
        wo_documents: [],
        edit_work_order_id: "",
        edit_work_request_option: null,
        // ผูกคำร้องไว้แล้วแต่ยังไม่กดบันทึก - ใช้ขึ้นข้อความเตือนท้าย modal
        work_request_link_dirty: false,
    });

    // master data ของฟอร์ม (GetOptions) มีหลายเส้น ตารางไม่ควรรอเส้นที่ช้าที่สุดก่อนค่อยโผล่
    // จึงยิงคู่ขนานกันและเก็บ promise ไว้ ให้จุดที่ต้องใช้ options จริง ๆ (เปิด modal) มา await เอง
    optionsReady = Promise.resolve();

    async componentDidMount() {
        loading(true);
        this.optionsReady = this.GetOptions();
        await this.applySearchFromQuery();
        loading(false);
    }

    // ทรัพย์สินโหลดเฉพาะของลูกค้าที่เลือกในฟอร์ม (หลักร้อยรายการ) แทนการดึงทั้งบริษัท (หลักหมื่น)
    // ทุกจุดที่เปลี่ยน create_customer_id (เลือกเอง / ผูกคำร้อง / เปิดแก้ไข) มาผ่านที่นี่ที่เดียว
    componentDidUpdate(prevProps, prevState) {
        if (prevState.create_customer_id !== this.state.create_customer_id) {
            this.loadCustomerAssets(this.state.create_customer_id);
        }
    }

    clearSearchQuery = () => {
        const url = new URL(window.location.href);
        ["search", "uid", "wr_uid", "visit", "return"].forEach((key) => url.searchParams.delete(key));
        window.history.replaceState({}, "", url.pathname + url.search + url.hash);
    };

    // รับเฉพาะ path ภายในแอป (ขึ้นต้นด้วย / ตัวเดียว) กันถูกส่ง URL ภายนอกมาใน ?return= แล้วเด้งออกนอกระบบ
    getSafeReturnPath = (value) => {
        const path = String(value || "").trim();
        return path.startsWith("/") && !path.startsWith("//") ? path : "";
    };

    // เลือก visit ใน modal ด้วย uid (รายการ visit ใน state คีย์ด้วย visit_date จึงต้องแปลงก่อน) ไม่เจอ = คง visit แรกที่เลือกไว้แล้ว
    // ใช้ functional setState เพราะเรียกต่อจาก openEditModal ที่ setState หลัง await - this.state อาจยังไม่ทันอัปเดต
    selectVisitByUid = (visitUid) => {
        if (!visitUid) return;
        this.setState((prevState) => {
            const visit = (prevState.visits || []).find((item) => item.uid === visitUid);
            if (!visit?.visit_date) return null;
            return { selected_visit_date: visit.visit_date, visit_detail_tab: "technician", ...this.getVisitPartsFieldState(visit) };
        });
    };

    // จำค่าที่เลือกไว้ใน localStorage (ISS-030)
    changeScope = (scope) => {
        localStorage.setItem("cm-wo-scope", scope);
        this.setState({ filter_scope: scope }, () => this.Get(1));
    };

    // ค้นด้วยคำค้น (Enter / ปุ่มค้นหา / เลือกจาก dropdown): ถ้าอยู่ "งานของฉัน" ให้สลับไป "ทั้งหมด" ก่อน
    // เพราะ dropdown แนะนำผลจากทุกใบ แต่ตาราง "งานของฉัน" กรองเฉพาะใบที่ฉันสร้าง/ถูกมอบหมาย - ค้นเจอแต่ตารางว่าง
    // ไม่บันทึกลง localStorage เพราะเป็นการสลับชั่วคราวเพื่อการค้นครั้งนี้ ไม่ใช่ค่าที่ผู้ใช้เลือกเอง
    searchWithScopeAll = (selectedTab) => {
        if (this.state.filter_search?.trim() && this.state.filter_scope === "mine") {
            this.setState({ filter_scope: "all" }, () => this.Get(1, selectedTab));
            return;
        }
        this.Get(1, selectedTab);
    };

    applySearchFromQuery = async () => {
        const queryParams = new URLSearchParams(window.location.search);
        const workOrderNumber = queryParams.get("search") || "";
        const woUid = queryParams.get("uid") || "";
        const visitUid = queryParams.get("visit") || "";
        const returnTo = this.getSafeReturnPath(queryParams.get("return"));

        // มาจากหน้าอื่นที่ระบุทางกลับ (เช่น จัดตารางงาน): เปิด modal ใบนั้นตามกฎสิทธิ์ปกติของ openEditModal (open แก้ได้)
        // และเลือก visit ที่กดมาค้างไว้ ปิด modal แล้ว closeCreateModal พากลับตาม return_to
        if (woUid && returnTo) {
            await this.Get(1, "all");
            await this.openEditModal({ uid: woUid });
            this.setState({ return_to: returnTo });
            this.selectVisitByUid(visitUid);
            this.clearSearchQuery();
            return;
        }

        // มาจากหน้าคำร้อง: ปิดงานที่ประเภทเอกสารเป็น "ใบงาน" แล้วให้มาเปิดฟอร์ม WO ใหม่ต่อ
        // (ระบบไม่ได้สร้าง WO ให้อัตโนมัติ แอดมินกรอก/assign ช่างเองที่นี่)
        const workRequestUid = queryParams.get("wr_uid") || "";

        if (workRequestUid) {
            await this.Get(1, "all");
            await this.optionsReady;
            await this.openCreateModalFromWorkRequest(workRequestUid);
            this.clearSearchQuery();
            return;
        }

        // มาจากหน้า Inspection Plan: เปิด modal ของ WO ตัวนั้นเลย
        // ใช้แท็บ "ทั้งหมด" เพราะ WO ที่ลิงก์มาอาจไม่ได้อยู่สถานะ open (แท็บ default)
        if (woUid) {
            await this.Get(1, "all");
            // มาจาก Inspection Plan: เปิดโหมดแก้ไขทันทีเสมอ (ไม่ต้องจำเลข WO ไปค้นในหน้าใบงาน)
            // openEditModal ล็อกสถานะ rejected/success ให้อ่านอย่างเดียวเองอยู่แล้ว
            await this.optionsReady;
            await this.openEditModal({ uid: woUid }, false);
            this.setState({ from_inspection: true });
            this.clearSearchQuery();
            return;
        }

        if (!workOrderNumber) {
            await this.Get(1);
            return;
        }

        // มาจากลิงก์ที่ค้นเลขใบงานไว้ให้ (เช่นปุ่ม "ดูรายละเอียด WO" ในอีเมลแจ้งเตือนผลตรวจไม่ผ่าน):
        // แค่เติมคำค้นแล้วแสดงผลในตาราง ให้ผู้ใช้กดเปิดดูเอง - สิทธิ์มองเห็น/เปิดใบงานเป็นไปตามปกติของหน้านี้
        // ถ้าอยู่ "งานของฉัน" ให้สลับไป "ทั้งหมด" ชั่วคราวเหมือนการค้นด้วยมือ (searchWithScopeAll) ไม่งั้นผู้รับอีเมล
        // ที่ไม่ได้สร้าง/ถูกมอบหมายใบนั้นจะเห็นตารางว่าง - ไม่บันทึกลง localStorage เพราะไม่ใช่ค่าที่ผู้ใช้เลือกเอง
        await new Promise((resolve) => {
            this.setState(
                (state) => ({ filter_search: workOrderNumber, filter_scope: state.filter_scope === "mine" ? "all" : state.filter_scope }),
                resolve
            );
        });
        // ค้นหาจาก query string ให้ข้ามการกรองตามแท็บ default ไม่งั้น WO ที่ไม่ใช่สถานะ open จะไม่ขึ้น
        await this.Get(1, "all");
        this.clearSearchQuery();
    };

    Get = async (page, selectedTab = this.state.tab) => {
        loading(true);
        const currentPage = page || this.state.page || 1;
        const { filter_search, filter_customer_uid, filter_technician_uid, page_size, filter_scope, viewMode } = this.state;
        // มุมมองคัมบัง/ปฏิทินต้องเห็นงานครบทุกคอลัมน์เสมอ จึงไม่ผูกกับแท็บสถานะของมุมมองรายการ
        // (เดิมส่ง status ตามแท็บไปด้วย พอผู้ใช้ค้างแท็บ "สำเร็จ" ไว้ บอร์ดจะไม่มีงานเปิดใหม่/กำลังดำเนินการเลย)
        // และดึงทีเดียวหลายแถว เพราะบอร์ดไม่มีการแบ่งหน้า - page_size 10 ของมุมมองรายการทำให้การ์ดหายไปเฉย ๆ
        // แก้แบบเดียวกับ CMMS-Frontend (การ์ด "Admin Portal:Work Order(kanban board) แสดงการ์ดไม่ครบ")
        const isBoardView = viewMode === "kanban" || viewMode === "calendar";
        const status = isBoardView || selectedTab === "all" ? "" : selectedTab;
        const listPage = isBoardView ? 1 : currentPage;
        const listPageSize = isBoardView ? BOARD_VIEW_PAGE_SIZE : page_size;
        const [result, summaryResult] = await Promise.all([
            GET("admin/work-orders", {
                page: listPage,
                page_size: listPageSize,
                // view=list: backend ตัด include ที่ตาราง/Kanban ไม่ใช้ (อะไหล่/ไฟล์แนบ/checklist ของ visit)
                // เปิดดูรายละเอียดยิง uid แยกอยู่แล้ว
                view: "list",
                data_search: filter_search || "",
                // backend รับพารามิเตอร์ชื่อ customer_id/technician_id (ค่าเป็น uid) เหมือนหน้าอื่น ๆ
                // ส่งชื่อ customer_uid/technician_uid ไปจะถูกมองข้ามทั้งคู่ = กรองไม่ติด
                customer_id: filter_customer_uid || "",
                technician_id: filter_technician_uid || "",
                status,
                scope: filter_scope,
            }),
            // summary=true: backend นับตามสถานะด้วย GROUP BY ไม่ต้องดึงทุกแถวมานับเอง
            GET("admin/work-orders", {
                summary: "true",
                data_search: filter_search || "",
                customer_id: filter_customer_uid || "",
                technician_id: filter_technician_uid || "",
                scope: filter_scope,
            }),
        ]);

        if (result?.status) {
            const summary_count = {
                all: 0, open: 0, check_in: 0, success: 0, rejected: 0,
                ...(summaryResult?.status && summaryResult.data ? summaryResult.data : {}),
            };

            this.setState({
                data_work_orders: result.data || [],
                count: result.pagination?.count || 0,
                page: currentPage,
                tab: selectedTab,
                summary_count,
            });
        }
        loading(false);
    };

    // คีย์เวิร์ดสถานะชุดเก่า -> ชุดใหม่ (2026-09-27 ตาม CMMS) เผื่อข้อมูลที่ยังไม่ถูก migrate หรือ client เก่า
    // ค่าจริงที่ backend/mobile เคยบันทึกคือ "en-route" (ขีดกลาง) จึงต้องรับทั้งสองแบบ
    legacyStatusMap = { "en-route": "start_job", en_route: "start_job", in_progress: "check_in", job_done: "close_job" };

    // แปลง status ดิบ (WO หรือ visit) ให้เป็น key ตัวพิมพ์เล็กชุดใหม่ - ทุกจุดที่เทียบสถานะต้องผ่านตัวนี้
    normalizeStatusKey = (status) => {
        const key = String(status || "").trim().toLowerCase();
        return this.legacyStatusMap[key] || key;
    };

    // สถานะ WO/visit ที่มีคำแปลใน th.json/en.json (key เดียวกับค่าสถานะ) - ใช้แสดงป้ายสถานะให้เป็นภาษาตามที่เลือก
    translatedStatusKeys = [
        "draft", "open", "pending", "assigned", "scheduled",
        "start_job", "check_in", "check_out", "close_job", "on_site", "working", "done",
        "completed", "success", "approved", "closed", "rejected", "cancelled",
    ];

    technicianOptions = [];

    technicianProfiles = {};

    visitTimeOptions = ["09:00 - 17:00", "08:00 - 12:00", "13:00 - 17:00"];

    normalizeTechnicians = (technician) => {
        if (Array.isArray(technician)) {
            return technician.filter(Boolean);
        }

        return technician ? [technician] : [];
    };

    getTechnicianOptions = () => {
        const { data_technicians } = this.state;

        if (Array.isArray(data_technicians) && data_technicians.length > 0) {
            // คืนครบทุกคน (รวม inactive) — Select ตัวกรองลิสต์ต้องเห็นด้วย ส่วนหน้ามอบหมาย visit ซ่อนด้วย activeOptions ตอน render
            return data_technicians.map((technician) => ({
                value: technician.uid,
                is_active: technician.is_active,
                status: technician.status,
                code: technician.technician_code || "",
                label: `${
                    [technician.first_name_th, technician.last_name_th, technician?.nickname_th ? ` (${technician?.nickname_th})` : ""].filter(Boolean).join(" ") ||
                    [technician.first_name_en, technician.last_name_en, technician?.nickname_en ? ` (${technician?.nickname_en})` : ""].filter(Boolean).join(" ") ||
                    "-" }`,
            }));
        }

        return this.technicianOptions.map((name) => ({ value: name, label: name }));
    };

    getTechnicianDisplayName = (technicianValue) => {
        const { data_technicians } = this.state;
        const matchedTechnician = data_technicians.find((technician) => technician.uid === technicianValue);

        if (matchedTechnician) {
            let nickname_th = matchedTechnician?.nickname_th ? ` (${matchedTechnician?.nickname_th})` : "";
            let nickname_en = matchedTechnician?.nickname_en ? ` (${matchedTechnician?.nickname_en})` : "";
            return (
                [matchedTechnician.first_name_th, matchedTechnician.last_name_th, nickname_th].filter(Boolean).join(" ") ||
                [matchedTechnician.first_name_en, matchedTechnician.last_name_en, nickname_en].filter(Boolean).join(" ") || "-"
            );
        }

        return technicianValue || "-";
    };

    getTechnicianProfile = (technicianValue) => {
        const name = this.getTechnicianDisplayName(technicianValue);
        return (
            this.technicianProfiles[name] || {
                initials: (name || "-")
                    .split(" ")
                    .filter(Boolean)
                    .slice(0, 2)
                    .map((part) => part[0])
                    .join("")
                    .toUpperCase(),
                specialty: t("technician"),
                distance: "-",
                status: t("ready_for_work"),
                tone: { bg: "#2563EB", soft: "#EFF6FF", border: "#BFDBFE" },
                recommended: false,
                recommendedLabel: "",
            }
        );
    };

    getPriorityDescription = (priorityItem) => {
        if (!priorityItem) {
            return "";
        }

        return `${priorityItem.name_th} - ต้องตอบสนองภายใน ${priorityItem.sla_response_time_start} - ${priorityItem.sla_response_time_end} ${priorityItem.sla_response_time_start_unit}`;
    };

    getPriorityIdFromServiceType = (serviceType) => {
        return serviceType?.priority_default?.uid || serviceType?.priority_default_id || serviceType?.priority?.uid || serviceType?.priority_id || serviceType?.work_requisition_priorities_id || "";
    };

    // ประเภทงาน "บำรุงรักษา/Preventive" ของบริษัทนี้ - เทียบชื่อแบบเดียวกับ resolveWorkOrderDefaults ฝั่ง backend
    // (modules/admin/inspection-plan/inspection-plan.service.js) เพื่อให้ค่า default ตรงกันทั้งสองฝั่ง
    getDefaultPreventiveServiceType = () => {
        return (
            this.state.data_service_types.find((item) =>
                [item?.name_en, item?.name_th].some((name) => String(name || "").toLowerCase().includes("preventive"))
            ) || null
        );
    };

    openCreateModal = () => {
        this.setState({
            modal_create: true,
            ...this.getCreateFormState(),
        });
    };

    // เปิดฟอร์มสร้าง WO พร้อมเติมข้อมูลจากใบคำร้องที่ระบุ
    // ใบคำร้องที่ปิดงานแล้วจะไม่อยู่ใน dropdown (กรองเฉพาะ approved ที่ยังไม่มี WO) จึงต้อง seed option เข้าไปเอง
    openCreateModalFromWorkRequest = async (workRequestUid) => {
        loading(true);
        const result = await GET("admin/work-requisitions", { uid: workRequestUid });
        loading(false);

        const detail = result?.status ? result.data : null;
        if (!detail?.uid) {
            alert("", "warning", t("warning"), result?.message || t("no_data_found"));
            return;
        }

        const option = {
            ...detail,
            value: detail.uid,
            label: [detail.wr_number || "-", detail.customer?.full_name_th || detail.customer?.name || ""].filter(Boolean).join(" - "),
        };

        this.openCreateModal();
        this.setState((prevState) => ({
            data_work_requests: [option, ...prevState.data_work_requests.filter((item) => item.value !== option.value)],
        }));
        this.handleWorkRequestChange(option.value, detail);
    };

    closeCreateModal = () => {
        // ถ้าเปิดมาจาก Inspection Master Plan -> ปิดแล้วกลับไปหน้าเดิม
        if (this.state.from_inspection) {
            window.location.href = "/ad/inspection-plan";
            return;
        }
        // เปิดมาจากหน้าอื่นด้วย ?return= (เช่น จัดตารางงาน) -> ปิดแล้วกลับไปหน้านั้น ไม่ว่าจะกดปุ่มปิด กด X หรือคลิกนอก modal
        if (this.state.return_to) {
            window.location.href = this.state.return_to;
            return;
        }
        this.setState({
            active_wo: null,
            modal_create: false,
            ...this.getCreateFormState(),
        });
    };

    getDatePart = (dateTime) => {
        if (!dateTime) {
            return "";
        }

        const value = String(dateTime).trim();
        if (value.includes("T")) {
            return value.split("T")[0];
        }

        if (value.includes(" ")) {
            return value.split(" ")[0];
        }

        return value;
    };

    getTimePart = (dateTime) => {
        if (!dateTime) {
            return "";
        }

        const value = String(dateTime).trim();
        const timeSource = value.includes("T") ? value.split("T")[1] || "" : value.split(" ")[1] || "";
        return timeSource.slice(0, 5);
    };

    // WO ที่ระบบสร้างจากแผนการตรวจสอบเก็บ visit ไว้แค่ระดับวัน (เวลาเป็น 00:00 ทั้งคู่) = ยังไม่ได้กำหนดช่วงเวลาจริง
    // ถ้าปล่อยไว้จะได้ time_slot "00:00 - 00:00" ที่ไม่ตรงกับตัวเลือกใน dropdown ทำให้แถบ "กำหนดช่าง" โชว์คนละค่ากับ select
    // จึงถอยไปใช้ช่วงเวลาเริ่มต้นเมื่ออ่านเวลาไม่ได้ หรือได้ช่วงเวลาที่ยาว 0 นาที
    buildTimeSlot = (startDateTime, endDateTime) => {
        const startTime = this.getTimePart(startDateTime);
        const endTime = this.getTimePart(endDateTime);

        if (!startTime || !endTime || startTime === endTime) {
            return this.visitTimeOptions[0];
        }

        return `${startTime} - ${endTime}`;
    };

    mapVisitItemToPart = (item, fallbackPrefix = "part") => ({
        uid: item?.uid || this.makeUnitUid(fallbackPrefix, item?.part?.uid || item?.part_id || ""),
        part_id: item?.part?.uid || item?.part_id || "",
        part_name: item?.part?.name || item?.part_name || item?.name || "-",
        part_number: item?.part?.part_number || item?.part?.code || item?.part_number || item?.code || "-",
        quantity: Number(item?.quantity) || 1,
        uom_name: item?.uom?.name || item?.part?.uom?.name || item?.uom_name || "",
        uom_id: item?.uom?.uid || item?.uom_id || item?.part?.uom?.uid || "",
        bom_id: item?.bom_master?.uid || item?.bom_id || "",
        price: Number(item?.part?.selling_price ?? item?.selling_price ?? item?.price) || 0,
        lot: item?.lot ?? "",
        exp_date: item?.exp_date ?? "",
        stock_quantity: item?.stock_quantity ?? null,
        stock_lot_id: item?.stock_lot?.uid || item?.stock_lot_id || "",
        // เก็บมิติของล็อตไว้ด้วย (สต็อกพิเศษ / WBS) ใช้ตัดสิน movement type ตอนขอโอนเข้า SAP
        stock_lot: item?.stock_lot || null,
        // รหัส WBS ปลายทาง - ล็อตที่มี WBS ใช้ของล็อต ล็อตทั่วไปผู้ใช้เลือกเอง
        wbs_element: item?.wbs_element || item?.stock_lot?.wbs_element || "",
        actual_quantity: item?.actual_quantity ?? null,
        is_active: item?.is_active === undefined ? true : item.is_active,
        // ผลการโอนเข้า VAN (SAP) ของชิ้นนี้ - มีเลขเอกสารแล้ว = ล็อก ห้ามแก้/ลบ
        sap_material_document: item?.sap_material_document || "",
        sap_material_document_year: item?.sap_material_document_year || "",
        sap_movement_type: item?.sap_movement_type || "",
        sap_transferred_at: item?.sap_transferred_at || "",
        // รหัสพนักงานผู้เบิกที่บันทึกไว้กับอะไหล่ชิ้นนี้ (backend เป็นคนเซ็ตให้ตอนบันทึก work order)
        emp_id: item?.emp_id || "",
        // เลข IAT ระดับอะไหล่รายชิ้น
        iat_number: item?.iat_number || "",
        // รหัสอ้างอิงรายบรรทัด (WO-xxxx-V01-<part_number>-n) backend ออกให้ตอนบันทึก แสดงอย่างเดียว ไม่ส่งกลับ
        line_no: item?.line_no || "",
        remark: item?.remark || "",
    });

    // ===== อะไหล่ใน visit: 1 แถว = 1 บรรทัด (quantity ได้มากกว่า 1) รูปแบบเดียวกับ CMMS =====
    // - จาก BOM: 1 บรรทัดใน BOM = 1 แถว ปรับจำนวนที่ช่องจำนวนของแถวนั้นตรง ๆ
    // - เพิ่มเติมนอก BOM: กด "เพิ่ม" = ต่อบรรทัดใหม่เสมอ แม้เป็นอะไหล่ตัวเดิม
    //   (อะไหล่ A 2 ชิ้น = บรรทัดที่ 1 เพิ่มอะไหล่ A ซ้ำ = บรรทัดที่ 2 แต่ละบรรทัดเลือกล็อต/WBS ของตัวเอง)
    // ฝั่งขวาแสดง 1 การ์ด = 1 แถว ไม่ยุบกลุ่ม และไม่รวมยอดแถวตอนโหลด - แต่ละแถวมี line_no ของตัวเอง

    // uid ชั่วคราวของแถวที่ยังไม่ได้บันทึกลง DB - ต้องไม่ซ้ำกัน
    // (React key และ handler ทุกตัวอ้างอิง uid) ใช้ตัวนับแทนความยาว array เพื่อไม่ให้เลขวนซ้ำหลังลบแถว
    makeUnitUid = (prefix, partId = "") => {
        this.unitSeq = (this.unitSeq || 0) + 1;
        return `${prefix}_${partId}_${this.unitSeq}`;
    };

    // uid ชั่วคราวต้องถูกตัดทิ้งตอนสร้าง payload เพื่อให้ backend สร้างแถวใหม่ ไม่ใช่ไปหาแถวเดิมที่ไม่มีอยู่จริง
    isTempUnitUid = (uid) => TEMP_UNIT_UID_PREFIXES.some((prefix) => String(uid || "").startsWith(prefix));

    // โอนเข้า VAN (SAP) สำเร็จแล้ว - ของเปลี่ยนมือใน SAP ไปแล้ว แก้หรือลบฝั่งเราไม่ได้อีก
    // (backend กันซ้ำอีกชั้นที่ utils/visit-items.js -> isUnitLocked)
    isPartTransferredToSap = (part) => !!String(part?.sap_material_document || "").trim();

    // ชิ้นที่แตะไม่ได้แล้ว: เบิกออกด้วยเลข IAT หรือโอนเข้า VAN ไปแล้ว
    isPartUnitLocked = (part) => !!part?.iat_number || this.isPartTransferredToSap(part);

    // line_no แบบย่อสำหรับแสดงผล: ตัดเลข WO ข้างหน้าทิ้ง (WO-2609-0019-V03-HPL800-1 -> V03-HPL800-1)
    // แล้วแยกเลข "รายการที่" ท้ายสุดออกมา เพื่อให้ตอน render ตัดข้อความยาวได้โดยเลขท้ายไม่หาย
    // ค่าที่บันทึกยังเป็นรูปแบบเต็มเหมือนเดิม ตัวนี้ใช้แค่ตอนแสดงผล
    splitLineNoForDisplay = (lineNo) => {
        const full = String(lineNo || "").trim();
        if (!full) return null;
        const short = full.replace(/^.*?-(?=V\d{2}-)/, "");
        const match = short.match(/^(.*-)(\d+)$/);
        return match ? { prefix: match[1], running: match[2] } : { prefix: short, running: "" };
    };

    // คำนวณ line_no แบบย่อ "ล่วงหน้า" ให้ทุกแถว (รวมบรรทัดที่เพิ่งเพิ่ม ยังไม่บันทึก) ด้วยกติกาเดียวกับ backend
    // (utils/visit-items.js assignVisitItemLineNos) เพื่อให้เห็นตั้งแต่ตอนเพิ่มอะไหล่ว่าเป็นบรรทัดที่เท่าไหร่ของอะไหล่ตัวนั้น:
    // - แถวที่ล็อกแล้ว (IAT / โอนเข้า SAP): ใช้เลขที่บันทึกไว้เสมอ
    // - แถวเดิมที่ prefix (ลำดับ visit + รหัสอะไหล่) ยังตรง: ใช้เลขที่บันทึกไว้
    // - นอกนั้น: เลขถัดจากเลขสูงสุดของ prefix นั้น ตามลำดับแถว
    // ค่าที่ได้ใช้แสดงผลเท่านั้น ตอนบันทึก backend เป็นคนออกเลขจริง (รูปแบบเต็มมีเลข WO นำหน้า)
    previewLineNos = (parts = [], sequence = 1) => {
        const prefixFor = (part) => `V${String(Number(sequence) || 1).padStart(2, "0")}-${String(part?.part_number || part?.part_id || "").trim()}-`;
        const result = new Map();
        const maxRunning = new Map();
        const reserved = new Set();
        const reserve = (prefix, running) => {
            reserved.add(`${prefix}${running}`);
            if (running > (maxRunning.get(prefix) || 0)) maxRunning.set(prefix, running);
        };

        // รอบ 1 - แถวที่คงเลขเดิม จองเลขก่อน กันแถวใหม่ที่อยู่ก่อนหน้าได้เลขชนกัน
        for (const part of parts) {
            const saved = this.splitLineNoForDisplay(part.line_no);
            if (!saved) continue;
            const prefix = prefixFor(part);
            const running = saved.prefix === prefix ? Number(saved.running) : NaN;

            if (this.isPartUnitLocked(part)) {
                result.set(part.uid, saved);
                if (running > 0) reserve(prefix, running);
                continue;
            }
            if (!(running > 0) || reserved.has(`${prefix}${running}`)) continue;
            result.set(part.uid, saved);
            reserve(prefix, running);
        }

        // รอบ 2 - ออกเลขใหม่ต่อจากเลขสูงสุดของ prefix นั้น
        for (const part of parts) {
            if (result.has(part.uid)) continue;
            const prefix = prefixFor(part);
            const next = (maxRunning.get(prefix) || 0) + 1;
            reserve(prefix, next);
            result.set(part.uid, { prefix, running: String(next) });
        }

        return result;
    };

    getVisitPartsFieldState = (visit = {}) => ({
        create_service_bom_id: visit?.service_bom_id || "",
        create_service_bom_parts: Array.isArray(visit?.service_bom_parts) ? visit.service_bom_parts : [],
        create_manual_parts: Array.isArray(visit?.manual_parts) ? visit.manual_parts : [],
    });

    updateSelectedVisitState = (updater, fallbackState = {}) => {
        this.setState((prevState) => {
            const selectedVisitIndex = prevState.visits.findIndex((visit) => visit.visit_date === prevState.selected_visit_date);

            if (selectedVisitIndex < 0) {
                return fallbackState;
            }

            const currentVisit = prevState.visits[selectedVisitIndex];
            const nextVisit = updater(currentVisit);
            const nextVisits = prevState.visits.map((visit, visitIndex) => (visitIndex === selectedVisitIndex ? nextVisit : visit));

            return {
                visits: nextVisits,
                ...this.getVisitPartsFieldState(nextVisit),
                ...fallbackState,
            };
        // เพิ่ม/ลบอะไหล่แล้วต้องมีตัวเลือกล็อตให้แถวใหม่ด้วย
        // GetStockLots เทียบชุดอะไหล่ก่อนยิง การเรียกตอนแก้จำนวนหรือแก้รายงานจึงไม่เสียเที่ยว
        }, this.GetStockLots);
    };

    getSelectedVisitSnapshot = (visits = this.state.visits, selectedVisitDate = this.state.selected_visit_date) => {
        return visits.find((visit) => visit.visit_date === selectedVisitDate) || null;
    };

    // ===== ไฟล์แนบ (รูป/วิดีโอ) — pattern เดียวกับ work-request =====
    mapFilesToItems = (files = []) =>
        Array.from(files).map((file) => ({
            file,
            name: file.name,
            size: file.size,
            type: file.type,
            url: URL.createObjectURL(file),
        }));

    // รวมเหตุผลที่ไฟล์ถูกปฏิเสธเป็นข้อความเดียว แล้วแจ้งครั้งเดียว
    // (alert() ของโปรเจกต์จะ "ทิ้ง" ข้อความที่ยิงซ้อนขณะมี modal เปิดอยู่)
    notifyRejectedFiles = ({ wrongType, tooBig, overLimit, rule }, fileType) => {
        const messages = [];

        if (wrongType.length > 0) {
            messages.push(`${t("file_type_not_allowed")}: ${wrongType.join(", ")}`);
        }
        if (tooBig.length > 0) {
            messages.push(`${t("file_too_large")} (${t("max")} ${toMB(rule.maxSize)} MB): ${tooBig.join(", ")}`);
        }
        if (overLimit > 0) {
            const key = fileType === "video" ? "max_videos_reached" : "max_images_reached";
            messages.push(formatText(t(key), { count: rule.maxFiles, excess: overLimit }));
        }

        if (messages.length > 0) {
            alert("", "warning", t("warning"), messages.join(" · "));
        }
    };

    // คัดไฟล์ตามกติกา (ชนิด -> ขนาดต่อไฟล์ -> จำนวนสูงสุด) แล้วบีบอัดรูปก่อนเก็บเข้า state
    // คืน array ของ item ที่พร้อมเก็บ (array ว่างถ้าไม่มีไฟล์ผ่านเกณฑ์)
    // kind: "images" | "videos", currentCount: จำนวนไฟล์ที่มีอยู่แล้วในโซนนั้น
    prepareFiles = async (files, kind, currentCount) => {
        const fileType = kind === "videos" ? "video" : "image";

        const result = pickFilesByRule(files, fileType, currentCount);
        this.notifyRejectedFiles(result, fileType);
        if (result.accepted.length === 0) return [];

        // บีบอัดรูปเพื่อลดพื้นที่จัดเก็บบน S3 (วิดีโอบีบฝั่ง browser ไม่ได้ ใช้ตามเดิม)
        let accepted = result.accepted;
        if (fileType === "image") {
            loading(true);
            try {
                accepted = await compressImageFiles(result.accepted);
            } finally {
                loading(false);
            }
        }

        return this.mapFilesToItems(accepted);
    };

    // แปลง attachment จาก API เป็น item สำหรับ preview (โหมดดู/แก้ไข)
    // แสดงรูปถ่าย PM แยก 2 กลุ่มตามคำนำหน้าชื่อไฟล์ (ต้องตรงกับ SNAPA-Mobile jobService.ts):
    // pm-checklist-photo-during- = ระหว่างดำเนินการ, รูปรุ่นเก่า pm-checklist-photo-N (ก่อนแยกช่วง) ถือเป็นหลังดำเนินการ
    renderPmPhotoGroups = (photos) => {
        const list = Array.isArray(photos) ? photos : [];
        const isDuring = (p) => (p.name || "").startsWith("pm-checklist-photo-during-");
        return [
            { key: "during", label: t("during_service"), photos: list.filter(isDuring) },
            { key: "after", label: t("after_service"), photos: list.filter((p) => !isDuring(p)) },
        ]
            .filter((group) => group.photos.length > 0)
            .map((group) => (
                <div className="mb-2" key={group.key}>
                    <div className="text-13 text-muted mb-1">{group.label} ({group.photos.length})</div>
                    <div className="row g-2">
                        {group.photos.map((photo, i) => (
                            <div className="col-6 col-md-3" key={photo.uid || i}>
                                <a href={photo.preview_url || photo.url} target="_blank" rel="noreferrer" download={photo.name || undefined}>
                                    <img
                                        src={photo.preview_url || photo.url}
                                        alt=""
                                        className="rounded-3 border w-100"
                                        style={{ aspectRatio: "1", objectFit: "cover" }}
                                    />
                                </a>
                            </div>
                        ))}
                    </div>
                </div>
            ));
    };

    attachmentToItem = (a) => ({
        uid: a.uid,
        name: a.file_name || "",
        url: a.file_path,
        file_type: a.file_type,
        mime_type: a.mime_type,
        file_size: a.file_size,
        is_uploaded: true,
    });

    // ไฟล์แนบที่อัปโหลดแล้วเก็บเป็น S3 URL ตรงๆ ซึ่งเข้าไม่ได้ (bucket policy ปิด public read กับโฟลเดอร์ใหม่ -> AccessDenied)
    // ต้องอ่านผ่าน endpoint ใหม่ (แนบ Authorization + company-uid) แล้วแปลงเป็น blob url ไว้ให้ <img>/<video>/<a> ใช้แสดงผลแทน
    hydratePreviewUrls = async (items) => {
        await Promise.all(
            (items || []).map(async (item) => {
                if (!item?.uid) return; // ไฟล์ที่เพิ่งเลือก ยังไม่บันทึก ใช้ local blob url เดิมได้เลย
                const result = await GET_FILE(`admin/attachments/${item.uid}`);
                if (result?.status === true && result.blob) {
                    item.preview_url = URL.createObjectURL(result.blob);
                }
            })
        );
    };

    // ดาวน์โหลดเอกสารแนบผ่าน GET /admin/attachments/:uid (แนบ auth header) ห้ามลิงก์ S3 URL ตรง
    openWoDocument = async (doc) => {
        if (!doc?.uid) return;
        loading(true);
        try {
            const result = await GET_FILE(`admin/attachments/${doc.uid}`, { download: 1 });
            if (result?.status !== true || !result.blob) {
                alert("", "warning", t("warning"), result?.message || t("no_data_found"));
                return;
            }
            const blobUrl = URL.createObjectURL(result.blob);
            const link = document.createElement("a");
            link.href = blobUrl;
            link.download = doc.name || "";
            document.body.appendChild(link);
            link.click();
            link.remove();
            setTimeout(() => URL.revokeObjectURL(blobUrl), 60000);
        } finally {
            loading(false);
        }
    };

    // อัปโหลดทีละไฟล์ (presigned URL -> fallback base64) คืน array attachment object (null ถ้าพลาด)
    uploadAttachments = async (items, folder, fileType) => {
        const uploaded = [];
        for (const item of items || []) {
            // ไฟล์ที่อัปโหลดแล้ว (โหมดดู/แก้ไข) ส่ง meta เดิมกลับ ไม่อัปโหลดซ้ำ
            if (!item?.file && typeof item?.url === "string" && item.url.includes("://")) {
                uploaded.push({
                    uid: item.uid,
                    file_path: item.url,
                    file_name: item.name || null,
                    file_type: item.file_type || fileType,
                    mime_type: item.mime_type || null,
                    file_size: item.file_size ?? null,
                });
                continue;
            }
            // backstop: กันไฟล์ใหญ่เกินหลุดมาถึงขั้นอัปโหลด
            const rule = WORK_REQUEST_UPLOAD_RULES[fileType] || WORK_REQUEST_UPLOAD_RULES.image;
            if (item?.file && item.file.size > rule.maxSize) {
                alert("", "warning", t("warning"), `${t("file_too_large")} (${t("max")} ${toMB(rule.maxSize)} MB): ${item?.name || ""}`);
                return null;
            }
            const res = await UPLOAD(item.file, { folder });
            if (res?.status === true && res?.data?.file_path) {
                uploaded.push({
                    file_path: res.data.file_path,
                    file_name: item.name || res.data.file_name || null,
                    file_type: fileType,
                    mime_type: res.data.mime_type || item.type || null,
                    file_size: res.data.file_size ?? item.size ?? null,
                });
            } else {
                alert("", "warning", t("warning"), `${t("upload")} "${item?.name || ""}" ${t("fail")}`);
                return null;
            }
        }
        return uploaded;
    };

    // ---- WO-level ----
    addWoFiles = async (files, kind) => {
        const key = kind === "videos" ? "wo_videos" : "wo_images";
        const items = await this.prepareFiles(files, kind, (this.state[key] || []).length);
        if (items.length === 0) return;
        this.setState((prev) => ({ [key]: [...(prev[key] || []), ...items] }));
    };

    removeWoFile = async (index, kind) => {
        if (!(await alert("", "warning", t("delete_item"), t("delete_desc"), t("confirm"), t("cancel")))) return;
        const key = kind === "videos" ? "wo_videos" : "wo_images";
        this.setState((prev) => {
            const arr = [...(prev[key] || [])];
            const [removed] = arr.splice(index, 1);
            if (removed?.url && removed.url.startsWith("blob:")) URL.revokeObjectURL(removed.url);
            if (removed?.preview_url && removed.preview_url.startsWith("blob:")) URL.revokeObjectURL(removed.preview_url);
            return { [key]: arr };
        });
    };

    // ---- Visit-level (ของ visit ที่เลือกอยู่) ----
    addVisitFiles = async (files, kind) => {
        const key = kind === "videos" ? "videos" : "images";
        const currentCount = (this.getSelectedVisitSnapshot()?.[key] || []).length;
        const items = await this.prepareFiles(files, kind, currentCount);
        if (items.length === 0) return;
        this.updateSelectedVisitState((currentVisit) => ({
            ...currentVisit,
            [key]: [...(currentVisit[key] || []), ...items],
        }));
    };

    removeVisitFile = async (index, kind) => {
        if (!(await alert("", "warning", t("delete_item"), t("delete_desc"), t("confirm"), t("cancel")))) return;
        const key = kind === "videos" ? "videos" : "images";
        this.updateSelectedVisitState((currentVisit) => {
            const arr = [...(currentVisit[key] || [])];
            const [removed] = arr.splice(index, 1);
            if (removed?.url && removed.url.startsWith("blob:")) URL.revokeObjectURL(removed.url);
            if (removed?.preview_url && removed.preview_url.startsWith("blob:")) URL.revokeObjectURL(removed.preview_url);
            return { ...currentVisit, [key]: arr };
        });
    };

    // JSX กลางสำหรับโซนอัปโหลด/พรีวิว ใช้ทั้ง WO และ visit
    renderAttachmentZone = ({ images = [], videos = [], documents = null, idPrefix, disabled = false, onAdd, onRemove }) => (
        <div className="bg-white rounded-3 p-3 border">
            <label className="form-label text-dark fw-bold text-13 mb-2">
                {t("images") || "รูปภาพ"} <span className="text-secondary fw-normal">({images.length}/{IMAGE_RULE.maxFiles})</span>
            </label>
            {!disabled && (
                <div
                    className="border rounded-3 p-3 mb-2 text-center pointer"
                    style={{ borderStyle: "dashed", borderColor: "#ccc", backgroundColor: "#fafafa" }}
                    onDragOver={(e) => e.preventDefault()}
                    onDrop={(e) => {
                        e.preventDefault();
                        const files = Array.from(e.dataTransfer.files || []);
                        e.dataTransfer.clearData();
                        onAdd(files, "images");
                    }}
                    onClick={() => document.getElementById(`${idPrefix}-img`).click()}
                >
                    <input type="file" id={`${idPrefix}-img`} multiple accept="image/*" hidden
                        onChange={(e) => { const files = Array.from(e.target.files || []); e.target.value = ""; onAdd(files, "images"); }} />
                    <span className="icon text-22 text-success d-block mb-1">{""}</span>
                    <div className="text-12 text-secondary">{t("click_or_drag_image_here") || "คลิกหรือลากรูปมาวาง"}</div>
                    <div className="text-11 text-secondary mt-1">
                        {formatText(t("upload_hint_images"), { count: IMAGE_RULE.maxFiles, size: toMB(IMAGE_RULE.maxSize) })}
                    </div>
                </div>
            )}
            {images.length > 0 && (
                <div className="d-flex flex-wrap gap-2 mb-3">
                    {images.map((img, i) => (
                        <div key={i} className="border rounded-3 p-1 position-relative bg-light" style={{ width: "90px" }}>
                            {!disabled && (
                                <div className="position-absolute top-0 end-0 bg-danger text-white rounded-circle wpx-15 hpx-15 d-flex align-items-center justify-content-center pointer"
                                    style={{ transform: "translate(30%, -30%)", zIndex: 2 }} onClick={() => onRemove(i, "images")}>
                                    <span className="icon text-10">{""}</span>
                                </div>
                            )}
                            <a href={img.preview_url || img.url} target="_blank" rel="noopener noreferrer" download={img.name || undefined}>
                                <img src={img.preview_url || img.url} alt={img.name} className="rounded-2" style={{ width: "100%", height: "60px", objectFit: "cover" }} />
                            </a>
                            <div className="text-10 text-secondary text-center">{formatFileSize(img.size ?? img.file_size)}</div>
                        </div>
                    ))}
                </div>
            )}

            <label className="form-label text-dark fw-bold text-13 mb-2">
                {t("videos") || "วิดีโอ"} <span className="text-secondary fw-normal">({videos.length}/{VIDEO_RULE.maxFiles})</span>
            </label>
            {!disabled && (
                <div
                    className="border rounded-3 p-3 mb-2 text-center pointer"
                    style={{ borderStyle: "dashed", borderColor: "#fd7e14", backgroundColor: "#fff8f3" }}
                    onDragOver={(e) => e.preventDefault()}
                    onDrop={(e) => {
                        e.preventDefault();
                        const files = Array.from(e.dataTransfer.files || []);
                        e.dataTransfer.clearData();
                        onAdd(files, "videos");
                    }}
                    onClick={() => document.getElementById(`${idPrefix}-vid`).click()}
                >
                    <input type="file" id={`${idPrefix}-vid`} multiple accept="video/mp4,video/quicktime" hidden
                        onChange={(e) => { const files = Array.from(e.target.files || []); e.target.value = ""; onAdd(files, "videos"); }} />
                    <span className="icon text-22 text-dark d-block mb-1">{""}</span>
                    <div className="text-12 text-secondary">{t("click_or_drag_video_here") || "คลิกหรือลากวิดีโอมาวาง"}</div>
                    <div className="text-11 text-secondary mt-1">
                        {formatText(t("upload_hint_videos"), { count: VIDEO_RULE.maxFiles, size: toMB(VIDEO_RULE.maxSize) })}
                    </div>
                </div>
            )}
            {videos.length > 0 && (
                <div className="d-flex flex-wrap gap-2">
                    {videos.map((vid, i) => (
                        <div key={i} className="border rounded-3 p-1 position-relative bg-light" style={{ width: "160px" }}>
                            {!disabled && (
                                <div className="position-absolute top-0 end-0 bg-danger text-white rounded-circle wpx-15 hpx-15 d-flex align-items-center justify-content-center pointer"
                                    style={{ transform: "translate(30%, -30%)", zIndex: 2 }} onClick={() => onRemove(i, "videos")}>
                                    <span className="icon text-10">{""}</span>
                                </div>
                            )}
                            <video src={vid.preview_url || vid.url} controls className="rounded-2 w-100 bg-dark" style={{ height: "90px", objectFit: "contain" }} />
                            <div className="text-10 text-secondary text-center">{formatFileSize(vid.size ?? vid.file_size)}</div>
                        </div>
                    ))}
                </div>
            )}
            {Array.isArray(documents) && (
                <>
                    <label className="form-label text-dark fw-bold text-13 mb-1 mt-3">
                        {t("documents")} <span className="text-secondary fw-normal">({documents.length})</span>
                    </label>
                    <div className="text-11 text-secondary mb-2">{t("wo_documents_hint")}</div>
                    {documents.length === 0 && <div className="text-secondary text-12">-</div>}
                    {documents.map((doc, i) => (
                        <div key={doc.uid || i} className="d-flex align-items-center justify-content-between border rounded-3 p-2 mb-2 bg-light">
                            <div className="d-flex align-items-center gap-2 overflow-hidden">
                                <span className="icon text-16 text-primary">{"\uf15c"}</span>
                                <div className="overflow-hidden">
                                    <div className="text-12 fw-bold text-dark text-truncate" title={doc.name}>{doc.name}</div>
                                    <div className="text-10 text-secondary">{formatFileSize(doc.size ?? doc.file_size)}</div>
                                </div>
                            </div>
                            <div className="d-flex align-items-center gap-2 ms-2 flex-shrink-0">
                                <button type="button" className="btn btn-sm btn-outline-primary text-11" onClick={() => this.openWoDocument(doc)}>{t("download")}</button>
                            </div>
                        </div>
                    ))}
                </>
            )}
            {disabled && images.length === 0 && videos.length === 0 && !(Array.isArray(documents) && documents.length > 0) && <div className="text-secondary text-12">-</div>}
        </div>
    );

    fetchServiceBomParts = async (serviceBomId) => {
        if (!serviceBomId) {
            return [];
        }

        const res = await GET("admin/bom-masters", { uid: serviceBomId });
        const bomItems = Array.isArray(res?.data?.bom_items) ? res.data.bom_items : [];

        // อะไหล่ 1 บรรทัดใน BOM = 1 แถว เก็บจำนวนตาม BOM ไว้ในแถวเดียว
        // uid ต้องเป็นของชั่วคราวที่ frontend ตั้งเอง ห้ามใช้ uid ของ bom_items (คนละตารางกับ visits_items)
        return bomItems.map((item) => {
            const partId = item.part?.uid || "";

            return {
                uid: this.makeUnitUid("bom", partId),
                part_id: partId,
                part_name: item.part?.name || "-",
                part_number: item.part?.part_number || item.part?.code || "-",
                quantity: Math.max(Number(item.quantity) || 1, 1),
                uom_name: item.uom?.name || item.part?.uom?.name || "",
                uom_id: item.uom?.uid || item.part?.uom?.uid || "",
                bom_id: serviceBomId,
                price: Number(item.part?.selling_price) || 0,
                remark: item.remark || "",
            };
        });
    };

    splitVisitItemsByBom = (visitItems = [], visitServiceBomId = "", serviceBomParts = []) => {
        const itemsWithBomId = visitItems.filter((item) => item?.bom_id);
        const itemsWithoutBomId = visitItems.filter((item) => !item?.bom_id);

        if (itemsWithBomId.length > 0 || itemsWithoutBomId.length > 0) {
            const activeBomParts = itemsWithBomId
                .filter((item) => !visitServiceBomId || item.bom_id === visitServiceBomId)
                .map((item) => ({ ...item, bom_id: item.bom_id || visitServiceBomId || "" }));

            if (visitServiceBomId && Array.isArray(serviceBomParts) && serviceBomParts.length > 0) {
                const activeBomPartIds = new Set(activeBomParts.map((p) => p.part_id).filter(Boolean));
                const inactiveBomParts = serviceBomParts
                    .filter((p) => p.part_id && !activeBomPartIds.has(p.part_id))
                    .map((p) => ({ ...p, bom_id: visitServiceBomId || p.bom_id || "", is_active: false }));
                activeBomParts.push(...inactiveBomParts);
            }

            return {
                serviceBomParts: activeBomParts,
                manualParts: itemsWithoutBomId.map((item) => ({ ...item, bom_id: "" })),
            };
        }

        if (!visitServiceBomId) {
            return {
                serviceBomParts: [],
                manualParts: visitItems.map((item) => ({ ...item, bom_id: "" })),
            };
        }

        if (!Array.isArray(serviceBomParts) || serviceBomParts.length === 0) {
            return {
                serviceBomParts: visitItems.map((item) => ({ ...item, bom_id: visitServiceBomId })),
                manualParts: [],
            };
        }

        const bomPartIds = new Set(serviceBomParts.map((item) => item.part_id).filter(Boolean));

        return {
            serviceBomParts: visitItems
                .filter((item) => bomPartIds.has(item.part_id))
                .map((item) => ({ ...item, bom_id: visitServiceBomId })),
            manualParts: visitItems
                .filter((item) => !bomPartIds.has(item.part_id))
                .map((item) => ({ ...item, bom_id: "" })),
        };
    };

    buildEditWorkRequestOption = (workOrderDetail) => {
        const workRequest = workOrderDetail?.wr || workOrderDetail?.work_request || workOrderDetail?.work_requisition;
        const workRequestUid = workRequest?.uid || workOrderDetail?.wr_id || workOrderDetail?.work_request_id || "";

        if (!workRequestUid && !workOrderDetail?.wr_number) {
            return null;
        }

        return {
            ...workRequest,
            value: workRequestUid || workOrderDetail?.wr_number || "",
            uid: workRequestUid || workOrderDetail?.wr_number || "",
            wr_number: workRequest?.wr_number || workOrderDetail?.wr_number || "",
            created_at: workRequest?.created_at || workOrderDetail?.created_at || "",
            contact_name_1: workRequest?.contact_name_1 || workOrderDetail?.contact_name || "",
            contact_name_2: workRequest?.contact_name_2 || workOrderDetail?.contact_name_2 || "",
            contact_phone_2: workRequest?.contact_phone_2 || workOrderDetail?.contact_phone_2 || "",
            customer: workRequest?.customer || workOrderDetail?.customer || null,
            label:
                [
                    workRequest?.wr_number || workOrderDetail?.wr_number || workRequest?.work_requisition_no || workRequest?.requisition_no || "-",
                    workRequest?.customer?.full_name_th || workRequest?.customer?.name || workOrderDetail?.customer?.full_name_th || workOrderDetail?.customer?.name || "",
                ]
                    .filter(Boolean)
                    .join(" - ") ||
                workRequestUid ||
                workOrderDetail?.wr_number ||
                "",
        };
    };

    handleServiceTypeChange = (serviceTypeId, serviceTypeItem) => {
        const { data_priorities } = this.state;
        const priorityId = this.getPriorityIdFromServiceType(serviceTypeItem);
        const priorityItem = data_priorities.find((item) => item.value === priorityId || item.uid === priorityId);

        this.updateSelectedVisitState(
            (currentVisit) => ({
                ...currentVisit,
                service_bom_id: "",
                service_bom_parts: [],
            }),
            {
                create_work_requisition_service_types_id: serviceTypeId,
                create_work_requisition_priorities_id: priorityId || "",
                create_service_bom_id: "",
                create_service_bom_parts: [],
                text_priority_id: this.getPriorityDescription(priorityItem),
            }
        );
    };

    getAssetCustomerId = (asset) => {
        return asset?.customer?.uid || asset?.customer_id || asset?.customer_uid || asset?.owner_customer_id || "";
    };

    // กรอง asset ให้เหลือเฉพาะของลูกค้าที่เลือกอยู่ (เหมือนหน้า work-request)
    getFilteredAssetOptions = () => {
        const { data_asset, create_customer_id } = this.state;

        if (!create_customer_id) {
            return [];
        }

        return data_asset.filter((asset) => this.getAssetCustomerId(asset) === create_customer_id);
    };

    handleCreateCategoryChange = (categoryId) => {
        // เปลี่ยน Request Category แล้วล้าง Service BOM ที่เลือกค้างไว้
        // เพราะรายการ Service BOM จะถูก filter ตาม category ใหม่ (กันเลือกค้างข้าม category)
        this.updateSelectedVisitState(
            (currentVisit) => ({
                ...currentVisit,
                service_bom_id: "",
                service_bom_parts: [],
            }),
            {
                create_work_requisition_categories_id: categoryId,
                create_service_bom_id: "",
                create_service_bom_parts: [],
            }
        );
    };

    handleServiceBOMChange = async (serviceBomId) => {
        this.updateSelectedVisitState(
            (currentVisit) => ({
                ...currentVisit,
                service_bom_id: serviceBomId,
                service_bom_parts: [],
            }),
            { create_service_bom_id: serviceBomId, create_service_bom_parts: [] }
        );

        if (!serviceBomId) {
            return;
        }

        loading(true);
        try {
            const bomParts = await this.fetchServiceBomParts(serviceBomId);
            this.updateSelectedVisitState(
                (currentVisit) => ({
                    ...currentVisit,
                    service_bom_id: serviceBomId,
                    service_bom_parts: bomParts,
                }),
                { create_service_bom_id: serviceBomId, create_service_bom_parts: bomParts }
            );
        } finally {
            loading(false);
        }
    };

    handleServiceBOMPartChange = (rowUid, quantity) => this.setPartRowQuantity("service_bom_parts", rowUid, quantity);

    handleAddManualPart = () => {
        const { create_manual_part_id, data_parts } = this.state;
        if (!create_manual_part_id) {
            return;
        }

        const selectedPart = data_parts.find((part) => part.value === create_manual_part_id || part.uid === create_manual_part_id);
        if (!selectedPart) {
            return;
        }

        this.setState((prevState) => {
            const selectedVisit = this.getSelectedVisitSnapshot(prevState.visits, prevState.selected_visit_date);
            const currentManualParts = Array.isArray(selectedVisit?.manual_parts) ? selectedVisit.manual_parts : prevState.create_manual_parts;
            // กด "เพิ่ม" = ต่อบรรทัดใหม่เสมอ แม้เป็นอะไหล่ตัวเดิม (แต่ละบรรทัดมีจำนวน ล็อต และ line_no ของตัวเอง)
            const nextManualParts = [
                ...currentManualParts,
                {
                    uid: this.makeUnitUid("manual", create_manual_part_id),
                    part_id: create_manual_part_id,
                    part_name: selectedPart.name || selectedPart.label || "-",
                    part_number: selectedPart.part_number || "-",
                    quantity: 1,
                    uom_name: selectedPart.uom?.name || "",
                    uom_id: selectedPart.uom?.uid || "",
                    bom_id: "",
                    price: Number(selectedPart.selling_price) || 0,
                },
            ];

            const nextVisits = prevState.visits.map((visit) =>
                visit.visit_date === prevState.selected_visit_date
                    ? {
                          ...visit,
                          manual_parts: nextManualParts,
                      }
                    : visit
            );

            return {
                create_manual_part_id: "",
                create_manual_parts: nextManualParts,
                visits: nextVisits,
            };
        // ตัวนี้อัปเดต state เองไม่ได้ผ่าน updateSelectedVisitState จึงต้องเรียก GetStockLots เอง
        // ไม่งั้นอะไหล่ที่เพิ่งเพิ่มจะไม่มีตัวเลือกล็อต (ขึ้นว่าไม่พบสต๊อกทั้งที่มีของ)
        }, this.GetStockLots);
    };

    /**
     * ปรับจำนวนของอะไหล่ 1 แถวจากช่องจำนวนฝั่งขวา (1 การ์ด = 1 แถว)
     * - แถวที่ล็อกด้วย IAT/SAP แก้จำนวนไม่ได้ (ของออกจากคลังจริงแล้ว) เบิกเพิ่มให้ไป "เพิ่มเติมนอก BOM" เป็นบรรทัดใหม่
     * - ลดจนเหลือ 0 จะคงแถวไว้โดยตั้งจำนวนเป็น 0 เพื่อให้การ์ดยังอยู่ในลิสต์เหมือนพฤติกรรมเดิม และล้างล็อตที่เลือกไว้ทิ้ง
     *   (แถวจำนวน 0 ถูกกรองออกทั้งตอนสร้าง payload และตอนนับรายการเบิกอยู่แล้ว)
     */
    setPartRowQuantity = (field, rowUid, value) => {
        this.updateSelectedVisitState((currentVisit) => {
            const parts = currentVisit[field] || [];
            const target = parts.find((part) => part.uid === rowUid);
            if (!target || this.isPartUnitLocked(target)) return currentVisit;

            const rawValue = value === "" || value === null ? 0 : Math.floor(Number(value));
            const nextQuantity = Math.max(Number.isFinite(rawValue) ? rawValue : 0, 0);

            return {
                ...currentVisit,
                [field]: parts.map((part) => {
                    if (part.uid !== rowUid) return part;
                    if (nextQuantity === 0) {
                        return {
                            ...part,
                            quantity: 0,
                            lot: "",
                            exp_date: "",
                            stock_quantity: null,
                            actual_quantity: null,
                            stock_lot_id: "",
                            stock_lot: null,
                            wbs_element: "",
                        };
                    }
                    return { ...part, quantity: nextQuantity };
                }),
            };
        });
    };

    handleManualPartChange = (rowUid, quantity) => this.setPartRowQuantity("manual_parts", rowUid, quantity);

    // ปุ่มกากบาทบนการ์ดฝั่งขวา = ลบแถวนั้นออก (แถวที่ล็อกด้วย IAT/SAP ลบไม่ได้)
    removeManualPart = (rowUid) => {
        this.updateSelectedVisitState((currentVisit) => ({
            ...currentVisit,
            manual_parts: (currentVisit.manual_parts || []).filter((part) => part.uid !== rowUid || this.isPartUnitLocked(part)),
        }));
    };

    handleRemoveManualPart = async (rowUid) => {
        if (!(await alert("", "warning", t("delete_item"), t("delete_desc"), t("confirm"), t("cancel")))) return;
        this.removeManualPart(rowUid);
    };

    // ลบอะไหล่ทีละแถวจากแท็บอะไหล่ - แถวจาก BOM ให้คงการ์ดไว้โดยตั้งจำนวนเป็น 0
    // (การ์ด BOM หายไปเลยจะเรียกกลับมาไม่ได้ ต้องไปเลือก BOM ใหม่ทั้งชุด) ส่วนแถวนอก BOM ลบทิ้งได้เลย
    removePartUnit = (field, unitUid) => {
        this.updateSelectedVisitState((currentVisit) => {
            const parts = currentVisit[field] || [];
            const target = parts.find((part) => part.uid === unitUid);
            if (!target) return currentVisit;
            // แถวที่เบิก/โอนไปแล้วลบไม่ได้ - backend ก็ไม่ยอมลบให้เช่นกัน (utils/visit-items.js)
            if (this.isPartUnitLocked(target)) return currentVisit;

            if (field === "service_bom_parts") {
                return {
                    ...currentVisit,
                    [field]: parts.map((part) =>
                        part.uid === unitUid
                            ? {
                                  ...part,
                                  quantity: 0,
                                  lot: "",
                                  exp_date: "",
                                  stock_quantity: null,
                                  actual_quantity: null,
                                  stock_lot_id: "",
                                  stock_lot: null,
                                  wbs_element: "",
                              }
                            : part
                    ),
                };
            }

            return { ...currentVisit, [field]: parts.filter((part) => part.uid !== unitUid) };
        });
    };

    // ติ๊ก "ไม่เบิกอะไหล่" ของ visit ที่เลือกอยู่ - ถ้ามีอะไหล่เลือกไว้แล้วให้ยืนยันก่อนล้างทั้งหมดกลับเป็นค่าว่าง
    handleToggleNoPartsRequisition = async (checked) => {
        const selectedVisit = this.getSelectedVisitSnapshot();
        if (!selectedVisit) return;

        const hasSelectedParts =
            !!selectedVisit.service_bom_id || (selectedVisit.service_bom_parts || []).length > 0 || (selectedVisit.manual_parts || []).length > 0;

        if (checked && hasSelectedParts) {
            if (!(await alert("", "warning", t("confirm"), t("confirm_clear_parts_no_requisition"), t("confirm"), t("cancel")))) return;
        }

        this.updateSelectedVisitState((currentVisit) => ({
            ...currentVisit,
            no_parts_requisition: checked,
            ...(checked ? { service_bom_id: "", service_bom_parts: [], manual_parts: [] } : {}),
        }));

        if (checked) {
            this.setState({ create_manual_part_id: "" });
        }
    };

    getVisitTimeRange = (timeSlot) => {
        const [startTime = "09:00", endTime = "17:00"] = String(timeSlot || "")
            .split("-")
            .map((value) => value.trim())
            .filter(Boolean);

        return {
            startTime,
            endTime,
        };
    };

    formatDateTime = (date, time = "00:00") => {
        if (!date) {
            return "";
        }

        return `${date} ${time}`;
    };

    getTechnicianUidByName = (technicianName) => {
        const { data_technicians } = this.state;
        const normalizedTarget = String(technicianName || "")
            .trim()
            .toLowerCase();

        if (!normalizedTarget) {
            return "";
        }

        if (data_technicians.some((technician) => technician.uid === technicianName)) {
            return technicianName;
        }

        const matchedTechnician = data_technicians.find((technician) => {
            const candidateNames = [
                technician.nickname_en,
                technician.nickname_th,
                [technician.first_name_en, technician.last_name_en].filter(Boolean).join(" "),
                [technician.first_name_th, technician.last_name_th].filter(Boolean).join(" "),
            ]
                .map((value) =>
                    String(value || "")
                        .trim()
                        .toLowerCase()
                )
                .filter(Boolean);

            return candidateNames.includes(normalizedTarget);
        });

        return matchedTechnician?.uid || "";
    };

    resolveWorkRequestUid = (workRequestValue) => {
        const { data_work_requests } = this.state;
        if (!workRequestValue) {
            return "";
        }

        const matchedWorkRequest = data_work_requests.find((item) => item.value === workRequestValue || item.uid === workRequestValue || item.wr_number === workRequestValue);

        return matchedWorkRequest?.uid || matchedWorkRequest?.value || "";
    };

    // ไอคอน info ข้างเลขที่ใบงาน - บอกที่มาของใบ (external/internal) และ process ที่ใบนี้วิ่งอยู่
    // ใช้ tooltip รูปแบบเดียวกับช่อง "ค่าเดินทาง" ในแท็บค่าใช้จ่าย
    renderSourceInfoIcon = (item) => {
        const rowKey = String(item?.uid || item?.id || "");
        const sourceView = WORK_ORDER_SOURCE_VIEWS[item?.source] || null;
        const processView = PROCESS_NAME_VIEWS[item?.process_name] || null;
        const isOpen = this.state.source_info_key === rowKey;
        const rect = this.state.source_info_rect;

        return (
            <span
                style={{ position: "relative", display: "inline-block", marginLeft: "5px", cursor: "pointer" }}
                onMouseEnter={(e) => {
                    const r = e.currentTarget.getBoundingClientRect();
                    this.setState({ source_info_key: rowKey, source_info_rect: r });
                }}
                onMouseLeave={() => this.setState({ source_info_key: null, source_info_rect: null })}
                onClick={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    const r = e.currentTarget.getBoundingClientRect();
                    this.setState((state) => ({
                        source_info_key: state.source_info_key === rowKey ? null : rowKey,
                        source_info_rect: state.source_info_key === rowKey ? null : r,
                    }));
                }}
            >
                {/* สีไอคอนตามที่มาของใบ - external ม่วง / internal เขียว (ไม่รู้ที่มา = เทา) */}
                <span className="icon" style={{ fontSize: "12px", color: sourceView ? sourceView.color : "#6c757d" }}>
                    {"\uf05a"}
                </span>
                {isOpen && (
                    <div
                        style={{
                            position: "fixed",
                            bottom: rect ? `${window.innerHeight - rect.top + 6}px` : "50%",
                            left: rect ? `${rect.left + rect.width / 2}px` : "50%",
                            transform: "translateX(-50%)",
                            background: "#fff",
                            border: "1px solid #dee2e6",
                            borderRadius: "8px",
                            boxShadow: "0 4px 12px rgba(0,0,0,0.12)",
                            padding: "10px 14px",
                            zIndex: 9999,
                            width: "auto",
                            textAlign: "left",
                            fontSize: "12px",
                            fontWeight: "normal",
                            color: "#333",
                            // กล่องกว้างตามเนื้อหา ทุกบรรทัดจึงอยู่บรรทัดเดียว ไม่ถูกตัดคำ
                            whiteSpace: "nowrap",
                        }}
                    >
                        {/* หัวข้อกว้างเท่ากันทั้งสองบรรทัด ไอคอน/ข้อความฝั่งขวาจึงเรียงตรงกันบนล่าง */}
                        {[
                            { label: t("wo_source"), view: sourceView },
                            { label: t("process_name"), view: processView },
                        ].map((row) => (
                            <div className="d-flex align-items-center gap-2 mb-1" key={row.label}>
                                <span className="text-secondary text-nowrap flex-shrink-0" style={{ width: "110px" }}>
                                    {row.label}
                                </span>
                                <span
                                    className="fw-bold d-flex align-items-center"
                                    style={{ color: row.view ? row.view.color : "#6c757d" }}
                                >
                                    <span className="icon me-2 text-center flex-shrink-0" style={{ width: "14px" }}>
                                        {row.view ? row.view.icon : ""}
                                    </span>
                                    {row.view ? t(row.view.labelKey) : "-"}
                                </span>
                            </div>
                        ))}
                    </div>
                )}
            </span>
        );
    };

    getWorkOrderNumber = (item) => {
        return item?.wo_number || item?.work_order_no || item?.code || item?.id || item?.uid || "-";
    };

    getWorkOrderPriority = (item) => {
        return item?.priority || item?.work_requisition_priority || item?.work_requisition_priorities || null;
    };

    getWorkOrderPriorityView = (item) => {
        const priority = this.getWorkOrderPriority(item);
        const label = priority?.name_th || priority?.name_en || item?.priority_name || "-";
        return {
            label,
            backgroundColor: priority?.background_color || "#E5E7EB",
            color: priority?.font_color || "#374151",
        };
    };

    getWorkOrderCustomerName = (item) => {
        return item?.customer?.full_name_th || item?.customer?.name || item?.customer_name || "-";
    };

    getWorkOrderAssetName = (item) => {
        return (
            item?.asset?.part?.name || item?.asset?.part?.part_number || item?.asset?.part_name || item?.asset?.asset_code || item?.asset?.serial_number || item?.asset?.name || item?.asset_name || "-"
        );
    };

    getVisitTechnicianNames = (visit) => {
        const technicianValues = Array.isArray(visit?.visits_technicians) ? visit.visits_technicians : [];

        const names = technicianValues
            .map((technician) => {
                if (typeof technician === "string") {
                    return this.getTechnicianDisplayName(technician);
                }

                const technicianInfo = technician?.technician || technician;
                let nickname_th = technicianInfo?.nickname_th ? ` (${technicianInfo?.nickname_th})` : "";
                let nickname_en = technicianInfo?.nickname_en ? ` (${technicianInfo?.nickname_en})` : "";
                
                return (
                    [technicianInfo?.first_name_th, technicianInfo?.last_name_th, nickname_th].filter(Boolean).join(" ") ||
                    [technicianInfo?.first_name_en, technicianInfo?.last_name_en, nickname_en].filter(Boolean).join(" ") ||
                    ""
                );
            })
            .filter(Boolean);

        return [...new Set(names)];
    };

    getWorkOrderTechnicianNames = (item) => {
        const visits = Array.isArray(item?.visits) ? item.visits : [];
        const names = visits.flatMap((visit) => this.getVisitTechnicianNames(visit));

        return [...new Set(names)];
    };

    getWorkOrderVisitAssignmentSummary = (item) => {
        const visits = Array.isArray(item?.visits) ? item.visits : [];
        const totalVisits = visits.length;
        const assignedVisits = visits.filter((visit) => {
            const visitTechnicians = Array.isArray(visit?.visits_technicians) ? visit.visits_technicians.filter(Boolean) : [];
            return visitTechnicians.length > 0;
        }).length;

        return {
            assignedVisits,
            totalVisits,
        };
    };

    getWorkOrderVisitSuccessSummary = (item) => {
        const visits = Array.isArray(item?.visits) ? item.visits : [];
        const totalVisits = visits.length;
        const successVisits = visits.filter((visit) =>
            ["completed", "success", "approved", "closed"].includes(String(visit?.status || "").toLowerCase())
        ).length;

        return {
            successVisits,
            totalVisits,
        };
    };

    getWorkOrderSlaText = (item) => {
        const priority = this.getWorkOrderPriority(item);
        if (!priority) {
            return "-";
        }

        return `${priority.sla_response_time_start || "-"} ${priority.sla_response_time_start_unit || ""}`.trim();
    };

    // สีของสถานะ WO ให้ตรงกับสีของ column ใน tab kanban (getKanbanColumnDefinitions) เพื่อความสอดคล้องกันทั้งระบบ
    getWorkOrderStatusBadgeClass = (status) => {
        switch (this.normalizeStatusKey(status)) {
            case "draft":
                return "bg-light text-secondary border-secondary";
            case "assigned":
            case "scheduled":
                return "bg-purple-light text-purple border-purple";
            case "start_job":
                return "bg-info-light text-info border-info";
            case "check_in":
            case "on_site":
            case "working":
                return "bg-warning-light text-warning border-warning";
            case "check_out":
                return "bg-teal-light text-teal border-teal";
            case "close_job":
            case "done":
                return "bg-pink-light text-pink border-pink";
            case "completed":
            case "success":
            case "approved":
            case "closed":
                return "bg-success-light text-success border-success";
            case "cancelled":
            case "rejected":
                return "bg-danger-light text-danger border-danger";
            default:
                // "open" / "pending" / อื่น ๆ -> เหมือน column "open" ใน kanban
                return "bg-primary-light text-primary border-primary";
        }
    };

    getWorkOrderStatusLabel = (status) => {
        const statusText = String(status || "").trim();

        if (!statusText) {
            return "-";
        }

        // สถานะที่รู้จัก (รวมค่าเก่าที่ยังไม่ migrate) ใช้คำแปล th/en จาก i18n - ค่าที่ไม่รู้จักค่อยแปลงจากตัว key ตรง ๆ
        const statusKey = this.normalizeStatusKey(statusText);
        if (this.translatedStatusKeys.includes(statusKey)) {
            return t(statusKey);
        }

        return statusText
            .replaceAll("_", " ")
            .split(" ")
            .filter(Boolean)
            .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
            .join(" ");
    };

    getWorkOrderSourceNumber = (item) => {
        return item?.wr_number || item?.wr?.wr_number || item?.work_request?.wr_number || item?.work_requisition?.wr_number || "-";
    };

    // เลข SO จากระบบต้นทาง (SAP) - WO ที่เปิดจากคำร้องหรือแผนการตรวจสอบจะไม่มีค่านี้
    getWorkOrderSoNumber = (item) => {
        return String(item?.so_no || "").trim();
    };

    // ที่มาของ WO ในหัว modal: "<เลข WR> / <เลข SO>" ฝั่งไหนไม่มีจะขึ้นเป็น "-" เช่น "- / 0120000012"
    getWorkOrderSourceLabel = (item) => {
        const soNumber = this.getWorkOrderSoNumber(item);

        return `${this.getWorkOrderSourceNumber(item)} / ${soNumber || "-"}`;
    };

    getWorkOrderCreatedAtLabel = (item) => {
        const createdAt = item?.created_at || item?.created_date || item?.create_date || item?.updated_at || "";

        if (!createdAt) {
            return "-";
        }

        const timeText = this.getTimePart(createdAt);

        return timeText
            ? format_date(createdAt, "dd/mm/yyyy hh:mm", "th")
            : format_date(createdAt, "dd/mm/yyyy", "th");
    };

    // สีของสถานะ visit ให้ตรงกับสีของ column ใน tab kanban (getKanbanColumnDefinitions) เพื่อความสอดคล้องกันทั้งระบบ
    getVisitStatusView = (status) => {
        const statusKey = this.normalizeStatusKey(status);

        switch (statusKey) {
            case "assigned":
            case "scheduled":
                return { label: t("assigned"), className: "bg-purple-light text-purple border-purple" };
            case "start_job":
                return { label: t("start_job"), className: "bg-info-light text-info border-info" };
            case "check_in":
            case "on_site":
            case "working":
                return { label: t("check_in"), className: "bg-warning-light text-warning border-warning" };
            case "check_out":
                return { label: t("check_out"), className: "bg-teal-light text-teal border-teal" };
            case "close_job":
            case "done":
                return { label: t("close_job"), className: "bg-pink-light text-pink border-pink" };
            case "completed":
            case "success":
            case "approved":
            case "closed":
                return { label: t("completed"), className: "bg-success-light text-success border-success" };
            case "cancelled":
            case "rejected":
                return { label: t("cancelled"), className: "bg-danger-light text-danger border-danger" };
            default:
                // "open" / "pending" / อื่น ๆ -> เหมือน column "open" ใน kanban
                return { label: this.getWorkOrderStatusLabel(status), className: "bg-primary-light text-primary border-primary" };
        }
    };

    // หา "วันหมดประกัน" ล่าสุดของ asset ตามประเภท (customer = ประกันลูกค้า, company = ประกันผู้จำหน่าย)
    getAssetWarrantyExpireDate = (asset, section = "customer") => {
        const listKey = section === "company" ? "company_warranty" : "customer_warranty";
        const dateKey = section === "company" ? "company_warranty_expire_date" : "customer_warranty_expire_date";
        const warrantyDates = [
            ...(Array.isArray(asset?.[listKey]) ? asset[listKey].map((item) => item?.[dateKey]) : []),
            asset?.[dateKey],
        ]
            .filter(Boolean)
            .map((date) => String(date).split("T")[0]);

        if (warrantyDates.length === 0) {
            return "";
        }

        return warrantyDates.reduce((latest, current) => (!latest || new Date(current) > new Date(latest) ? current : latest), "");
    };

    // ไม่มีวันที่ = ถือว่าหมดอายุ
    isWarrantyExpired = (expireDate) => {
        const raw = String(expireDate || "").trim();
        if (!raw) return true;
        const parsed = new Date(raw.split("T")[0]);
        if (isNaN(parsed.getTime())) return true;
        parsed.setHours(0, 0, 0, 0);
        const today = new Date();
        today.setHours(0, 0, 0, 0);
        return parsed < today;
    };

    openEditModal = async (workOrderItem, viewMode = false) => {
        const workOrderId = workOrderItem?.uid;
        if (!workOrderId) {
            return;
        }

        loading(true);
        // ฟอร์มแก้ไขอ่าน dropdown (WR/priority/category ฯลฯ) ตอน map ข้อมูล ต้องให้ master data มาก่อน
        await this.optionsReady;
        try {
            const result = await GET("admin/work-orders", { uid: workOrderId });
            const workOrderDetail = result?.data || workOrderItem;
            const formState = await this.mapWorkOrderDetailToFormState(workOrderDetail);
            // WO ที่ถูก rejected หรือปิดงานสำเร็จ (success) แล้ว ดูได้อย่างเดียว แก้ไขไม่ได้ ไม่ว่าจะเปิดจากทางไหน (list/kanban/calendar)
            const workOrderStatus = String(workOrderDetail?.status || "").toLowerCase();
            const isReadOnlyStatus = ["rejected", "success"].includes(workOrderStatus);
            this.setState({
                modal_create: true,
                wo_view_mode: viewMode || isReadOnlyStatus || !can("wo.update"),
                active_wo: workOrderDetail,
                edit_work_order_id: workOrderId,
                ...formState,
            });
        } finally {
            loading(false);
        }
    };

    sortVisitsByDate = (visits = []) => {
        return [...(visits || [])].sort((a, b) => {
            const aDate = this.getDatePart(a?.start_date || a?.visit_date || "");
            const bDate = this.getDatePart(b?.start_date || b?.visit_date || "");

            if (aDate !== bDate) {
                return String(aDate).localeCompare(String(bDate));
            }

            const aStart = this.getTimePart(a?.start_date || "") || "00:00";
            const bStart = this.getTimePart(b?.start_date || "") || "00:00";
            return String(aStart).localeCompare(String(bStart));
        });
    };

    mapWorkOrderDetailToFormState = async (workOrderDetail) => {
        // dropdown ลูกค้าโหลดตอนค้นหาเท่านั้น จึงต้องดึงลูกค้าของใบนี้มาปักหมุดไว้ก่อน
        await this.loadCustomerOption(workOrderDetail?.customer?.uid || "");
        const visits = this.sortVisitsByDate(Array.isArray(workOrderDetail?.visits) ? workOrderDetail.visits : []);
        const firstVisit = visits[0];
        const lastVisit = visits[visits.length - 1];
        const serviceBomId = workOrderDetail?.service_bom?.uid || workOrderDetail?.bom_master?.uid || workOrderDetail?.service_bom_id || workOrderDetail?.bom_master_id || "";
        const editWorkRequestOption = this.buildEditWorkRequestOption(workOrderDetail);
        // WO ตามแผน PM ที่ถูกสร้างไว้ก่อนระบบใส่ค่า default ให้ จะไม่มีประเภทงาน/ความเร่งด่วนติดมาเลย
        // ทำให้กด "แปลงเป็น WO" ไม่ผ่านเพราะสองช่องนี้บังคับกรอก (ดู CreateUpdate) จึงเติมค่าเริ่มต้นให้เหมือน WO ตามแผนที่สร้างใหม่
        const inspectionDefaultServiceType =
            workOrderDetail?.inspection_plan_id && !workOrderDetail?.service_type?.uid
                ? this.getDefaultPreventiveServiceType()
                : null;
        const serviceTypeId = workOrderDetail?.service_type?.uid || inspectionDefaultServiceType?.value || "";
        const priorityId =
            workOrderDetail?.priority?.uid ||
            workOrderDetail?.work_requisition_priority?.uid ||
            workOrderDetail?.work_requisition_priorities_id ||
            // ความเร่งด่วนตามค่าเริ่มต้นของประเภทงานที่เพิ่งเติมให้ - ตรงกับพฤติกรรมตอนผู้ใช้เลือกประเภทงานเอง
            (inspectionDefaultServiceType ? this.getPriorityIdFromServiceType(inspectionDefaultServiceType) : "");
        const priorityItem = this.state.data_priorities.find((item) => item.value === priorityId || item.uid === priorityId);
        const visitBomIds = Array.from(
            new Set(
                visits
                    .map((visit) => visit?.bom_master?.uid || visit?.bom_id || serviceBomId || "")
                    .filter(Boolean)
            )
        );
        const bomPartsEntries = await Promise.all(
            visitBomIds.map(async (bomUid) => [bomUid, await this.fetchServiceBomParts(bomUid)])
        );
        const bomPartsMap = Object.fromEntries(bomPartsEntries);
        const normalizedVisits = visits.map((visit, index) => {
            const visitServiceBomId = visit?.bom_master?.uid || visit?.bom_id || serviceBomId || "";
            const visitItems = (Array.isArray(visit?.visits_items) ? visit.visits_items : []).map((item) =>
                this.mapVisitItemToPart(item, "visit")
            );
            const { serviceBomParts, manualParts } = this.splitVisitItemsByBom(
                visitItems,
                visitServiceBomId,
                bomPartsMap[visitServiceBomId] || []
            );

            return {
                uid: visit?.uid || `visit_${index + 1}`,
                sequence: visit?.sequence || (index + 1),
                visit_date: this.getDatePart(visit?.start_date || visit?.visit_date),
                technician: this.normalizeTechnicians(
                    (visit?.visits_technicians || []).map((technician) => {
                        if (typeof technician === "string") {
                            return technician;
                        }

                        return technician?.technician?.uid || technician?.technician_id || technician?.uid || "";
                    })
                ),
                time_slot: this.buildTimeSlot(visit?.start_date, visit?.end_date),
                status: visit?.status || "open",
                is_followup: !!visit?.is_followup,
                no_parts_requisition: !!visit?.no_parts_requisition,
                service_bom_id: visitServiceBomId,
                service_bom_parts: serviceBomParts,
                manual_parts: manualParts,
                root_cause: visit?.root_cause || "",
                // สาเหตุหลักที่ช่างเลือกจาก dropdown ในมือถือ (แสดงผลอย่างเดียวในหน้าเว็บ)
                root_cause_type: visit?.root_cause_type || "",
                resolution: visit?.resolution || "",
                parts_notes: visit?.parts_notes || "",
                // หมายเหตุของ PM checklist (กรอกจากมือถือ - แสดงผลอย่างเดียวในหน้าเว็บ)
                pm_notes: visit?.pm_notes || "",
                report_service_type: visit?.report_service_type?.uid || visit?.report_service_type || "",
                report_category: visit?.report_category?.uid || visit?.report_category || "",
                // ความพึงพอใจของลูกค้าตอนจบงาน (กรอกจากมือถือ - แสดงผลอย่างเดียวในหน้าเว็บ)
                customer_signature: visit?.customer_signature || "",
                signee_name: visit?.signee_name || "",
                signee_position: visit?.signee_position || "",
                // อีเมลปลายทางที่ช่างกรอกตอนปิดงาน (ใช้ส่ง service report) - แสดงผลอย่างเดียวในหน้าเว็บ
                signee_email: visit?.signee_email || "",
                customer_rating: visit?.customer_rating ?? null,
                customer_feedback: visit?.customer_feedback || "",
                service_attachments: (Array.isArray(visit?.service_attachments) ? visit.service_attachments : []).map(this.attachmentToItem),
                // บันทึก/รูปตอนช่างเช็คอินหน้างาน (กรอกจากมือถือ - แสดงผลอย่างเดียวในหน้าเว็บ)
                checkin_remark: visit?.checkin_remark || "",
                checkin_attachments: (Array.isArray(visit?.checkin_attachments) ? visit.checkin_attachments : []).map(this.attachmentToItem),
                iat_number: visit?.iat_number || "",
                iat_status: visit?.iat_status || "",
                iat_issued_at: visit?.iat_issued_at || "",
                // ค่าใช้จ่าย (แท็บค่าใช้จ่าย) + snapshot อัตราค่าเดินทาง ณ วันสร้าง visit
                travel_allowance_snapshot: visit?.travel_allowance_snapshot || null,
                travel_vehicle: visit?.travel_vehicle || "",
                // ผลการเข้าเปลี่ยนไส้กรอง (HHU/HQW): null/true = สำเร็จ, false = ไม่สำเร็จ · closed_at/checkin_at ใช้แสดงวันที่ช่างเปลี่ยน (อ่านอย่างเดียว)
                filter_change_result: visit?.filter_change_result ?? null,
                closed_at: visit?.closed_at || "",
                checkin_at: visit?.checkin_at || "",
                travel_cost: visit?.travel_cost ?? "",
                mileage_start: visit?.mileage_start ?? "",
                mileage_end: visit?.mileage_end ?? "",
                // รูปมาตรวัดไมล์ตอนเริ่ม/จบงาน (ถ่ายจากมือถือ - แสดงผลอย่างเดียว)
                mileage_start_photo: visit?.mileage_start_photo || "",
                mileage_end_photo: visit?.mileage_end_photo || "",
                // พิกัดจุดเริ่ม/จุดสิ้นสุด + เส้นทางจริงที่มือถือบันทึกระหว่างเดินทาง (แสดงผลอย่างเดียว)
                start_latitude: visit?.start_latitude ?? null,
                start_longitude: visit?.start_longitude ?? null,
                end_latitude: visit?.end_latitude ?? null,
                end_longitude: visit?.end_longitude ?? null,
                travel_route: Array.isArray(visit?.travel_route) ? visit.travel_route : [],
                travel_distance_km: visit?.travel_distance_km ?? null,
                travel_extras: (Array.isArray(visit?.travel_extras) ? visit.travel_extras : []).map((row, i) => ({
                    uid: `travel_${i}_${Math.random().toString(36).slice(2)}`,
                    type: row?.type || "toll",
                    amount: row?.amount ?? 0,
                })),
                other_costs: (Array.isArray(visit?.other_costs) ? visit.other_costs : []).map((row, i) => ({
                    uid: `other_${i}_${Math.random().toString(36).slice(2)}`,
                    name: row?.name || "",
                    amount: row?.amount ?? 0,
                    category: row?.category || "job",
                })),
                images: (Array.isArray(visit?.attachments) ? visit.attachments : []).filter((a) => a.file_type === "image").map(this.attachmentToItem),
                videos: (Array.isArray(visit?.attachments) ? visit.attachments : []).filter((a) => a.file_type === "video").map(this.attachmentToItem),
                // รูปถ่ายตอนทำ PM checklist (กรอกจากมือถือ) - อยู่ใน attachments ทั่วไปของ visit ร่วมกับไฟล์แนบอื่น แยกด้วยชื่อไฟล์
                pm_checklist_photos: (Array.isArray(visit?.attachments) ? visit.attachments : [])
                    .filter((a) => (a.file_name || "").startsWith("pm-checklist-photo-"))
                    .map(this.attachmentToItem),
            };
        });
        // รูป/วิดีโอของ WO และของแต่ละ visit ต้อง preview ทันทีที่เปิด modal โหลด blob url ผ่าน endpoint ใหม่ให้เสร็จก่อน setState
        const woImages = (Array.isArray(workOrderDetail?.attachments) ? workOrderDetail.attachments : []).filter((a) => a.file_type === "image").map(this.attachmentToItem);
        const woVideos = (Array.isArray(workOrderDetail?.attachments) ? workOrderDetail.attachments : []).filter((a) => a.file_type === "video").map(this.attachmentToItem);
        // เอกสาร (รวมที่คัดลอกมาจาก WR ตอนสร้าง WO) ไม่ preload blob แต่ต้องเก็บใน state ไว้ส่งกลับตอนบันทึก
        // เพราะ sync attachments เป็น full-replace ถ้าไม่ส่งกลับเอกสารจะถูกลบ
        const woDocuments = (Array.isArray(workOrderDetail?.attachments) ? workOrderDetail.attachments : [])
            .filter((a) => a.file_type === "document" || a.file_type === "other")
            .map(this.attachmentToItem);
        await Promise.all([
            this.hydratePreviewUrls(woImages),
            this.hydratePreviewUrls(woVideos),
            ...normalizedVisits.flatMap((visit) => [
                this.hydratePreviewUrls(visit.images),
                this.hydratePreviewUrls(visit.videos),
                this.hydratePreviewUrls(visit.pm_checklist_photos),
                this.hydratePreviewUrls(visit.checkin_attachments),
                this.hydratePreviewUrls(visit.service_attachments),
            ]),
        ]);

        const firstVisitSnapshot = normalizedVisits[0] || null;
        const savedRequisitionMap = {};
        const visitIatMap = {};
        const visitIatStatusMap = {};
        normalizedVisits.forEach((visit) => {
            const partsCount = (visit.service_bom_parts?.length || 0) + (visit.manual_parts?.length || 0);
            if (partsCount > 0) {
                savedRequisitionMap[visit.visit_date] = true;
            }
            if (visit.iat_number) {
                visitIatMap[visit.visit_date] = visit.iat_number;
                visitIatStatusMap[visit.visit_date] = visit.iat_status || "pending";
            }
        });

        return {
            saved_requisition_map: savedRequisitionMap,
            visit_iat_map: visitIatMap,
            visit_iat_status_map: visitIatStatusMap,
            edit_work_request_option: editWorkRequestOption,
            create_work_request_id:
                this.state.data_work_requests.find((item) => item.wr_number === workOrderDetail?.wr_number)?.value || editWorkRequestOption?.value || workOrderDetail?.wr_id || "",
            create_customer_id: workOrderDetail?.customer?.uid || workOrderDetail?.customer_id || "",
            create_asset_id: workOrderDetail?.asset?.uid || workOrderDetail?.asset_id || "",
            create_contact_name: workOrderDetail?.contact_name || "",
            create_contact_phone: workOrderDetail?.contact_phone || "",
            create_contact_name_2: workOrderDetail?.contact_name_2 || "",
            create_contact_phone_2: workOrderDetail?.contact_phone_2 || "",
            create_root_cause: workOrderDetail?.root_cause || "",
            create_work_order_title: workOrderDetail?.title || "",
            create_work_requisition_categories_id: workOrderDetail?.category?.uid || "",
            create_work_requisition_service_types_id: serviceTypeId,
            create_work_requisition_priorities_id: priorityId,
            create_service_bom_id: firstVisitSnapshot?.service_bom_id || serviceBomId,
            create_service_bom_parts: firstVisitSnapshot?.service_bom_parts || [],
            create_manual_parts: firstVisitSnapshot?.manual_parts || [],
            create_manual_part_id: "",
            text_priority_id: this.getPriorityDescription(priorityItem),
            create_start_date: this.getDatePart(workOrderDetail?.start_date || firstVisit?.start_date),
            create_end_date: this.getDatePart(workOrderDetail?.end_date || lastVisit?.end_date || firstVisit?.end_date),
            create_internal_remark: workOrderDetail?.internal_remark || "",
            create_status: workOrderDetail?.status || "open",
            edit_row_version: workOrderDetail?.row_version ?? null,
            edit_source: workOrderDetail?.source ?? null,
            create_checklist_template_id: workOrderDetail?.checklist_template?.uid || "",
            create_checklist_items: Array.isArray(workOrderDetail?.checklist_items)
                ? workOrderDetail.checklist_items.map((item) => ({
                      uid: item.uid || "",
                      checklist_item_id: item.checklist_item_id || "",
                      sequence: item.sequence,
                      description: item.description || "",
                      input_type: item.input_type || "check",
                      is_used: item.is_used !== false,
                      source: item.source || "template",
                      // ผลตรวจที่กรอกจากมือถือ (PM checklist) - แสดงผลอย่างเดียวในหน้าเว็บ
                      is_checked: !!item.is_checked,
                      value: item.value ?? "",
                      // หมายเหตุรายข้อที่ช่างกรอกจากมือถือ - แสดงผลอย่างเดียว (ไม่ส่งกลับตอนบันทึก backend จึงคงค่าเดิม)
                      remark: item.remark ?? "",
                      is_required: !!item.is_required,
                      label_left: item.label_left ?? "",
                      label_right: item.label_right ?? "",
                      unit: item.unit ?? "",
                      min: item.min ?? "",
                      max: item.max ?? "",
                  }))
                : [],
            create_inspection_plan_id: workOrderDetail?.inspection_plan_id || null,
            visits: normalizedVisits,
            selected_visit_date: this.getDatePart(firstVisit?.start_date || firstVisit?.visit_date),
            visit_detail_tab: normalizedVisits.length > 0 ? "technician" : this.state.visit_detail_tab,
            wo_images: woImages,
            wo_videos: woVideos,
            wo_documents: woDocuments,
        };
    };

    buildCreatePayload = (statusOverride, sourceValues = this.state) => {
        const {
            create_work_request_id,
            create_customer_id,
            create_asset_id,
            create_contact_name,
            create_contact_phone,
            create_contact_name_2,
            create_contact_phone_2,
            create_work_order_title,
            create_root_cause,
            create_work_requisition_categories_id,
            create_work_requisition_service_types_id,
            create_work_requisition_priorities_id,
            create_start_date,
            create_end_date,
            create_internal_remark,
            create_status,
            create_checklist_template_id,
            create_checklist_items,
            visits,
        } = sourceValues;
        const resolvedWorkRequestUid = this.resolveWorkRequestUid(create_work_request_id);

        const firstVisit = visits[0];
        const lastVisit = visits[visits.length - 1];
        const firstVisitRange = this.getVisitTimeRange(firstVisit?.time_slot);
        const lastVisitRange = this.getVisitTimeRange(lastVisit?.time_slot);

        return {
            company_id: company?.id || "",
            wr_id: resolvedWorkRequestUid || "",
            customer_id: create_customer_id || "",
            asset_id: create_asset_id || "",
            contact_name: create_contact_name || "",
            contact_phone: create_contact_phone || "",
            contact_name_2: create_contact_name_2 || "",
            contact_phone_2: create_contact_phone_2 || "",
            title: create_work_order_title || "",
            root_cause: create_root_cause || "",
            work_requisition_service_types_id: create_work_requisition_service_types_id || "",
            work_requisition_priorities_id: create_work_requisition_priorities_id || "",
            work_requisition_category_id: create_work_requisition_categories_id || "",
            start_date: this.formatDateTime(create_start_date, firstVisitRange.startTime),
            end_date: this.formatDateTime(create_end_date, lastVisitRange.endTime),
            internal_remark: create_internal_remark || "",
            status: statusOverride || create_status || "draft",
            // optimistic lock - ส่งเฉพาะตอนแก้ไขใบงานที่โหลดมาแล้ว (ใบใหม่ยังไม่มีเวอร์ชัน)
            row_version: sourceValues.edit_row_version ?? undefined,
            checklist_template_id: create_checklist_template_id || "",
            checklist_items: (create_checklist_items || []).map((item, i) => ({
                uid: item.uid || undefined,
                checklist_item_id: item.checklist_item_id || "",
                sequence: item.sequence ?? i + 1,
                description: item.description || "",
                input_type: item.input_type || "Inspection",
                is_used: item.is_used !== false,
                source: item.source || "template",
                is_required: !!item.is_required,
                // ค่าตั้งค่าเฉพาะข้อที่เพิ่มเอง (manual) - null = ล้างค่า
                ...(item.source === "manual"
                    ? {
                          label_left: item.label_left || null,
                          label_right: item.label_right || null,
                          unit: item.unit || null,
                          min: item.min === "" || item.min == null || Number.isNaN(Number(item.min)) ? null : Number(item.min),
                          max: item.max === "" || item.max == null || Number.isNaN(Number(item.max)) ? null : Number(item.max),
                      }
                    : {}),
            })),
            visits: visits.map((visit, index) => {
                const visitRange = this.getVisitTimeRange(visit.time_slot);

                return {
                    uid: visit?.uid || undefined,
                    sequence: index + 1,
                    start_date: this.formatDateTime(visit.visit_date, visitRange.startTime),
                    end_date: this.formatDateTime(visit.visit_date, visitRange.endTime),
                    // เช็กจาก create_status เดิมเป็น draft เท่านั้น กัน save ปกติของ WO ที่ open อยู่แล้วไปทับสถานะ visit ที่ทำงานไปแล้ว (check_in/check_out/close_job ฯลฯ)
                    status: this.resolveVisitSaveStatus(visit, { createStatus: create_status, statusOverride }),
                    no_parts_requisition: !!visit?.no_parts_requisition,
                    root_cause: visit?.root_cause || "",
                    // สาเหตุหลักจากมือถือ - เว็บไม่มี UI แก้ไข ส่งค่าเดิมกลับไปกันหาย
                    root_cause_type: visit?.root_cause_type || "",
                    resolution: visit?.resolution || "",
                    parts_notes: visit?.parts_notes || "",
                    report_service_type: visit?.report_service_type?.uid || visit?.report_service_type || "",
                    report_category: visit?.report_category?.uid || visit?.report_category || "",
                    // ความพึงพอใจของลูกค้าตอนจบงาน - เว็บไม่มี UI แก้ไข ส่งค่าเดิมกลับไปกันหาย
                    signee_name: visit?.signee_name || "",
                    signee_position: visit?.signee_position || "",
                    signee_email: visit?.signee_email || "",
                    customer_rating: this.toNullableNumber(visit?.customer_rating),
                    customer_feedback: visit?.customer_feedback || "",
                    bom_id: visit?.service_bom_id || "",
                    // ค่าใช้จ่าย (แท็บค่าใช้จ่าย)
                    travel_vehicle: visit?.travel_vehicle || "",
                    filter_change_result: visit?.filter_change_result ?? null,
                    travel_cost: this.toNullableNumber(visit?.travel_cost),
                    mileage_start: this.toNullableNumber(visit?.mileage_start),
                    mileage_end: this.toNullableNumber(visit?.mileage_end),
                    travel_extras: (visit?.travel_extras || []).map((row) => ({
                        type: row.type || "",
                        amount: Number(row.amount) || 0,
                    })),
                    other_costs: (visit?.other_costs || []).map((row) => ({
                        name: row.name || "",
                        amount: Number(row.amount) || 0,
                        category: row.category || "",
                    })),
                    // ไม่เบิกอะไหล่ -> ส่ง visits_items ว่างเสมอ ไม่ว่า state จะมีอะไหล่ค้างอยู่หรือไม่
                    visits_items: visit?.no_parts_requisition
                        ? []
                        : [
                              ...(visit?.service_bom_parts || []).map((part) => ({
                                  ...part,
                                  resolved_bom_id: part.bom_id || visit?.service_bom_id || null,
                              })),
                              ...(visit?.manual_parts || []).map((part) => ({
                                  ...part,
                                  resolved_bom_id: null,
                              })),
                          ]
                              .filter((part) => part.part_id && Number(part.quantity) > 0 && part.is_active !== false)
                              .map((part) => ({
                                  uid: this.isTempUnitUid(part.uid) ? undefined : part.uid,
                                  bom_id: part.resolved_bom_id,
                                  part_id: part.part_id,
                                  quantity: Number(part.quantity) || 0,
                                  actual_quantity: this.toNullableNumber(part.actual_quantity),
                                  uom_id: part.uom_id || "",
                                  lot: part.lot || "",
                                  stock_lot_id: part.stock_lot_id || null,
                                  wbs_element: part.wbs_element || null,
                                  exp_date: part.exp_date || null,
                                  stock_quantity: part.stock_quantity === null || part.stock_quantity === undefined || part.stock_quantity === "" ? null : Number(part.stock_quantity),
                                  price: this.toNullableNumber(part.price),
                                  is_active: part.is_active !== false,
                                  status: "pending",
                              })),
                    visits_technicians: this.normalizeTechnicians(visit.technician)
                        .map((technicianName) => this.getTechnicianUidByName(technicianName))
                        .filter(Boolean),
                };
            }),
        };
    };

    /**
     * ก่อนปิดงาน WO WBS: GET เอกสารเบิก WBS สดๆ แล้วหาบรรทัดสถานะ ok ที่มีของเหลือ (เบิก - ใช้จริง - คืนแล้ว > 0 รวมกรณีใช้จริง = 0)
     * ของเหลือเหล่านี้ backend จะคืนเข้า SAP อัตโนมัติตอนปิดงาน - คืนค่า null = ไม่ใช่ WBS/ไม่มีของเหลือ (ไม่ต้องเตือน),
     * true = ผู้ใช้ยืนยัน, false = ผู้ใช้ยกเลิก
     */
    confirmWbsReturnOnClose = async (woUid) => {
        const escHtml = (v) => String(v ?? "").replace(/[&<>"]/g, (c) => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;" })[c]);
        const res = await GET("admin/wo-wbs-issues", { wo_uid: woUid }, true, { skipAccessDeniedAlert: true });
        const docs = res?.status && Array.isArray(res.data) ? res.data : [];
        const lines = [];
        docs.filter((d) => d.status === "ok").forEach((d) =>
            (d.items || []).forEach((i) => {
                const remaining = Number(i.qty || 0) - Number(i.used_qty || 0) - Number(i.returned_qty || 0);
                if (remaining > 0) lines.push({ doc_no: d.doc_no, part_number: i.part_number, part_name: i.part_name, uom_name: i.uom_name, remaining, used: Number(i.used_qty || 0) });
            }),
        );
        if (!lines.length) return null;
        const rows = lines
            .map(
                (l) =>
                    `<tr><td style="padding:2px 6px">${escHtml(l.doc_no)}</td><td style="padding:2px 6px">${escHtml(l.part_number)} ${escHtml(l.part_name)}</td><td style="padding:2px 6px;text-align:right"><b>${escHtml(formatNumber(l.remaining))}</b> ${escHtml(l.uom_name || "")}</td></tr>`,
            )
            .join("");
        const html = `<div style="text-align:left;font-size:14px"><div style="margin-bottom:8px">${escHtml(t("wo_close_wbs_return_body"))}</div><table style="width:100%;font-size:13px">${rows}</table><div style="margin-top:10px;color:#b91c1c;font-weight:600">${escHtml(t("wo_close_wbs_return_warn"))}</div></div>`;
        return !!(await alert("", "warning", t("wo_close_wbs_return_title"), "", t("complete_job"), t("cancel"), { html }));
    };

    CreateUpdate = async (statusOverride = "draft") => {
        const {
            edit_work_order_id,
            create_customer_id,
            create_asset_id,
            create_root_cause,
            create_work_requisition_service_types_id,
            create_work_requisition_priorities_id,
            create_work_requisition_categories_id,
            create_start_date,
            create_end_date,
            visits,
        } = this.state;

        // WO จากแผนการตรวจสอบไม่มีหมวดหมู่คำร้อง/อาการที่แจ้ง (ซ่อน input ไว้) จึงไม่บังคับกรอกสองช่องนี้
        const skipRequisitionFields = this.isInspectionPlanWorkOrder();

        // ยกเลิก WO ทำได้เฉพาะตอนยังไม่มี visit เลย จึงไม่บังคับให้ต้องมี visit เหมือน flow อื่น
        if (
            !create_customer_id ||
            !create_asset_id ||
            (!skipRequisitionFields && !create_root_cause) ||
            !create_work_requisition_service_types_id ||
            !create_work_requisition_priorities_id ||
            (!skipRequisitionFields && !create_work_requisition_categories_id) ||
            !create_start_date ||
            !create_end_date ||
            (statusOverride !== "rejected" && visits.length === 0)
        ) {
            alert("", "warning", t("warning"), t("please_fill_required"));
            return;
        }

        // ปิดงาน WO WBS: เตือนก่อนว่าของเหลือจะถูกคืนเข้า SAP อัตโนมัติ (คืนแล้วแก้ไม่ได้) - ยืนยันแล้วไม่ต้องถามซ้ำด้วย confirm_submission
        let closeWarnConfirmed = false;
        // WO Normal Sales ไม่ใช่ WBS จึงไม่ต้อง GET เอกสาร WBS
        if (statusOverride === "success" && edit_work_order_id && !this.isNormalSalesWorkOrder()) {
            const closeWarn = await this.confirmWbsReturnOnClose(edit_work_order_id);
            if (closeWarn === false) return;
            closeWarnConfirmed = closeWarn === true;
        }

        if (closeWarnConfirmed || (await alert("", "info", t("confirm"), t("confirm_submission"), t("confirm"), t("cancel")))) {
            loading(true);

            // อัปโหลดไฟล์แนบทีละไฟล์ (WO-level + ของแต่ละ visit) ผ่าน presigned URL -> fallback base64
            // เพื่อนำ path กลับมาใส่ใน body ก่อนบันทึกข้อมูลทั้งหมด
            const woImages = await this.uploadAttachments(this.state.wo_images, "work-orders/images", "image");
            const woVideos = await this.uploadAttachments(this.state.wo_videos, "work-orders/videos", "video");
            const woDocuments = await this.uploadAttachments(this.state.wo_documents, "work-orders/documents", "document");
            if (woImages === null || woVideos === null || woDocuments === null) {
                loading(false);
                return;
            }

            const visitAttachments = [];
            for (const visit of visits) {
                const vImages = await this.uploadAttachments(visit.images, "visits/images", "image");
                const vVideos = await this.uploadAttachments(visit.videos, "visits/videos", "video");
                if (vImages === null || vVideos === null) {
                    loading(false);
                    return;
                }
                visitAttachments.push([...vImages, ...vVideos]);
            }

            const body = this.buildCreatePayload(statusOverride);
            body.attachments = [...woImages, ...woVideos, ...woDocuments];
            body.visits = body.visits.map((visit, index) => ({ ...visit, attachments: visitAttachments[index] || [] }));

            const result = !edit_work_order_id ? await POST("admin/work-orders", body) : await PUT("admin/work-orders/" + edit_work_order_id, body);

            if (result?.status === true) {
                // แปลงเป็น WO จากแผนการตรวจสอบสำเร็จ -> ปิด modal กลับไปหน้าแผนเลย ไม่ต้องโหลดข้อมูลกลับเข้า modal
                if (this.state.from_inspection && statusOverride === "open") {
                    loading(false);
                    await alert("", "success", t("success"));
                    this.closeCreateModal();
                    return;
                }

                alert("", "success", t("success"));
                // โหลดข้อมูลที่อัปเดตใหม่กลับเข้า modal โดยไม่ปิดหน้าต่าง
                const savedId = edit_work_order_id || result?.data?.uid || result?.data?.id || result?.data?.work_order?.uid || "";
                await this.reloadWorkOrderInModal(savedId);
                if (statusOverride === "rejected") {
                    // ยกเลิก WO สำเร็จแล้ว เหลือแค่ปุ่มปิดใน modal ไม่ให้แก้ไข/กดปุ่มอื่นต่อได้อีก
                    this.setState({ wo_view_mode: true });
                }
                this.Get(this.state.page);
                // บันทึกแล้ว คำร้องที่ผูกไว้ถูกเก็บจริงแล้ว จึงเอาข้อความเตือน "ยังไม่ได้บันทึก" ออก และรีเฟรช dropdown ให้คำร้องใบนี้หลุดออกไป
                if (this.state.work_request_link_dirty) {
                    await this.refreshWorkRequestOptions();
                    this.setState({ work_request_link_dirty: false });
                }
            } else if (!(await this.handleStaleWorkOrder(result))) {
                alert("", "warning", t("warning"), result?.message || t("error_occurred"));
            }

            loading(false);
        }
    };

    saveWorkOrderSilently = async ({ allowEmptyVisits = false } = {}) => {
        const {
            edit_work_order_id,
            create_customer_id,
            create_asset_id,
            create_root_cause,
            create_work_requisition_service_types_id,
            create_work_requisition_priorities_id,
            create_work_requisition_categories_id,
            create_start_date,
            create_end_date,
            visits,
        } = this.state;

        // WO จากแผนการตรวจสอบไม่มีหมวดหมู่คำร้อง/อาการที่แจ้ง (ซ่อน input ไว้) จึงไม่บังคับกรอกสองช่องนี้
        const skipRequisitionFields = this.isInspectionPlanWorkOrder();

        if (
            !create_customer_id ||
            !create_asset_id ||
            (!skipRequisitionFields && !create_root_cause) ||
            !create_work_requisition_service_types_id ||
            !create_work_requisition_priorities_id ||
            (!skipRequisitionFields && !create_work_requisition_categories_id) ||
            !create_start_date ||
            !create_end_date ||
            (!allowEmptyVisits && visits.length === 0)
        ) {
            alert("", "warning", t("warning"), t("please_fill_required"));
            return false;
        }

        const woImages = await this.uploadAttachments(this.state.wo_images, "work-orders/images", "image");
        const woVideos = await this.uploadAttachments(this.state.wo_videos, "work-orders/videos", "video");
        const woDocuments = await this.uploadAttachments(this.state.wo_documents, "work-orders/documents", "document");
        if (woImages === null || woVideos === null || woDocuments === null) return false;

        const visitAttachments = [];
        for (const visit of visits) {
            const vImages = await this.uploadAttachments(visit.images, "visits/images", "image");
            const vVideos = await this.uploadAttachments(visit.videos, "visits/videos", "video");
            if (vImages === null || vVideos === null) return false;
            visitAttachments.push([...vImages, ...vVideos]);
        }

        const body = this.buildCreatePayload();
        body.attachments = [...woImages, ...woVideos, ...woDocuments];
        body.visits = body.visits.map((visit, index) => ({ ...visit, attachments: visitAttachments[index] || [] }));

        const result = !edit_work_order_id
            ? await POST("admin/work-orders", body)
            : await PUT("admin/work-orders/" + edit_work_order_id, body);

        if (result?.status === true) {
            const savedId = edit_work_order_id || result?.data?.uid || "";
            await this.reloadWorkOrderInModal(savedId);
            // await ให้ Get เสร็จก่อน return — Get toggle loading(true→false) เอง ถ้าไม่ await มันจะไปปิด loading
            // ระหว่างที่ผู้เรียก (เช่น handleCreateSapTransferOrder) กำลังทำงานต่อ ทำให้ตัวโหลดหายกลางคัน
            await this.Get(this.state.page);
            await this.refreshWorkRequestOptions();
            this.setState({ work_request_link_dirty: false });
            return true;
        }

        // บันทึกไม่ผ่านทั้งที่เพิ่งผูกคำร้อง = อาจโดนคนอื่นใช้คำร้องใบนั้นไปก่อน โหลดรายการใหม่ให้ตัวเลือกตรงกับของจริง
        if (this.state.work_request_link_dirty) {
            await this.refreshWorkRequestOptions();
        }

        if (!(await this.handleStaleWorkOrder(result))) {
            alert("", "warning", t("warning"), result?.message || t("error_occurred"));
        }
        return false;
    };

    // 409 optimistic lock: ใบงานถูกบันทึกจากที่อื่นไปแล้ว (เช่น ช่างปิดงานจากมือถือขณะ modal เปิดค้าง)
    // แจ้งให้รู้ก่อนว่าสิ่งที่แก้ไว้ยังไม่ถูกบันทึก แล้วค่อยโหลดข้อมูลล่าสุดเข้า modal เดิม (คง visit/แท็บที่เลือกไว้)
    // ไม่โหลดเงียบ ๆ เพราะผู้ใช้จะไม่รู้ว่าค่าที่กรอกหายไปไหน และไม่ให้เลือก "เขียนทับ" เพราะจะทับข้อมูลที่ใหม่กว่า
    handleStaleWorkOrder = async (result) => {
        if (result?.errors?.code !== "STALE_DATA") return false;
        await alert("", "warning", t("work_order_outdated"), t("work_order_updated_elsewhere"), t("confirm"));
        loading(true);
        await this.reloadWorkOrderInModal(this.state.edit_work_order_id);
        await this.Get(this.state.page);
        loading(false);
        return true;
    };

    // นำข้อมูล Work Order detail ที่ได้มา map กลับเข้า state ของ modal (คง Visit/แท็บที่เลือกไว้)
    applyWorkOrderDetail = async (workOrderDetail) => {
        if (!workOrderDetail) return;
        const previousSelectedVisit = this.state.selected_visit_date;
        const previousTab = this.state.visit_detail_tab;

        const formState = await this.mapWorkOrderDetailToFormState(workOrderDetail);
        const keepSelectedVisit = (formState.visits || []).some((visit) => visit.visit_date === previousSelectedVisit)
            ? previousSelectedVisit
            : formState.selected_visit_date;

        this.setState({
            active_wo: workOrderDetail,
            edit_work_order_id: workOrderDetail.uid || this.state.edit_work_order_id,
            ...formState,
            selected_visit_date: keepSelectedVisit,
            visit_detail_tab: previousTab,
            ...this.getVisitPartsFieldState((formState.visits || []).find((visit) => visit.visit_date === keepSelectedVisit) || null),
        });
    };

    // ดึงข้อมูล Work Order ล่าสุดกลับเข้า modal (ไม่ปิดหน้าต่าง) เพื่อทำงานต่อเนื่องได้ทันที
    reloadWorkOrderInModal = async (workOrderId) => {
        if (!workOrderId) return;
        try {
            const detailResult = await GET("admin/work-orders", { uid: workOrderId });
            await this.applyWorkOrderDetail(detailResult?.data);
        } catch (error) {
            // หากโหลดใหม่ไม่สำเร็จ ให้คงข้อมูลที่แก้ไขอยู่ใน modal ต่อไป (ไม่ปิดหน้าต่าง)
            console.error("reloadWorkOrderInModal failed", error);
        }
    };

    // defaultStatus = สถานะของ visit ที่ "เกิดใหม่" ในช่วง (visit เดิมคงสถานะตัวเองไว้เสมอ)
    // WO ที่ยังเป็น draft ต้องได้ visit ใหม่เป็น draft ตามไปด้วย ไม่ใช่ open
    getDateRangeVisits = (startDate, endDate, currentVisits = [], defaultStatus = "open") => {
        if (!startDate || !endDate) {
            return [];
        }

        const start = new Date(startDate);
        const end = new Date(endDate);

        if (Number.isNaN(start.getTime()) || Number.isNaN(end.getTime()) || start > end) {
            return [];
        }

        const visits = [];
        const visitMap = new Map((currentVisits || []).map((visit) => [visit.visit_date, visit]));
        const cursor = new Date(start);

        while (cursor <= end) {
            const visitDate = cursor.toISOString().split("T")[0];
            const existingVisit = visitMap.get(visitDate);

            visits.push({
                ...existingVisit,
                visit_date: visitDate,
                technician: this.normalizeTechnicians(existingVisit?.technician).length > 0 ? this.normalizeTechnicians(existingVisit?.technician) : [],
                time_slot: existingVisit?.time_slot || this.visitTimeOptions[0],
                status: existingVisit?.status || defaultStatus,
                service_bom_id: existingVisit?.service_bom_id || "",
                service_bom_parts: Array.isArray(existingVisit?.service_bom_parts) ? existingVisit.service_bom_parts : [],
                manual_parts: Array.isArray(existingVisit?.manual_parts) ? existingVisit.manual_parts : [],
                no_parts_requisition: existingVisit?.no_parts_requisition || false,
            });

            cursor.setDate(cursor.getDate() + 1);
        }

        return this.adoptUndatedVisit(visits, currentVisits);
    };

    /**
     * Visit ที่ยังไม่มีวันที่ = Visit ตั้งต้นที่ถืออะไหล่ซึ่งขอเบิกมากับใบคำร้อง (ใบงานที่เกิดจากการปิดคำร้องยังไม่มีวันนัด)
     * พอผู้ใช้กำหนดช่วงวันที่ ให้ย้ายเข้าไปเป็น Visit ของ "วันแรก" เสมอ อะไหล่ที่ขอเบิกจะได้อยู่ใน Visit แรก
     * ไม่ว่าผู้ใช้จะเลือกวันที่เริ่มต้นหรือวันที่สิ้นสุดก่อน (ไม่งั้น visit นี้จะหลุดจากช่วงแล้วอะไหล่หายไปเงียบ ๆ)
     * วันแรกมี visit จริงอยู่แล้ว (มี uid) = ไม่ทับ ย้ายแค่อะไหล่ไปรวมไว้
     */
    adoptUndatedVisit = (rangeVisits = [], currentVisits = []) => {
        const undatedVisit = (currentVisits || []).find((visit) => !visit?.visit_date);
        if (!undatedVisit || !rangeVisits.length) return rangeVisits;

        const [firstVisit, ...restVisits] = rangeVisits;
        if (!firstVisit.uid) {
            return [{ ...undatedVisit, visit_date: firstVisit.visit_date, time_slot: undatedVisit.time_slot || firstVisit.time_slot }, ...restVisits];
        }

        return [
            {
                ...firstVisit,
                no_parts_requisition: false,
                service_bom_parts: [...(firstVisit.service_bom_parts || []), ...(undatedVisit.service_bom_parts || [])],
                manual_parts: [...(firstVisit.manual_parts || []), ...(undatedVisit.manual_parts || [])],
            },
            ...restVisits,
        ];
    };

    // Visit ที่มีวันนัดแล้วจริง ๆ (ไม่นับ Visit ตั้งต้นที่ถือแค่อะไหล่จากใบคำร้อง)
    hasScheduledVisits = (visits = this.state.visits) => (visits || []).some((visit) => !!visit?.visit_date);

    // เลื่อนวันที่แบบ ISO string ("YYYY-MM-DD") ไปข้างหน้า/ถอยหลังตามจำนวนวันที่ระบุ
    shiftDateString = (dateStr, days) => {
        if (!dateStr) {
            return dateStr;
        }
        const date = new Date(dateStr);
        if (Number.isNaN(date.getTime())) {
            return dateStr;
        }
        date.setDate(date.getDate() + days);
        return date.toISOString().split("T")[0];
    };

    // เช็กว่าสถานะ visit เป็น open อยู่หรือไม่ (ยังไม่เริ่มงาน) - ใช้เป็นเงื่อนไขแก้ไข "วันที่เริ่มต้น" ไม่ว่าจะมีกี่ visit ก็ตาม
    isVisitOpenStatus = (visit) => ["", "open"].includes(String(visit?.status || "open").toLowerCase());

    // ทุก visit ยังเป็นสถานะ open (ยังไม่เริ่มงานสักตัว) -> ยังย่อ "วันที่สิ้นสุด" กลับได้ถึงวันที่เริ่มต้น
    areAllVisitsOpen = (visits = []) => (visits || []).every((visit) => this.isVisitOpenStatus(visit));

    // visit ตัวล่าสุดของช่วง (วันที่มากที่สุด) - ใช้เป็นฐานของเงื่อนไขแก้ไข "วันที่สิ้นสุด" กรณีต้องติดตามงานต่อ
    getLastVisit = (visits = []) =>
        (visits || []).reduce(
            (latest, visit) => (!latest || String(visit?.visit_date || "") > String(latest?.visit_date || "") ? visit : latest),
            null
        );

    // visit ตัวล่าสุดถูกระบุว่าต้องติดตามงานต่อ (follow-up) -> ปลดล็อกให้ขยาย "วันที่สิ้นสุด" ออกไปได้
    // แม้ visit จะเลยสถานะ open/assigned ไปแล้วหรือมีเลข IAT แล้วก็ตาม (แต่ขยายได้แค่วันที่ >= วันของ visit ตัวล่าสุด)
    isFollowupEndDateExtendable = (visits = []) => !!this.getLastVisit(visits)?.is_followup;

    // WO ตัวนี้ถูกสร้างมาจากแผนการตรวจสอบหลัก (ไม่ได้มาจากคำร้อง)
    // -> ไม่มีหมวดหมู่คำร้องและอาการที่แจ้ง จึงซ่อนสองช่องนั้นและไม่บังคับกรอกตอนบันทึก
    isInspectionPlanWorkOrder = () => !!this.state.create_inspection_plan_id;

    // WO ที่ระบบสร้างจากแผนการตรวจสอบและยัง "draft" อยู่ -> เลื่อนวันที่เริ่มต้น/สิ้นสุดได้อิสระ
    // แต่ต้องอยู่ภายใน "เดือนของ WO ตัวนั้น" เท่านั้น (เช่น WO เดือน ส.ค. 2569 ย้ายได้แค่ในเดือน ส.ค. 2569)
    // ยึดเดือนจากวันที่ของ WO ที่โหลดมาจาก server ไม่ใช่ค่าที่กำลังแก้ในฟอร์ม ขอบเขตจะได้ไม่ไหลตามที่เพิ่งเลือก
    // การแก้ไขมีผลกับ WO ตัวนี้ตัวเดียว ไม่แตะแผนและไม่แตะ WO เดือนอื่น
    getInspectionDraftMonthRange = () => {
        const { create_inspection_plan_id, create_status, active_wo, wo_view_mode } = this.state;
        if (wo_view_mode || !create_inspection_plan_id) return null;
        if (String(create_status || "").toLowerCase() !== "draft") return null;

        const anchor = this.getDatePart(active_wo?.start_date || active_wo?.visits?.[0]?.start_date || "");
        if (!anchor) return null;

        const month = anchor.slice(0, 7); // "YYYY-MM"
        const lastDay = new Date(Number(anchor.slice(0, 4)), Number(anchor.slice(5, 7)), 0).getDate();
        return { month, first: `${month}-01`, last: `${month}-${String(lastDay).padStart(2, "0")}` };
    };

    // ป้ายชื่อเดือน (ค.ศ.) ของขอบเขตด้านบน ใช้ในข้อความเตือน/คำอธิบายใต้ช่องวันที่ เช่น "สิงหาคม 2026"
    getInspectionDraftMonthLabel = (monthRange) => (monthRange ? format_date(monthRange.first, "mmmm yyyy", "th") : "");

    // แก้ไขวันที่เริ่มต้น/สิ้นสุดของช่วง visit ทั้งหมด ตามเงื่อนไข:
    // 1) วันที่เริ่มต้น -> แก้ไขได้ก็ต่อเมื่อ "ทุก visit" เป็นสถานะ open เท่านั้น ไม่ว่าจะมีกี่ visit ก็ตาม
    //    ถ้ามีมากกว่า 1 visit ต้อง confirm ก่อนว่าจะเคลียร์ข้อมูลทุก visit ทิ้งทั้งหมด (สร้าง visit ใหม่ล้วนในช่วงใหม่)
    //    ถ้ามีแค่ 0-1 visit ข้อมูลของ visit เดิม (ถ้ามี) จะย้ายไปอยู่ที่วันที่เริ่มต้นเสมอ วันอื่นที่เพิ่มมาใหม่ (ไปทางวันที่สิ้นสุด) จะเป็น visit ว่าง ๆ
    // 2) วันที่สิ้นสุด -> แก้ไขได้ตราบใดที่ยังปิดงานไม่สำเร็จครบทุก visit (ล็อกเมื่อทุก visit เป็น completed/success แล้วเท่านั้น)
    //    เลือกได้แค่วันที่ >= วันที่สิ้นสุดเดิม (ย่อช่วงกลับไม่ได้) และห้ามแตะ/สร้าง visit เดิมซ้ำ - เพิ่ม visit ใหม่ต่อจากวันที่สิ้นสุดเดิมไปข้างหน้าเท่านั้น ไม่มี confirm
    //    ยกเว้น "ทุก visit ยังเป็นสถานะ open" -> ย่อวันที่สิ้นสุดกลับได้ถึงวันที่เริ่มต้น (visit ที่เลยช่วงใหม่จะถูกตัดทิ้ง มี confirm ก่อน)
    updateVisitRange = async (field, value) => {
        if (!value) return;

        const { visits } = this.state;
        const visitCount = visits.length;

        // WO จากแผนการตรวจสอบที่ยังเป็น draft: เลื่อนวันได้อิสระ (ทั้งเลื่อนไปข้างหน้าและย้อนกลับ)
        // แต่ต้องอยู่ภายในเดือนของ WO ตัวเองเท่านั้น และมีผลกับ WO ตัวนี้ตัวเดียว
        const inspectionDraftMonth = this.getInspectionDraftMonthRange();
        if (inspectionDraftMonth) {
            if (value < inspectionDraftMonth.first || value > inspectionDraftMonth.last) {
                // เด้งค่าในช่อง DatePicker กลับเป็นค่าเดิม (กันเคสพิมพ์วันที่นอกเดือนเข้ามาเอง ไม่ได้กดจากปฏิทิน)
                this.forceUpdate();
                return alert(
                    "",
                    "warning",
                    t("warning"),
                    t("inspection_draft_month_only").replace("{month}", this.getInspectionDraftMonthLabel(inspectionDraftMonth))
                );
            }

            this.setState((prevState) => {
                let nextStartDate = field === "create_start_date" ? value : prevState.create_start_date || value;
                let nextEndDate = field === "create_end_date" ? value : prevState.create_end_date || value;

                // ดันอีกฝั่งตามให้ช่วงถูกต้องเสมอ (ยังอยู่ในเดือนเดิม เพราะทั้งคู่ถูก clamp ไว้แล้ว)
                if (nextEndDate < nextStartDate) {
                    if (field === "create_start_date") nextEndDate = nextStartDate;
                    else nextStartDate = nextEndDate;
                }

                // WO ยังเป็น draft อยู่ -> visit ที่เกิดใหม่จากการขยายช่วงต้องเป็น draft ตามไปด้วย
                let nextVisits = this.getDateRangeVisits(nextStartDate, nextEndDate, prevState.visits, "draft");

                // draft จากแผนมี visit เดียวเสมอ -> ย้าย visit เดิม (พร้อม uid/ช่างที่ผูกไว้) ไปที่วันเริ่มต้นใหม่ ไม่ใช่สร้างใหม่ทับ
                const movedVisit = prevState.visits.length === 1 ? prevState.visits[0] : null;
                if (movedVisit) {
                    nextVisits = nextVisits.map((visit) =>
                        visit.visit_date === nextStartDate ? { ...movedVisit, visit_date: nextStartDate } : visit
                    );
                }

                return {
                    create_start_date: nextStartDate,
                    create_end_date: nextEndDate,
                    visits: nextVisits,
                    selected_visit_date: nextVisits.some((visit) => visit.visit_date === prevState.selected_visit_date)
                        ? prevState.selected_visit_date
                        : nextVisits[0]?.visit_date || "",
                };
            });
            return;
        }

        if (field === "create_end_date") {
            const { create_end_date } = this.state;
            const lastVisit = this.getLastVisit(visits);

            // ล็อกเฉพาะตอนที่ทุก visit ปิดงานสำเร็จแล้วเท่านั้น
            if (this.areAllVisitsCompleted(visits)) return;

            if (lastVisit?.is_followup) {
                // visit ตัวล่าสุดต้องติดตามงานต่อ -> เลือกได้แค่วันที่ >= วันของ visit ตัวล่าสุดเท่านั้น (ย้อนหลังไม่ได้)
                if (lastVisit.visit_date && value < lastVisit.visit_date) return;
            } else if (create_end_date && value < create_end_date) {
                // ปกติวันที่สิ้นสุดใหม่ต้อง >= วันที่สิ้นสุดเดิม (ย่อช่วงกลับไม่ได้ กันข้อมูล visit ท้ายช่วงหาย)
                // ยกเว้นกรณีทุก visit ยังเป็นสถานะ open (ยังไม่มีงานเดินสักตัว) -> ย่อกลับได้ถึง "วันที่เริ่มต้น"
                const { create_start_date } = this.state;
                if (!this.areAllVisitsOpen(visits)) return;
                if (create_start_date && value < create_start_date) return;

                if (!(await alert("", "warning", t("confirm"), t("confirm_shrink_visits_change_end_date"), t("confirm"), t("cancel")))) {
                    // เด้งค่าในช่อง DatePicker กลับเป็นค่าเดิมเมื่อผู้ใช้ยกเลิก
                    this.forceUpdate();
                    return;
                }

                this.setState((prevState) => {
                    // ตัด visit ที่เลยวันที่สิ้นสุดใหม่ออก แต่คงข้อมูลของ visit ที่ยังอยู่ในช่วงไว้เหมือนเดิม
                    const nextVisits = this.getDateRangeVisits(prevState.create_start_date || value, value, prevState.visits);
                    return {
                        create_end_date: value,
                        visits: nextVisits,
                        selected_visit_date: nextVisits.some((visit) => visit.visit_date === prevState.selected_visit_date)
                            ? prevState.selected_visit_date
                            : nextVisits[0]?.visit_date || "",
                    };
                });
                return;
            }

            this.setState((prevState) => {
                // ยังไม่เคยมี visit เลย -> generate ช่วงใหม่ปกติ
                if (prevState.visits.length === 0 || !prevState.create_end_date) {
                    const nextStartDate = prevState.create_start_date || value;
                    const nextVisits = this.getDateRangeVisits(nextStartDate, value, prevState.visits);
                    return {
                        create_start_date: nextStartDate,
                        create_end_date: value,
                        visits: nextVisits,
                        selected_visit_date: nextVisits.some((visit) => visit.visit_date === prevState.selected_visit_date)
                            ? prevState.selected_visit_date
                            : "",
                    };
                }

                // มี visit อยู่แล้ว -> ห้ามแตะ/สร้างทับของเดิม เพิ่ม visit ใหม่ต่อจาก visit ตัวล่าสุด (หรือวันที่สิ้นสุดเดิม แล้วแต่อันไหนมาทีหลัง) ไปข้างหน้าเท่านั้น
                const lastVisitDate = this.getLastVisit(prevState.visits)?.visit_date || "";
                const appendAnchorDate = lastVisitDate > prevState.create_end_date ? lastVisitDate : prevState.create_end_date;
                const additionalVisits = this.getDateRangeVisits(this.shiftDateString(appendAnchorDate, 1), value, []);
                return {
                    create_end_date: value,
                    visits: [...prevState.visits, ...additionalVisits],
                };
            });
            return;
        }

        // field === "create_start_date"
        if (!visits.every((visit) => this.isVisitOpenStatus(visit))) {
            return;
        }

        if (visitCount > 1) {
            if (!(await alert("", "warning", t("confirm"), t("confirm_clear_visits_change_start_date"), t("confirm"), t("cancel")))) return;

            this.setState((prevState) => {
                const nextEndDate = prevState.create_end_date && prevState.create_end_date >= value ? prevState.create_end_date : value;
                const nextVisits = this.getDateRangeVisits(value, nextEndDate, []);
                return {
                    create_start_date: value,
                    create_end_date: nextEndDate,
                    visits: nextVisits,
                    selected_visit_date: "",
                };
            });
            return;
        }

        this.setState((prevState) => {
            const existingSingleVisit = prevState.visits.length === 1 ? prevState.visits[0] : null;

            const nextStartDate = value;
            let nextEndDate = prevState.create_end_date;

            if (value && (!nextEndDate || nextEndDate < value)) {
                nextEndDate = value;
            }

            let nextVisits = this.getDateRangeVisits(nextStartDate, nextEndDate, existingSingleVisit ? [] : prevState.visits);

            // มีแค่ 1 visit เดิม -> ข้อมูลเดิมย้ายไปอยู่ที่วันที่เริ่มต้นเสมอ (วันอื่นในช่วงเป็น visit ใหม่ว่าง ๆ)
            if (existingSingleVisit) {
                nextVisits = nextVisits.map((visit) =>
                    visit.visit_date === nextStartDate ? { ...existingSingleVisit, visit_date: nextStartDate } : visit
                );
            }

            return {
                create_start_date: nextStartDate,
                create_end_date: nextEndDate,
                visits: nextVisits,
                selected_visit_date: existingSingleVisit
                    ? nextStartDate
                    : nextVisits.some((visit) => visit.visit_date === prevState.selected_visit_date)
                    ? prevState.selected_visit_date
                    : "",
            };
        });
    };

    updateVisitField = (index, field, value) => {
        this.setState((prevState) => ({
            visits: prevState.visits.map((visit, visitIndex) => (visitIndex === index ? { ...visit, [field]: value } : visit)),
        }));
    };

    toggleVisitTechnician = (index, technicianName) => {
        this.setState((prevState) => ({
            visits: prevState.visits.map((visit, visitIndex) => {
                if (visitIndex !== index) {
                    return visit;
                }

                const currentTechnicians = this.normalizeTechnicians(visit.technician);
                const hasTechnician = currentTechnicians.includes(technicianName);

                return {
                    ...visit,
                    technician: hasTechnician ? currentTechnicians.filter((name) => name !== technicianName) : [...currentTechnicians, technicianName],
                };
            }),
        }));
    };

    selectVisit = (visitDate) => {
        this.setState((prevState) => {
            const selectedVisit = prevState.visits.find((visit) => visit.visit_date === visitDate) || null;

            return {
                selected_visit_date: visitDate,
                visit_detail_tab: "technician",
                ...this.getVisitPartsFieldState(selectedVisit),
            };
        });
    };

    /* ===== Transfer Order (SAP) - โอนอะไหล่เข้าสต็อกโครงการ ===== */

    // เงื่อนไขแสดงปุ่ม: ขอแค่มีอะไหล่ที่จำนวนเบิก > 0 อย่างน้อย 1 รายการ (ฝั่ง backend หาสต็อกต้นทางเอง)
    // (plant / storage location / batch จากตาราง stocks) แล้วตอบกลับมาว่ารายการไหนของไม่พอ
    isReadyForSapTransfer = (parts = []) => this.getPendingSapTransferParts(parts).length > 0;

    // อะไหล่ที่ยังรอโอน - ชิ้นที่มีเลขเอกสารแล้วถูกตัดออก ไม่งั้นกดซ้ำจะโอนซ้ำใน SAP
    getPendingSapTransferParts = (parts = []) =>
        parts.filter((part) => part.part_id && Number(part.quantity) > 0 && !this.isPartTransferredToSap(part));

    // เวลาที่โอนเข้า VAN สำเร็จล่าสุดของ visit นี้ (โอนได้หลายรอบ เอารอบล่าสุดมาแสดง)
    getVisitSapTransferredAt = (parts = []) =>
        parts
            .map((part) => part?.sap_transferred_at)
            .filter(Boolean)
            .sort()
            .pop() || "";

    /**
     * เลขที่ Material Document ของ visit นี้ - อ่านจากอะไหล่ที่ประทับไว้ตอนโอนสำเร็จ
     *
     * ห้ามอ่านจาก sap_transfer_map อย่างเดียว เพราะนั่นเป็น state ชั่วคราวของรอบที่เพิ่งกดโอน
     * มีเฉพาะ visit ที่กดในหน้าจอรอบนั้น สลับ visit หรือรีเฟรชแล้วหายหมด
     *
     * 1 movement type = 1 เอกสาร อะไหล่หลายชิ้นจึงอ้างเลขเดียวกันได้ - ยุบให้เหลือใบละบรรทัด
     */
    getVisitSapDocuments = (parts = []) => {
        const documents = [];

        for (const part of parts) {
            const materialDocument = String(part?.sap_material_document || "").trim();
            if (!materialDocument) continue;
            if (documents.some((doc) => doc.material_document === materialDocument)) continue;

            documents.push({
                material_document: materialDocument,
                material_document_year: part.sap_material_document_year || "",
                movement_type: part.sap_movement_type || "",
            });
        }

        // 412 (โอนเข้าเป็นของโครงการ) มาก่อน 311 (ย้ายภายในโครงการ) ตามลำดับที่ยิงเข้า SAP จริง
        return documents.sort((a, b) => String(b.movement_type).localeCompare(String(a.movement_type)));
    };

    // ขอโอนอะไหล่ของ visit นี้เข้าเป็น Project Stock (Q) ของ WBS โครงการ ผ่าน SAP
    // movement type มาจากสถานะสต็อกต้นทาง (412 / 311) ตัดสินด้วยกติกาเดียวกันทั้งสองฝั่ง
    // ฝั่งนี้คำนวณไว้โชว์ตอนยืนยัน ฝั่ง backend คำนวณซ้ำตอนประกอบ payload จริง
    handleCreateSapTransferOrder = async (visit) => {
        const transferParts = this.getPendingSapTransferParts([
            ...(visit?.service_bom_parts || []).filter((part) => part.is_active !== false),
            ...(visit?.manual_parts || []),
        ]);

        // ห้ามเบิกเกินยอดว่างของสต็อกที่เลือก - ปุ่มถูกปิดอยู่แล้วเมื่อไม่พอ ตรวจซ้ำตรงนี้กันข้อมูลที่เปลี่ยนระหว่างเปิดหน้า
        // (backend ตรวจซ้ำอีกชั้นก่อนยิง SAP ด้วยกติกาเดียวกัน)
        // โหลดสต็อกสดก่อนตรวจ (ล้าง key แล้วรอ state อัปเดตให้เสร็จก่อนอ่านผล)
        await new Promise((resolve) => this.setState({ stock_lots_key: "" }, resolve));
        await this.GetStockLots();
        await new Promise((resolve) => this.setState({}, resolve));
        const insufficientUids = this.getInsufficientStockPartUids(transferParts);
        if (insufficientUids.size) {
            const names = transferParts
                .filter((part) => insufficientUids.has(part.uid))
                .map((part) => part.part_number || part.part_name || part.name || "-")
                .join(", ");
            alert("", "warning", t("warning"), `${t("part_stock_not_enough")} (${names})`);
            return;
        }

        // WBS ปลายทางเป็นรายบรรทัด - บรรทัดที่ยังไม่มี (ทั้งจากล็อตและที่เลือกเอง) SAP จะไม่รู้ว่าโอนเข้า WBS ไหน
        // ยกเว้นโครงการมี WBS ตัวเดียว backend ใช้ตัวนั้นแทนให้ได้เลย ไม่ต้องบังคับเลือก
        await this.GetProjectWbs();
        // ล็อตที่มี WBS ติดมาใช้ของล็อตได้เลย นอกนั้นต้องเป็น WBS ระดับ 3 ของโครงการเท่านั้น
        // ค่าที่เคยบันทึกไว้แต่ไม่ใช่ระดับ 3 (ข้อมูลเก่า) ต้องกลับไปเลือกใหม่ก่อน ไม่ปล่อยให้โอนด้วยค่าเดิม
        const selectableWbs = this.getSelectableWbsOptions().map((option) => option.value);
        const missingWbsParts = transferParts.filter((part) => {
            if (String(this.getSelectedStockLot(part)?.wbs_element || "").trim()) return false;
            const partWbs = String(part.wbs_element || "").trim();
            if (!partWbs) return selectableWbs.length !== 1;
            return !selectableWbs.includes(partWbs);
        });
        if (missingWbsParts.length) {
            const names = missingWbsParts.map((part) => part.part_number || part.part_name || part.name || "-").join(", ");
            alert("", "warning", t("warning"), `${t("verify_part_wbs_element")} (${names})`);
            return;
        }

        // ขึ้นบรรทัดใหม่ก่อนสรุป 412Q/311Q ให้อ่านง่าย - swal ใช้ text เป็น textContent ขึ้นบรรทัดใหม่ไม่ได้
        // จึงส่ง html เฉพาะกล่องนี้ (ข้อความมาจาก i18n กับตัวเลขที่เรานับเอง ไม่มีข้อมูลจากผู้ใช้)
        const confirmDetail = [t("confirm_create_sap_transfer_order"), this.buildSapMovementSummary(transferParts)]
            .filter(Boolean)
            .join("<br />");

        if (!(await alert("", "question", t("confirm"), "", t("confirm"), t("cancel"), { html: confirmDetail }))) return;

        loading(true);

        const saved = await this.saveWorkOrderSilently();
        if (!saved) {
            loading(false);
            return;
        }

        // saveWorkOrderSilently → Get() ปิด loading ไปแล้ว จึงต้องเปิดตัวโหลดใหม่ให้ค้างไว้จนกว่า alert จะขึ้น
        loading(true);

        // หลัง save state ถูก reload — ดึง visit ล่าสุดจาก state
        const currentVisit = this.state.visits.find((v) => v.uid === visit.uid) || visit;

        try {
            const result = await POST(`admin/transfer-orders/visits/${currentVisit.uid}/material-document`, {});
            if (result?.status !== true) {
                alert("", "warning", t("warning"), result?.message || t("sap_transfer_order_failed"));
                return;
            }

            this.setState((state) => ({
                sap_transfer_map: { ...state.sap_transfer_map, [currentVisit.visit_date]: result?.data || null },
            }));

            // backend ประทับเลขเอกสารลงอะไหล่รายชิ้นแล้ว - โหลดใหม่เพื่อให้แถวที่โอนแล้วถูกล็อกทันที
            // ไม่ต้องรอผู้ใช้ปิด-เปิดใบสั่งงานใหม่ (ไม่งั้นกดโอนซ้ำได้จนกว่าจะรีเฟรช)
            await this.reloadWorkOrderInModal(this.state.edit_work_order_id);

            // backend ตัดสต็อกต้นทางฝั่งเราไปแล้วหลัง SAP ตอบสำเร็จ - ล้าง cache ล็อตให้คอลัมน์ "สต๊อก" โชว์ยอดใหม่ทันที
            // (GetStockLots ข้ามถ้าชุดอะไหล่เดิม จึงต้องล้าง key ก่อน)
            this.setState({ stock_lots_key: "" }, () => this.GetStockLots());

            // โอนครบแล้วและข้อมูลที่จำเป็นครบ -> visit เลื่อนเป็น assigned
            // ต้องบันทึกเดี๋ยวนี้ ไม่งั้นสถานะใหม่จะค้างอยู่แค่ในหน้าจอจนกว่าผู้ใช้จะกดบันทึกเอง
            const transferredVisit = this.state.visits.find((v) => v.uid === currentVisit.uid);
            if (transferredVisit && this.resolveVisitSaveStatus(transferredVisit, {}) !== transferredVisit.status) {
                await this.saveWorkOrderSilently();
            }

            // 412 กับ 311 ถูกแยกเป็นคนละเอกสาร - โชว์ทุกเลขที่ SAP สร้างให้ ไม่ใช่แค่ใบแรก
            const documentNumbers = (result?.data?.documents || [])
                .filter((doc) => doc.material_document)
                .map((doc) => `${doc.material_document}${doc.movement_type ? ` (${doc.movement_type}Q)` : ""}`)
                .join(", ");

            alert(
                "",
                "success",
                t("success"),
                `${t("sap_transfer_order_created")} ${documentNumbers || result?.data?.material_document || ""}`.trim(),
            );
        } finally {
            loading(false);
        }
    };

    // โครงการที่ผูกกับทรัพย์สินที่เลือก (work_orders ไม่มี project ของตัวเอง)
    getSelectedAssetProject = () => {
        const { data_asset, create_asset_id, active_wo } = this.state;
        const selectedAsset =
            (Array.isArray(data_asset) ? data_asset.find((asset) => asset.uid === create_asset_id || asset.value === create_asset_id) : null) ||
            active_wo?.asset ||
            null;
        return selectedAsset?.project || null;
    };

    /**
     * รหัส WBS ทั้งหมดของโครงการที่ผูกกับทรัพย์สินในงานนี้
     * ทรัพย์สินผูกแค่ระดับโครงการ และ 1 โครงการมีได้หลาย WBS จึงเป็น "ชุด" ไม่ใช่ค่าเดียว
     * ใช้ตัดสินว่าล็อตสต็อกไหนเป็นของโครงการนี้ และเป็นตัวเลือกของช่อง "รหัส WBS"
     */
    getProjectWbsElements = () =>
        (this.state.data_project_wbs || []).map((row) => String(row?.wbs_element || "").trim()).filter(Boolean);

    /**
     * WBS ที่เลือกเป็นปลายทางได้ต้องเป็นระดับ 3 ใต้รหัสโครงการพอดี: <รหัสโครงการ>-xx-xx-xx
     * (เช่น 26-T-BKK-0000-M-01-01-01) ระดับ 1-2 หรือลึกกว่า 3 ไม่เอามาให้เลือก
     * ตัดรหัสโครงการออกก่อนแล้วนับส่วนที่เหลือ เพราะรหัสโครงการเองก็มี "-" และแต่ละโครงการมีไม่เท่ากัน
     * กติกาเดียวกับ isTargetWbsElement ฝั่ง backend (transfer-order.service.js)
     */
    isSelectableWbsElement = (wbsElement) => {
        const wbs = String(wbsElement || "").trim();
        const prefix = `${String(this.getSelectedAssetProject()?.project_code || "").trim()}-`;
        if (prefix === "-" || !wbs.startsWith(prefix)) return false;

        const levels = wbs.slice(prefix.length).split("-");
        return levels.length === 3 && levels.every((level) => level.trim());
    };

    /**
     * ตัวเลือกช่อง "รหัส WBS" ในแท็บอะไหล่ - WBS ที่ใช้งานอยู่ของโครงการนี้จาก master (เมนูโครงการ > WBS)
     * ใช้เมื่อล็อตที่เลือกไม่มี WBS ติดมา ทรัพย์สินไม่ได้ผูกโครงการ = ไม่มีตัวเลือก
     */
    getSelectableWbsOptions = () =>
        (this.state.data_project_wbs || [])
            .filter((row) => this.isSelectableWbsElement(row?.wbs_element))
            // ในช่องแสดงเฉพาะรหัส (ช่องแคบ อ่านรหัสได้ครบสำคัญกว่า) ส่วนในรายการมีชื่อ WBS ต่อท้ายให้แยกออก
            .map((row) => ({
                value: row.wbs_element,
                label: [row.wbs_element, row.wbs_element_name].filter(Boolean).join(" - "),
                selected_label: row.wbs_element,
            }));

    // โหลด WBS ของโครงการในงานนี้ (ข้ามถ้าโครงการเดิม)
    GetProjectWbs = async () => {
        const projectUid = String(this.getSelectedAssetProject()?.uid || "").trim();
        if (projectUid === this.state.project_wbs_project_uid) return;
        if (!projectUid) {
            this.setState({ data_project_wbs: [], project_wbs_project_uid: "" });
            return;
        }

        const result = await GET("admin/wbs", { project_id: projectUid, is_active: "true", page: 0, page_size: 10000 });
        if (!result?.status) return;
        this.setState({ data_project_wbs: result.data || [], project_wbs_project_uid: projectUid });
    };

    /**
     * ล็อตสต็อกที่เลือกได้ในแท็บอะไหล่ — ทุกล็อตของอะไหล่ตัวนั้นเท่าที่มีข้อมูลในระบบ
     *
     * ไม่กรองด้วยยอดคงเหลือ เพราะสต็อกฝั่งเรามาจากการ import เป็นรอบ จึงตามหลัง SAP อยู่เสมอ
     * ล็อตที่ยอดเป็น 0 ในระบบเราอาจมีของจริงใน SAP แล้ว - SAP เป็นเจ้าของยอดจริง ให้ SAP ปฏิเสธเอง
     *
     * โหลดมาทุกล็อตของอะไหล่ ส่วนการกรองด้วย WBS ไปทำตอนสร้างตัวเลือก (ดู getSelectableStockLots)
     * เพื่อให้ล็อตที่เคยเลือกไว้ยังหาเจอ แม้ภายหลังจะไม่เข้าเงื่อนไขแล้ว
     */
    GetStockLots = async () => {
        // WBS ของโครงการโหลดคู่กันเสมอ (มี key ของตัวเอง จึงไม่ยิงซ้ำถ้าโครงการเดิม)
        this.GetProjectWbs();

        const currentVisit = this.getSelectedVisitSnapshot();
        const partUids = [
            ...new Set(
                [...(currentVisit?.service_bom_parts || []), ...(currentVisit?.manual_parts || [])]
                    .map((part) => part.part_id)
                    .filter(Boolean),
            ),
        ].sort();

        const stockLotsKey = partUids.join(",");
        if (stockLotsKey === this.state.stock_lots_key) return;

        if (!partUids.length) {
            this.setState({ data_stock_lots: {}, stock_lots_key: "" });
            return;
        }

        const result = await GET("warehouse/stocks", {
            view: "lot",
            part_ids: stockLotsKey,
            page: 0,
            page_size: 10000,
        });
        if (!result?.status) return;

        const lotsByPart = {};
        (result.data || []).forEach((lot) => {
            const partUid = lot?.part?.uid;
            if (!partUid) return;
            if (!lotsByPart[partUid]) lotsByPart[partUid] = [];
            lotsByPart[partUid].push(lot);
        });

        this.setState({ data_stock_lots: lotsByPart, stock_lots_key: stockLotsKey });
    };

    /**
     * ไอคอน info ท้ายหัวคอลัมน์ + กล่องอธิบายว่าค่าที่แสดงประกอบด้วยอะไรบ้าง
     * (รูปแบบเดียวกับไอคอนของคอลัมน์ Lot) เปิดด้วยการชี้หรือคลิกก็ได้
     * กล่องใช้ position: fixed อ้างตำแหน่งไอคอน เพื่อไม่ให้โดนขอบตารางที่เลื่อนได้ตัดหาย
     */
    renderColumnInfoIcon = ({ stateKey, parts, title }) => {
        const rectKey = `${stateKey}_rect`;
        const isOpen = this.state[stateKey];
        const rect = this.state[rectKey];
        const closeTooltip = () => this.setState({ [stateKey]: false, [rectKey]: null });

        return (
            <span
                style={{ position: "relative", display: "inline-block", marginLeft: "5px", marginBottom: "2px", cursor: "pointer" }}
                onMouseEnter={(e) => this.setState({ [stateKey]: true, [rectKey]: e.currentTarget.getBoundingClientRect() })}
                onMouseLeave={closeTooltip}
                onClick={(e) => {
                    e.stopPropagation();
                    const nextRect = e.currentTarget.getBoundingClientRect();
                    this.setState((prevState) =>
                        prevState[stateKey] ? { [stateKey]: false, [rectKey]: null } : { [stateKey]: true, [rectKey]: nextRect },
                    );
                }}
            >
                <span className="icon text-secondary" style={{ fontSize: "12px" }}>
                    {"\uf05a"}
                </span>
                {isOpen && (
                    <div
                        style={{
                            position: "fixed",
                            bottom: rect ? `${window.innerHeight - rect.top + 6}px` : "50%",
                            left: rect ? `${rect.left + rect.width / 2}px` : "50%",
                            transform: "translateX(-50%)",
                            background: "#fff",
                            border: "1px solid #dee2e6",
                            borderRadius: "8px",
                            boxShadow: "0 4px 12px rgba(0,0,0,0.12)",
                            padding: "10px 14px",
                            zIndex: 9999,
                            minWidth: "230px",
                            textAlign: "left",
                            fontSize: "12px",
                            fontWeight: "normal",
                            color: "#333",
                            whiteSpace: "nowrap",
                        }}
                    >
                        <div className="d-flex justify-content-between align-items-center mb-2">
                            <div className="fw-bold" style={{ fontSize: "12px", color: "#555" }}>
                                {title || t("lot_info_breakdown")}
                            </div>
                            <span
                                className="icon text-secondary"
                                style={{ fontSize: "12px", cursor: "pointer", marginLeft: "12px" }}
                                onClick={(e) => {
                                    e.stopPropagation();
                                    closeTooltip();
                                }}
                            >
                                {"\uf00d"}
                            </span>
                        </div>
                        {parts.map((label, index) => (
                            <div key={label} className={`d-flex align-items-center gap-2 ${index === parts.length - 1 ? "" : "mb-1"}`}>
                                <span className="badge bg-secondary" style={{ minWidth: "24px", fontSize: "10px" }}>
                                    {index + 1}
                                </span>
                                <span className="fw-bold" style={{ minWidth: "80px" }}>
                                    {label}
                                </span>
                            </div>
                        ))}
                        <div className="mt-2 pt-2 border-top text-secondary" style={{ fontSize: "11px" }}>
                            {t("display_format_label")} <span className="text-dark">{parts.map((_, index) => index + 1).join(" / ")}</span>
                        </div>
                    </div>
                )}
            </span>
        );
    };

    /**
     * ไอคอน info ที่กดแล้วโชว์รายละเอียดเป็นคู่ "ป้าย: ค่า"
     * ใช้กับข้อมูลที่ยาวหรือมีหลายบรรทัด ซึ่งถ้าวางไว้ในแถบตรง ๆ จะทำให้แถบยืดจนจัดวางยาก
     * (ต่างจาก renderColumnInfoIcon ที่อธิบาย "รูปแบบ" ของคอลัมน์ ไม่ได้โชว์ค่าจริง)
     */
    renderValueInfoIcon = ({ stateKey, title, rows = [] }) => {
        const visibleRows = rows.filter((row) => row && row.value !== "" && row.value !== null && row.value !== undefined);
        if (!visibleRows.length) return null;

        const rectKey = `${stateKey}_rect`;
        const isOpen = this.state[stateKey];
        const rect = this.state[rectKey];
        const closeTooltip = () => this.setState({ [stateKey]: false, [rectKey]: null });

        return (
            <span
                style={{ position: "relative", display: "inline-block", cursor: "pointer" }}
                onMouseEnter={(e) => this.setState({ [stateKey]: true, [rectKey]: e.currentTarget.getBoundingClientRect() })}
                onMouseLeave={closeTooltip}
                onClick={(e) => {
                    e.stopPropagation();
                    const nextRect = e.currentTarget.getBoundingClientRect();
                    this.setState((prevState) =>
                        prevState[stateKey] ? { [stateKey]: false, [rectKey]: null } : { [stateKey]: true, [rectKey]: nextRect },
                    );
                }}
            >
                <span className="icon text-secondary" style={{ fontSize: "13px" }}>
                    {"\uf05a"}
                </span>
                {isOpen && (
                    <div
                        style={{
                            position: "fixed",
                            // กล่องวางแบบ fixed อ้างตำแหน่งไอคอน จะได้ไม่โดนขอบแถบ/ตารางที่เลื่อนได้ตัดหาย
                            bottom: rect ? `${window.innerHeight - rect.top + 6}px` : "50%",
                            left: rect ? `${rect.left + rect.width / 2}px` : "50%",
                            transform: "translateX(-50%)",
                            background: "#fff",
                            border: "1px solid #dee2e6",
                            borderRadius: "8px",
                            boxShadow: "0 4px 12px rgba(0,0,0,0.12)",
                            padding: "10px 14px",
                            zIndex: 9999,
                            minWidth: "240px",
                            textAlign: "left",
                            fontSize: "12px",
                            fontWeight: "normal",
                            color: "#333",
                            whiteSpace: "nowrap",
                        }}
                    >
                        <div className="d-flex justify-content-between align-items-center mb-2">
                            <div className="fw-bold" style={{ fontSize: "12px", color: "#555" }}>
                                {title}
                            </div>
                            <span
                                className="icon text-secondary"
                                style={{ fontSize: "12px", cursor: "pointer", marginLeft: "12px" }}
                                onClick={(e) => {
                                    e.stopPropagation();
                                    closeTooltip();
                                }}
                            >
                                {"\uf00d"}
                            </span>
                        </div>
                        {visibleRows.map((row, index) => (
                            <div
                                key={row.label}
                                className={`d-flex align-items-center gap-3 ${index === visibleRows.length - 1 ? "" : "mb-1"}`}
                            >
                                <span className="text-secondary" style={{ minWidth: "120px" }}>
                                    {row.label}
                                </span>
                                <span className="fw-bold text-dark">{row.value}</span>
                            </div>
                        ))}
                    </div>
                )}
            </span>
        );
    };

    // ป้ายในตัวเลือกล็อต: พื้นที่เก็บ / เลขล็อต / สต็อกพิเศษ / รหัส WBS
    // withWbs=false ใช้กับค่าที่เลือกแล้วในช่อง เพราะรหัส WBS ไปแสดงที่ช่อง "รหัส WBS" แล้ว ไม่ต้องซ้ำ
    formatStockLotLabel = (lot, { withWbs = true } = {}) =>
        [lot?.location?.location_code || lot?.location?.name, lot?.batch_number, lot?.special_stock_type, withWbs ? lot?.wbs_element : ""]
            .map((value) => String(value ?? "").trim() || "-")
            .join(" / ");

    /**
     * ล็อตที่เลือกได้ของอะไหล่ 1 บรรทัด — เหลือเฉพาะ 2 แบบ
     *   1) ล็อตที่รหัส WBS เป็น WBS ตัวใดตัวหนึ่งของโครงการในงานนี้ (เคส 311Q ย้ายที่เก็บภายใน WBS เดิม)
     *   2) ล็อตที่ยังไม่มีรหัส WBS ในสต็อก คือของทั่วไปที่ยังไม่เป็นของโครงการไหน (เคส 412Q)
     * ล็อตที่เป็นสต็อกของโครงการอื่นถูกตัดออก เพราะโอนข้ามโครงการไม่ได้
     *
     * ยังไม่รู้ WBS ของโครงการ (ทรัพย์สินไม่ได้ผูกโครงการ / โครงการยังไม่มี WBS) จะไม่กรองเลย
     * เพราะแยกไม่ออกว่าล็อตไหนของเรา ถ้าซ่อนทิ้งจะกลายเป็นไม่มีอะไรให้เลือกโดยไม่บอกสาเหตุ
     */
    getSelectableStockLots = (part) => {
        const lots = this.state.data_stock_lots?.[part?.part_id] || [];
        const projectWbs = this.getProjectWbsElements();
        if (!projectWbs.length) return lots;

        return lots.filter((lot) => {
            const lotWbs = String(lot?.wbs_element || "").trim();
            return !lotWbs || projectWbs.includes(lotWbs);
        });
    };

    // ล็อตที่เลือกไว้ของอะไหล่บรรทัดนี้ — เอาจากค่าที่บันทึกไว้ก่อน แล้วค่อยหาในตัวเลือกที่โหลดมา
    getSelectedStockLot = (part) => {
        if (!part?.stock_lot_id) return null;
        if (part.stock_lot?.uid === part.stock_lot_id) return part.stock_lot;
        return (this.state.data_stock_lots?.[part.part_id] || []).find((lot) => lot.uid === part.stock_lot_id) || null;
    };

    // คีย์ของสต็อก 1 ก้อน: รหัสอะไหล่ + พื้นที่เก็บ + สต็อกพิเศษ + รหัส WBS + เลขล็อต (ชุดเดียวกับป้ายในตัวเลือกล็อต)
    getStockLotKey = (partUid, lot) =>
        [partUid, lot?.location?.uid || lot?.location?.location_code, lot?.special_stock_type, lot?.wbs_element, lot?.batch_number]
            .map((value) => String(value ?? "").trim())
            .join("|");

    // คีย์สต็อกของบรรทัดนี้จากล็อตที่เลือก - ใช้ข้อมูลล็อตที่โหลดมา เพราะล็อตที่แนบมากับรายการที่บันทึกไว้ไม่มีพื้นที่เก็บ
    // คืน "" เมื่อยังไม่เลือกล็อต หรือล็อตที่เลือกไม่มีในสต็อกแล้ว
    getPartStockKey = (part) => {
        if (!part?.stock_lot_id) return "";
        const lot = (this.state.data_stock_lots?.[part.part_id] || []).find((row) => row.uid === part.stock_lot_id);
        return lot ? this.getStockLotKey(part.part_id, lot) : "";
    };

    /**
     * ยอดพร้อมใช้ (unrestricted_qty - กติกาเดียวกับ backend collectStockShortages) ที่บรรทัดนี้เบิกได้
     * จับคู่ด้วย รหัสอะไหล่ + พื้นที่เก็บ + สต็อกพิเศษ + รหัส WBS + เลขล็อต ของล็อตที่เลือก (ตรงกันหลายแถวรวมยอด)
     * คืน null เมื่อยังไม่เลือกล็อต - ยังไม่รู้ว่าจะตัดจากสต็อกก้อนไหน จึงยังบอกยอดไม่ได้
     */
    // สต็อกของอะไหล่ชิ้นนี้ถูกโหลดแล้วหรือยัง (stock_lots_key = รายการ part_id ที่ GetStockLots โหลดสำเร็จล่าสุด)
    isPartStockLoaded = (part) => String(this.state.stock_lots_key || "").split(",").includes(part?.part_id);

    getPartAvailableStock = (part) => {
        const stockKey = this.getPartStockKey(part);
        if (!stockKey) {
            if (part?.stock_lot_id) return 0;
            // โหลดสต็อกแล้วแต่อะไหล่นี้ไม่มีสต็อกฝั่ง SNAPA เลย = คงเหลือ 0 (ผู้ใช้ตัดสิน 2026-10-18)
            if (this.isPartStockLoaded(part) && !(this.state.data_stock_lots?.[part.part_id] || []).length) return 0;
            return null;
        }
        return (this.state.data_stock_lots?.[part.part_id] || [])
            .filter((row) => this.getStockLotKey(part.part_id, row) === stockKey)
            .reduce((sum, row) => sum + (Number(row.unrestricted_qty) || 0), 0);
    };

    /**
     * uid ของบรรทัดที่สต็อกไม่พอเบิก - นับเฉพาะบรรทัดที่ยังรอโอน (ที่โอนแล้วของออกจากสต็อกไปแล้ว)
     * หลายบรรทัดที่ตัดจากสต็อกก้อนเดียวกันต้องรวมจำนวนเบิกกันก่อนเทียบ ไม่งั้นแต่ละบรรทัดพอแต่รวมกันเกิน
     * บรรทัดที่ยังไม่เลือกล็อตถือว่ายังไม่พอ เพราะยังไม่รู้ยอดของสต็อกที่จะตัด
     */
    getInsufficientStockPartUids = (parts = []) => {
        const pendingParts = this.getPendingSapTransferParts(parts);
        const demandByStock = {};
        pendingParts.forEach((part) => {
            const stockKey = this.getPartStockKey(part);
            if (stockKey) demandByStock[stockKey] = (demandByStock[stockKey] || 0) + (Number(part.quantity) || 0);
        });

        return new Set(
            pendingParts
                .filter((part) => {
                    // สต็อกยังโหลดไม่เสร็จ = ยังไม่รู้ยอด ไม่บล็อกผิด (handleCreateSapTransferOrder โหลดก่อนตรวจ และ backend ตรวจซ้ำ)
                    if (!this.isPartStockLoaded(part)) return false;
                    const available = this.getPartAvailableStock(part);
                    return available === null || !available || demandByStock[this.getPartStockKey(part)] > available;
                })
                .map((part) => part.uid),
        );
    };

    /**
     * ประเภทการเคลื่อนไหวที่จะส่งเข้า SAP ของอะไหล่ 1 บรรทัด
     * กติกาเดียวกับ resolveGoodsMovementType ฝั่ง backend (sap-transfer-order.client.js)
     *   311 = เป็นสต็อกของ WBS ปลายทางอยู่แล้ว (special = Q และ WBS ของล็อต = WBS ของบรรทัด) ย้ายแค่ที่เก็บ
     *   412 = ยังไม่ใช่ของ WBS ปลายทาง (special ไม่ใช่ Q หรือ WBS คนละตัว) ต้องเปลี่ยนเจ้าของสต็อก
     * WBS ปลายทางเป็นรายบรรทัด: ล็อตที่มี WBS ติดมาบังคับใช้ของล็อต ไม่งั้นใช้ตัวที่ผู้ใช้เลือกในช่อง "รหัส WBS"
     * คืน null เมื่อยังไม่ได้เลือกล็อต -> backend จะเป็นคนเลือกสต็อกต้นทางให้เอง
     */
    resolveSapMovementType = (part) => {
        const lot = this.getSelectedStockLot(part);
        if (!lot) return null;

        const isProjectStock = String(lot.special_stock_type || "").trim().toUpperCase() === "Q";
        const lotWbs = String(lot.wbs_element || "").trim();
        const targetWbs = lotWbs || String(part.wbs_element || "").trim();
        return isProjectStock && !!lotWbs && lotWbs === targetWbs ? "311" : "412";
    };

    // นับว่ารายการที่จะส่งเข้า SAP เข้าเคสไหนบ้าง (auto = ยังไม่ได้เลือกล็อต ให้ backend ตัดสินเอง)
    countSapMovementTypes = (parts = []) => {
        const counts = { 412: 0, 311: 0, auto: 0 };
        parts.forEach((part) => {
            counts[this.resolveSapMovementType(part) || "auto"] += 1;
        });
        return counts;
    };

    // สรุปว่าจะส่งเข้า SAP เป็น 412Q / 311Q อย่างละกี่รายการ ใช้โชว์ตอนกดยืนยัน
    // เจอทั้งสองเคสในคราวเดียว backend จะแยกเป็นคนละเอกสารและยิง SAP 2 ครั้ง (payload คนละชุด)
    buildSapMovementSummary = (parts = []) => {
        const counts = this.countSapMovementTypes(parts);

        return [
            counts[412] && `412Q ${counts[412]} ${t("items_unit_short")}`,
            counts[311] && `311Q ${counts[311]} ${t("items_unit_short")}`,
            counts.auto && `${counts.auto} ${t("items_unit_short")} (${t("sap_movement_auto_desc")})`,
        ]
            .filter(Boolean)
            .join("  /  ");
    };

    // เลือกล็อตสต็อกให้อะไหล่ 1 บรรทัด — เก็บแค่ตัวชี้ล็อต
    handleSelectStockLot = (part, stockLotUid) => {
        const selectedLot = (this.state.data_stock_lots?.[part.part_id] || []).find((lot) => lot.uid === stockLotUid) || null;
        // ล็อตที่มี WBS -> ใช้ WBS ของล็อต (ช่องรหัส WBS ถูกล็อก)
        // ล็อตไม่มี WBS -> คงค่าที่ผู้ใช้เคยเลือกไว้ถ้ายังอยู่ในตัวเลือก ไม่งั้นล้างให้เลือกใหม่
        // (โครงการมี WBS ตัวเดียว = ไม่มีอะไรให้เลือก ใส่ให้เลย)
        const lotWbs = String(selectedLot?.wbs_element || "").trim();
        const selectableWbs = this.getSelectableWbsOptions().map((option) => option.value);
        const fallbackWbs = selectableWbs.length === 1 ? selectableWbs[0] : "";
        const resolveWbs = (current) => lotWbs || (selectableWbs.includes(current) ? current : fallbackWbs);
        const applyStockLot = (target) =>
            target.uid === part.uid
                ? { ...target, stock_lot_id: stockLotUid || "", stock_lot: selectedLot, wbs_element: resolveWbs(target.wbs_element || "") }
                : target;
        this.updateSelectedVisitState((currentVisit) => ({
            ...currentVisit,
            service_bom_parts: (currentVisit.service_bom_parts || []).map(applyStockLot),
            manual_parts: (currentVisit.manual_parts || []).map(applyStockLot),
        }));
    };

    // เลือกรหัส WBS ให้อะไหล่ 1 บรรทัด (ใช้ได้เฉพาะเมื่อล็อตที่เลือกไม่มี WBS ติดมา)
    handleSelectWbsElement = (part, wbsElement) => {
        const applyWbs = (target) => (target.uid === part.uid ? { ...target, wbs_element: wbsElement || "" } : target);
        this.updateSelectedVisitState((currentVisit) => ({
            ...currentVisit,
            service_bom_parts: (currentVisit.service_bom_parts || []).map(applyWbs),
            manual_parts: (currentVisit.manual_parts || []).map(applyWbs),
        }));
    };

    /* ===== แท็บค่าใช้จ่าย ===== */

    // จำนวน "ใช้จริง" ของอะไหล่ 1 รายการ - ถ้ายังไม่มีการบันทึกใช้จริง ให้ถือตามจำนวนที่เบิกไปก่อน
    getPartUsedQuantity = (part) => {
        const actualQuantity = part?.actual_quantity;
        if (actualQuantity === null || actualQuantity === undefined || actualQuantity === "") {
            return Number(part?.quantity) || 0;
        }
        return Number(actualQuantity) || 0;
    };

    // จำนวนที่ต้องคืนคลัง = เบิก - ใช้จริง (ไม่ให้ติดลบกรณีใช้จริงมากกว่าที่เบิก)
    getPartReturnQuantity = (part) => Math.max((Number(part?.quantity) || 0) - this.getPartUsedQuantity(part), 0);

    // เฉพาะ admin / super_user เท่านั้นที่เพิ่มค่าใช้จ่ายอื่น ๆ ได้
    canEditOtherCost = () => {
        const userType = getProfile()?.user_type;
        return userType === "admin" || userType === "super_user";
    };

    // visit นี้เป็นงานเปลี่ยนไส้กรอง (HHU/HQW) ไหม - หมวดที่ช่างเลือกใน visit มาก่อนหมวดของใบงาน (ตรงกับ service-report.category.js ฝั่ง backend)
    isFilterChangeVisit = (visit) => {
        const { data_categories, create_work_requisition_categories_id, active_wo } = this.state;
        const list = Array.isArray(data_categories) ? data_categories : [];
        const category = visit?.report_category
            ? list.find((c) => c.value === visit.report_category)
            : list.find((c) => c.value === create_work_requisition_categories_id) || active_wo?.category;
        const haystack = `${category?.name_th || ""} ${category?.name_en || ""}`.toUpperCase();
        return /(^|[^A-Z0-9])(HHU|HQW)([^A-Z0-9]|$)/.test(haystack);
    };

    // วันที่ช่างเปลี่ยนไส้กรอง (ค.ศ. dd/mm/yyyy) - เกณฑ์เดียวกับรายงานแจ้งเตือนไส้กรอง: วันปิดงาน > เช็คอิน > วันสิ้นสุดตามแผน
    getFilterChangeDateText = (visit) => {
        const raw = visit?.closed_at || visit?.checkin_at || visit?.visit_date;
        if (!raw) return "-";
        const [y, m, d] = String(raw).slice(0, 10).split("-");
        return y && m && d ? `${d}/${m}/${y}` : "-";
    };

    formatBaht = (value) => `${(Number(value) || 0).toLocaleString("en-US", { minimumFractionDigits: 0, maximumFractionDigits: 2 })} ฿`;

    // แปลงรหัสโมเดลค่าเดินทาง (distance / per_trip / per_day / zone) เป็นข้อความตามภาษา
    formatPaymentModel = (model) => {
        const labels = {
            distance: "ta_model_distance",
            per_trip: "ta_model_per_trip",
            per_day: "ta_model_per_day",
            zone: "ta_model_zone",
        };
        return labels[model] ? t(labels[model]) : (model || "-");
    };

    // แปลงรหัสพาหนะที่ช่างเลือก เป็นข้อความตามภาษา
    formatTravelVehicle = (vehicle) => {
        const labels = {
            personal_car: "personal_car",
            car: "personal_car",
            motorcycle: "ta_vehicle_motorcycle",
            moto: "ta_vehicle_motorcycle",
            company: "company_car",
            company_car: "company_car",
            taxi: "taxi_grab",
        };
        return labels[vehicle] ? t(labels[vehicle]) : (vehicle || "-");
    };

    // แจกแจงที่มาของยอดค่าเดินทางของ visit ตาม snapshot อัตราที่ล็อกไว้ ณ วันสร้างใบงาน
    // สูตรตรงกับ calculateTravelCost ฝั่ง backend (distance / per_trip / per_day / zone)
    // คืน { rows: [{label, value}], notes: [ข้อความ], computed: ยอดตามสูตร (null = คำนวณไม่ได้) }
    buildTravelCostBreakdown = (visit, customer) => {
        const snapshot = visit?.travel_allowance_snapshot || null;
        const rows = [];
        const notes = [];
        const rate = (key) => Number(snapshot?.[key]) || 0;

        if (!snapshot) {
            return { rows, notes: [t("travel_source_no_snapshot")], computed: null };
        }

        const vehicle = String(visit?.travel_vehicle || "").toLowerCase();
        const vehicleCategory =
            vehicle === "personal_car" || vehicle === "car" ? "car"
                : vehicle === "motorcycle" || vehicle === "moto" ? "moto"
                    : vehicle === "company" || vehicle === "company_car" ? "company" : null;
        const paymentModel = snapshot.payment_model || "";

        rows.push({ label: t("payment_model_label"), value: this.formatPaymentModel(paymentModel) });
        rows.push({ label: t("vehicle_type"), value: this.formatTravelVehicle(visit?.travel_vehicle) });

        if (!vehicleCategory) {
            return { rows, notes: [t("travel_source_vehicle_no_rate")], computed: null };
        }
        if (vehicleCategory === "company") {
            return { rows, notes: [t("travel_source_company_car")], computed: 0 };
        }
        const isCar = vehicleCategory === "car";
        if ((isCar && snapshot.vehicle_personal_car_enabled === false) || (!isCar && snapshot.vehicle_motorcycle_enabled === false)) {
            return { rows, notes: [t("travel_source_vehicle_disabled")], computed: 0 };
        }

        // ระยะทางจากเลขไมล์ที่ช่างกรอก (null = ยังกรอกไม่ครบ หรือค่าผิดปกติ)
        const mileageStart = visit?.mileage_start;
        const mileageEnd = visit?.mileage_end;
        const rawDistance = mileageStart == null || mileageStart === "" || mileageEnd == null || mileageEnd === ""
            ? null
            : Number(mileageEnd) - Number(mileageStart);
        const distance = Number.isFinite(rawDistance) && rawDistance >= 0 ? rawDistance : null;

        if (paymentModel === "distance") {
            const perKm = rate(isCar ? "rate_car_per_km" : "rate_moto_per_km");
            const minimum = rate(isCar ? "rate_car_min" : "rate_moto_min");
            rows.push({ label: t("travel_source_rate_per_km"), value: `${this.formatBaht(perKm)} / ${t("km_unit")}` });
            rows.push({ label: t("travel_source_min_charge"), value: this.formatBaht(minimum) });
            if (distance == null) {
                rows.push({ label: t("travel_source_distance"), value: "-" });
                return { rows, notes: [t("travel_source_mileage_incomplete")], computed: null };
            }
            const raw = distance * perKm;
            rows.push({ label: t("travel_source_distance"), value: `${distance.toLocaleString("en-US")} ${t("km_unit")}` });
            rows.push({ label: t("travel_source_formula"), value: `${distance.toLocaleString("en-US")} × ${perKm.toLocaleString("en-US")} = ${this.formatBaht(raw)}` });
            if (raw < minimum) notes.push(t("travel_source_min_applied"));
            return { rows, notes, computed: Math.max(raw, minimum) };
        }

        if (paymentModel === "per_trip" || paymentModel === "per_day") {
            const isTrip = paymentModel === "per_trip";
            const flatRate = rate(isTrip
                ? (isCar ? "rate_per_trip_car" : "rate_per_trip_moto")
                : (isCar ? "rate_per_day_car" : "rate_per_day_moto"));
            const capKm = rate(isTrip
                ? (isCar ? "cap_km_per_trip_car" : "cap_km_per_trip_moto")
                : (isCar ? "cap_km_per_day_car" : "cap_km_per_day_moto"));
            rows.push({ label: t("travel_source_flat_rate"), value: this.formatBaht(flatRate) });
            rows.push({ label: t("travel_source_cap_km"), value: `${capKm.toLocaleString("en-US")} ${t("km_unit")}` });
            rows.push({ label: t("travel_source_distance"), value: distance == null ? "-" : `${distance.toLocaleString("en-US")} ${t("km_unit")}` });

            const overageMode = snapshot.overage_mode || "none";
            if (overageMode === "none" || distance == null) {
                if (distance == null) notes.push(t("travel_source_overage_pending"));
                return { rows, notes, computed: flatRate };
            }
            const overageDistance = Math.max(0, distance - capKm);
            if (overageDistance <= 0) {
                notes.push(t("travel_source_no_overage"));
                return { rows, notes, computed: flatRate };
            }
            let overageAmount = 0;
            if (overageMode === "fixed_customer") {
                // เหมาส่วนเกินเป็นก้อนเดียวตามอัตราของลูกค้ารายนั้น ไม่มีค่าลูกค้าจึงใช้ค่ากลางของบริษัท
                const customerRate = customer?.travel_rate_per_trip;
                overageAmount = Number(customerRate ?? snapshot.overage_fixed_fallback_amount) || 0;
                if (customerRate === undefined || customerRate === null) notes.push(t("travel_source_overage_fallback"));
                rows.push({ label: t("travel_source_overage_distance"), value: `${overageDistance.toLocaleString("en-US")} ${t("km_unit")}` });
                rows.push({ label: t("travel_source_overage_fixed"), value: this.formatBaht(overageAmount) });
            } else {
                const overageRate = rate(isCar ? "overage_rate_car_per_km" : "overage_rate_moto_per_km");
                overageAmount = overageDistance * overageRate;
                rows.push({ label: t("travel_source_overage_distance"), value: `${overageDistance.toLocaleString("en-US")} ${t("km_unit")}` });
                rows.push({
                    label: t("travel_source_overage_amount"),
                    value: `${overageDistance.toLocaleString("en-US")} × ${overageRate.toLocaleString("en-US")} = ${this.formatBaht(overageAmount)}`,
                });
            }
            return { rows, notes, computed: flatRate + overageAmount };
        }

        if (paymentModel === "zone") {
            // จับโซนจากจังหวัดของลูกค้า - ไม่ตรงโซนไหนเลยถือว่าคำนวณไม่ได้ (ตรงกับ backend ที่ไม่เดาโซนแรกให้)
            const province = String(customer?.province || "").trim().toLowerCase();
            const zone = province && Array.isArray(snapshot.zones)
                ? snapshot.zones.find((item) => Array.isArray(item?.provinces)
                    && item.provinces.some((value) => String(value).trim().toLowerCase() === province))
                : null;
            rows.push({ label: t("province"), value: customer?.province || "-" });
            if (!zone) {
                return { rows, notes: [t("travel_source_zone_not_matched")], computed: null };
            }
            rows.push({ label: t("travel_source_zone"), value: zone.name || "-" });
            rows.push({ label: t("travel_source_zone_rate"), value: this.formatBaht(zone.rate_per_trip) });
            return { rows, notes, computed: Number(zone.rate_per_trip) || 0 };
        }

        return { rows, notes, computed: null };
    };

    // แปลงค่าจาก input เป็นตัวเลขหรือ null (สำหรับส่งขึ้น API)
    toNullableNumber = (value) => {
        if (value === null || value === undefined || value === "") return null;
        const num = Number(value);
        return Number.isFinite(num) ? num : null;
    };

    // ค่าใช้จ่ายระหว่างทาง (ค่าทางด่วน/จอดรถ/น้ำมัน) — ต่อยอดจากค่าเดินทางที่ช่างบันทึก
    addTravelExtra = () => {
        const newRow = { uid: `travel_${Math.random().toString(36).slice(2)}`, type: "toll", amount: 0 };
        this.updateSelectedVisitState((currentVisit) => ({
            ...currentVisit,
            travel_extras: [...(currentVisit.travel_extras || []), newRow],
        }));
    };

    updateTravelExtra = (rowUid, field, value) => {
        this.updateSelectedVisitState((currentVisit) => ({
            ...currentVisit,
            travel_extras: (currentVisit.travel_extras || []).map((row) => (row.uid === rowUid ? { ...row, [field]: value } : row)),
        }));
    };

    removeTravelExtra = async (rowUid) => {
        if (!(await alert("", "warning", t("delete_item"), t("delete_desc"), t("confirm"), t("cancel")))) return;
        this.updateSelectedVisitState((currentVisit) => ({
            ...currentVisit,
            travel_extras: (currentVisit.travel_extras || []).filter((row) => row.uid !== rowUid),
        }));
    };

    // ค่าใช้จ่ายอื่น ๆ ที่ Admin เพิ่มเองได้
    addOtherCost = () => {
        if (!this.canEditOtherCost()) return;
        const newRow = { uid: `other_${Math.random().toString(36).slice(2)}`, name: "", amount: 0, category: "job" };
        this.updateSelectedVisitState((currentVisit) => ({
            ...currentVisit,
            other_costs: [...(currentVisit.other_costs || []), newRow],
        }));
    };

    updateOtherCost = (rowUid, field, value) => {
        this.updateSelectedVisitState((currentVisit) => ({
            ...currentVisit,
            other_costs: (currentVisit.other_costs || []).map((row) => (row.uid === rowUid ? { ...row, [field]: value } : row)),
        }));
    };

    removeOtherCost = async (rowUid) => {
        if (!(await alert("", "warning", t("delete_item"), t("delete_desc"), t("confirm"), t("cancel")))) return;
        this.updateSelectedVisitState((currentVisit) => ({
            ...currentVisit,
            other_costs: (currentVisit.other_costs || []).filter((row) => row.uid !== rowUid),
        }));
    };

    handleSetServiceBOMPartActive = (rowUid, isActive) => {
        this.updateSelectedVisitState((currentVisit) => ({
            ...currentVisit,
            service_bom_parts: (currentVisit.service_bom_parts || []).map((part) =>
                part.uid === rowUid ? { ...part, is_active: isActive } : part
            ),
        }));
    };

    handleVisitReportChange = (field, value) => {
        this.updateSelectedVisitState((currentVisit) => ({
            ...currentVisit,
            [field]: value,
        }));
    };

    handleDeleteIATRow = async (part) => {
        if (this.isPartUnitLocked(part)) {
            alert("", "warning", t("warning"), t("part_locked_cannot_delete"));
            return;
        }
        if (!(await alert("", "warning", t("delete_item"), t("delete_desc"), t("confirm"), t("cancel")))) return;
        this.removePartUnit(part.bom_id ? "service_bom_parts" : "manual_parts", part.uid);
    };

    // ทุก visit ต้อง completed แล้วเท่านั้น (และต้องมีอย่างน้อย 1 visit) ถึงจะปิดงาน (ปุ่ม "ปิดงาน") ได้
    areAllVisitsCompleted = (visits = []) =>
        Array.isArray(visits) &&
        visits.length > 0 &&
        visits.every((visit) => ["completed", "success", "approved", "closed"].includes(String(visit?.status || "").toLowerCase()));

    // ปิดการเข้าพื้นที่ของ visit นี้ (กดได้เฉพาะสถานะ close_job = ช่างกดปิดงานแล้ว) แล้วบันทึกสถานะ visit เป็น completed ทันที
    // เสร็จหน้างาน (check_out) ยังปิดไม่ได้ - ต้องรอช่างกดปิดงานในแอปก่อน (backend กันซ้ำอีกชั้น)
    handleCloseVisit = async (visitIndex, visit) => {
        if (this.normalizeStatusKey(visit?.status) !== "close_job") return;
        // งานเปลี่ยนไส้กรอง (HHU/HQW) ต้องเลือกผลสำเร็จ/ไม่สำเร็จก่อนปิด visit
        if (this.isFilterChangeVisit(visit) && (visit?.filter_change_result === null || visit?.filter_change_result === undefined)) {
            alert("", "warning", t("warning"), t("filter_change_result_required"));
            return;
        }
        if (!(await alert("", "question", t("confirm"), t("confirm_close_visit"), t("confirm"), t("cancel")))) return;

        loading(true);

        // ปิดการเข้าพื้นที่ = อัปเดตสถานะในระบบเราอย่างเดียว ไม่ยิง API ไปหา SAP หรือระบบภายนอกใด ๆ
        await new Promise((resolve) => {
            this.setState(
                (prevState) => ({
                    visits: prevState.visits.map((v, i) => (i === visitIndex ? { ...v, status: "completed" } : v)),
                }),
                resolve
            );
        });

        const saved = await this.saveWorkOrderSilently();
        loading(false);
        if (saved) {
            alert("", "success", t("success"), t("close_visit_success"));
        }
    };

    // Service Report เปิดดู/ดาวน์โหลดได้เมื่อ visit นั้นเสร็จหน้างานแล้ว - ไม่ต้องรอปิด WO ทั้งใบ
    // ยึดสถานะ visit อย่างเดียว จึงโผล่เหมือนกันทั้งตอนกด "ดูข้อมูล" และ "แก้ไข" (modal เดียวกัน ต่างแค่ wo_view_mode)
    // รายการสถานะตรงกับ getVisitStatusView: เสร็จหน้างาน (check_out) / ปิดงาน (close_job/done) และ "เสร็จสิ้น" (completed/success/approved/closed)
    // เปิดให้ดูได้ตั้งแต่ช่างกด "เช็คเอาท์" ในแอป (check_out - ลูกค้าเซ็นรับงานแล้ว) ไม่ต้องรอกดปิดงาน (close_job)
    hasServiceReport = (visit) => {
        return ["check_out", "close_job", "done", "completed", "success", "approved", "closed"].includes(this.normalizeStatusKey(visit?.status));
    };

    // ปุ่ม Service Report ต้องกดได้แม้ WO อยู่ในโหมดดูอย่างเดียว (สถานะ success เข้าโหมดนี้เสมอ)
    // แต่เนื้อหาทั้ง modal ถูกครอบด้วย <fieldset disabled={wo_view_mode}> ซึ่งปิดการทำงานของ <button>
    // ทุกตัวที่อยู่ข้างใน จึงต้องเรนเดอร์เป็น span role="button" แทน (fieldset ปิดได้เฉพาะ form control)
    // ปุ่ม "พิมพ์ WO" ราย visit อยู่แถวเดียวกัน และต้องเป็น span role="button" ด้วยเหตุผลเดียวกัน
    // พิมพ์ได้เมื่อ visit ถูกบันทึกแล้ว (มี uid) ไม่ขึ้นกับสถานะ เพราะใช้พิมพ์ไปเบิกอะไหล่ก่อนออกงาน
    renderServiceReportActions = (visit) => {
        const canPrintWo = !!visit?.uid && !!this.state.edit_work_order_id;
        if (!this.hasServiceReport(visit) && !canPrintWo) return null;

        const action = (key, className, glyph, label, run) => (
            <span
                key={key}
                role="button"
                tabIndex={0}
                className={className}
                onClick={(e) => {
                    e.stopPropagation();
                    run();
                }}
                onKeyDown={(e) => {
                    if (e.key !== "Enter" && e.key !== " ") return;
                    e.preventDefault();
                    e.stopPropagation();
                    run();
                }}
            >
                <span className="icon me-2">{glyph}</span> {label}
            </span>
        );
        const buttonClass = "btn-sm btn-light border border-primary text-primary rounded-3 px-3 py-1 decoration-none";

        return (
            <div className={`d-flex gap-2 ${visit.is_followup ? "ms-2" : "ms-auto"}`} style={{ marginBottom: "6px" }}>
                {canPrintWo && action("print_wo", buttonClass, ACTION_ICONS.print, t("print_wo"), () => this.printWorkOrder(this.state.edit_work_order_id, visit.uid))}
                {this.hasServiceReport(visit) && action("view", buttonClass, "\uf1c1", t("view_service_report"), () => this.viewServiceReport(visit))}
                {/* {action("export", "btn btn-sm btn-primary rounded-3 px-3 py-1", "\uf019", t("export_service_report"), { download: true })} */}
            </div>
        );
    };

    // ดู/ดาวน์โหลด Service Report - ใช้ไฟล์ PDF ที่ backend เรนเดอร์เองด้วย pdfkit
    // เดิมส่ง HTML มาให้เบราว์เซอร์พิมพ์เอง เอกสารเลยหน้าตาต่างกันตามตัวเรนเดอร์ของแต่ละเบราว์เซอร์
    // (Edge ทำหัวตารางเป็นกล่องดำ ขนาดเส้น/ตัวอักษรไม่เท่ากับ Chrome) ใช้ PDF จาก server จึงได้ไฟล์เดียวกันทุกที่
    // ส่ง download = true เมื่อกดปุ่ม export เพื่อบันทึกเป็นไฟล์แทนการเปิดดู
    viewServiceReport = async (visit, { download = false } = {}) => {
        const woUid = this.state.edit_work_order_id;
        if (!woUid || !visit?.uid) return;

        // เปิดแท็บ "ในจังหวะที่ผู้ใช้กดปุ่ม" เท่านั้น ถ้าไปเปิดหลัง await เบราว์เซอร์จะไม่ถือว่ามาจากการกด
        // แล้วบล็อก popup เงียบ ๆ (window.open คืน null) ทำให้กดปุ่มแล้วไม่มีอะไรเกิดขึ้น
        // ปุ่มดาวน์โหลดไม่ต้องเปิดแท็บ เพราะใช้ลิงก์ <a download> แทน
        const viewerWindow = download ? null : window.open("", "_blank");
        if (!download && !viewerWindow) {
            alert("", "warning", t("warning"), t("service_report_popup_blocked"));
            return;
        }
        if (viewerWindow) {
            viewerWindow.document.write(
                `<!DOCTYPE html><html><head><meta charset="utf-8"><title>Service Report</title></head><body>${t("service_report_loading")}</body></html>`
            );
        }

        loading(true);
        try {
            const result = await GET_FILE(`admin/work-orders/${woUid}/visits/${visit.uid}/service-report/pdf`);
            if (result?.status !== true || !result.blob) {
                if (viewerWindow) viewerWindow.close();
                alert("", "warning", t("warning"), result?.message || t("service_report_unavailable"));
                return;
            }

            const blobUrl = URL.createObjectURL(result.blob);
            if (download) {
                const link = document.createElement("a");
                link.href = blobUrl;
                link.download = result.fileName || "service-report.pdf";
                document.body.appendChild(link);
                link.click();
                link.remove();
            } else {
                // blob URL ไม่มีชื่อไฟล์ (เบราว์เซอร์ตั้งเป็น UUID) จึงห่อด้วยหน้า HTML ที่ตั้ง title + ลิงก์ดาวน์โหลดเป็นชื่อจาก backend
                // (แถบหัว PDF viewer ใน iframe ใช้ metadata Title ที่ backend ฝังไว้ในไฟล์)
                const viewerName = String(result.fileName || "service-report.pdf").replace(/[^A-Za-z0-9._-]/g, "_");
                viewerWindow.document.open();
                viewerWindow.document.write(
                    `<!DOCTYPE html><html><head><meta charset="utf-8"><title>${viewerName}</title></head>` +
                    `<body style="margin:0;display:flex;flex-direction:column;height:100vh;font-family:sans-serif">` +
                    `<div style="padding:6px 12px;background:#f1f1f1;font-size:14px"><a href="${blobUrl}" download="${viewerName}">${viewerName}</a></div>` +
                    `<iframe src="${blobUrl}" style="flex:1;border:0;width:100%"></iframe></body></html>`
                );
                viewerWindow.document.close();
            }
            // โหมดดาวน์โหลดเท่านั้นที่คืน blob (โหมดดูต้องคงไว้ให้ลิงก์ดาวน์โหลดในแท็บยังใช้ได้)
            if (download) setTimeout(() => URL.revokeObjectURL(blobUrl), 60000);
        } finally {
            loading(false);
        }
    };

    // พิมพ์ใบสั่งงาน (Work Order) ราย visit - PDF จาก backend เปิดในแท็บใหม่ (เปิดแท็บตอนกดปุ่มก่อน await กัน popup ถูกบล็อก)
    printWorkOrder = async (woUid, visitUid) => {
        if (!woUid || !visitUid) return;
        const viewerWindow = window.open("", "_blank");
        if (!viewerWindow) {
            alert("", "warning", t("warning"), t("service_report_popup_blocked"));
            return;
        }
        viewerWindow.document.write(`<!DOCTYPE html><html><head><meta charset="utf-8"><title>Work Order</title></head><body>${t("print_wo_loading")}</body></html>`);

        loading(true);
        try {
            const result = await GET_FILE(`admin/work-orders/${woUid}/visits/${visitUid}/pdf`);
            if (result?.status !== true || !result.blob) {
                viewerWindow.close();
                alert("", "warning", t("warning"), result?.message || t("print_wo_unavailable"));
                return;
            }
            const blobUrl = URL.createObjectURL(result.blob);
            const viewerName = String(result.fileName || "work-order.pdf").replace(/[^A-Za-z0-9._-]/g, "_");
            viewerWindow.document.open();
            viewerWindow.document.write(
                `<!DOCTYPE html><html><head><meta charset="utf-8"><title>${viewerName}</title></head>` +
                `<body style="margin:0;display:flex;flex-direction:column;height:100vh;font-family:sans-serif">` +
                `<div style="padding:6px 12px;background:#f1f1f1;font-size:14px"><a href="${blobUrl}" download="${viewerName}">${viewerName}</a></div>` +
                `<iframe src="${blobUrl}" style="flex:1;border:0;width:100%"></iframe></body></html>`
            );
            viewerWindow.document.close();
        } finally {
            loading(false);
        }
    };

    // อะไหล่ทั้งหมดของ visit (BOM ที่ปิดใช้งานไม่นับ) - ชุดเดียวกับที่แท็บอะไหล่ใช้
    getVisitPartsForStatus = (visit) => [
        ...(visit?.service_bom_parts || []).filter((part) => part.is_active !== false),
        ...(visit?.manual_parts || []),
    ];

    // อะไหล่ของ visit นี้โอนเข้า VAN ครบทุกชิ้นแล้วหรือยัง (เกณฑ์เดียวกับป้าย "โอนเข้า VAN แล้ว")
    isVisitSapTransferDone = (visit) => {
        const parts = this.getVisitPartsForStatus(visit);
        return !this.isReadyForSapTransfer(parts) && this.getVisitSapDocuments(parts).length > 0;
    };

    /**
     * visit พร้อมมอบหมายงาน (assigned) หรือยัง - ใช้กับเคสที่ต้องเบิกอะไหล่เข้า VAN ก่อนเข้าพื้นที่
     * ต้องครบทั้ง 2 อย่าง: อะไหล่โอนเข้า VAN แล้ว และข้อมูลที่จำเป็นครบ (ช่าง + วันที่เข้าพื้นที่)
     */
    isVisitReadyForAssignment = (visit) => {
        // งานขายปกติ (normal_sales) ไม่มีขั้นตอนโอนอะไหล่เข้า VAN ในระบบเรา
        // ขึ้น assigned ได้เมื่อข้อมูลที่จำเป็นครบ (ช่าง + วันที่เข้าพื้นที่) ไม่รอเลข Material Document จาก SAP
        if (!this.isNormalSalesWorkOrder() && !this.isVisitSapTransferDone(visit)) return false;
        return this.normalizeTechnicians(visit?.technician).length > 0 && !!visit?.visit_date;
    };

    // ใบสั่งงานที่เปิดอยู่เป็น process ขายปกติหรือไม่ (อ่านจากใบที่โหลดมา - ใบใหม่ที่ยังไม่บันทึกให้ backend ตัดสินเอง)
    isNormalSalesWorkOrder = () =>
        String(this.state.active_wo?.category?.process_name ?? this.state.active_wo?.process_name ?? "").toLowerCase() === PROCESS_NORMAL_SALES;

    /**
     * สถานะของ visit ที่จะบันทึกลง DB
     * เลื่อนขึ้นเป็น assigned ได้จาก open เท่านั้น - สถานะที่เดินไปไกลกว่านั้นแล้ว (check_in / check_out / close_job /
     * completed) ห้ามถอยกลับ ไม่งั้นการกดบันทึกธรรมดาจะรีเซ็ตงานที่ช่างทำไปแล้ว
     */
    resolveVisitSaveStatus = (visit, { createStatus, statusOverride }) => {
        // กดแปลงเป็น WO (draft -> open) ต้องดัน visit ทุกตัวเป็น open ด้วย ไม่ใช่ค้างสถานะ draft เดิมจากตอนสร้างแผน
        if (createStatus === "draft" && statusOverride === "open") return "open";

        const current = String(visit?.status || "open").toLowerCase();
        if ((current === "" || current === "open") && this.isVisitReadyForAssignment(visit)) return "assigned";

        return visit?.status || "open";
    };

    // visit ที่ยกเลิกได้ต้องยังไม่มีเลข IAT (ยังไม่ได้เบิกอะไหล่ออกจากคลัง)
    // และต้องยังไม่ได้โอนอะไหล่เข้า VAN (ของเปลี่ยนมือใน SAP แล้ว backend ก็ไม่ยอมลบให้ - utils/visit-items.js)
    // นอกนั้นกันด้วยสถานะ - ยกเลิกได้เฉพาะตอนที่ยังเป็น open เท่านั้น
    isVisitCancellable = (visit) => {
        if (!visit || visit.iat_number) return false;
        // visit แรกของ WO ที่ยิงมาจาก Sale Order (source external) ลบไม่ได้ - อะไหล่จาก SO ผูกอยู่กับ visit นี้ (backend กันซ้ำ)
        if (this.state.edit_source === "external" && Number(visit.sequence) === 1) return false;
        if (this.getVisitPartsForStatus(visit).some((part) => this.isPartTransferredToSap(part))) return false;

        const statusKey = String(visit.status || "open").toLowerCase();
        return statusKey === "" || statusKey === "open";
    };

    // ยกเลิก visit ที่ยังไม่มีเลข IAT (soft delete) แล้วปรับวันที่เริ่มต้น/สิ้นสุดของ WO ตาม visit ที่เหลือ
    // ถ้าไม่เหลือ visit แล้วให้คงวันที่เริ่มต้น/สิ้นสุดเดิมไว้
    cancelVisit = async (visit) => {
        if (!this.isVisitCancellable(visit)) return;
        if (!(await alert("", "warning", t("cancel_visit"), t("confirm_cancel_visit"), t("confirm"), t("cancel")))) return;

        const { visits, create_start_date, create_end_date, selected_visit_date, edit_work_order_id } = this.state;
        const remainingVisits = visits.filter((v) => v.visit_date !== visit.visit_date);
        const sortedRemaining = this.sortVisitsByDate(remainingVisits);
        const nextStartDate = sortedRemaining.length > 0 ? sortedRemaining[0].visit_date : create_start_date;
        const nextEndDate = sortedRemaining.length > 0 ? sortedRemaining[sortedRemaining.length - 1].visit_date : create_end_date;
        const nextSelectedVisitDate = selected_visit_date === visit.visit_date ? sortedRemaining[0]?.visit_date || "" : selected_visit_date;
        const nextSelectedVisit = remainingVisits.find((v) => v.visit_date === nextSelectedVisitDate) || null;

        loading(true);
        await new Promise((resolve) => {
            this.setState(
                {
                    visits: remainingVisits,
                    create_start_date: nextStartDate,
                    create_end_date: nextEndDate,
                    selected_visit_date: nextSelectedVisitDate,
                    ...this.getVisitPartsFieldState(nextSelectedVisit),
                },
                resolve
            );
        });

        if (edit_work_order_id) {
            const saved = await this.saveWorkOrderSilently({ allowEmptyVisits: true });
            loading(false);
            if (saved) {
                alert("", "success", t("success"), t("cancel_visit_success"));
            }
            return;
        }

        loading(false);
    };

    handleWorkRequestChange = (workRequestId, selectedRequest) => {
        const customerId = selectedRequest?.customer?.uid || selectedRequest?.customer_id || "";
        this.loadCustomerOption(customerId);
        const assetId = selectedRequest?.asset?.uid || selectedRequest?.asset_id || "";
        const categoryId = selectedRequest?.category?.uid || selectedRequest?.work_requisition_categories_id || "";
        const serviceTypeId = selectedRequest?.service_type?.uid || selectedRequest?.work_requisition_service_types_id || "";
        const priorityId = selectedRequest?.priority?.uid || selectedRequest?.work_requisition_priorities_id || "";
        const priorityItem = this.state.data_priorities.find((item) => item.value === priorityId || item.uid === priorityId);

        this.setState({
            create_work_request_id: workRequestId,
            create_customer_id: customerId,
            create_asset_id: assetId,
            create_contact_name: selectedRequest?.contact_name_1 || "",
            create_contact_phone: selectedRequest?.contact_phone_1 || "",
            create_contact_name_2: selectedRequest?.contact_name_2 || "",
            create_contact_phone_2: selectedRequest?.contact_phone_2 || "",
            create_root_cause: selectedRequest?.problem_description || "",
            create_work_requisition_categories_id: categoryId,
            create_work_requisition_service_types_id: serviceTypeId,
            create_work_requisition_priorities_id: priorityId,
            text_priority_id: this.getPriorityDescription(priorityItem),
        });
    };

    // คำร้องที่เลือกมาผูกกับ WO ได้ = ปิดงานแล้ว (success) และยังไม่ถูกใช้กับ WO ใบไหน
    toWorkRequestOptions = (rows = []) =>
        rows
            .filter((e) => e?.status === "success" && !e?.wo_id)
            .map((e) => ({
                ...e,
                value: e.uid,
                label: [e.wr_number || e.work_requisition_no || e.requisition_no || e.code || "-", e.customer?.full_name_th || e.customer?.name || ""].filter(Boolean).join(" - "),
            }));

    getWorkRequestCustomerId = (workRequest) => workRequest?.customer?.uid || workRequest?.customer_id || workRequest?.customer_uid || "";

    // dropdown ผูกคำร้อง: เหลือเฉพาะคำร้องของลูกค้าเดียวกับที่ใบงานถืออยู่
    // (ยังไม่ได้เลือกลูกค้า เช่น ตอนสร้าง WO ใหม่ = ให้เห็นทั้งหมด เพราะจะเลือกคำร้องมาเติมลูกค้าให้อยู่แล้ว)
    // คำร้องที่เลือกค้างไว้ต้องคงอยู่ในลิสต์เสมอ ไม่งั้น Select หา label ไม่เจอแล้วแสดงเป็นค่าว่าง
    getFilteredWorkRequestOptions = () => {
        const { data_work_requests, create_customer_id, create_work_request_id } = this.state;
        const options = data_work_requests || [];

        if (!create_customer_id) return options;

        return options.filter(
            (item) =>
                this.getWorkRequestCustomerId(item) === create_customer_id ||
                (create_work_request_id && (item.value === create_work_request_id || item.uid === create_work_request_id))
        );
    };

    // โหลดรายการคำร้องใหม่หลังบันทึก - คำร้องที่เพิ่งผูกไปต้องหลุดจาก dropdown ไม่งั้นถูกเลือกซ้ำกับ WO ใบอื่นได้
    refreshWorkRequestOptions = async () => {
        const result = await GET("admin/work-requisitions", { page: 0, page_size: 10000, data_search: "", type: "", lite: "true" });
        if (!result?.status) return;

        this.setState({ data_work_requests: this.toWorkRequestOptions(result.data || []) });
    };

    // ผูกคำร้องให้ WO ที่ยังไม่มีคำร้อง (เช่น WO ที่ยิงเข้ามาจาก SAP)
    // dropdown โหลดมาแบบ lite (มีแค่ wr_number/status/ลูกค้า) จึงต้องดึงรายละเอียดเต็มก่อน ถึงจะเติมฟอร์มได้ครบ
    handleLinkWorkRequest = async (workRequestUid) => {
        if (!workRequestUid) {
            this.setState({ create_work_request_id: "", work_request_link_dirty: false });
            return;
        }

        loading(true);
        const result = await GET("admin/work-requisitions", { uid: workRequestUid });
        loading(false);

        const detail = result?.status ? result.data : null;
        if (!detail?.uid) {
            alert("", "warning", t("warning"), result?.message || t("no_data_found"));
            return;
        }

        // คนละลูกค้ากับที่ใบงานถืออยู่ = ผูกแล้วลูกค้า/เครื่องบนฟอร์มจะถูกเปลี่ยนตามคำร้อง จึงต้องให้ยืนยันก่อน
        const workRequestCustomerId = detail?.customer?.uid || detail?.customer_id || "";
        const { create_customer_id } = this.state;

        if (create_customer_id && workRequestCustomerId && workRequestCustomerId !== create_customer_id) {
            const currentCustomer =
                (this.state.data_customer || []).find((item) => item.uid === create_customer_id || item.value === create_customer_id) || this.state.active_wo?.customer;
            const currentCustomerName = currentCustomer?.full_name_th || currentCustomer?.full_name_en || currentCustomer?.label || "-";
            const workRequestCustomerName = detail?.customer?.full_name_th || detail?.customer?.full_name_en || detail?.customer?.name || "-";

            const confirmed = await alert(
                "",
                "warning",
                t("confirm"),
                `${t("confirm_link_wr_customer_mismatch")} (${currentCustomerName} → ${workRequestCustomerName})`,
                t("confirm"),
                t("cancel")
            );

            if (!confirmed) return;
        }

        this.applyWorkRequestToForm(workRequestUid, detail);
    };

    // เติมข้อมูลจากคำร้องลงตามช่องต่าง ๆ ของฟอร์ม
    // ช่องไหนที่คำร้องไม่มีค่าจะคงของเดิมไว้ - WO จาก SAP มีลูกค้า/ผู้ติดต่อ/วันที่มาแล้ว ไม่ควรถูกล้างเพราะคำร้องเว้นว่าง
    applyWorkRequestToForm = (workRequestUid, detail) => {
        const customerId = detail?.customer?.uid || detail?.customer_id || "";
        const assetId = detail?.asset?.uid || detail?.asset_id || "";
        const categoryId = detail?.category?.uid || detail?.work_requisition_categories_id || "";
        const serviceTypeId = detail?.service_type?.uid || detail?.work_requisition_service_types_id || "";
        const priorityId = detail?.priority?.uid || detail?.work_requisition_priorities_id || "";
        const priorityItem = this.state.data_priorities.find((item) => item.value === priorityId || item.uid === priorityId);

        if (customerId) {
            this.loadCustomerOption(customerId);
        }

        this.setState((prevState) => {
            // ถ้าคำร้องเปลี่ยนลูกค้า เครื่องเดิมเป็นของลูกค้ารายก่อนจึงใช้ต่อไม่ได้
            const customerChanged = !!customerId && customerId !== prevState.create_customer_id;

            return {
                visits: this.seedWorkRequestPartsToFirstVisit(prevState.visits, detail),
                create_work_request_id: workRequestUid,
                work_request_link_dirty: true,
                create_customer_id: customerId || prevState.create_customer_id,
                create_asset_id: assetId || (customerChanged ? "" : prevState.create_asset_id),
                create_contact_name: detail?.contact_name_1 || prevState.create_contact_name,
                create_contact_phone: detail?.contact_phone_1 || prevState.create_contact_phone,
                create_contact_name_2: detail?.contact_name_2 || prevState.create_contact_name_2,
                create_contact_phone_2: detail?.contact_phone_2 || prevState.create_contact_phone_2,
                create_root_cause: detail?.problem_description || prevState.create_root_cause,
                create_work_requisition_categories_id: categoryId || prevState.create_work_requisition_categories_id,
                create_work_requisition_service_types_id: serviceTypeId || prevState.create_work_requisition_service_types_id,
                create_work_requisition_priorities_id: priorityId || prevState.create_work_requisition_priorities_id,
                text_priority_id: priorityId ? this.getPriorityDescription(priorityItem) : prevState.text_priority_id,
            };
        });
    };

    /**
     * อะไหล่ที่ขอเบิกไว้ในใบคำร้อง -> รายการตั้งต้นของ Visit แรกในใบงาน (กติกาเดียวกับตอน backend เปิดใบงานจากการปิดคำร้อง)
     * - ยังไม่มี visit (ยังไม่ได้เลือกวันที่) = เก็บไว้ใน Visit ตั้งต้นที่ยังไม่มีวันที่ แล้ว adoptUndatedVisit จะย้ายไปวันแรกให้เอง
     * - อะไหล่ตัวที่ Visit แรกมีอยู่แล้วไม่เพิ่มซ้ำ (ผูกคำร้องเดิมซ้ำสองรอบจำนวนจะไม่บวกทบ)
     * - Visit แรกล็อกไปแล้ว (มีเลข IAT / โอนเข้า SAP / เดินงานแล้ว) หรือคำร้องติ๊ก "ไม่เบิกอะไหล่" = ไม่แตะ
     */
    seedWorkRequestPartsToFirstVisit = (visits = [], detail) => {
        // งานขายปกติ (normal_sales) อะไหล่ต้องมาจาก Sale Order (SAP) เท่านั้น ไม่ดึงจากคำร้อง ไม่ว่าฝั่งไหนเป็น normal_sales
        const isNormalSales = (name) => String(name || "").toLowerCase() === PROCESS_NORMAL_SALES;
        if (isNormalSales(detail?.process_name) || isNormalSales(this.state.active_wo?.process_name)) return visits;

        const requestedParts = (Array.isArray(detail?.parts) ? detail.parts : []).filter((part) => part?.part_id && Number(part.quantity) > 0);
        if (detail?.no_parts_requisition || !requestedParts.length) return visits;

        const firstVisit = visits[0] || null;
        if (firstVisit && !this.isVisitOpenStatus(firstVisit)) return visits;

        const existingPartIds = new Set(
            [...(firstVisit?.service_bom_parts || []), ...(firstVisit?.manual_parts || [])].filter((part) => part.is_active !== false).map((part) => part.part_id)
        );
        const seededParts = requestedParts
            .filter((part) => !existingPartIds.has(part.part_id))
            .map((part) => this.mapVisitItemToPart({ ...part, uid: "" }, "manual"));
        if (!seededParts.length) return visits;

        if (!firstVisit) {
            return [
                {
                    uid: "",
                    visit_date: "",
                    technician: [],
                    time_slot: this.visitTimeOptions[0],
                    status: "open",
                    service_bom_id: "",
                    service_bom_parts: [],
                    manual_parts: seededParts,
                    no_parts_requisition: false,
                },
            ];
        }

        return [{ ...firstVisit, no_parts_requisition: false, manual_parts: [...(firstVisit.manual_parts || []), ...seededParts] }, ...visits.slice(1)];
    };

    openViewModal = (wo) => {
        // เปิด modal เดียวกับการแก้ไข แต่เป็นโหมดดูอย่างเดียว (read-only)
        this.openEditModal(wo, true);
    };

    openFollowUpModal = () => {
        this.setState({ modal_followup: true });
    };

    // -----------------------------------
    // API Methods
    // -----------------------------------

    toCustomerOption = (customer) => ({
        ...customer,
        value: customer.uid,
        label: customer.full_name_th || customer.name || customer.customer_code || "-",
        // group ของลูกค้า = กลุ่มลูกค้า (เช่น General) ไม่ใช่หัวกลุ่มของ Select - ไม่ส่งต่อ ไม่งั้น dropdown จะขึ้นหัวข้อ General
        group: undefined,
    });

    // ค้นหาลูกค้าฝั่ง server (Select เรียกให้ตอนพิมพ์) - token กันผลลัพธ์ที่ตอบช้ามาทับคำค้นล่าสุด
    // search_scope=display: ค้นเฉพาะที่แสดงในป้าย (รหัส + ชื่อ) ไม่ค้นเบอร์/อีเมล/เลขผู้เสียภาษี
    // เพราะผู้ใช้จะเห็นรายการที่ตรงแต่ดูไม่ออกว่าตรงตรงไหน
    customerSearchToken = 0;

    searchCustomers = async (keyword = "") => {
        const token = ++this.customerSearchToken;
        const rows = await searchCustomerRows(keyword, { search_scope: "display" });
        if (token !== this.customerSearchToken || rows === null) return;

        this.setState((prevState) => ({
            data_customer: mergeCustomerPins(rows.map(this.toCustomerOption), prevState.customer_pins),
        }));
    };

    pinCustomer = (customer) => {
        const option = customer?.uid ? this.toCustomerOption(customer) : customer;
        if (!option?.value) return;

        this.setState((prevState) => {
            const customer_pins = addCustomerPin(prevState.customer_pins, option);
            return { customer_pins, data_customer: mergeCustomerPins(prevState.data_customer, customer_pins) };
        });
    };

    // ลูกค้าของ WO/WR ที่กำลังเปิด: ดึงข้อมูลเต็มมาปักหมุดไว้ เพราะหน้านี้อ่าน tax_number/branch_code
    // จาก data_customer (customer ที่ติดมากับ WO/WR ไม่มีสองฟิลด์นี้)
    loadCustomerOption = async (customerUid) => {
        if (!customerUid) return;

        const result = await GET("admin/customers", { uid: customerUid });
        const row = Array.isArray(result?.data) ? result.data[0] : result?.data;
        if (row?.uid) this.pinCustomer(row);
    };

    toAssetOption = (asset) => ({
        ...asset,
        value: asset.uid,
        label: [asset.part_name, asset.asset_code, asset.serial_number].filter(Boolean).join(" - ") || asset.location_name || "-",
    });

    // token กันผลลัพธ์ที่ตอบช้า (ลูกค้ารายก่อน) มาทับรายการของลูกค้าที่เลือกล่าสุด
    assetLoadToken = 0;

    // ทรัพย์สินของลูกค้าที่เลือก - ดึงเฉพาะ customer_id นั้น (lite=true: field snapshot + project + customer)
    // ไม่ดึงทั้งบริษัท เพราะ dropdown กรองตามลูกค้าอยู่แล้ว (getFilteredAssetOptions) แต่เคยโหลดหลักหมื่นแถวทุกครั้งที่เปิดหน้า
    loadCustomerAssets = async (customerUid) => {
        const token = ++this.assetLoadToken;

        if (!customerUid) {
            this.setState({ data_asset: [] });
            return;
        }

        const result = await GET("admin/assets", { page: 0, page_size: 10000, lite: "true", customer_id: customerUid });
        if (token !== this.assetLoadToken || !result?.status) return;

        this.setState({ data_asset: (result.data || []).map(this.toAssetOption) });
    };

    // ดึงข้อมูล Master Data สำหรับ Dropdown
    GetOptions = async () => {
        // ลูกค้าไม่โหลดยกก้อน - ค้นหาฝั่ง server ตอนพิมพ์ (searchCustomers)
        // ทรัพย์สินไม่โหลดยกก้อนเช่นกัน - โหลดตามลูกค้าที่เลือก (loadCustomerAssets)
        this.searchCustomers("");

        let [res_work_requests, res_reject, res_service, res_priority, res_category, res_bom, res_parts, res_technicians, res_checklist_templates] = await Promise.all([
            // lite=true: dropdown เลือก WR ใช้แค่ wr_number/status/wo_id/ชื่อลูกค้า
            GET("admin/work-requisitions", { page: 0, page_size: 10000, data_search: "", type: "", lite: "true" }),
            GET("admin/work-requisition/reject-reasons", { page: 0, page_size: 10000 }),
            GET("admin/work-requisition/service-types", { page: 0, page_size: 10000 }),
            GET("admin/work-requisition/priorities", { page: 0, page_size: 10000 }),
            GET("admin/work-requisition/categories", { page: 0, page_size: 10000 }),
            GET("admin/bom-masters", { page: 0, page_size: 10000 }),
            // lite=true: field หลัก + uom + ราคา สำหรับ dropdown เพิ่มอะไหล่ manual
            GET("warehouse/part-masters", { page: 0, page_size: 10000, lite: "true" }),
            // lite=true: dropdown ใช้แค่ชื่อ/ชื่อเล่น/uid ไม่ต้อง join skills/vehicles/role
            GET("admin/technicians", { page: 0, page_size: 10000, lite: "true" }),
            GET("admin/checklist-templates", { page: 0, page_size: 10000, is_active: "true" }),
        ]);

        this.setState({
            data_work_requests: this.toWorkRequestOptions(res_work_requests?.data || []),
            data_reject_reasons: res_reject?.data?.map((e) => ({ ...e, value: e.uid, label: e.name_th })) || [],
            data_service_types: res_service?.data?.map((e) => ({ ...e, value: e.uid, label: e.name_th })) || [],
            data_priorities: res_priority?.data?.map((e) => ({ ...e, value: e.uid, label: e.name_th })) || [],
            data_categories: res_category?.data?.map((e) => ({ ...e, value: e.uid, label: e.name_th })) || [],
            data_service_boms:
                res_bom?.data?.map((e) => ({
                    ...e,
                    value: e.uid,
                    label: e.name || "-",
                })) || [],
            data_parts:
                res_parts?.data?.map((e) => ({
                    ...e,
                    value: e.uid,
                    label: [e.part_number, e.name].filter(Boolean).join(" - ") || e.name || "-",
                })) || [],
            data_technicians: res_technicians?.data || [],
            data_checklist_templates:
                res_checklist_templates?.data?.map((e) => ({
                    ...e,
                    value: e.uid,
                    label: e.name || "-",
                })) || [],
        });
    };

    getKanbanColumnDefinitions = () => [
        {
            id: "open",
            title: t("open"),
            dotColor: "#0d6efd",
            badgeBg: "#e0ebff",
            statusBadge: "bg-primary-light text-primary border-primary",
        },
        {
            id: "assigned",
            title: t("assigned"),
            dotColor: "#6f42c1",
            badgeBg: "#f3e8ff",
            statusBadge: "bg-purple-light text-purple border-purple",
        },
        {
            id: "start_job",
            title: t("start_job"),
            dotColor: "#0dcaf0",
            badgeBg: "#cff4fc",
            statusBadge: "bg-info-light text-info border-info",
        },
        {
            id: "check_in",
            title: t("check_in"),
            dotColor: "#fd7e14",
            badgeBg: "#fff0e0",
            statusBadge: "bg-warning-light text-warning border-warning",
        },
        {
            id: "check_out",
            title: t("check_out"),
            dotColor: "#20c997",
            badgeBg: "#d2f4ea",
            statusBadge: "bg-teal-light text-teal border-teal",
        },
        {
            id: "close_job",
            title: t("close_job"),
            dotColor: "#ec4899",
            badgeBg: "#fce7f3",
            statusBadge: "bg-pink-light text-pink border-pink",
        },
        {
            id: "completed",
            title: t("completed"),
            dotColor: "#198754",
            badgeBg: "#d1e7dd",
            statusBadge: "bg-success-light text-success border-success",
        },
    ];

    getKanbanColumnId = (item) => {
        // normalizeStatusKey แปลงค่าเก่า (en-route/in_progress/job_done) ให้เป็นชุดใหม่ก่อนเทียบ
        const status = this.normalizeStatusKey(item?.status);
        const visitAssignmentSummary = this.getWorkOrderVisitAssignmentSummary(item);
        const hasAssignedTechnician = visitAssignmentSummary.assignedVisits > 0;

        if (["completed", "success", "approved", "closed"].includes(status)) {
            return "completed";
        }

        if (["close_job", "done"].includes(status)) {
            return "close_job";
        }

        if (status === "check_out") {
            return "check_out";
        }

        // start_job ต้องเช็กก่อน assigned/check_in (งานที่กำลังเดินทางมักมีช่าง assigned แล้ว)
        if (status === "start_job") {
            return "start_job";
        }

        if (["check_in", "on_site", "working"].includes(status)) {
            return "check_in";
        }

        if (["assigned", "scheduled"].includes(status) || hasAssignedTechnician) {
            return "assigned";
        }

        return "open";
    };

    getTechnicianAvatars = (names = []) => {
        return names.map((name) => {
            const profile = this.getTechnicianProfile(name);
            return {
                initials: profile?.initials || name.slice(0, 2).toUpperCase(),
                bg: profile?.tone?.bg || "#2563EB",
                name,
            };
        });
    };

    getWorkOrderTechnicianAvatars = (item) => {
        return this.getTechnicianAvatars(this.getWorkOrderTechnicianNames(item));
    };

    getWorkOrderDate = (item) => {
        const value = item?.start_date || item?.created_at || item?.updated_at || "";
        const dateText = this.getDatePart(value);

        if (!dateText) {
            return null;
        }

        const date = new Date(dateText);
        return Number.isNaN(date.getTime()) ? null : date;
    };

    getWorkOrderTimeLabel = (item, columnId) => {
        const workOrderDate = this.getWorkOrderDate(item);
        const timeText = this.getTimePart(item?.start_date || item?.created_at || "");

        if (columnId === "completed") {
            return {
                text: `${t("completed_text")} ${this.getWorkOrderCreatedAtLabel(item)}`,
                icon: "\uf00c",
            };
        }

        if (workOrderDate) {
            return {
                text: `${format_date(workOrderDate, "dd/mm/yyyy", "th")}${timeText ? ` ${timeText}` : ""}`,
                icon: "\uf073",
            };
        }

        return {
            text: `${t("sla")}: ${this.getWorkOrderSlaText(item)}`,
            icon: "\uf017",
        };
    };

    mapWorkOrderToKanbanCard = (item) => {
        const priorityView = this.getWorkOrderPriorityView(item);
        const visitAssignmentSummary = this.getWorkOrderVisitAssignmentSummary(item);
        const columnId = this.getKanbanColumnId(item);
        const technicianAvatars = this.getWorkOrderTechnicianAvatars(item);
        const timeView = this.getWorkOrderTimeLabel(item, columnId);
        const statusLabel = this.getWorkOrderStatusLabel(item?.status);
        const totalVisits = visitAssignmentSummary.totalVisits;
        const assignedVisits = visitAssignmentSummary.assignedVisits;

        return {
            uid: item?.uid,
            source: item,
            columnId,
            id: this.getWorkOrderNumber(item),
            priority: priorityView.label,
            priorityBg: priorityView.backgroundColor,
            priorityColor: priorityView.color,
            priorityIcon: columnId === "completed" ? "\uf00c" : "",
            title: item?.title || item?.root_cause || "-",
            customer: this.getWorkOrderCustomerName(item),
            asset: this.getWorkOrderAssetName(item),
            tag: `${t("visit")} ${assignedVisits} ${t("of")} ${totalVisits}`,
            tagIcon: "\uf073",
            tagBg: "#EFF6FF",
            tagColor: "#2563EB",
            time: timeView.text,
            timeIcon: timeView.icon,
            borderColor: priorityView.color || "#0d6efd",
            avatars: technicianAvatars,
            date: this.getWorkOrderDate(item)?.getDate() || null,
            statusText: columnId === "check_in" ? statusLabel : "",
            statusIcon: columnId === "check_in" ? "\uf0ad" : "",
            statusColor: columnId === "check_in" ? "#fd7e14" : "",
            progressText: totalVisits > 0 ? `${t("visit")} ${assignedVisits} ${t("of")} ${totalVisits}` : "",
            progress: totalVisits > 0 ? Math.round((assignedVisits / totalVisits) * 100) : 0,
        };
    };

    // จัด visit ลง column ตามสถานะของ visit เอง (ยึดตามสถานะตรง ๆ ไม่เดาจากการมีช่าง)
    getVisitKanbanColumnId = (visit) => {
        // normalizeStatusKey แปลงค่าเก่า (en-route/in_progress/job_done) ให้เป็นชุดใหม่ก่อนเทียบ
        const status = this.normalizeStatusKey(visit?.status);

        if (["completed", "success", "approved", "closed"].includes(status)) {
            return "completed";
        }

        if (["close_job", "done"].includes(status)) {
            return "close_job";
        }

        if (status === "check_out") {
            return "check_out";
        }

        if (status === "start_job") {
            return "start_job";
        }

        if (["check_in", "on_site", "working"].includes(status)) {
            return "check_in";
        }

        if (["assigned", "scheduled"].includes(status)) {
            return "assigned";
        }

        return "open";
    };

    mapVisitToKanbanCard = (item, visit, visitIndex, totalVisits) => {
        const priorityView = this.getWorkOrderPriorityView(item);
        const columnId = this.getVisitKanbanColumnId(visit);
        const technicianAvatars = this.getTechnicianAvatars(this.getVisitTechnicianNames(visit));
        const statusLabel = this.getVisitStatusView(visit?.status).label;
        // backend ส่ง visit เป็น start_date/end_date/sequence (ไม่มี visit_date/time_slot)
        const visitSequence = visit?.sequence || visitIndex + 1;
        const visitDateText = visit?.start_date ? format_date(this.getDatePart(visit.start_date), "dd/mm/yyyy", "th") : "";
        const startTime = this.getTimePart(visit?.start_date);
        const endTime = this.getTimePart(visit?.end_date);
        const timeSlot = [startTime, endTime].filter(Boolean).join(" - ");
        const timeText = [visitDateText, timeSlot].filter(Boolean).join(", ");

        return {
            uid: `${item?.uid || "wo"}-${visit?.uid || visitIndex}`,
            source: item,
            columnId,
            id: this.getWorkOrderNumber(item),
            priority: priorityView.label,
            priorityBg: priorityView.backgroundColor,
            priorityColor: priorityView.color,
            priorityIcon: columnId === "completed" ? "" : "",
            title: item?.title || item?.root_cause || "-",
            customer: this.getWorkOrderCustomerName(item),
            asset: this.getWorkOrderAssetName(item),
            tag: `${t("visit")} ${visitSequence}/${totalVisits}`,
            visitSequenceText: `${t("visit")} ${visitSequence}/${totalVisits}`,
            tagIcon: "",
            tagBg: "#EFF6FF",
            tagColor: "#2563EB",
            time: timeText || `${t("visit")} ${visitSequence}`,
            timeIcon: "",
            borderColor: priorityView.color || "#0d6efd",
            avatars: technicianAvatars,
            date: null,
            statusText: columnId === "check_in" ? statusLabel : "",
            statusIcon: columnId === "check_in" ? "" : "",
            statusColor: columnId === "check_in" ? "#fd7e14" : "",
            progressText: "",
            progress: 0,
        };
    };

    // เช็กว่าวันที่ที่ให้มาตรงกับ filter shortcut ของ Kanban หรือไม่ (วันนี้ / สัปดาห์นี้ / เดือนนี้)
    isDateWithinKanbanFilter = (date) => {
        const { kanban_date_filter } = this.state;
        if (!kanban_date_filter) {
            return true;
        }
        if (!date) {
            return false;
        }

        const now = new Date();
        if (kanban_date_filter === "today") {
            return this.getDateKey(date) === this.getDateKey(now);
        }
        if (kanban_date_filter === "week") {
            const start = this.getStartOfWeek(now);
            const end = this.getEndOfWeek(now);
            return date >= start && date <= end;
        }
        if (kanban_date_filter === "month") {
            const start = this.getMonthStart(now);
            const end = this.getMonthEnd(now);
            return date >= start && date <= end;
        }

        return true;
    };

    getKanbanColumns = () => {
        const columns = this.getKanbanColumnDefinitions().map((column) => ({
            ...column,
            count: 0,
            cards: [],
        }));
        const columnMap = new Map(columns.map((column) => [column.id, column]));

        const pushCard = (card) => {
            const column = columnMap.get(card.columnId) || columnMap.get("open");
            column.cards.push(card);
        };

        this.state.data_work_orders.forEach((item) => {
            // Visit ที่ยังไม่มีวันนัด = Visit ตั้งต้นที่ถือแค่อะไหล่จากใบคำร้อง ยังไม่ใช่งานที่วางแผนแล้ว จึงไม่นับ
            // (ถ้านับ ใบงานที่เพิ่งเปิดจากคำร้องจะหายจากบอร์ดเมื่อกรองวันที่ เพราะ visit ไม่มีวันให้เทียบ)
            const visits = (Array.isArray(item?.visits) ? item.visits : []).filter((visit) => !!visit?.start_date);

            // ไม่มี visit -> แสดงการ์ดระดับ work-order ตามเดิม กันงานหาย
            if (visits.length === 0) {
                if (this.isDateWithinKanbanFilter(this.getWorkOrderDate(item))) {
                    pushCard(this.mapWorkOrderToKanbanCard(item));
                }
                return;
            }

            // มี visit -> 1 visit = 1 การ์ด ลง column ตามสถานะ visit (กรองตามวันที่ของ visit เอง)
            visits.forEach((visit, visitIndex) => {
                if (this.isDateWithinKanbanFilter(this.parseDateValue(visit?.start_date))) {
                    pushCard(this.mapVisitToKanbanCard(item, visit, visitIndex, visits.length));
                }
            });
        });

        columns.forEach((column) => {
            column.count = column.cards.length;
        });

        return columns;
    };

    parseDateValue = (value) => {
        const dateText = this.getDatePart(value || "");
        if (!dateText) {
            return null;
        }

        const [year, month, day] = dateText.split("-").map(Number);
        const date = new Date(year, (month || 1) - 1, day || 1);
        return Number.isNaN(date.getTime()) ? null : date;
    };

    normalizeDate = (date) => {
        if (!(date instanceof Date) || Number.isNaN(date.getTime())) {
            return null;
        }
        return new Date(date.getFullYear(), date.getMonth(), date.getDate());
    };

    addDays = (date, days) => {
        const normalized = this.normalizeDate(date);
        if (!normalized) {
            return null;
        }
        return new Date(normalized.getFullYear(), normalized.getMonth(), normalized.getDate() + days);
    };

    getDateDiffInDays = (startDate, endDate) => {
        const start = this.normalizeDate(startDate);
        const end = this.normalizeDate(endDate);
        if (!start || !end) {
            return 0;
        }
        return Math.round((end.getTime() - start.getTime()) / 86400000);
    };

    getStartOfWeek = (date) => {
        const normalized = this.normalizeDate(date);
        if (!normalized) {
            return null;
        }
        return this.addDays(normalized, -normalized.getDay());
    };

    getEndOfWeek = (date) => {
        const normalized = this.normalizeDate(date);
        if (!normalized) {
            return null;
        }
        return this.addDays(normalized, 6 - normalized.getDay());
    };

    getDateKey = (date) => {
        const normalized = this.normalizeDate(date);
        if (!normalized) {
            return "";
        }
        const year = normalized.getFullYear();
        const month = String(normalized.getMonth() + 1).padStart(2, "0");
        const day = String(normalized.getDate()).padStart(2, "0");
        return `${year}-${month}-${day}`;
    };

    getMonthValue = (date) => {
        const normalized = this.normalizeDate(date);
        if (!normalized) {
            return "";
        }
        return this.getDateKey(new Date(normalized.getFullYear(), normalized.getMonth(), 1));
    };

    getCalendarViewDate = () => {
        return this.parseDateValue(this.state.calendar_view_date) || new Date();
    };

    getMonthStart = (date) => {
        const normalized = this.normalizeDate(date);
        if (!normalized) {
            return null;
        }
        return new Date(normalized.getFullYear(), normalized.getMonth(), 1);
    };

    getMonthEnd = (date) => {
        const normalized = this.normalizeDate(date);
        if (!normalized) {
            return null;
        }
        return new Date(normalized.getFullYear(), normalized.getMonth() + 1, 0);
    };

    shiftMonth = (offset) => {
        const currentViewDate = this.getCalendarViewDate();
        const nextDate = new Date(currentViewDate.getFullYear(), currentViewDate.getMonth() + offset, 1);
        this.setState({ calendar_view_date: this.getMonthValue(nextDate) });
    };

    resetCalendarToToday = () => {
        this.setState({ calendar_view_date: this.getMonthValue(new Date()) });
    };

    // เปลี่ยนข้อมูล calendar ให้เป็นระดับ visit (1 visit = 1 ช่อง) แสดงตามวันของ visit นั้น ๆ ไม่ใช่ช่วงวันของทั้ง WO
    getCalendarItems = () => {
        const columnColorMap = new Map(this.getKanbanColumnDefinitions().map((column) => [column.id, column]));
        const items = [];

        (this.state.data_work_orders || []).forEach((item) => {
            // ไม่นับ Visit ตั้งต้นที่ยังไม่มีวันนัด (เหตุผลเดียวกับบอร์ด Kanban)
            const visits = (Array.isArray(item?.visits) ? item.visits : []).filter((visit) => !!visit?.start_date);
            const woNumber = this.getWorkOrderNumber(item);
            const tooltip = item?.title || item?.root_cause || "-";

            if (visits.length === 0) {
                const startDate =
                    this.parseDateValue(item?.start_date) || this.parseDateValue(item?.created_at) || this.parseDateValue(item?.updated_at);
                if (!startDate) {
                    return;
                }
                const colorDef = columnColorMap.get(this.getKanbanColumnId(item)) || {};
                items.push({
                    uid: item?.uid,
                    source: item,
                    startDate,
                    endDate: startDate,
                    label: woNumber,
                    tooltip,
                    background: colorDef.badgeBg || "#e0ebff",
                    color: colorDef.dotColor || "#0d6efd",
                });
                return;
            }

            this.sortVisitsByDate(visits).forEach((visit, visitIndex) => {
                const visitDate = this.parseDateValue(visit?.start_date) || this.parseDateValue(visit?.visit_date);
                if (!visitDate) {
                    return;
                }
                const rawEndDate = this.parseDateValue(visit?.end_date);
                const endDate = rawEndDate && rawEndDate > visitDate ? rawEndDate : visitDate;
                const colorDef = columnColorMap.get(this.getVisitKanbanColumnId(visit)) || {};
                const visitSequence = visit?.sequence || visitIndex + 1;

                items.push({
                    uid: `${item?.uid || "wo"}-${visit?.uid || visitIndex}`,
                    source: item,
                    startDate: visitDate,
                    endDate,
                    label: visits.length > 1 ? `${woNumber} (${visitSequence}/${visits.length})` : woNumber,
                    tooltip,
                    background: colorDef.badgeBg || "#e0ebff",
                    color: colorDef.dotColor || "#0d6efd",
                });
            });
        });

        return items;
    };

    getCalendarTitle = (date) => {
        const normalized = this.normalizeDate(date);
        return normalized ? format_date(normalized, "mmm yyyy", "th") : "-";
    };

    buildCalendarWeeks = (items, rangeStart, rangeEnd) => {
        const weeks = [];

        for (let cursor = this.normalizeDate(rangeStart); cursor && rangeEnd && cursor <= rangeEnd; cursor = this.addDays(cursor, 7)) {
            const weekStart = cursor;
            const weekEnd = this.addDays(weekStart, 6);
            const days = Array.from({ length: 7 }, (_, index) => this.addDays(weekStart, index));

            const segments = items
                .filter((item) => item.startDate <= weekEnd && item.endDate >= weekStart)
                .map((item) => {
                    const segmentStart = item.startDate > weekStart ? item.startDate : weekStart;
                    const segmentEnd = item.endDate < weekEnd ? item.endDate : weekEnd;
                    return {
                        ...item,
                        startIndex: this.getDateDiffInDays(weekStart, segmentStart),
                        endIndex: this.getDateDiffInDays(weekStart, segmentEnd),
                        continuesLeft: item.startDate < weekStart,
                        continuesRight: item.endDate > weekEnd,
                    };
                })
                .sort((a, b) => {
                    if (a.startIndex !== b.startIndex) {
                        return a.startIndex - b.startIndex;
                    }
                    return b.endIndex - a.endIndex;
                });

            const lanes = [];
            segments.forEach((segment) => {
                let laneIndex = lanes.findIndex((lane) => lane[lane.length - 1].endIndex < segment.startIndex);
                if (laneIndex === -1) {
                    lanes.push([segment]);
                    laneIndex = lanes.length - 1;
                } else {
                    lanes[laneIndex].push(segment);
                }
            });

            weeks.push({
                key: this.getDateKey(weekStart),
                weekStart,
                days,
                lanes,
            });
        }

        return weeks;
    };

    renderList = () => {
        const { data_work_orders, count, page, page_size } = this.state;
        return (
            <>
                <div className="table-responsive">
                    <table className="table table-hover align-middle mb-0" style={{ minWidth: "1000px" }}>
                        <thead>
                            <tr className="text-muted fw-bold text-12 border-bottom border-light text-uppercase text-nowrap">
                                <th className="py-3 border-0">{t("wo_number")}</th>
                                <th className="py-3 border-0">{t("wr_number")}</th>
                                <th className="py-3 border-0">{t("customer_asset")}</th>
                                <th className="py-3 border-0">{t("description")}</th>
                                <th className="py-3 border-0 text-center">{t("priority")}</th>
                                <th className="py-3 border-0 text-center">{t("status")}</th>
                                <th className="py-3 border-0 text-center">{t("visit_progress")}</th>
                                <th className="py-3 border-0 text-center">{t("sla")}</th>
                                <th className="py-3 border-0 text-center">{t("actions")}</th>
                            </tr>
                        </thead>
                        <tbody>
                            {data_work_orders.length > 0 ? (
                                data_work_orders.map((item, idx) => {
                                    const priorityView = this.getWorkOrderPriorityView(item);
                                    const visitSuccessSummary = this.getWorkOrderVisitSuccessSummary(item);
                                    return (
                                        <tr key={item.uid || idx} className="border-bottom border-light bg-white">
                                            <td className="text-12 text-nowrap">
                                                <span className="text-primary fw-bold text-decoration-none pointer" onClick={() => this.openViewModal(item)}>
                                                    {this.getWorkOrderNumber(item)}
                                                </span>
                                                {this.renderSourceInfoIcon(item)}
                                            </td>
                                            <td className="text-secondary text-nowrap text-12">{item.wr_number || "-"}</td>
                                            <td className="text-nowrap">
                                                <div className="fw-bold text-dark text-truncate" style={{ maxWidth: "220px" }} title={this.getWorkOrderCustomerName(item)}>
                                                    {this.getWorkOrderCustomerName(item)}
                                                </div>
                                                <div className="text-secondary text-12 text-truncate" style={{ maxWidth: "220px" }} title={this.getWorkOrderAssetName(item)}>
                                                    {this.getWorkOrderAssetName(item)}
                                                </div>
                                            </td>
                                            <td className="text-dark">
                                                <div className="text-truncate" style={{ maxWidth: "220px" }} title={item.root_cause || ""}>
                                                    {item.root_cause || "-"}
                                                </div>
                                            </td>
                                            <td className="text-center">
                                                <span className="badge rounded-pill fw-bold text-12 px-3" style={{ backgroundColor: priorityView.backgroundColor, color: priorityView.color }}>
                                                    {priorityView.label}
                                                </span>
                                            </td>
                                            <td className="text-center">
                                                <span className={`badge rounded-pill fw-bold text-12 px-3 border ${this.getWorkOrderStatusBadgeClass(item.status)}`}>
                                                    {String(item.status || "-")
                                                        .replaceAll("_", " ")
                                                        .toUpperCase()}
                                                </span>
                                            </td>
                                            <td className="text-secondary text-12">
                                                <div className="text-center text-14 mt-1">
                                                    {visitSuccessSummary.successVisits} / {visitSuccessSummary.totalVisits}
                                                </div>
                                            </td>
                                            <td className="text-center fw-bold text-secondary text-12">{this.getWorkOrderSlaText(item)}</td>
                                            <td className="text-nowrap text-center">
                                                <div className="d-flex align-items-center gap-2 justify-content-center">
                                                    <ActionIconButton label={t("view")} icon={ACTION_ICONS.view} variant="primary" onClick={() => this.openViewModal(item)} />
                                                    {can("wo.update") && !["rejected", "success"].includes(String(item.status || "").toLowerCase()) && (
                                                        <ActionIconButton label={t("edit")} icon={ACTION_ICONS.edit} variant="warning" onClick={() => this.openEditModal(item)} />
                                                    )}
                                                </div>
                                            </td>
                                        </tr>
                                    );
                                })
                            ) : (
                                <tr>
                                    <td colSpan="9" className="text-center py-4 text-secondary">
                                        {t("no_work_order_found")}
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>
                <div className="d-flex justify-content-between align-items-center pt-3">
                    <div className="text-secondary text-12">{count > 0 ? `${formatNumber((page - 1) * page_size + 1)}-${formatNumber(Math.min(page * page_size, count))} ${t("of")} ${formatNumber(count)}` : `0 ${t("records")}`}</div>
                    <Pagination className="mb-0" count={Math.ceil(count / page_size) || 1} page={page} showFirstButton={false} showLastButton={false} onChange={(_, nextPage) => this.Get(nextPage)} />
                </div>
            </>
        );
    };

    renderCalendar = () => {
        const items = this.getCalendarItems();
        const currentMonthDate = this.getCalendarViewDate();
        const monthStart = this.getMonthStart(currentMonthDate);
        const monthEnd = this.getMonthEnd(currentMonthDate);
        const rangeStart = this.getStartOfWeek(monthStart);
        const rangeEnd = this.getEndOfWeek(monthEnd);
        const weeks = this.buildCalendarWeeks(items, rangeStart, rangeEnd);
        const todayKey = this.getDateKey(new Date());
        const dayLabels = [t("sun"), t("mon"), t("tue"), t("wed"), t("thu"), t("fri"), t("sat")];
        const currentMonth = monthStart?.getMonth();
        const currentYear = monthStart?.getFullYear();

        return (
            <div className="w-100 border border-bottom-0 rounded-top overflow-hidden">
                <div className="d-flex justify-content-between align-items-center p-3 border-bottom">
                    <div className="d-flex align-items-center">
                        <button className="btn btn-link text-secondary px-2 text-decoration-none" onClick={() => this.shiftMonth(-1)}>
                            <span className="icon">{"\uf053"}</span>
                        </button>
                        <h5 className="fw-bold mb-0 text-dark">{this.getCalendarTitle(monthStart)}</h5>
                        <button className="btn btn-link text-secondary px-2 text-decoration-none" onClick={() => this.shiftMonth(1)}>
                            <span className="icon">{"\uf054"}</span>
                        </button>
                    </div>
                    <button className="btn btn-outline-secondary btn-sm px-3 rounded-2 text-dark bg-white" onClick={this.resetCalendarToToday}>
                        {t("today")}
                    </button>
                </div>

                <div className="d-grid border-bottom text-secondary text-12 fw-bold bg-light py-2" style={{ gridTemplateColumns: "repeat(7, minmax(0, 1fr))" }}>
                    {dayLabels.map((label) => (
                        <div key={label} className="text-end px-2">
                            {label}
                        </div>
                    ))}
                </div>

                <div className="d-flex flex-column">
                    {weeks.map((week) => {
                        const laneCount = Math.max(week.lanes.length, 1);
                        return (
                            <div
                                key={week.key}
                                className="d-grid border-bottom"
                                style={{
                                    gridTemplateColumns: "repeat(7, minmax(0, 1fr))",
                                    gridTemplateRows: `48px repeat(${laneCount}, 28px)`,
                                }}
                            >
                                {week.days.map((day, dayIndex) => {
                                    const dayKey = this.getDateKey(day);
                                    const isToday = dayKey === todayKey;
                                    const isCurrentMonthDay = day.getMonth() === currentMonth && day.getFullYear() === currentYear;

                                    return (
                                        <div
                                            key={`${week.key}-bg-${dayIndex}`}
                                            className="border-end p-2"
                                            style={{
                                                gridColumn: `${dayIndex + 1}`,
                                                gridRow: `1 / span ${laneCount + 1}`,
                                                backgroundColor: isCurrentMonthDay ? "#ffffff" : "#fafafa",
                                                minHeight: `${48 + laneCount * 28}px`,
                                            }}
                                        ></div>
                                    );
                                })}

                                {week.days.map((day, dayIndex) => {
                                    const dayKey = this.getDateKey(day);
                                    const isToday = dayKey === todayKey;
                                    const isCurrentMonthDay = day.getMonth() === currentMonth && day.getFullYear() === currentYear;

                                    return (
                                        <div key={`${week.key}-day-${dayIndex}`} className="px-2 pt-2 d-flex justify-content-end" style={{ gridColumn: `${dayIndex + 1}`, gridRow: "1" }}>
                                            <div
                                                className={`text-13 fw-bold ${isToday ? "text-primary" : isCurrentMonthDay ? "text-dark" : "text-secondary"}`}
                                                style={{
                                                    width: "28px",
                                                    height: "28px",
                                                    borderRadius: "999px",
                                                    backgroundColor: isToday ? "#E7F1FF" : "transparent",
                                                    display: "flex",
                                                    alignItems: "center",
                                                    justifyContent: "center",
                                                }}
                                            >
                                                {day.getDate()}
                                            </div>
                                        </div>
                                    );
                                })}

                                {week.lanes.map((lane, laneIndex) =>
                                    lane.map((segment) => (
                                        <div
                                            key={`${week.key}-${segment.uid}-${segment.startIndex}-${segment.endIndex}`}
                                            className="text-10 px-2 py-1 fw-bold pointer"
                                            style={{
                                                gridColumn: `${segment.startIndex + 1} / ${segment.endIndex + 2}`,
                                                gridRow: `${laneIndex + 2}`,
                                                backgroundColor: segment.background,
                                                color: segment.color,
                                                borderLeft: `3px solid ${segment.color}`,
                                                borderRadius: segment.continuesLeft ? "0 8px 8px 0" : "8px",
                                                borderTopLeftRadius: segment.continuesLeft ? "0" : "8px",
                                                borderBottomLeftRadius: segment.continuesLeft ? "0" : "8px",
                                                borderTopRightRadius: segment.continuesRight ? "0" : "8px",
                                                borderBottomRightRadius: segment.continuesRight ? "0" : "8px",
                                                whiteSpace: "nowrap",
                                                overflow: "hidden",
                                                textOverflow: "ellipsis",
                                                margin: "0 2px",
                                                alignSelf: "center",
                                                zIndex: 1,
                                                userSelect: "none",
                                            }}
                                            title={`${segment.label} - ${segment.tooltip}`}
                                            onClick={() => this.openEditModal(segment.source)}
                                        >
                                            {segment.label}
                                        </div>
                                    ))
                                )}
                            </div>
                        );
                    })}
                </div>
            </div>
        );
    };

    renderKanban = () => {
        const columns = this.getKanbanColumns();
        const columnWidth = 320;
        const columnGap = 16;
        const boardMinWidth = columns.length * columnWidth + Math.max(columns.length - 1, 0) * columnGap;
        return (
            <div className="overflow-auto pb-3">
                <div style={{ minWidth: `${boardMinWidth}px` }}>
                    <div className="d-flex gap-3 px-3 pt-3">
                        {columns.map((col, index) => (
                            <div key={`header-${index}`} className="flex-shrink-0" style={{ width: `${columnWidth}px` }}>
                                <div className="d-flex align-items-center px-1">
                                    <div className="wpx-10 hpx-10 rounded-circle me-2" style={{ backgroundColor: col.dotColor }}></div>
                                    <h6 className="fw-bold mb-0 me-2 text-dark">{col.title}</h6>
                                    <span className="badge rounded-pill text-dark fw-bold px-2 py-1" style={{ backgroundColor: col.badgeBg }}>
                                        {formatNumber(col.count)}
                                    </span>
                                </div>
                            </div>
                        ))}
                    </div>

                    <div className="d-flex gap-3 px-3 pt-2" style={{ minHeight: "65vh" }}>
                        {columns.map((col, index) => (
                            <div key={index} className="flex-shrink-0" style={{ width: `${columnWidth}px` }}>
                                <div className="d-flex flex-column gap-3 rounded-4 p-2" style={{ minHeight: "100%", backgroundColor: "#f8f9fa" }}>
                                    {col.cards.length > 0 ? (
                                        col.cards.map((card, cIndex) => (
                                            <div
                                                key={card.uid || cIndex}
                                                className="card border-0 shadow-sm rounded-4 bg-white pointer"
                                                style={{ borderLeft: `5px solid ${card.borderColor}` }}
                                                onClick={() => this.openEditModal(card.source)}
                                            >
                                                <div className="card-body p-3">
                                                    <div className="d-flex justify-content-between align-items-start mb-2">
                                                        <a
                                                            href="#"
                                                            className="text-primary fw-bold text-decoration-none text-14"
                                                            onClick={(e) => {
                                                                e.preventDefault();
                                                                this.openEditModal(card.source);
                                                            }}
                                                        >
                                                            {card.id}
                                                        </a>
                                                        <span
                                                            className="badge rounded-pill fw-bold text-10 px-2 py-1 d-flex align-items-center"
                                                            style={{ backgroundColor: card.priorityBg, color: card.priorityColor }}
                                                        >
                                                            {card.priorityIcon && <span className="icon me-1">{card.priorityIcon}</span>}
                                                            {card.priority}
                                                        </span>
                                                    </div>

                                                    {card.visitSequenceText && (
                                                        <div className="mb-2">
                                                            <span className="badge rounded-pill bg-primary-light text-primary fw-bold text-10 px-2 py-1">
                                                                {card.visitSequenceText}
                                                            </span>
                                                        </div>
                                                    )}

                                                    <div className="mb-3">
                                                        <h6
                                                            className="fw-bold mb-1 text-dark text-truncate"
                                                            style={{ whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}
                                                            title={card.title}
                                                        >
                                                            {card.title}
                                                        </h6>
                                                        <div
                                                            className="text-secondary text-12 text-truncate"
                                                            style={{ whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}
                                                            title={card.customer}
                                                        >
                                                            {card.customer}
                                                        </div>
                                                    </div>

                                                    {card.progressText && col.id === "check_in" && (
                                                        <div className="mb-2">
                                                            <div className="text-12 text-secondary mb-1">{card.progressText}</div>
                                                            <div className="progress hpx-5">
                                                                <div
                                                                    className="progress-bar"
                                                                    role="progressbar"
                                                                    style={{ width: `${card.progress}%`, backgroundColor: card.statusColor || "#2563EB" }}
                                                                ></div>
                                                            </div>
                                                        </div>
                                                    )}

                                                    <div className="d-flex justify-content-between align-items-end mt-2">
                                                        <div className="text-secondary text-12 d-flex align-items-center">
                                                            {card.timeIcon && <span className="icon me-1">{card.timeIcon}</span>}
                                                            {card.time}
                                                        </div>

                                                        <div className="d-flex align-items-center">
                                                            {card.avatars?.length > 0 ? (
                                                                <>
                                                                    <div className="d-flex align-items-center">
                                                                        {card.avatars.slice(0, 3).map((avatar, avatarIndex) => (
                                                                            <div
                                                                                key={`${avatar.name}-${avatarIndex}`}
                                                                                className="wpx-25 hpx-25 rounded-circle text-white d-flex align-items-center justify-content-center text-10 fw-bold shadow-sm border border-white"
                                                                                style={{
                                                                                    backgroundColor: avatar.bg,
                                                                                    marginLeft: avatarIndex === 0 ? 0 : "-8px",
                                                                                }}
                                                                                title={avatar.name}
                                                                            >
                                                                                {avatar.initials}
                                                                            </div>
                                                                        ))}
                                                                    </div>
                                                                    {card.avatars.length > 3 && (
                                                                        <div
                                                                            className="wpx-25 hpx-25 rounded-circle bg-light border text-secondary d-flex align-items-center justify-content-center text-10 fw-bold ms-1"
                                                                            title={`+${card.avatars.length - 3} ${t("technicians")}`}
                                                                        >
                                                                            +{card.avatars.length - 3}
                                                                        </div>
                                                                    )}
                                                                </>
                                                            ) : (
                                                                <div className="wpx-25 hpx-25 rounded-circle bg-light border text-secondary d-flex align-items-center justify-content-center text-10"></div>
                                                            )}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        ))
                                    ) : (
                                        <div className="border border-dashed rounded-4 bg-white text-center text-secondary text-12 py-4 px-3">
                                            {t("no_work_order_in_status")}
                                        </div>
                                    )}
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        );
    };

    render() {
        const {
            viewMode,
            tab,
            summary_count,
            filter_search,
            filter_technician_uid,
            filter_customer_uid,
            kanban_date_filter,
            modal_create,
            modal_view,
            modal_followup,
            active_wo,
            create_work_request_id,
            create_customer_id,
            create_asset_id,
            create_contact_name,
            create_contact_phone,
            create_contact_name_2,
            create_contact_phone_2,
            create_work_order_title,
            create_root_cause,
            create_work_requisition_categories_id,
            create_work_requisition_service_types_id,
            create_work_requisition_priorities_id,
            create_service_bom_id,
            create_service_bom_parts,
            create_manual_part_id,
            create_manual_parts,
            create_start_date,
            create_end_date,
            create_internal_remark,
            create_status,
            visits,
            selected_visit_date,
            visit_detail_tab,
            visit_iat_map,
            visit_iat_status_map,
            saved_requisition_map,
            sap_transfer_map,
            wo_view_mode,
            return_info_open,
            return_info_rect,
            travel_info_open,
            travel_info_rect,
            wo_images,
            wo_videos,
            wo_documents,
            fu_reason,
            fu_detail,
            fu_priority,
            fu_date,
            fu_copy_info,
            data_categories,
            data_priorities,
            data_reject_reasons,
            data_service_types,
            data_service_boms,
            data_parts,
            data_technicians,
            data_customer,
            data_checklist_templates,
            create_checklist_template_id,
            create_checklist_items,
            create_inspection_plan_id,
            new_checklist_description,
            new_checklist_input_type,
            new_checklist_unit,
            new_checklist_min,
            new_checklist_max,
            new_checklist_label_left,
            new_checklist_label_right,
            new_checklist_required,
            new_checklist_errors,
            edit_work_order_id,
            edit_work_request_option,
            data_work_requests,
            work_request_link_dirty,
            from_inspection,
            modal_route_map,
            modal_route_points,
            modal_route_distance,
        } = this.state;
        const selectedVisitIndex = visits.findIndex((visit) => visit.visit_date === selected_visit_date);
        const selectedVisit = selectedVisitIndex >= 0 ? visits[selectedVisitIndex] : null;
        const isEditing = !!edit_work_order_id;
        // เปิดจาก Inspection และ WO ถูก convert แล้ว (พ้น draft ไปแล้ว รวม check_in ด้วย) ใช้ปรับสี pipeline
        const woIsOpen = ["open", "check_in", "completed", "success"].includes(this.normalizeStatusKey(create_status));
        // ยังเป็น draft จากแผนการตรวจสอบ = ยังไม่ได้แปลงเป็น WO
        // มี visit ไหนเข้าหน้างานแล้ว หรือผ่านดำเนินการไปแล้วแต่ยังไม่ completed (check_out/close_job)
        // (หรือ WO ถูกยกสถานะเป็น check_in แล้ว) ใช้ปรับสี pipeline ด้านบน
        const woIsInProgress =
            this.normalizeStatusKey(create_status) === "check_in" ||
            (visits || []).some((visit) => ["check_in", "check_out", "close_job"].includes(this.normalizeStatusKey(visit?.status)));
        // WO ปิดงานสำเร็จแล้ว (success) ให้ pipeline ด้านบนเป็นสีเขียวทั้งหมด
        const woIsSuccess = String(create_status || "").toLowerCase() === "success";
        // วันที่เริ่มต้น: แก้ไขได้ก็ต่อเมื่อ "ทุก visit" เป็นสถานะ open เท่านั้น ไม่ว่าจะมีกี่ visit ก็ตาม
        const startDateRangeLocked = !visits.every((visit) => this.isVisitOpenStatus(visit));
        // วันที่สิ้นสุด: แก้ไขได้ตราบใดที่ยังปิดงานไม่สำเร็จครบทุก visit -> ล็อกเมื่อทุก visit เป็น completed/success แล้วเท่านั้น
        const followupEndDateExtendable = this.isFollowupEndDateExtendable(visits);
        const endDateRangeLocked = this.areAllVisitsCompleted(visits);
        // เลือกได้แค่วันที่ >= วันที่สิ้นสุดเดิม (ย่อช่วงกลับไม่ได้) หรือ >= วันของ visit ตัวล่าสุด กรณี follow-up
        // ยกเว้นทุก visit ยังเป็น open -> ย่อกลับได้ถึงวันที่เริ่มต้น
        // ปฏิทินเช็คแบบ exclusive จึงต้องขยับ min ถอยไป 1 วัน เพื่อให้ยังเลือกวันเดิมซ้ำได้
        const endDateShrinkable = !followupEndDateExtendable && this.areAllVisitsOpen(visits);
        const endDateMinBase = followupEndDateExtendable
            ? this.getLastVisit(visits)?.visit_date || create_end_date
            : endDateShrinkable
            ? create_start_date || create_end_date
            : create_end_date;
        const endDateMinAllowed = endDateMinBase ? this.shiftDateString(endDateMinBase, -1) : create_start_date || undefined;
        // WO draft ที่มาจากแผนการตรวจสอบ: ปลดล็อกทั้งวันที่เริ่มต้น/สิ้นสุด แต่จำกัดให้เลือกได้เฉพาะในเดือนของ WO ตัวนั้น
        // (ปฏิทินเช็คแบบ exclusive จึงต้องถอย min ไป 1 วัน เพื่อให้ยังเลือกวันที่ 1 ของเดือนได้)
        const isInspectionPlanWorkOrder = this.isInspectionPlanWorkOrder();
        const inspectionDraftMonth = this.getInspectionDraftMonthRange();
        const inspectionDraftMonthLabel = this.getInspectionDraftMonthLabel(inspectionDraftMonth);
        const inspectionDraftMinAllowed = inspectionDraftMonth ? this.shiftDateString(inspectionDraftMonth.first, -1) : undefined;
        const startDateInputLocked = inspectionDraftMonth ? false : startDateRangeLocked;
        const endDateInputLocked = inspectionDraftMonth ? false : endDateRangeLocked;
        const filteredAssetOptions = this.getFilteredAssetOptions();
        const filteredWorkRequestOptions = this.getFilteredWorkRequestOptions();
        const allTechnicianOptions = this.getTechnicianOptions();
        const technicianSearchKeyword = (this.state.visit_technician_search || "").trim().toLowerCase();
        // ฟิลเตอร์หน้าตารางโชว์รหัสลูกค้านำหน้าชื่อ - เติมตอน render เท่านั้น
        // ห้ามแก้ที่ toCustomerOption เพราะ data_customer ใช้เป็น lookup และเป็นตัวเลือกในฟอร์มสร้าง WO ด้วย
        const customerOptions = (data_customer || []).map((customer) => ({
            ...customer,
            label: [customer.customer_code, customer.label].filter(Boolean).join(" - "),
        }));
        const selectedTechnicianIds = this.normalizeTechnicians(selectedVisit?.technician);
        // หน้ามอบหมาย visit: ซ่อนช่าง inactive แต่คงช่างที่เลือกไว้เดิมให้เห็น/ถอดออกได้
        const technicianOptions = activeOptions(allTechnicianOptions, selectedTechnicianIds, { isActive: isTechnicianActive });
        // ค้นด้วยรหัสช่างหรือชื่อ และดันช่างที่ถูกเลือกขึ้นบนสุด (sort เสถียร คงลำดับเดิมในแต่ละกลุ่ม)
        const filteredTechnicianOptions = (technicianSearchKeyword
            ? technicianOptions.filter(
                (technicianOption) =>
                    (technicianOption.label || "").toLowerCase().includes(technicianSearchKeyword) ||
                    (technicianOption.code || "").toLowerCase().includes(technicianSearchKeyword)
            )
            : technicianOptions
        )
            .map((technicianOption, index) => ({ technicianOption, index, selected: selectedTechnicianIds.includes(technicianOption.value) }))
            .sort((x, y) => Number(y.selected) - Number(x.selected) || x.index - y.index)
            .map(({ technicianOption }) => technicianOption);
        const selectedTechnicianNames = selectedTechnicianIds.map((technicianId) => this.getTechnicianDisplayName(technicianId));
        const selectedTechnicianPrimary = selectedTechnicianNames[0] || "-";
        const selectedPriorityItem = data_priorities.find((item) => item.value === create_work_requisition_priorities_id || item.uid === create_work_requisition_priorities_id);
        const selectedWorkRequest =
            data_work_requests.find((item) => item.value === create_work_request_id || item.uid === create_work_request_id || item.wr_number === create_work_request_id) || edit_work_request_option;
        const headerWorkOrder = active_wo || {
            wo_number: edit_work_order_id || "",
            status: create_status,
            priority: selectedPriorityItem || null,
            wr_number: selectedWorkRequest?.wr_number || selectedWorkRequest?.value || "",
            so_no: "",
            created_at: selectedWorkRequest?.created_at || "",
        };
        const headerWorkOrderNumber = this.getWorkOrderNumber(headerWorkOrder);
        const headerPriorityView = this.getWorkOrderPriorityView(headerWorkOrder);
        const headerStatusText = this.getWorkOrderStatusLabel(headerWorkOrder?.status || create_status || "open");
        // คำร้องที่เพิ่งเลือกยังไม่ถูกบันทึก จึงยังไม่มี wr_number ใน active_wo
        // ดันเลขที่เลือกไว้ขึ้นหัว modal ก่อน เพื่อให้เห็นว่ากำลังจะผูกคำร้องใบไหน
        const headerSourceLabel = this.getWorkOrderSourceLabel({
            ...headerWorkOrder,
            wr_number: this.getWorkOrderSourceNumber(headerWorkOrder) !== "-" ? headerWorkOrder?.wr_number : selectedWorkRequest?.wr_number || "",
        });
        // WO ที่ยังไม่มีคำร้องผูกอยู่ (WO จาก SAP หรือสร้างเองจากศูนย์) เปิดให้เลือกคำร้องมาผูกได้
        // ยกเว้น WO ที่สร้างจากแผนการเข้าตรวจเช็ค (PM Plan) ไม่มีคำร้องต้นทางให้ผูก จึงซ่อนช่องนี้ไปเลย
        const canLinkWorkRequest = !edit_work_request_option && !isInspectionPlanWorkOrder && !from_inspection;
        const headerCreatedAtText = this.getWorkOrderCreatedAtLabel(headerWorkOrder);
        const selectedAsset =
            (Array.isArray(this.state.data_asset) ? this.state.data_asset.find((asset) => asset.uid === create_asset_id || asset.value === create_asset_id) : null) ||
            active_wo?.asset ||
            null;
        const selectedCustomer =
            (Array.isArray(data_customer) ? data_customer.find((customer) => customer.uid === create_customer_id || customer.value === create_customer_id) : null) ||
            active_wo?.customer ||
            null;
        const selectedCustomerContactName = [selectedCustomer?.contact_prefix, selectedCustomer?.contact_first_name, selectedCustomer?.contact_last_name]
            .filter(Boolean)
            .join(" ");
        // โครงการมาจากทรัพย์สินที่เลือก (ตาราง work_orders ไม่มี project_id ของตัวเอง) จึงเป็นข้อมูลแสดงผลอย่างเดียว
        const selectedAssetProjectText = selectedAsset
            ? [selectedAsset?.project?.project_code, selectedAsset?.project?.name].filter(Boolean).join(" ") ||
              selectedAsset?.project_name ||
              t("project_unspecified")
            : "-";
        // SAP โอนอะไหล่เข้าสต็อกโครงการได้เฉพาะเมื่อทรัพย์สินผูกโครงการ - WBS ปลายทางเลือกรายบรรทัดในแท็บอะไหล่
        // (บรรทัดไหนยังไม่มี WBS จะถูกเตือนตอนกดโอน ดู handleCreateSapTransferOrder)
        const hasSelectedAssetProject = !!selectedAsset?.project?.uid;
        // งาน normal_sales (ขายปกติ) ไม่มีขั้นตอนโอนอะไหล่เข้าสต็อกโครงการ ซ่อนแถบทั้งอัน
        // ขั้นตอนอะไหล่โครงการ (แผงเบิกอะไหล่ฝั่งขวา + แถบโอนอะไหล่เข้าสต็อกโครงการ SAP) ใช้เงื่อนไขเดียวกัน
        // มีเฉพาะงานประกันโครงการที่สร้างในระบบเอง ใบที่ยิงมาจากระบบภายนอกมีรายการอะไหล่จากต้นทางอยู่แล้ว
        // WO ที่แปลงมาจากงาน PM (process_name = null แต่ผูก inspection_plan_id) ใช้ workflow WBS เดียวกับงานประกันโครงการ
        const isPmWorkOrder = !!(create_inspection_plan_id || active_wo?.inspection_plan_id);
        const isProjectWarranteeProcess =
            (String(active_wo?.process_name || "").toLowerCase() === PROCESS_PROJECT_WARRANTEE || isPmWorkOrder) &&
            String(active_wo?.source || "").toLowerCase() !== WORK_ORDER_SOURCE_EXTERNAL;
        // from_inspection ซ่อนแท็บ visit ไว้ตอนยังเป็น draft เปิดให้ใช้เฉพาะ WO ที่แปลงแล้ว (ไม่ใช่ draft)
        const isInspectionConverted = from_inspection && String(create_status || "").toLowerCase() !== "draft";
        // งานขายปกติ (normal_sales) ที่ยิงมาจากระบบภายนอก ไม่มีแผงเบิกอะไหล่ฝั่งขวาให้เลือกล็อต
        // จึงซ่อนช่อง "ล็อตสต็อก" ในแท็บอะไหล่ของ visit (ช่องอื่นแสดงตามปกติ)
        const isExternalNormalSales =
            String(active_wo?.process_name || "").toLowerCase() === PROCESS_NORMAL_SALES &&
            String(active_wo?.source || "").toLowerCase() === WORK_ORDER_SOURCE_EXTERNAL;
        const customerWarrantyExpireDate = this.getAssetWarrantyExpireDate(selectedAsset, "customer");
        const vendorWarrantyExpireDate = this.getAssetWarrantyExpireDate(selectedAsset, "company");
        const isCustomerWarrantyExpired = this.isWarrantyExpired(customerWarrantyExpireDate);
        const isVendorWarrantyExpired = this.isWarrantyExpired(vendorWarrantyExpireDate);
        const selectedAssetLocationText =
            [
                selectedAsset?.location_address,
                selectedAsset?.location_floor_room,
                selectedAsset?.location_sub_district,
                selectedAsset?.location_district,
                selectedAsset?.location_province,
                selectedAsset?.location_zip_code,
            ]
                .filter(Boolean)
                .join(" ") ||
            selectedAsset?.location_name ||
            "";
        const filteredServiceBOMs = [...data_service_boms]
            .filter((bom) => {
                if (!create_work_requisition_categories_id) {
                    return true;
                }

                // backend list DTO ส่ง category มาเป็น work_requisition_categories (พหูพจน์)
                const bomCategoryId =
                    bom?.work_requisition_categories?.uid ||
                    bom?.work_requisition_category?.uid ||
                    bom?.work_requisition_categories_id ||
                    "";

                return bomCategoryId === create_work_requisition_categories_id;
            })
            .map((bom) => ({
                ...bom,
                label: bom.name || bom.label || "-",
            }));
        const selectedServiceBOM = filteredServiceBOMs.find((bom) => bom.value === create_service_bom_id || bom.uid === create_service_bom_id);
        // อะไหล่ของ visit ที่เลือกอยู่ (ชุดเดียวกับที่แท็บอะไหล่ใช้ - BOM ที่ปิดใช้งานไม่นับ)
        const selectedVisitParts = [
            ...create_service_bom_parts.filter((part) => part.is_active !== false),
            ...create_manual_parts,
        ];
        // โอนเข้า VAN ครบทุกชิ้นแล้ว = เงื่อนไขเดียวกับป้าย "โอนเข้า VAN แล้ว" ในแถบเลขที่เอกสาร
        const isSapTransferDone =
            !this.isReadyForSapTransfer(selectedVisitParts) && this.getVisitSapDocuments(selectedVisitParts).length > 0;
        // ล็อกการแก้ไขเบิกอะไหล่เมื่อสร้าง IAT แล้ว (มีเลข IAT) หรือรออนุมัติ/เบิกแล้ว
        // รวมถึงตอนโอนเข้า VAN ครบแล้ว - ของเปลี่ยนมือใน SAP ไปหมดแล้ว แก้รายการเบิกไม่ได้อีก
        const requisitionLocked =
            wo_view_mode ||
            isSapTransferDone ||
            !!visit_iat_map[selected_visit_date] ||
            ["pending_approve", "issued"].includes(visit_iat_status_map[selected_visit_date]);
        // "ไม่เบิกอะไหล่" ติ๊กได้เฉพาะ visit ที่ยังเป็นสถานะ open เท่านั้น
        const selectedVisitStatusKey = String(selectedVisit?.status || "open").toLowerCase();
        const isSelectedVisitOpen = selectedVisitStatusKey === "" || selectedVisitStatusKey === "open";
        const noPartsRequisitionActive = !!selectedVisit?.no_parts_requisition;
        const noPartsRequisitionDisabled = requisitionLocked || !isSelectedVisitOpen;
        // เงื่อนไขที่ยังขาดก่อน visit จะขึ้นเป็นสถานะ assigned ได้ (ต้องเคลียร์เรื่องอะไหล่ + ต้องมีช่าง) - กติกาเดียวกับ CMMS
        // ยังไม่เลือกอะไหล่และไม่ติ๊ก "ไม่เบิกอะไหล่" = ยังตัดสินใจไม่ครบ backend จะคง visit ไว้ที่ open
        // (เลือกอะไหล่แล้วยังต้องโอนเข้า SAP ครบทุกชิ้นก่อน backend ถึงจะยกขึ้น assigned ให้)
        const selectedVisitPartsCount =
            (selectedVisit?.service_bom_parts || []).filter((part) => part.is_active !== false).length + (selectedVisit?.manual_parts || []).length;
        const assignedRequirementBlockers = !isSelectedVisitOpen
            ? []
            : [
                  ...(noPartsRequisitionActive || selectedVisitPartsCount > 0 ? [] : [t("assigned_requires_parts_decision")]),
                  ...(selectedTechnicianIds.length > 0 ? [] : [t("assigned_requires_technician")]),
              ];
        const selectedTechnicianInitials = selectedTechnicianPrimary
            .split(" ")
            .filter(Boolean)
            .slice(0, 2)
            .map((part) => part[0])
            .join("")
            .toUpperCase();

        return (
            <div className="w-100 min-vh-100" style={{ backgroundColor: "#F4F7FE" }}>
                <style>{`
                .work-order-create-dialog {
                    max-width: min(1320px, calc(100vw - 3rem));
                }

                .visit-row-selected {
                    animation: visitSelectionPulse 220ms ease-out;
                }

                .visit-detail-panel {
                    animation: visitDetailSwapIn 220ms ease-out;
                }

                @keyframes visitSelectionPulse {
                    0% {
                        transform: scale(0.992);
                        box-shadow: 0 0 0 0 rgba(37, 99, 235, 0.02);
                    }
                    60% {
                        transform: scale(1.008);
                        box-shadow: 0 0 0 6px rgba(37, 99, 235, 0.08);
                    }
                    100% {
                        transform: scale(1);
                        box-shadow: 0 0 0 2px rgba(37, 99, 235, 0.14);
                    }
                }

                @keyframes visitDetailSwapIn {
                    0% {
                        opacity: 0;
                        transform: translateY(8px);
                    }
                    100% {
                        opacity: 1;
                        transform: translateY(0);
                    }
                }

                @media (max-width: 991.98px) {
                    .work-order-create-dialog {
                        max-width: calc(100vw - 1.5rem);
                    }
                }

                @media (prefers-reduced-motion: reduce) {
                    .visit-row-selected,
                    .visit-detail-panel {
                        animation: none !important;
                    }
                }
                `}</style>
                <NavbarAdmin />
                <div className="body p-4 mt-3">
                    {/* Header Section */}
                    <div className="d-flex flex-wrap justify-content-between align-items-center mb-4 gap-3">
                        <div>
                            <h3 className="fw-bold mb-1">{t("work_orders")}</h3>
                            <div className="text-secondary">{t("manage_track_all_wos")}</div>
                        </div>
                        <div className="d-flex gap-3 align-items-center">
                            <div className="btn-group bg-white p-1 rounded-3 shadow-sm border">
                                <button
                                    className={`btn btn-sm rounded-2 px-3 fw-bold d-flex align-items-center border-0 ${
                                        viewMode === "list" ? "btn-primary" : "btn-white text-secondary bg-transparent"
                                    }`}
                                    onClick={() => this.setState({ viewMode: "list" }, () => this.Get(1))}
                                >
                                    <span className="icon me-2">{"\uf03a"}</span> {t("list_view")}
                                </button>
                                <button
                                    className={`btn btn-sm rounded-2 px-3 fw-bold d-flex align-items-center border-0 ${
                                        viewMode === "kanban" ? "btn-primary" : "btn-white text-secondary bg-transparent"
                                    }`}
                                    onClick={() => this.setState({ viewMode: "kanban" }, () => this.Get(1))}
                                >
                                    <span className="icon me-2">{"\uf0db"}</span> {t("kanban")}
                                </button>
                                <button
                                    className={`btn btn-sm rounded-2 px-3 fw-bold d-flex align-items-center border-0 ${
                                        viewMode === "calendar" ? "btn-primary" : "btn-white text-secondary bg-transparent"
                                    }`}
                                    onClick={() => this.setState({ viewMode: "calendar" }, () => this.Get(1))}
                                >
                                    <span className="icon me-2">{"\uf073"}</span> {t("calendar")}
                                </button>
                            </div>

                            {/* <button className="btn btn-primary fw-bold px-3 rounded-3 shadow-sm" onClick={this.openCreateModal}>
                                <span className="me-2">+</span>
                                {t("new_work_order")}
                            </button> */}
                        </div>
                    </div>

                    {/* Top Filter Toolbar */}
                    <div className="rounded-4 bg-white p-3 mb-3 shadow-sm border-0">
                        <div className="d-flex flex-wrap align-items-center justify-content-between gap-3">
                            <div className="d-flex flex-wrap gap-2 flex-grow-1">
                                {/* ค้นหาเฉพาะใบงานในเมนูนี้ (ครอบคลุมเลขที่ / ลูกค้า / ทรัพย์สิน / S-N / part master / ผู้ติดต่อ / หมวด ฯลฯ)
                                    Enter = กรองตาราง, เลือกจาก dropdown = เติมเลขที่แล้วกรองบนแท็บ "ทั้งหมด" เพราะใบที่เลือกอาจไม่อยู่แท็บปัจจุบัน
                                    ทั้งสองทางสลับ "งานของฉัน" -> "ทั้งหมด" ให้เอง (searchWithScopeAll) */}
                                <GlobalSearchBox
                                    scope="work_order"
                                    value={filter_search}
                                    onChange={(value) => this.setState({ filter_search: value })}
                                    onEnter={() => this.searchWithScopeAll()}
                                    onSelect={() => this.searchWithScopeAll("all")}
                                    placeholder={t("search_work_orders_placeholder")}
                                />
                                <Select
                                    className="form-control wpx-200 rounded-3 text-dark"
                                    options={allTechnicianOptions}
                                    value={filter_technician_uid}
                                    onChange={(value) => this.setState({ filter_technician_uid: value })}
                                    placeholder={t("all_technicians")}
                                    nowrapOptions
                                />
                                <Select
                                    className="form-control wpx-200 rounded-3 text-dark"
                                    options={customerOptions}
                                    onSearch={this.searchCustomers}
                                    value={filter_customer_uid}
                                    onChange={(value, item) => {
                                        this.pinCustomer(item);
                                        this.setState({ filter_customer_uid: value });
                                    }}
                                    placeholder={t("all_customers")}
                                    nowrapOptions
                                />
                                {/* ISS-030: สลับดูเฉพาะงานของฉัน / ทั้งหมด (ค่าเริ่มต้น = งานของฉัน) */}
                                {/* สไตล์ pill ชุดเดียวกับแท็บสลับมุมมอง (รายการ/คัมบังบอร์ด/ปฏิทิน)
                                    ใช้พื้น bg-light เพราะกล่องฟิลเตอร์นี้เป็นพื้นขาว ถ้าใช้พื้นขาวด้วยจะกลืนจนไม่เห็นกรอบ */}
                                <div className="btn-group bg-light p-1 rounded-3 border" role="group">
                                    {[
                                        { key: "mine", label: t("scope_mine"), icon: "\uf007" },
                                        { key: "all", label: t("scope_all"), icon: "\uf0c9" },
                                    ].map((option) => (
                                        <button
                                            key={option.key}
                                            type="button"
                                            className={`btn btn-sm rounded-2 px-3 fw-bold text-nowrap d-flex align-items-center border-0 ${
                                                this.state.filter_scope === option.key ? "btn-primary" : "btn-white text-secondary bg-transparent"
                                            }`}
                                            onClick={() => this.changeScope(option.key)}
                                        >
                                            <span className="icon me-2">{option.icon}</span> {option.label}
                                        </button>
                                    ))}
                                </div>

                                <div className="d-flex gap-2">
                                    <button className="btn btn-secondary px-3 py-2 fw-bold rounded-3 shadow-sm" onClick={() => this.searchWithScopeAll()}>
                                        {t("filter")}
                                    </button>
                                    <button
                                        className="btn btn-white border px-3 py-2 fw-bold rounded-3 shadow-sm"
                                        onClick={() => this.setState({ filter_search: "", filter_technician_uid: "", filter_customer_uid: "" }, () => this.Get(1))}
                                    >
                                        {t("clear_all")}
                                    </button>
                                </div>
                            </div>
                        </div>

                        {viewMode === "kanban" && (
                            <div className="d-flex flex-wrap gap-2 mt-3 pt-3 border-top">
                                {[
                                    { value: "today", label: t("today") },
                                    { value: "week", label: t("this_week") },
                                    { value: "month", label: t("this_month") },
                                ].map((shortcut) => (
                                    <button
                                        key={shortcut.value}
                                        type="button"
                                        className={`btn btn-sm rounded-pill px-3 fw-bold ${
                                            kanban_date_filter === shortcut.value ? "btn-primary" : "btn-white border text-secondary"
                                        }`}
                                        onClick={() =>
                                            this.setState({
                                                kanban_date_filter: kanban_date_filter === shortcut.value ? "" : shortcut.value,
                                            })
                                        }
                                    >
                                        {shortcut.label}
                                    </button>
                                ))}
                            </div>
                        )}
                    </div>

                    {/* Status Tabs (list view only) */}
                    {viewMode === "list" && (
                        <div className="d-flex border-bottom mb-3 px-2 text-14">
                            {[
                                { key: "all", label: t("all_status"), bg: "#6B7280", color: "#fff" },
                                { key: "open", label: t("open"), bg: "#2563EB", color: "#fff" },
                                { key: "check_in", label: t("check_in"), bg: "#FFE58F", color: "#212529" },
                                { key: "success", label: t("success"), bg: "#22C55E", color: "#fff" },
                                { key: "rejected", label: t("rejected"), bg: "#EF4444", color: "#fff" },
                            ].map((tabItem) => (
                                <div
                                    key={tabItem.key}
                                    className={`py-3 px-3 d-flex align-items-center gap-2 ${tab === tabItem.key ? "fw-bold text-primary" : "text-secondary"} pointer`}
                                    style={{ borderBottom: tab === tabItem.key ? "3px #1976D2 solid" : "" }}
                                    onClick={() => this.Get(1, tabItem.key)}
                                >
                                    {tabItem.label}
                                    <span
                                        className="badge rounded-circle p-0 d-inline-flex align-items-center justify-content-center"
                                        style={{ backgroundColor: tabItem.bg, color: tabItem.color, minWidth: "22px", height: "22px", fontSize: "11px" }}
                                    >
                                        {formatNumber(summary_count[tabItem.key])}
                                    </span>
                                </div>
                            ))}
                        </div>
                    )}

                    {/* Main Container */}
                    <div className="bg-white rounded-4 shadow-sm pb-2">
                        {viewMode === "list" && this.renderList()}
                        {viewMode === "kanban" && this.renderKanban()}
                        {viewMode === "calendar" && this.renderCalendar()}
                    </div>
                </div>

                {/* ===================== MODAL: CREATE WORK ORDER ===================== */}
                <Modal
                    size="xl"
                    show={modal_create}
                    onHide={this.closeCreateModal}
                    centered
                    dialogClassName="work-order-create-dialog"
                    contentClassName="border-0 rounded-4 overflow-hidden shadow-lg bg-light"
                >
                    <Modal.Header className="bg-white border-bottom px-4 py-3 d-flex justify-content-between align-items-center" closeButton>
                        <div className="w-100 pe-3">
                            <div className="d-flex align-items-center justify-content-between mb-3">
                                <div className="d-flex align-items-center gap-3">
                                    <h4 className="fw-bold mb-0 text-dark">{headerWorkOrderNumber}</h4>
                                    <span className="badge rounded-pill fw-bold text-12 px-3 py-1" style={{ backgroundColor: headerPriorityView.backgroundColor, color: headerPriorityView.color }}>
                                        <span className="icon me-1">{"\uf06a"}</span> {headerPriorityView.label}
                                    </span>
                                    <span className={`badge rounded-pill fw-bold text-12 px-3 py-1 border ${this.getWorkOrderStatusBadgeClass(headerWorkOrder?.status || create_status)}`}>
                                        {headerStatusText}
                                    </span>
                                    {wo_view_mode && (
                                        <span className="badge rounded-pill fw-bold text-12 px-3 py-1 bg-light text-secondary border">
                                            <span className="icon me-1">{"\uf06e"}</span> {t("view_data")}
                                        </span>
                                    )}
                                </div>
                            </div>
                            <div className="text-secondary text-12 mb-3">
                                {t("created_label")}: {headerCreatedAtText} <span className="mx-2">|</span> {t("from")} {headerSourceLabel}
                            </div>

                            {/* Pipeline Status */}
                            {from_inspection ? (
                            <div className="d-flex w-100 overflow-auto pb-1" style={{ gap: "2px" }}>
                                <div className="bg-success text-white px-3 py-2 fw-bold text-12 rounded-start d-flex align-items-center flex-grow-1 justify-content-center" style={{ clipPath: "polygon(0% 0%, 95% 0%, 100% 50%, 95% 100%, 0% 100%)" }}>{t("pm_plan_created")}</div>
                                <div className={`${woIsOpen ? "bg-success" : "bg-primary"} text-white px-3 py-2 fw-bold text-12 d-flex align-items-center flex-grow-1 justify-content-center`} style={{ clipPath: "polygon(0% 0%, 95% 0%, 100% 50%, 95% 100%, 0% 100%, 5% 50%)", marginLeft: "-5px" }}>{t("convert_to_wo")}</div>
                                <div className={`${woIsSuccess || woIsInProgress ? "bg-success text-white" : woIsOpen ? "bg-primary text-white" : "bg-light text-secondary border"} px-3 py-2 fw-bold text-12 d-flex align-items-center flex-grow-1 justify-content-center`} style={{ clipPath: "polygon(0% 0%, 95% 0%, 100% 50%, 95% 100%, 0% 100%, 5% 50%)", marginLeft: "-5px" }}>{t("wo_opened")}</div>
                                <div className={`${woIsSuccess ? "bg-success text-white" : woIsInProgress ? "bg-primary text-white" : "bg-light text-secondary border"} px-3 py-2 fw-bold text-12 d-flex align-items-center flex-grow-1 justify-content-center`} style={{ clipPath: "polygon(0% 0%, 95% 0%, 100% 50%, 95% 100%, 0% 100%, 5% 50%)", marginLeft: "-5px" }}>{t("check_in")}</div>
                                <div className={`${woIsSuccess ? "bg-success text-white" : "bg-light text-secondary border"} px-3 py-2 fw-bold text-12 rounded-end d-flex align-items-center flex-grow-1 justify-content-center`} style={{ clipPath: "polygon(0% 0%, 100% 0%, 100% 100%, 0% 100%, 5% 50%)", marginLeft: "-5px" }}>{t("complete_job")}</div>
                            </div>
                            ) : (
                            <div className="d-flex w-100 overflow-auto pb-1" style={{ gap: "2px" }}>
                                <div
                                    className="bg-success text-white px-3 py-2 fw-bold text-12 rounded-start d-flex align-items-center position-relative flex-grow-1 justify-content-center"
                                    style={{ clipPath: "polygon(0% 0%, 95% 0%, 100% 50%, 95% 100%, 0% 100%)" }}
                                >
                                    <span className="icon me-1">{"\uf00c"}</span> {t("wr_received")}
                                </div>
                                <div
                                    className="bg-success text-white px-3 py-2 fw-bold text-12 d-flex align-items-center position-relative flex-grow-1 justify-content-center"
                                    style={{ clipPath: "polygon(0% 0%, 95% 0%, 100% 50%, 95% 100%, 0% 100%, 5% 50%)", marginLeft: "-5px" }}
                                >
                                    <span className="icon me-1">{"\uf00c"}</span> {t("approved")}
                                </div>
                                <div
                                    className="bg-success text-white px-3 py-2 fw-bold text-12 d-flex align-items-center position-relative flex-grow-1 justify-content-center"
                                    style={{ clipPath: "polygon(0% 0%, 95% 0%, 100% 50%, 95% 100%, 0% 100%, 5% 50%)", marginLeft: "-5px" }}
                                >
                                    <span className="icon me-1">{"\uf00c"}</span> {t("call_result_saved")}
                                </div>
                                <div
                                    className={`${woIsSuccess || woIsInProgress ? "bg-success" : "bg-primary"} text-white px-3 py-2 fw-bold text-12 d-flex align-items-center position-relative flex-grow-1 justify-content-center`}
                                    style={{ clipPath: "polygon(0% 0%, 95% 0%, 100% 50%, 95% 100%, 0% 100%, 5% 50%)", marginLeft: "-5px" }}
                                >
                                    <span className="icon me-1">{"\uf022"}</span> {t("wo_opened")}
                                </div>
                                <div
                                    className={`${woIsSuccess ? "bg-success text-white" : woIsInProgress ? "bg-primary text-white" : "bg-light text-secondary border"} px-3 py-2 fw-bold text-12 d-flex align-items-center position-relative flex-grow-1 justify-content-center`}
                                    style={{ clipPath: "polygon(0% 0%, 95% 0%, 100% 50%, 95% 100%, 0% 100%, 5% 50%)", marginLeft: "-5px" }}
                                >
                                    <span className="icon me-1">{"\uf0ad"}</span> {t("check_in")}
                                </div>
                                <div
                                    className={`${woIsSuccess ? "bg-success text-white" : "bg-light text-secondary border"} px-3 py-2 fw-bold text-12 rounded-end d-flex align-items-center position-relative flex-grow-1 justify-content-center`}
                                    style={{ clipPath: "polygon(0% 0%, 100% 0%, 100% 100%, 0% 100%, 5% 50%)", marginLeft: "-5px" }}
                                >
                                    <span className="icon me-1">{"\uf00c"}</span> {t("complete_job")}
                                </div>
                            </div>
                            )}
                        </div>
                    </Modal.Header>

                    <Modal.Body className="p-4" style={{ maxHeight: "65vh", overflowY: "auto" }}>
                        <fieldset disabled={wo_view_mode} className="border-0 p-0 m-0" style={{ minWidth: 0 }}>
                        <div className="row g-4">
                            {/* Left Column */}
                            <div className="col-lg-7">
                                {/* ข้อมูลลูกค้าและสินทรัพย์ */}
                                <div className="mb-4">
                                    <div className="d-flex align-items-center justify-content-between gap-3 mb-3 border-bottom pb-2">
                                        <h6 className="fw-bold text-dark mb-0 d-flex align-items-center text-16">
                                            <span className="icon me-2 text-primary">{"\uf007"}</span> {t("customer_asset_info")}
                                        </h6>
                                        {canLinkWorkRequest && (
                                            <div className="d-flex align-items-center gap-2" style={{ minWidth: "350px" }}>
                                                <span className="text-secondary text-14 text-nowrap">{t("link_work_request")}</span>
                                                <Select
                                                    className="form-control"
                                                    options={filteredWorkRequestOptions}
                                                    onChange={(e) => this.handleLinkWorkRequest(e)}
                                                    value={create_work_request_id}
                                                    placeholder={t("select_work_request")}
                                                    disabled={wo_view_mode}
                                                />
                                            </div>
                                        )}
                                    </div>
                                        
                                    <div className="row g-3">
                                        <div className="col-md-6">
                                            <label className="form-label text-dark fw-bold text-14">
                                                {t("customer")} <span className="text-danger">*</span>
                                            </label>
                                            <Select
                                                className="form-control d-none"
                                                options={data_customer}
                                                onSearch={this.searchCustomers}
                                                onChange={(e, i) => {
                                                    this.pinCustomer(i);
                                                    this.setState({
                                                        create_customer_id: e,
                                                        create_asset_id: "", // เปลี่ยนลูกค้าแล้วล้าง asset ที่เลือกค้างไว้
                                                    });
                                                }}
                                                value={create_customer_id}
                                                placeholder={t("select_customer")}
                                                disabled={isEditing}
                                            />
                                            
                                            <div className="bg-white rounded-3 p-3 border hpx-140 shadow-sm">
                                                <h6 className="fw-bold text-dark mb-1">
                                                    {selectedCustomer?.full_name_th || selectedCustomer?.full_name_en || selectedCustomer?.label || "-"}
                                                </h6>
                                                <div className="text-secondary text-14 mb-2">{selectedCustomer?.address || "-"} {selectedCustomer?.sub_district || "-"} {selectedCustomer?.district || "-"} {selectedCustomer?.province || "-"} {selectedCustomer?.zip_code || "-"}</div>
                                                <div className="text-dark text-14 d-flex align-items-center mb-1">
                                                    <span className="icon me-2 text-secondary">{"\uf095"}</span> {selectedCustomer?.phone || selectedCustomer?.mobile_phone || "-"}
                                                </div>
                                                <div className="text-dark text-14 d-flex align-items-center">
                                                    <span className="icon me-2 text-secondary">{"\uf007"}</span>
                                                    {selectedCustomerContactName
                                                        ? `${selectedCustomerContactName}${selectedCustomer?.contact_position ? ` (${selectedCustomer.contact_position})` : ""}`
                                                        : "-"}
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-6">
                                            <label className="form-label text-dark fw-bold text-14">
                                                {t("asset_machine")} <span className="text-danger">*</span>
                                            </label>
                                            <Select
                                                className="form-control d-none"
                                                options={filteredAssetOptions}
                                                onChange={(e, i) => {
                                                    this.setState({ create_asset_id: e });
                                                }}
                                                value={create_asset_id}
                                                placeholder={create_customer_id ? t("select_asset") : t("select_customer_first")}
                                                disabled={isEditing}
                                            />
                                            
                                            <div className="bg-white rounded-3 p-3 border hpx-140 shadow-sm">
                                                <h6 className="fw-bold text-dark mb-1">{selectedAsset?.part?.name || selectedAsset?.part_name || "-"}</h6>
                                                <div className="text-secondary text-14 mb-2">
                                                    {t("serial_number")}: {selectedAsset?.serial_number || "-"}
                                                </div>
                                                <div className={`text-14 d-flex align-items-center mb-1 fw-bold ${isCustomerWarrantyExpired ? "text-danger" : "text-success"}`}>
                                                    <span className="icon me-2">{"\uf3ed"}</span>
                                                    {t("customer_warranty")} : {" "}
                                                    {customerWarrantyExpireDate
                                                        ? <> <span className="icon mx-1">{isCustomerWarrantyExpired ? "\uf00d" : "\uf00c"}</span> {format_date(customerWarrantyExpireDate, "dd/mm/yyyy", "th")}</>
                                                        : "-"}
                                                </div>
                                                <div className={`text-14 d-flex align-items-center fw-bold ${isVendorWarrantyExpired ? "text-danger" : "text-success"}`}>
                                                    <span className="icon me-2">{"\uf3ed"}</span>
                                                    {t("vendor_warranty")} : {" "}
                                                    {vendorWarrantyExpireDate
                                                        ? <> <span className="icon mx-1">{isVendorWarrantyExpired ? "\uf00d" : "\uf00c"}</span> {format_date(vendorWarrantyExpireDate, "dd/mm/yyyy", "th")}</>
                                                        : "-"}
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-12">
                                            <label className="form-label text-dark fw-bold text-14">{t("label_project")}</label>
                                            <input type="text" className="form-control bg-light" value={selectedAssetProjectText} readOnly disabled />
                                        </div>
                                        <div className="col-md-6">
                                            <label className="form-label text-dark fw-bold text-14">{t("site_contact")}</label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                value={create_contact_name}
                                                placeholder={t("site_contact_name_placeholder")}
                                                onChange={(e) => this.setState({ create_contact_name: e.target.value })}
                                            />
                                        </div>
                                        <div className="col-md-6">
                                            <label className="form-label text-dark fw-bold text-14">{t("contact_phone")}</label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                value={create_contact_phone}
                                                placeholder="02XXXXXXX"
                                                maxLength={10}
                                                onChange={(e) => this.setState({ create_contact_phone: e.target.value.replace(/\D/g, "") })}
                                            />
                                        </div>
                                        <div className="col-md-6">
                                            <label className="form-label text-dark fw-bold text-14">{t("site_contact_2")}</label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                value={create_contact_name_2}
                                                placeholder={t("site_contact_name_2_placeholder")}
                                                onChange={(e) => this.setState({ create_contact_name_2: e.target.value })}
                                            />
                                        </div>
                                        <div className="col-md-6">
                                            <label className="form-label text-dark fw-bold text-14">{t("contact_phone_2_label")}</label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                value={create_contact_phone_2}
                                                placeholder="02XXXXXXX"
                                                maxLength={10}
                                                onChange={(e) => this.setState({ create_contact_phone_2: e.target.value.replace(/\D/g, "") })}
                                            />
                                        </div>
                                    </div>
                                </div>

                                {/* รายละเอียดงาน */}
                                <div className="mb-4">
                                    <h6 className="fw-bold text-dark mb-3 d-flex align-items-center text-16 border-bottom pb-2">
                                        <span className="icon me-2 text-warning">{"\uf044"}</span> {t("work_details")}
                                    </h6>
                                    {/* WO ที่มาจากแผนการตรวจสอบไม่ได้มาจากคำร้อง จึงไม่มีหมวดหมู่คำร้อง/อาการที่แจ้ง -> ซ่อนทั้งสองช่อง */}
                                    {!isInspectionPlanWorkOrder && (
                                        <>
                                            <div className="mb-3">
                                                <label className="form-label text-dark fw-bold text-14">
                                                    {t("req_category")}
                                                    <span className="text-danger"> *</span>
                                                </label>
                                                <Select
                                                    className="form-control"
                                                    options={data_categories}
                                                    value={create_work_requisition_categories_id}
                                                    onChange={(e) => this.handleCreateCategoryChange(e)}
                                                    placeholder={t("select_req_category")}
                                                />
                                            </div>

                                            <div className="mb-3">
                                                <label className="form-label text-dark fw-bold text-14">
                                                    {t("symptom_problem_detail")} <span className="text-danger">*</span>
                                                </label>
                                                <textarea
                                                    className="form-control"
                                                    rows="4"
                                                    value={create_root_cause}
                                                    placeholder={t("symptom_detail_placeholder")}
                                                    onChange={(e) => this.setState({ create_root_cause: e.target.value })}
                                                ></textarea>
                                            </div>
                                        </>
                                    )}

                                    <div className="row g-3">
                                        <div className="col-md-6">
                                            <label className="form-label text-dark fw-bold text-14">
                                                {t("service_type")} <span className="text-danger">*</span>
                                            </label>
                                            <Select
                                                className="form-control"
                                                placeholder={t("select_service_type_placeholder")}
                                                options={data_service_types}
                                                onChange={(e, i) => this.handleServiceTypeChange(e, i)}
                                                value={create_work_requisition_service_types_id}
                                            />
                                        </div>
                                        <div className="col-md-6">
                                            <label className="form-label text-dark fw-bold text-14">
                                                {t("priority")} <span className="text-danger">*</span>
                                            </label>
                                            <Select
                                                className="form-control"
                                                placeholder={t("select_priority")}
                                                options={data_priorities}
                                                onChange={(e, i) => {
                                                    this.setState({
                                                        create_work_requisition_priorities_id: e,
                                                        text_priority_id: this.getPriorityDescription(i),
                                                    });
                                                }}
                                                value={create_work_requisition_priorities_id}
                                            />
                                        </div>
                                    </div>
                                </div>

                                {/* วันที่ และ Visits */}
                                <div className="mb-4">
                                    <h6 className="fw-bold text-dark mb-3 d-flex align-items-center text-16 border-bottom pb-2">
                                        <span className="icon me-2 text-primary">{"\uf073"}</span> {t("set_dates_and_visits")}
                                    </h6>

                                    <div className="bg-white rounded-3 p-2 border mb-3 text-secondary text-14">
                                        <span className="icon text-warning me-2">{"\uf0eb"}</span> {t("multi_day_visit_hint")}
                                    </div>

                                    {/* WO draft จากแผนการตรวจสอบ: บอกให้ชัดว่าเลื่อนวันได้เฉพาะภายในเดือนของ WO ตัวนี้ */}
                                    {inspectionDraftMonth && (
                                        <div className="bg-white rounded-3 p-2 border mb-3 text-primary text-14">
                                            <span className="icon me-2">{""}</span>
                                            {t("inspection_draft_month_hint").replace("{month}", inspectionDraftMonthLabel)}
                                        </div>
                                    )}

                                    {/* วันที่เริ่มต้น */}
                                    <div className="d-flex align-items-end gap-3 mb-4">
                                        <div className="flex-grow-1">
                                            <label className="form-label text-dark fw-bold text-14">
                                                {t("start_date")} <span className="text-danger">*</span>
                                            </label>
                                            <div className="position-relative">
                                                <DatePicker
                                                    type="th"
                                                    className="form-control"
                                                    value={create_start_date}
                                                    min={inspectionDraftMinAllowed}
                                                    max={inspectionDraftMonth ? inspectionDraftMonth.last : undefined}
                                                    disabled={startDateInputLocked}
                                                    onChange={(val) => this.updateVisitRange("create_start_date", val)}
                                                />
                                            </div>
                                        </div>
                                        <div className="pb-2">
                                            <span className="icon text-secondary">{"\uf061"}</span>
                                        </div>
                                        <div className="flex-grow-1">
                                            <label className="form-label text-dark fw-bold text-14">
                                                {t("end_date")} <span className="text-danger">*</span>
                                            </label>
                                            <div className="position-relative">
                                                <DatePicker
                                                    type="th"
                                                    className="form-control"
                                                    value={create_end_date}
                                                    min={inspectionDraftMonth ? inspectionDraftMinAllowed : endDateMinAllowed}
                                                    max={inspectionDraftMonth ? inspectionDraftMonth.last : undefined}
                                                    disabled={endDateInputLocked}
                                                    onChange={(val) => this.updateVisitRange("create_end_date", val)}
                                                />
                                            </div>
                                        </div>
                                    </div>

                                    {/* Auto generated visits */}
                                    <div className="bg-light rounded-3 p-3 border">
                                        <div className="d-flex justify-content-between align-items-center mb-3">
                                            <div className="fw-bold text-dark text-14">
                                                <span className="icon me-2">{"\uf073"}</span>{t("auto_generate_visits")}{" "}
                                                <span className="badge bg-primary rounded-pill ms-2">{formatNumber(visits.length)} {t("visit")}</span>
                                            </div>
                                            <div className="text-secondary text-12">{t("assign_technician_each_visit_hint")}</div>
                                        </div>

                                        {visits.length > 0 ? (
                                            <div className="d-flex flex-column gap-2">
                                                {visits.map((visit, idx) => {
                                                    const isSelectedVisit = selected_visit_date === visit.visit_date;
                                                    const visitTechnicians = this.normalizeTechnicians(visit.technician);
                                                    const visitTechnicianSummary =
                                                        visitTechnicians.length > 0
                                                            ? visitTechnicians.map((technicianId) => this.getTechnicianDisplayName(technicianId)).join(", ")
                                                            : t("no_technician_selected");
                                                    const canCancelVisit = !wo_view_mode && !from_inspection && this.isVisitCancellable(visit);

                                                    return (
                                                        <div
                                                            key={visit.visit_date || visit.uid || idx}
                                                            className={`rounded-3 overflow-hidden ${isSelectedVisit ? "border border-primary shadow-sm" : "bg-white border"}`}
                                                            style={isSelectedVisit ? { boxShadow: "0 0 0 2px rgba(37, 99, 235, 0.14)" } : undefined}
                                                        >
                                                            <div
                                                                role="button"
                                                                onClick={() => this.selectVisit(visit.visit_date)}
                                                                className="p-2 d-flex align-items-center gap-3"
                                                                style={{ cursor: "pointer", ...(isSelectedVisit ? { backgroundColor: "#EEF4FF" } : {}) }}
                                                            >
                                                                <div className="wpx-35 hpx-35 ms-2 rounded-circle bg-primary text-white d-flex align-items-center justify-content-center fw-bold text-12 flex-shrink-0">
                                                                    <span className="text-14">{idx + 1}</span>
                                                                </div>
                                                                <div className="flex-grow-1" style={{ minWidth: 0 }}>
                                                                    <div className="fw-bold text-dark text-truncate">
                                                                        {t("visit")} {idx + 1} - {visit.visit_date ? format_date(visit.visit_date, "dd/mm/yyyy", "th") : t("visit_date_not_set")}
                                                                    </div>
                                                                    <div className="text-secondary text-12 text-truncate" title={visitTechnicianSummary}>
                                                                        <span className="icon me-2 text-secondary">{"\uf007"}</span>
                                                                        {visitTechnicianSummary}
                                                                    </div>
                                                                </div>
                                                                <select
                                                                    className="form-select form-select-sm wpx-150"
                                                                    value={visit.time_slot}
                                                                    onClick={(e) => e.stopPropagation()}
                                                                    onChange={(e) => this.updateVisitField(idx, "time_slot", e.target.value)}
                                                                >
                                                                    {this.visitTimeOptions.map((option) => (
                                                                        <option key={option} value={option}>
                                                                            {option}
                                                                        </option>
                                                                    ))}
                                                                </select>
                                                                {/* สถานะ visit */}
                                                                <div className="px-2">
                                                                    <span className={`badge rounded-pill fw-bold text-10 px-3 py-2 border ${this.getVisitStatusView(visit.status).className}`}>
                                                                        {this.getVisitStatusView(visit.status).label}
                                                                    </span>
                                                                </div>
                                                                <span className="icon text-secondary me-1">{isSelectedVisit ? "\uf078" : "\uf054"}</span>
                                                                {canCancelVisit && (
                                                                    <button
                                                                        type="button"
                                                                        title={t("cancel_visit")}
                                                                        onClick={(e) => {
                                                                            e.stopPropagation();
                                                                            this.cancelVisit(visit);
                                                                        }}
                                                                        className="btn btn-sm btn-light border border-danger rounded-circle d-flex align-items-center justify-content-center p-0 text-danger flex-shrink-0"
                                                                        style={{ width: "22px", height: "22px", lineHeight: 1 }}
                                                                    >
                                                                        <span className="icon text-10">{"\uf00d"}</span>
                                                                    </button>
                                                                )}
                                                            </div>
                                                            {isSelectedVisit && (!from_inspection || isInspectionConverted) && (
                                                                <div className="border-top bg-white p-3">
                                                                    {/* แท็บข้อมูลย่อยของ Visit (ข้อมูลตัวอย่าง) */}
                                                                    <div className="border-bottom d-flex gap-4 text-14 fw-bold mb-3">
                                                                        {[
                                                                            { key: "technician", icon: "\uf4fe", label: t("technician_short"), iconClass: "text-warning" },
                                                                            { key: "parts", icon: "\uf0ad", label: t("parts") },
                                                                            { key: "report", icon: "\uf044", label: t("report") },
                                                                            { key: "cost", icon: "\uf155", label: t("expenses") },
                                                                        ].map((tab) => {
                                                                            const isActiveTab = visit_detail_tab === tab.key;
                                                                            return (
                                                                                <div
                                                                                    key={tab.key}
                                                                                    onClick={(e) => {
                                                                                        e.stopPropagation();
                                                                                        this.setState({ visit_detail_tab: tab.key });
                                                                                        // ตัวเลือกล็อตขึ้นกับ WBS ของโครงการ จึงโหลดตอนเปิดแท็บ (ข้ามเองถ้าเป็น WBS เดิม)
                                                                                        if (tab.key === "parts") this.GetStockLots();
                                                                                    }}
                                                                                    className={`pb-2 pointer d-flex align-items-center ${isActiveTab ? "text-primary fw-bold" : "text-secondary"}`}
                                                                                    style={{
                                                                                        borderBottom: isActiveTab ? "3px solid #2563EB" : "3px solid transparent",
                                                                                        marginBottom: "-1px",
                                                                                    }}
                                                                                >
                                                                                    <span className={`icon me-2 ${isActiveTab && tab.iconClass ? tab.iconClass : ""}`}>{tab.icon}</span> {tab.label}
                                                                                </div>
                                                                            );
                                                                        })}
                                                                        {!!visit.is_followup && (
                                                                            <div
                                                                                className="ms-auto pb-2 d-flex align-items-center text-purple"
                                                                                style={{ color: "#7C3AED" }}
                                                                                title={t("followup_visit_badge")}
                                                                            >
                                                                                <span className="icon me-2">{""}</span> {t("followup_visit_badge")}
                                                                            </div>
                                                                        )}
                                                                        {/* ปุ่ม Service Report (ดู / export) - ขวาสุดของแถวแท็บ
                                                                            โผล่เมื่อ visit เป็น "งานเสร็จแล้ว"/"เสร็จสิ้น" และกดได้แม้ modal อยู่ในโหมดดูอย่างเดียว */}
                                                                        {this.renderServiceReportActions(visit)}
                                                                    </div>

                                                                    {visit_detail_tab === "technician" && (
                                                                        <div>
                                                                            <div className="d-flex align-items-center justify-content-between mb-2">
                                                                                <div className="text-12 fw-bold text-secondary text-uppercase">
                                                                                    <span className="icon me-2 text-primary">{"\uf0c0"}</span> {t("assigned_technicians")}
                                                                                </div>
                                                                                <span className="badge rounded-pill bg-light text-secondary border">{visitTechnicians.length} {t("persons_unit")}</span>
                                                                            </div>
                                                                            {visitTechnicians.length > 0 ? (
                                                                                <div className="d-flex flex-row flex-wrap align-items-center gap-2 mb-3">
                                                                                    {visitTechnicians.map((technicianId, tIdx) => {
                                                                                        const techName = this.getTechnicianDisplayName(technicianId);
                                                                                        const techProfile = this.getTechnicianProfile(technicianId);
                                                                                        return (
                                                                                            <div
                                                                                                key={technicianId || tIdx}
                                                                                                className="d-flex align-items-center border rounded-pill ps-1 pe-3 py-1 bg-white shadow-sm"
                                                                                            >
                                                                                                <div
                                                                                                    className="rounded-circle text-white d-flex align-items-center justify-content-center fw-bold text-14 me-2 flex-shrink-0"
                                                                                                    style={{ backgroundColor: techProfile.tone?.bg || "#6f42c1", width: "36px", height: "36px" }}
                                                                                                >
                                                                                                    {techProfile.initials || "-"}
                                                                                                </div>
                                                                                                <div className="lh-sm">
                                                                                                    <div className="fw-bold text-dark text-14">{techName}</div>
                                                                                                    <div className="text-secondary text-12">{techProfile.specialty || t("technician")}</div>
                                                                                                </div>
                                                                                            </div>
                                                                                        );
                                                                                    })}
                                                                                </div>
                                                                            ) : (
                                                                                <div className="border border-dashed rounded-3 p-3 text-secondary text-12 text-center mb-3" style={{ borderStyle: "dashed" }}>
                                                                                    {t("no_technician_assigned_hint")}
                                                                                </div>
                                                                            )}
                                                                            <div className="d-flex align-items-start bg-light rounded-3 p-3">
                                                                                <span className="icon me-2 text-danger mt-1">{"\uf3c5"}</span>
                                                                                <div>
                                                                                    <div className="text-12 fw-bold text-secondary">{t("work_location_from_asset")}</div>
                                                                                    <div className="text-14 text-dark">{selectedAssetLocationText || t("no_location_data_from_asset")}</div>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    )}

                                                                    {visit_detail_tab === "parts" && (() => {
                                                                        const iatNumber = visit_iat_map[visit.visit_date] || "";
                                                                        const iatStatus = visit_iat_status_map[visit.visit_date] || "";
                                                                        const sapTransfer = sap_transfer_map[visit.visit_date] || null;
                                                                        // เลขเอกสารมาจากอะไหล่ที่ประทับไว้แล้ว (คงอยู่ข้าม visit และข้ามการรีเฟรช)
                                                                        // ตกมาใช้ผลลัพธ์ของรอบที่เพิ่งกดเฉพาะตอนโหลดใบสั่งงานใหม่ไม่สำเร็จ
                                                                        const visitAllParts = [...create_service_bom_parts, ...create_manual_parts];
                                                                        const sapDocuments = this.getVisitSapDocuments(visitAllParts);
                                                                        const sapTransferredAt = this.getVisitSapTransferredAt(visitAllParts);
                                                                        const isLocked = wo_view_mode || !!iatNumber || iatStatus === "pending_approve" || iatStatus === "issued";
                                                                        const visitStatus = String(visit?.status || "").toLowerCase();
                                                                        const isVisitOpen = visitStatus === "" || visitStatus === "open";
                                                                        // ลบอะไหล่ได้ในเงื่อนไขเดียวกับที่เลือกอะไหล่จากแผงขวาได้
                                                                        // (งานประกันโครงการ และยังไม่ถูกล็อกจากการสร้าง IAT)
                                                                        const canRemoveParts = isProjectWarranteeProcess && !isLocked;
                                                                        // 1 แถว = อะไหล่ 1 รายการพร้อมจำนวนรวม (จำนวน 0 คือการ์ดที่ปรับจำนวนลงเหลือ 0 ไว้ ไม่นับเป็นรายการเบิก)
                                                                        const requisitionParts = [
                                                                            ...create_service_bom_parts.filter((p) => p.is_active !== false).map((p) => ({ ...p, source: "จาก BOM" })),
                                                                            ...create_manual_parts.map((p) => ({ ...p, source: "เพิ่มเติม" })),
                                                                        ].filter((p) => Number(p.quantity) > 0);
                                                                        // line_no แบบย่อของทุกแถว (แถวที่บันทึกแล้วใช้เลขจริง แถวที่เพิ่งเพิ่มคำนวณล่วงหน้าด้วยกติกาเดียวกับ backend)
                                                                        // ลำดับ visit ที่ใช้บันทึกคือ idx + 1 (ดู payload ตอน save) ไม่ใช่ visit.sequence ที่อาจค้างจากรอบก่อน
                                                                        const lineNoPreviews = this.previewLineNos(requisitionParts, idx + 1);
                                                                        // บรรทัดที่สต็อก (ยอดว่าง) ไม่พอเบิก - ขึ้นสีแดงในช่องสต๊อก และปิดปุ่มขอเบิกอะไหล่จนกว่าจะพอทุกบรรทัด
                                                                        const insufficientStockUids = this.getInsufficientStockPartUids(requisitionParts);
                                                                        return (
                                                                            <div>
                                                                                {/* แถบโอนอะไหล่เข้าสต็อกโครงการ (SAP) */}
                                                                                {SHOW_SAP_TRANSFER_ORDER && isProjectWarranteeProcess && hasSelectedAssetProject && !visit?.no_parts_requisition && (
                                                                                <div className="d-flex align-items-center justify-content-between py-2 px-3 rounded-3 border bg-light mb-2">
                                                                                    <div className="pe-3">
                                                                                        <div className="text-12 text-secondary mb-1">
                                                                                            <span className="icon me-2 text-primary">{"\uf15c"}</span> {t("sap_material_document_label")}
                                                                                        </div>
                                                                                        {sapDocuments.length || sapTransfer?.material_document ? (
                                                                                            <div className="d-flex flex-wrap align-items-center gap-2">
                                                                                                {/* 1 movement type = 1 เอกสาร จึงอาจได้ 2 เลขในการกดครั้งเดียว (412Q + 311Q) */}
                                                                                                {(sapDocuments.length
                                                                                                    ? sapDocuments
                                                                                                    : sapTransfer.documents?.length
                                                                                                      ? sapTransfer.documents
                                                                                                      : [sapTransfer]
                                                                                                )
                                                                                                    .filter((doc) => doc.material_document)
                                                                                                    .map((doc) => (
                                                                                                        <span
                                                                                                            key={doc.material_document}
                                                                                                            className="badge rounded-pill bg-white border text-dark fw-bold text-14 px-3 py-2"
                                                                                                        >
                                                                                                            {doc.material_document}
                                                                                                            {doc.material_document_year ? ` / ${doc.material_document_year}` : ""}
                                                                                                            {doc.movement_type ? (
                                                                                                                <span className="text-secondary fw-normal ms-2">{doc.movement_type}Q</span>
                                                                                                            ) : null}
                                                                                                        </span>
                                                                                                    ))}
                                                                                            </div>
                                                                                        ) : (
                                                                                            <div className="text-12 text-secondary">{t("sap_transfer_order_not_created_yet")}</div>
                                                                                        )}
                                                                                    </div>
                                                                                    {saved_requisition_map[visit.visit_date] ? (
                                                                                        <div className="d-flex align-items-center gap-2 flex-shrink-0" onClick={(e) => e.stopPropagation()}>
                                                                                            {this.isReadyForSapTransfer(requisitionParts) ? (
                                                                                                !wo_view_mode && (
                                                                                                    <button
                                                                                                        type="button"
                                                                                                        className="btn btn-primary btn-sm fw-bold d-flex align-items-center text-nowrap"
                                                                                                        disabled={insufficientStockUids.size > 0}
                                                                                                        title={insufficientStockUids.size > 0 ? t("part_stock_not_enough") : undefined}
                                                                                                        onClick={() => this.handleCreateSapTransferOrder(visit)}
                                                                                                    >
                                                                                                        <span className="icon me-1">{"\uf0ec"}</span> {t("create_sap_transfer_order")}
                                                                                                    </button>
                                                                                                )
                                                                                            ) : sapDocuments.length ? (
                                                                                                // ไม่มีอะไหล่รอโอนแล้วและมีเลขเอกสารครบ = โอนครบทุกชิ้น (โชว์ให้เห็นแม้อยู่โหมดดูอย่างเดียว)
                                                                                                <div className="text-end">
                                                                                                    <span
                                                                                                        className="badge rounded-pill px-3 py-2"
                                                                                                        style={{ backgroundColor: "#DCFCE7", color: "#166534" }}
                                                                                                    >
                                                                                                        <span className="icon me-1">{"\uf00c"}</span> {t("sap_transfer_done")}
                                                                                                    </span>
                                                                                                    {sapTransferredAt && (
                                                                                                        <div className="text-10 text-secondary mt-1">
                                                                                                            {t("sap_transfer_done")}: {format_date(sapTransferredAt, "dd/mm/yyyy hh:mm", "th")}
                                                                                                        </div>
                                                                                                    )}
                                                                                                </div>
                                                                                            ) : (
                                                                                                !wo_view_mode && (
                                                                                                    <span className="text-12 text-secondary text-nowrap">{t("check_data_before_sap_transfer")}</span>
                                                                                                )
                                                                                            )}
                                                                                        </div>
                                                                                    ) : requisitionParts.length > 0 ? (
                                                                                        <span className="text-12 text-secondary fst-italic text-nowrap">{t("save_withdrawal_list_first")}</span>
                                                                                    ) : null}
                                                                                </div>
                                                                                )}

                                                                                {/* ตารางอะไหล่ (ดึงจากเบิกอะไหล่ของ Visit) */}
                                                                                {/* table-layout: fixed = คอลัมน์กว้างตามที่กำหนด ไม่ยืดตามข้อความจนต้องเลื่อนซ้าย-ขวา ข้อความยาวตัดเป็น ... แทน */}
                                                                                {requisitionParts.length > 0 ? (
                                                                                    <div style={{ overflow: "hidden" }}>
                                                                                        <table className="table table-sm align-middle mb-0" style={{ tableLayout: "fixed", width: "100%" }}>
                                                                                            <thead>
                                                                                                <tr className="text-secondary border-bottom">
                                                                                                    <th className="fw-bold">{t("parts")}</th>
                                                                                                    <th className="fw-bold text-center" style={{ width: "56px" }}>{t("issues")}</th>
                                                                                                    <th className="fw-bold text-center" style={{ width: "64px" }}>{isVisitOpen ? t("part_stock") : t("actual_used")}</th>
                                                                                                    {!isExternalNormalSales && (
                                                                                                    <th className="fw-bold text-center" style={{ width: "27%" }}>
                                                                                                        {t("stock_lot")}
                                                                                                        {this.renderColumnInfoIcon({
                                                                                                            stateKey: "stock_lot_info_open",
                                                                                                            title: t("stock_lot_info_breakdown"),
                                                                                                            parts: [
                                                                                                                t("storage_area"),
                                                                                                                t("batch_number"),
                                                                                                                t("special_stock_type"),
                                                                                                                t("wbs_element"),
                                                                                                            ],
                                                                                                        })}
                                                                                                    </th>
                                                                                                    )}
                                                                                                    {!isExternalNormalSales && (
                                                                                                    <th className="fw-bold text-center" style={{ width: "29%" }}>{t("wbs_element")}</th>
                                                                                                    )}
                                                                                                    {canRemoveParts && <th className="fw-bold text-center" style={{ width: "36px" }} />}
                                                                                                </tr>
                                                                                            </thead>
                                                                                            <tbody className="text-14">
                                                                                                {requisitionParts.map((part) => {
                                                                                                    // โอนเข้า VAN สำเร็จแล้ว = ของเปลี่ยนมือใน SAP ไปแล้ว เปลี่ยนล็อตไม่ได้อีก
                                                                                                    // ล็อกเฉพาะช่องล็อตสต็อก ช่องอื่นยังใช้งาน/อ่านได้ตามปกติ ไม่ทำทั้งแถวจาง
                                                                                                    const isTransferred = this.isPartTransferredToSap(part);
                                                                                                    const isStockLotLocked = isLocked || isTransferred;
                                                                                                    return (
                                                                                                    <tr key={part.uid}>
                                                                                                        <td style={{ overflow: "hidden" }}>
                                                                                                            <div className="fw-bold text-dark text-truncate" title={part.part_name}>
                                                                                                                {part.part_name}
                                                                                                            </div>
                                                                                                            <div className="text-12 text-secondary text-truncate">
                                                                                                                {part.source === "เพิ่มเติม" ? t("manual_added") : t("from_bom")} ·{" "}
                                                                                                                {part.part_number || "-"}
                                                                                                            </div>
                                                                                                            {/* บรรทัด 3 = รหัสอ้างอิงรายบรรทัดแบบย่อ (ตัดเลข WO ออก) เลขท้ายสุดแยกไว้ไม่ให้ถูกตัดเมื่อรหัสอะไหล่ยาว
                                                                                                                แถวที่เพิ่งเพิ่มยังไม่บันทึกก็เห็นเลขล่วงหน้าแล้ว (ตัวเอียง + tooltip บอกว่าเป็นค่าคาดการณ์) */}
                                                                                                            {(() => {
                                                                                                                const lineNo = lineNoPreviews.get(part.uid);
                                                                                                                if (!lineNo) return null;
                                                                                                                const isSaved = !!part.line_no;
                                                                                                                return (
                                                                                                                    <div
                                                                                                                        className={`d-flex text-10 text-secondary ${isSaved ? "" : "fst-italic"}`}
                                                                                                                        title={`${t("part_line_no")}: ${isSaved ? part.line_no : `${lineNo.prefix}${lineNo.running} (${t("part_line_no_preview")})`}`}
                                                                                                                    >
                                                                                                                        <span className="text-truncate">{lineNo.prefix}</span>
                                                                                                                        <span className="fw-bold text-dark flex-shrink-0">{lineNo.running}</span>
                                                                                                                    </div>
                                                                                                                );
                                                                                                            })()}
                                                                                                            {isTransferred && (
                                                                                                                <div className="text-12 text-success text-truncate" title={t("sap_transfer_done_hint")}>
                                                                                                                    <span className="icon me-1">{"\uf00c"}</span>
                                                                                                                    {part.sap_material_document}
                                                                                                                    {part.sap_movement_type ? ` · ${part.sap_movement_type}Q` : ""}
                                                                                                                </div>
                                                                                                            )}
                                                                                                        </td>
                                                                                                        <td className="text-center">{formatNumber(part.quantity)}</td>
                                                                                                        <td className="text-center" onClick={(e) => e.stopPropagation()}>
                                                                                                            {isVisitOpen ? (
                                                                                                                <span
                                                                                                                    className={insufficientStockUids.has(part.uid) ? "text-danger fw-bold" : ""}
                                                                                                                    title={insufficientStockUids.has(part.uid) ? t("part_stock_not_enough") : undefined}
                                                                                                                >
                                                                                                                    {this.getPartAvailableStock(part) == null ? "-" : formatNumber(this.getPartAvailableStock(part))}
                                                                                                                </span>
                                                                                                            ) : (
                                                                                                                // "ใช้จริง" เป็นค่าที่ช่างบันทึกจากมือถือ ฝั่งเว็บแสดงอย่างเดียว ห้ามแก้ทับ
                                                                                                                <span>{formatNumber(part.actual_quantity ?? 0)}</span>
                                                                                                            )}
                                                                                                        </td>
                                                                                                        {!isExternalNormalSales && (
                                                                                                        <td className="text-center" onClick={(e) => e.stopPropagation()}>
                                                                                                            {(() => {
                                                                                                                const stockLotOptions = this.getSelectableStockLots(part);
                                                                // มีล็อตอยู่แต่ถูกกรองออกหมด = เป็นสต็อกของโครงการอื่นล้วน คนละเรื่องกับไม่มีสต็อกเลย
                                                                const hasLotOfOtherProject = !stockLotOptions.length && !!(this.state.data_stock_lots?.[part.part_id] || []).length;
                                                                                                                const selectedStockLot = this.getSelectedStockLot(part);
                                                                                                                const stockLotSelectOptions = stockLotOptions.map((lot) => ({
                                                                                                                    value: lot.uid,
                                                                                                                    label: this.formatStockLotLabel(lot),
                                                                                                                    // ในช่องหลังเลือกแล้วตัดรหัส WBS ออก (ไปอยู่ช่อง "รหัส WBS" แล้ว)
                                                                                                                    selected_label: this.formatStockLotLabel(lot, { withWbs: false }),
                                                                                                                }));

                                                                                                                return (
                                                                                                                    <div style={{ width: "100%" }}>
                                                                                                                        <Select
                                                                                                                            className="form-control form-control-sm"
                                                                                                                            options={stockLotSelectOptions}
                                                                                                                            value={part.stock_lot_id || ""}
                                                                                                                            // ล็อตที่เคยเลือกไว้อาจไม่อยู่ในตัวเลือกแล้ว (ของหมด) แต่ยังต้องอ่านออกว่าเลือกอะไรไว้
                                                                                                                            valueLabel={selectedStockLot ? this.formatStockLotLabel(selectedStockLot, { withWbs: false }) : ""}
                                                                                                                            placeholder={stockLotOptions.length ? t("select_stock_lot") : t(hasLotOfOtherProject ? "stock_lot_other_project_only" : "stock_lot_not_found")}
                                                                                                                            defaultLabel={t("no_stock_lot_selected")}
                                                                                                                            // ป้ายยาว 4 ส่วน ถ้าปล่อยให้กล่องกว้างเท่าช่องจะตัดขึ้นบรรทัดใหม่ตอนเปิดดู
                                                                                                                            nowrapOptions
                                                                                                                            disabled={isStockLotLocked || !stockLotOptions.length}
                                                                                                                            onChange={(value) => this.handleSelectStockLot(part, value)}
                                                                                                                        />
                                                                                                                    </div>
                                                                                                                );
                                                                                                            })()}
                                                                                                        </td>
                                                                                                        )}
                                                                                                        {!isExternalNormalSales && (
                                                                                                        <td className="text-center" onClick={(e) => e.stopPropagation()}>
                                                                                                            {(() => {
                                                                                                                // ล็อตที่มี WBS ติดมา = ใช้ของล็อต ล็อกช่องไว้ให้อ่านอย่างเดียว
                                                                                                                // ล็อตไม่มี WBS = ให้เลือกจาก WBS ที่ขึ้นต้นด้วยรหัสโครงการของทรัพย์สิน
                                                                                                                const selectedStockLot = this.getSelectedStockLot(part);
                                                                                                                const lotWbs = String(selectedStockLot?.wbs_element || "").trim();
                                                                                                                const wbsOptions = lotWbs ? [{ value: lotWbs, label: lotWbs }] : this.getSelectableWbsOptions();
                                                                                                                return (
                                                                                                                    <div style={{ width: "100%" }}>
                                                                                                                        <Select
                                                                                                                            className="form-control form-control-sm"
                                                                                                                            options={wbsOptions}
                                                                                                                            value={part.wbs_element || ""}
                                                                                                                            // ค่าที่บันทึกไว้อาจไม่อยู่ในตัวเลือกแล้ว (เปลี่ยนทรัพย์สิน/โครงการ) แต่ยังต้องอ่านออกว่าเลือกอะไรไว้
                                                                                                                            valueLabel={part.wbs_element || ""}
                                                                                                                            placeholder={wbsOptions.length ? t("select_wbs_element") : t("wbs_element_not_found")}
                                                                                                                            defaultLabel={t("no_wbs_element_selected")}
                                                                                                                            nowrapOptions
                                                                                                                            disabled={isStockLotLocked || !!lotWbs || !wbsOptions.length}
                                                                                                                            onChange={(value) => this.handleSelectWbsElement(part, value)}
                                                                                                                        />
                                                                                                                    </div>
                                                                                                                );
                                                                                                            })()}
                                                                                                        </td>
                                                                                                        )}
                                                                                                        {canRemoveParts && (
                                                                                                        <td className="text-center" onClick={(e) => e.stopPropagation()}>
                                                                                                            {this.isPartUnitLocked(part) ? (
                                                                                                                <span className="icon text-secondary" title={t("part_locked_cannot_delete")}>
                                                                                                                    {"\uf023"}
                                                                                                                </span>
                                                                                                            ) : (
                                                                                                                <span
                                                                                                                    className="icon text-danger pointer"
                                                                                                                    title={t("delete_item")}
                                                                                                                    onClick={() => this.handleDeleteIATRow(part)}
                                                                                                                >
                                                                                                                    {"\uf00d"}
                                                                                                                </span>
                                                                                                            )}
                                                                                                        </td>
                                                                                                        )}
                                                                                                    </tr>
                                                                                                    );
                                                                                                })}
                                                                                            </tbody>
                                                                                        </table>
                                                                                    </div>
                                                                                ) : (
                                                                                    <div className="border rounded-3 p-3 bg-white text-secondary text-12 text-center">
                                                                                        {t("no_withdrawal_items_in_visit")}
                                                                                    </div>
                                                                                )}
                                                                                        {/* กล่องแยกตาม Mat Doc ของเอกสารเบิกเพิ่มเติม WBS (ระดับ WO เห็นเหมือนกันทุก Visit) */}
                                                                                        {this.state.edit_work_order_id && <WoWbsPartsBoxes woUid={this.state.edit_work_order_id} />}
                                                                                        {/* อะไหล่ที่เบิกเพิ่มจากใบขอเบิกที่บันทึกแล้ว (เฉพาะ Normal Sales) */}
                                                                                        {this.isNormalSalesWorkOrder() && this.state.edit_work_order_id && <WoPickingExtraPartsTable lists={this.state.pl_lists} />}
                                                                            </div>
                                                                        );
                                                                    })()}

                                                                    {visit_detail_tab === "report" && create_inspection_plan_id && (() => {
                                                                        // WO นี้มาจาก PM Plan (มี checklist) - แสดงผลตรวจ/รูป/หมายเหตุ/ลายเซ็นที่กรอกจากมือถือ แทนฟอร์มรายงานบริการปกติ
                                                                        const pmChecklistTemplate = (data_checklist_templates || []).find(
                                                                            (tmpl) => tmpl.uid === create_checklist_template_id
                                                                        );
                                                                        const pmTemplateItemsByUid = new Map(
                                                                            (Array.isArray(pmChecklistTemplate?.items) ? pmChecklistTemplate.items : []).map((item) => [
                                                                                item.uid,
                                                                                item,
                                                                            ])
                                                                        );
                                                                        const pmChecklistItems = (create_checklist_items || []).filter((item) => item.is_used !== false);
                                                                        const pmAnswerLabel = (item) => {
                                                                            if (item.value === "" || item.value == null) return t("no_answer");
                                                                            if (item.input_type === "measurement") {
                                                                                const tpl = pmTemplateItemsByUid.get(item.checklist_item_id);
                                                                                return tpl?.unit ? `${item.value} ${tpl.unit}` : String(item.value);
                                                                            }
                                                                            if (item.input_type === "check") return item.value === "fail" ? t("fail") : t("pass");
                                                                            if (item.input_type === "yesno") return item.value === "no" ? t("pm_no") : t("pm_yes");
                                                                            if (item.input_type === "checkbox") {
                                                                                if (item.value !== "done") return t("ct_answer_not_done");
                                                                                const tpl = pmTemplateItemsByUid.get(item.checklist_item_id);
                                                                                return tpl?.label_right || t("ct_answer_done");
                                                                            }
                                                                            return String(item.value);
                                                                        };
                                                                        // คอลัมน์หมายเหตุช่าง: แสดงเมื่อเทมเพลตเปิด Remark หรือมีข้อใดมีหมายเหตุอยู่แล้ว
                                                                        const pmShowRemark = !!pmChecklistTemplate?.is_remark_enabled || pmChecklistItems.some((item) => item.remark);
                                                                        const pmPhotos = Array.isArray(visit?.pm_checklist_photos) ? visit.pm_checklist_photos : [];

                                                                        return (
                                                                        <div>
                                                                            <div className="mb-3">
                                                                                <label className="form-label fw-bold text-dark text-13">{t("pm_checklist_items")}</label>
                                                                                <div className="table-responsive">
                                                                                    <table className="table table-sm align-middle mb-0">
                                                                                        <thead>
                                                                                            <tr>
                                                                                                <th style={{ width: 40 }}>#</th>
                                                                                                <th>{t("description")}</th>
                                                                                                <th>{t("answer")}</th>
                                                                                                {pmShowRemark && <th>{t("checklist_item_remark")}</th>}
                                                                                            </tr>
                                                                                        </thead>
                                                                                        <tbody>
                                                                                            {pmChecklistItems.map((item, idx) => (
                                                                                                <tr key={item.uid || idx}>
                                                                                                    <td>{idx + 1}</td>
                                                                                                    <td>{item.description || "-"}</td>
                                                                                                    <td className={isChecklistItemFailed(item, pmTemplateItemsByUid.get(item.checklist_item_id)) ? "text-danger fw-bold" : ""}>
                                                                                                        {pmAnswerLabel(item)}
                                                                                                    </td>
                                                                                                    {pmShowRemark && <td style={{ whiteSpace: "pre-wrap" }}>{item.remark || "-"}</td>}
                                                                                                </tr>
                                                                                            ))}
                                                                                            {pmChecklistItems.length === 0 && (
                                                                                                <tr>
                                                                                                    <td colSpan={pmShowRemark ? 4 : 3} className="text-center text-secondary">
                                                                                                        {t("no_checklist")}
                                                                                                    </td>
                                                                                                </tr>
                                                                                            )}
                                                                                        </tbody>
                                                                                    </table>
                                                                                </div>
                                                                            </div>
                                                                            <div className="mb-3">
                                                                                <label className="form-label fw-bold text-dark text-13">{t("service_photos_mobile")}</label>
                                                                                {pmPhotos.length > 0 ? (
                                                    <div>{this.renderPmPhotoGroups(pmPhotos)}</div>
                                                ) : (
                                                                                    <div className="text-secondary text-13">{t("no_photos")}</div>
                                                                                )}
                                                                            </div>
                                                                            <div className="mb-3">
                                                                                <label className="form-label fw-bold text-dark text-13">{t("pm_notes_label")}</label>
                                                                                <textarea className="form-control" rows={3} value={visit?.pm_notes || ""} disabled />
                                                                            </div>
                                                                            <div>
                                                                                <label className="form-label fw-bold text-dark text-13">{t("customer_signature_job_complete")}</label>
                                                                                {visit?.customer_signature ? (
                                                                                    <div className="border rounded-3 p-2 text-center bg-light mb-2">
                                                                                        <img src={visit.customer_signature} alt="" style={{ maxHeight: 120, maxWidth: "100%" }} />
                                                                                    </div>
                                                                                ) : (
                                                                                    <div
                                                                                        className="border rounded-3 p-4 text-center text-secondary bg-light mb-2"
                                                                                        style={{ borderStyle: "dashed" }}
                                                                                    >
                                                                                        <span className="icon me-2 text-warning">{"\uf044"}</span> {t("waiting_customer_signature")}
                                                                                    </div>
                                                                                )}
                                                                            </div>
                                                                        </div>
                                                                        );
                                                                    })()}
                                                                    {visit_detail_tab === "report" && !create_inspection_plan_id && (() => {
                                                                        const mobilePhotos = Array.isArray(visit?.service_attachments) ? visit.service_attachments : [];
                                                                        // รูปชุดเก่า (ตั้งชื่อไฟล์ตายตัวตามช่วงงาน) - ยังมีในข้อมูลเดิมก่อนเปลี่ยนเป็นอัปโหลดหลายรูป
                                                                        const legacyPhotoKeys = [
                                                                            { key: "before-service.jpg", label: t("before_service") },
                                                                            { key: "during-service.jpg", label: t("during_service") },
                                                                            { key: "after-service-progress.jpg", label: t("after_service") },
                                                                            { key: "after-service-completion.jpg", label: t("after_service_completion") },
                                                                        ];
                                                                        const legacyPhotoGroups = legacyPhotoKeys
                                                                            .map((group) => ({ ...group, photo: mobilePhotos.find((a) => a.name === group.key) }))
                                                                            .filter((group) => group.photo);
                                                                        // คำนำหน้าชื่อไฟล์รูปช่วง "ระหว่างดำเนินการ" / "หลังดำเนินการ" จากหน้ารายงานบริการมือถือ (ตอนปิดงาน
                                                                        // ช่างแยกอัปโหลด 2 ช่อง ตาม PM ชี้แจง 2026-09-12) ต้องตรงกับ SNAPA-Mobile/app/services/jobService.ts และ
                                                                        // SNAPA-Backend/modules/admin/work-order/service-report.template.js buildServicePhotoStages()
                                                                        const SERVICE_PHOTO_DURING_PREFIX = "service-photo-during-";
                                                                        const SERVICE_PHOTO_AFTER_PREFIX = "service-photo-after-";
                                                                        const sortByIndex = (a, b) => (parseInt(a.name.replace(/\D/g, ""), 10) || 0) - (parseInt(b.name.replace(/\D/g, ""), 10) || 0);
                                                                        // รูปช่วง "ระหว่างดำเนินการ" ของจริง เรียงตาม sequence
                                                                        const duringPhotoGroups = mobilePhotos
                                                                            .filter((a) => (a.name || "").startsWith(SERVICE_PHOTO_DURING_PREFIX))
                                                                            .sort(sortByIndex)
                                                                            .map((photo, i) => ({ key: photo.name || `service-photo-during-${i + 1}`, label: `${t("during_service")} ${i + 1}`, photo }));
                                                                        // รูปช่วง "หลังดำเนินการ" ของจริง เรียงตาม sequence
                                                                        const afterIndexedPhotoGroups = mobilePhotos
                                                                            .filter((a) => (a.name || "").startsWith(SERVICE_PHOTO_AFTER_PREFIX))
                                                                            .sort(sortByIndex)
                                                                            .map((photo, i) => ({ key: photo.name || `service-photo-after-${i + 1}`, label: `${t("after_service")} ${i + 1}`, photo }));
                                                                        // รูปรุ่นก่อนแยกช่วง: ชื่อไฟล์ service-photo-1.jpg, -2, ... ไม่มี during/after - ไม่มีข้อมูลพอจะรู้ช่วงจริง
                                                                        // ถือเป็น "หลังดำเนินการ" เหมือนที่ backend/มือถือ fallback ไว้ ไม่ให้รูปเก่าหายไปจากหน้านี้
                                                                        const legacyUnsplitPhotoGroups = mobilePhotos
                                                                            .filter((a) => {
                                                                                const name = a.name || "";
                                                                                return (
                                                                                    name.startsWith("service-photo-") &&
                                                                                    !name.startsWith(SERVICE_PHOTO_DURING_PREFIX) &&
                                                                                    !name.startsWith(SERVICE_PHOTO_AFTER_PREFIX)
                                                                                );
                                                                            })
                                                                            .sort(sortByIndex)
                                                                            .map((photo, i) => ({ key: photo.name || `service-photo-${i + 1}`, label: `${t("service_photos_mobile")} ${i + 1}`, photo }));
                                                                        // ไฟล์แนบกลุ่ม service ที่ไม่เข้าพวกทั้งหมดข้างต้น ก็ยังต้องแสดง ไม่ให้ไฟล์ของช่างหายไปเงียบ ๆ
                                                                        const otherPhotoGroups = mobilePhotos
                                                                            .filter(
                                                                                (a) =>
                                                                                    !(a.name || "").startsWith("service-photo-") &&
                                                                                    !legacyPhotoKeys.some((group) => group.key === a.name)
                                                                            )
                                                                            .map((photo, i) => ({ key: photo.name || `service-other-${i + 1}`, label: photo.name || "-", photo }));
                                                                        // รูปเก่าทุกแบบที่ไม่มีข้อมูลพอจะรู้ช่วงจริง + รูปช่วง "หลังดำเนินการ" ของจริง รวมกันเป็นกลุ่มเดียว
                                                                        const afterPhotoGroups = [...legacyPhotoGroups, ...legacyUnsplitPhotoGroups, ...afterIndexedPhotoGroups, ...otherPhotoGroups];
                                                                        // ผลตรวจ checklist ที่ช่างติ๊ก/กรอกจากมือถือ (WO ที่ไม่ได้มาจาก PM Plan ก็มี checklist ได้)
                                                                        const checklistTemplate = (data_checklist_templates || []).find(
                                                                            (tmpl) => tmpl.uid === create_checklist_template_id
                                                                        );
                                                                        const templateItemsByUid = new Map(
                                                                            (Array.isArray(checklistTemplate?.items) ? checklistTemplate.items : []).map((item) => [item.uid, item])
                                                                        );
                                                                        const reportChecklistItems = (create_checklist_items || []).filter((item) => item.is_used !== false);
                                                                        const checklistAnswerLabel = (item) => {
                                                                            // input_type "check" ที่ยังไม่มี value ให้ดูผลติ๊กจากรายงานบริการ (is_checked) แทน
                                                                            if (item.value === "" || item.value == null) {
                                                                                return item.is_checked ? t("pass") : t("no_answer");
                                                                            }
                                                                            if (item.input_type === "measurement") {
                                                                                const tpl = templateItemsByUid.get(item.checklist_item_id);
                                                                                return tpl?.unit ? `${item.value} ${tpl.unit}` : String(item.value);
                                                                            }
                                                                            if (item.input_type === "check") return item.value === "fail" ? t("fail") : t("pass");
                                                                            if (item.input_type === "yesno") return item.value === "no" ? t("pm_no") : t("pm_yes");
                                                                            if (item.input_type === "checkbox") {
                                                                                if (item.value !== "done") return t("ct_answer_not_done");
                                                                                const tpl = templateItemsByUid.get(item.checklist_item_id);
                                                                                return tpl?.label_right || t("ct_answer_done");
                                                                            }
                                                                            return String(item.value);
                                                                        };
                                                                        const reportShowRemark = !!checklistTemplate?.is_remark_enabled || reportChecklistItems.some((item) => item.remark);
                                                                        const checkinPhotos = Array.isArray(visit?.checkin_attachments) ? visit.checkin_attachments : [];

                                                                        return (
                                                                        <div>
                                                                            {/* สถานะที่ช่างเลือกตอนส่งรายงาน/ปิดงานจากมือถือ (เสร็จสิ้น / ติดตามผล) */}
                                                                            {["check_out", "close_job"].includes(this.normalizeStatusKey(visit?.status)) && (
                                                                                <div className="mb-3">
                                                                                    <label className="form-label fw-bold text-dark text-13">{t("visit_job_status")}</label>
                                                                                    <div>
                                                                                        <span className={`badge ${visit?.is_followup ? "bg-warning text-dark" : "bg-success"}`}>
                                                                                            {visit?.is_followup ? t("job_status_followup") : t("job_status_completed")}
                                                                                        </span>
                                                                                    </div>
                                                                                </div>
                                                                            )}
                                                                            {/* ISS-023: ใครมอบหมาย / ใครปิดงาน พร้อมเวลา (แสดงเฉพาะที่มีข้อมูลจริง ไม่ใส่ค่าปลอม) */}
                                                                            {(visit?.assigned_at || visit?.closed_at || visit?.site_closed_at) && (
                                                                            <div className="mb-3 px-3 py-1 rounded border bg-light">
                                                                                {visit?.assigned_at && (
                                                                                    <div className="d-flex align-items-center gap-2 py-2">
                                                                                        <svg className="text-primary" width="14" height="14" viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true"><path d="M9.5 2.5l4 4-2 2-4-4z" /><path d="M8.5 5.5L2 12a1.4 1.4 0 0 0 2 2l6.5-6.5" /></svg>
                                                                                        <span className="fw-bold text-dark text-13">{t("visit_assigned_by")}:</span>
                                                                                        <span className="text-secondary text-13">
                                                                                            {visit?.assigned_by_user?.full_name || "-"}
                                                                                            {` (${format_date(visit.assigned_at, "dd/mm/yyyy hh:mm", "th")})`}
                                                                                        </span>
                                                                                    </div>
                                                                                )}
                                                                                {visit?.closed_at && (
                                                                                    <div className="d-flex align-items-center gap-2 py-2">
                                                                                        <svg className="text-primary" width="14" height="14" viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true"><path d="M2.5 8.5l3.5 3.5 7.5-8" /></svg>
                                                                                        <span className="fw-bold text-dark text-13">{t("visit_closed_by")}:</span>
                                                                                        <span className="text-secondary text-13">
                                                                                            {visit?.closed_by_user?.full_name || "-"}
                                                                                            {` (${format_date(visit.closed_at, "dd/mm/yyyy hh:mm", "th")})`}
                                                                                        </span>
                                                                                    </div>
                                                                                )}
                                                                                {visit?.site_closed_at && (
                                                                                    <div className="d-flex align-items-center gap-2 py-2">
                                                                                        <svg className="text-primary" width="14" height="14" viewBox="0 0 16 16" fill="currentColor" aria-hidden="true"><path d="M8 1a3 3 0 0 0-3 3v3H4a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V8a1 1 0 0 0-1-1h-1V4a3 3 0 0 0-3-3m2 6H6V4a2 2 0 1 1 4 0z" /></svg>
                                                                                        <span className="fw-bold text-dark text-13">{t("visit_site_closed_by")}:</span>
                                                                                        <span className="text-secondary text-13">
                                                                                            {visit?.site_closed_by_user?.full_name || "-"}
                                                                                            {` (${format_date(visit.site_closed_at, "dd/mm/yyyy hh:mm", "th")})`}
                                                                                        </span>
                                                                                    </div>
                                                                                )}
                                                                            </div>
                                                                        )}
                                                                            {/* อาการ/รายละเอียดปัญหา ที่ช่างกรอกจากมือถือ - เก็บที่ระดับ WO (work_orders.root_cause) */}
                                                                            <div className="mb-3">
                                                                                <label className="form-label fw-bold text-dark text-13">{t("symptom_problem_detail")}</label>
                                                                                <textarea className="form-control" rows={2} value={create_root_cause || ""} disabled />
                                                                            </div>
                                                                            <div className="mb-3">
                                                                                <label className="form-label fw-bold text-dark text-13">{t("req_category")}</label>
                                                                                <Select
                                                                                    className="form-control"
                                                                                    placeholder={t("select_req_category")}
                                                                                    options={data_categories}
                                                                                    value={visit?.report_category || ""}
                                                                                    onChange={(e) => this.handleVisitReportChange("report_category", e)}
                                                                                />
                                                                            </div>
                                                                            <div className="mb-3">
                                                                                <label className="form-label fw-bold text-dark text-13">{t("service_type")}</label>
                                                                                <Select
                                                                                    className="form-control"
                                                                                    placeholder={t("select_job_type_placeholder")}
                                                                                    options={data_service_types}
                                                                                    value={visit?.report_service_type || ""}
                                                                                    onChange={(e) => this.handleVisitReportChange("report_service_type", e)}
                                                                                />
                                                                            </div>
                                                                            {/* สาเหตุหลักที่ช่างเลือกจาก dropdown ในมือถือ - เว็บแสดงผลอย่างเดียว แก้ไขไม่ได้ */}
                                                                            {!!visit?.root_cause_type && (
                                                                                <div className="mb-3">
                                                                                    <label className="form-label fw-bold text-dark text-13">{t("root_cause_type")}</label>
                                                                                    <input
                                                                                        className="form-control"
                                                                                        value={
                                                                                            ROOT_CAUSE_TYPE_LABEL_KEYS[visit.root_cause_type]
                                                                                                ? t(ROOT_CAUSE_TYPE_LABEL_KEYS[visit.root_cause_type])
                                                                                                : visit.root_cause_type
                                                                                        }
                                                                                        disabled
                                                                                    />
                                                                                </div>
                                                                            )}
                                                                            <div className="mb-3">
                                                                                <label className="form-label fw-bold text-dark text-13">{t("root_cause_found")}</label>
                                                                                <textarea
                                                                                    className="form-control"
                                                                                    rows={3}
                                                                                    placeholder={t("specify_root_cause_placeholder")}
                                                                                    value={visit?.root_cause || ""}
                                                                                    onChange={(e) => this.handleVisitReportChange("root_cause", e.target.value)}
                                                                                />
                                                                            </div>
                                                                            <div className="mb-3">
                                                                                <label className="form-label fw-bold text-dark text-13">{t("resolution_method_steps")}</label>
                                                                                <textarea
                                                                                    className="form-control"
                                                                                    rows={3}
                                                                                    placeholder={t("specify_resolution_placeholder")}
                                                                                    value={visit?.resolution || ""}
                                                                                    onChange={(e) => this.handleVisitReportChange("resolution", e.target.value)}
                                                                                />
                                                                            </div>
                                                                            <div className="mb-3">
                                                                                <label className="form-label fw-bold text-dark text-13">{t("parts_notes")}</label>
                                                                                <textarea
                                                                                    className="form-control"
                                                                                    rows={2}
                                                                                    placeholder={t("specify_parts_notes_placeholder")}
                                                                                    value={visit?.parts_notes || ""}
                                                                                    onChange={(e) => this.handleVisitReportChange("parts_notes", e.target.value)}
                                                                                />
                                                                            </div>
                                                                            {/* ผลรายการตรวจสอบที่ช่างติ๊ก/กรอกจากมือถือ - แสดงผลอย่างเดียว */}
                                                                            {reportChecklistItems.length > 0 && (
                                                                                <div className="mb-3">
                                                                                    <label className="form-label fw-bold text-dark text-13">{t("checklist_results")}</label>
                                                                                    <div className="table-responsive">
                                                                                        <table className="table table-sm align-middle mb-0">
                                                                                            <thead>
                                                                                                <tr>
                                                                                                    <th style={{ width: 40 }}>#</th>
                                                                                                    <th>{t("description")}</th>
                                                                                                    <th>{t("answer")}</th>
                                                                                                    {reportShowRemark && <th>{t("checklist_item_remark")}</th>}
                                                                                                </tr>
                                                                                            </thead>
                                                                                            <tbody>
                                                                                                {reportChecklistItems.map((item, idx) => (
                                                                                                    <tr key={item.uid || idx}>
                                                                                                        <td>{idx + 1}</td>
                                                                                                        <td>{item.description || "-"}</td>
                                                                                                        <td className={isChecklistItemFailed(item, templateItemsByUid.get(item.checklist_item_id)) ? "text-danger fw-bold" : ""}>
                                                                                                            {checklistAnswerLabel(item)}
                                                                                                        </td>
                                                                                                        {reportShowRemark && <td style={{ whiteSpace: "pre-wrap" }}>{item.remark || "-"}</td>}
                                                                                                    </tr>
                                                                                                ))}
                                                                                            </tbody>
                                                                                        </table>
                                                                                    </div>
                                                                                </div>
                                                                            )}
                                                                            {/* หมายเหตุ + รูปที่ช่างกรอกในหน้า PM checklist ของมือถือ (WO ปกติที่มี checklist ก็เข้าหน้านี้ได้) */}
                                                                            {!!visit?.pm_notes && (
                                                                                <div className="mb-3">
                                                                                    <label className="form-label fw-bold text-dark text-13">{t("pm_notes_label")}</label>
                                                                                    <textarea className="form-control" rows={2} value={visit.pm_notes} disabled />
                                                                                </div>
                                                                            )}
                                                                            {Array.isArray(visit?.pm_checklist_photos) && visit.pm_checklist_photos.length > 0 && (
                                                <div className="mb-3">
                                                    <label className="form-label fw-bold text-dark text-13">{t("pm_checklist_photos")}</label>
                                                    {this.renderPmPhotoGroups(visit.pm_checklist_photos)}
                                                </div>
                                            )}
                                            {/* บันทึก + รูปตอนช่างเช็คอินหน้างาน (มือถือ) - แสดงผลอย่างเดียว */}
                                                                            {(!!visit?.checkin_remark || checkinPhotos.length > 0) && (
                                                                                <div className="mb-3">
                                                                                    <label className="form-label fw-bold text-dark text-13">{t("checkin_record")}</label>
                                                                                    {!!visit?.checkin_remark && (
                                                                                        <textarea className="form-control mb-2" rows={2} value={visit.checkin_remark} disabled />
                                                                                    )}
                                                                                    {checkinPhotos.length > 0 && (
                                                                                        <div className="row g-2">
                                                                                            {checkinPhotos.map((photo, i) => (
                                                                                                <div className="col-6 col-md-3" key={photo.uid || i}>
                                                                                                    <a href={photo.preview_url || photo.url} target="_blank" rel="noreferrer" download={photo.name || undefined}>
                                                                                                        <img
                                                                                                            src={photo.preview_url || photo.url}
                                                                                                            alt=""
                                                                                                            className="rounded-3 border w-100"
                                                                                                            style={{ aspectRatio: "1", objectFit: "cover" }}
                                                                                                        />
                                                                                                    </a>
                                                                                                </div>
                                                                                            ))}
                                                                                        </div>
                                                                                    )}
                                                                                </div>
                                                                            )}
                                                                            <div className="mb-3">
                                                                                <label className="form-label fw-bold text-dark text-13">{t("service_photos")}</label>
                                                                                {this.renderAttachmentZone({
                                                                                    images: Array.isArray(visit?.images) ? visit.images : [],
                                                                                    videos: Array.isArray(visit?.videos) ? visit.videos : [],
                                                                                    idPrefix: "visit-photo",
                                                                                    disabled: wo_view_mode,
                                                                                    onAdd: this.addVisitFiles,
                                                                                    onRemove: this.removeVisitFile,
                                                                                })}
                                                                            </div>
                                                                            {(duringPhotoGroups.length > 0 || afterPhotoGroups.length > 0) && (
                                                                                <div className="mb-3">
                                                                                    <label className="form-label fw-bold text-dark text-13">{t("service_photos_mobile")}</label>
                                                                                    {duringPhotoGroups.length > 0 && (
                                                                                        <div className="mb-2">
                                                                                            <div className="text-12 text-secondary mb-1">{t("during_service")}</div>
                                                                                            <div className="row g-2">
                                                                                                {duringPhotoGroups.map((group) => (
                                                                                                    <div className="col-6 col-md-3" key={group.key}>
                                                                                                        <a href={group.photo.preview_url || group.photo.url} target="_blank" rel="noreferrer" download={group.photo.name || undefined}>
                                                                                                            <img
                                                                                                                src={group.photo.preview_url || group.photo.url}
                                                                                                                alt={group.label}
                                                                                                                className="rounded-3 border w-100"
                                                                                                                style={{ aspectRatio: "1", objectFit: "cover" }}
                                                                                                            />
                                                                                                        </a>
                                                                                                        <div className="text-11 text-secondary text-center mt-1">{group.label}</div>
                                                                                                    </div>
                                                                                                ))}
                                                                                            </div>
                                                                                        </div>
                                                                                    )}
                                                                                    {afterPhotoGroups.length > 0 && (
                                                                                        <div>
                                                                                            <div className="text-12 text-secondary mb-1">{t("after_service")}</div>
                                                                                            <div className="row g-2">
                                                                                                {afterPhotoGroups.map((group) => (
                                                                                                    <div className="col-6 col-md-3" key={group.key}>
                                                                                                        <a href={group.photo.preview_url || group.photo.url} target="_blank" rel="noreferrer" download={group.photo.name || undefined}>
                                                                                                            <img
                                                                                                                src={group.photo.preview_url || group.photo.url}
                                                                                                                alt={group.label}
                                                                                                                className="rounded-3 border w-100"
                                                                                                                style={{ aspectRatio: "1", objectFit: "cover" }}
                                                                                                            />
                                                                                                        </a>
                                                                                                        <div className="text-11 text-secondary text-center mt-1">{group.label}</div>
                                                                                                    </div>
                                                                                                ))}
                                                                                            </div>
                                                                                        </div>
                                                                                    )}
                                                                                </div>
                                                                            )}
                                                                            <div>
                                                                                <label className="form-label fw-bold text-dark text-13">{t("customer_signature_job_complete")}</label>
                                                                                {visit?.customer_signature ? (
                                                                                    <div className="border rounded-3 p-2 text-center bg-light mb-2">
                                                                                        <img src={visit.customer_signature} alt="" style={{ maxHeight: 120, maxWidth: "100%" }} />
                                                                                    </div>
                                                                                ) : (
                                                                                    <div
                                                                                        className="border rounded-3 p-4 text-center text-secondary bg-light mb-2"
                                                                                        style={{ borderStyle: "dashed" }}
                                                                                    >
                                                                                        <span className="icon me-2 text-warning">{"\uf044"}</span> {t("waiting_customer_signature")}
                                                                                    </div>
                                                                                )}
                                                                                <div className="row g-2">
                                                                                    <div className="col-6">
                                                                                        <input
                                                                                            className="form-control"
                                                                                            placeholder={t("signer_name_placeholder")}
                                                                                            value={visit?.signee_name || ""}
                                                                                            disabled
                                                                                        />
                                                                                    </div>
                                                                                    <div className="col-6">
                                                                                        <input
                                                                                            className="form-control"
                                                                                            placeholder={t("position")}
                                                                                            value={visit?.signee_position || ""}
                                                                                            disabled
                                                                                        />
                                                                                    </div>
                                                                                    {/* อีเมลปลายทางที่ใช้ส่ง service report (ช่างกรอกจากมือถือตอนปิดงาน) - แสดงผลอย่างเดียว */}
                                                                                    <div className="col-12">
                                                                                        <input
                                                                                            className="form-control"
                                                                                            placeholder={t("sr_recipient_email")}
                                                                                            value={visit?.signee_email || ""}
                                                                                            disabled
                                                                                        />
                                                                                    </div>
                                                                                </div>
                                                                                {(!!visit?.customer_rating || !!visit?.customer_feedback) && (
                                                                                    <div className="mt-2 text-13 text-secondary">
                                                                                        {!!visit?.customer_rating && (
                                                                                            <div>
                                                                                                {/* \u0e14\u0e32\u0e27\u0e04\u0e23\u0e1a 5 \u0e14\u0e27\u0e07\u0e40\u0e2a\u0e21\u0e2d: \u0e17\u0e36\u0e1a (\u2605) = \u0e04\u0e30\u0e41\u0e19\u0e19\u0e17\u0e35\u0e48\u0e44\u0e14\u0e49, \u0e42\u0e1b\u0e23\u0e48\u0e07\u0e2a\u0e35\u0e40\u0e17\u0e32 (\u2606) = \u0e2a\u0e48\u0e27\u0e19\u0e17\u0e35\u0e48\u0e40\u0e2b\u0e25\u0e37\u0e2d
                                                                                                    \u0e43\u0e0a\u0e49\u0e2d\u0e31\u0e01\u0e02\u0e23\u0e30 Unicode \u0e44\u0e21\u0e48\u0e43\u0e0a\u0e48\u0e1f\u0e2d\u0e19\u0e15\u0e4c .icon \u0e40\u0e1e\u0e23\u0e32\u0e30 fa-light-300 \u0e21\u0e35\u0e41\u0e15\u0e48\u0e14\u0e32\u0e27\u0e40\u0e2a\u0e49\u0e19\u0e1a\u0e32\u0e07 \u0e44\u0e21\u0e48\u0e21\u0e35\u0e41\u0e1a\u0e1a\u0e17\u0e36\u0e1a */}
                                                                                                {t("rating")}:{" "}
                                                                                                <span className="text-16" style={{ letterSpacing: "2px", verticalAlign: "middle" }}>
                                                                                                    {[1, 2, 3, 4, 5].map((star) => (
                                                                                                        <span
                                                                                                            key={star}
                                                                                                            className={star <= visit.customer_rating ? "text-warning" : ""}
                                                                                                            style={star <= visit.customer_rating ? undefined : { color: "#c4c4c4" }}
                                                                                                        >
                                                                                                            {star <= visit.customer_rating ? "\u2605" : "\u2606"}
                                                                                                        </span>
                                                                                                    ))}
                                                                                                </span>
                                                                                            </div>
                                                                                        )}
                                                                                        {!!visit?.customer_feedback && (
                                                                                            <div>{t("customer_feedback")}: {visit.customer_feedback}</div>
                                                                                        )}
                                                                                    </div>
                                                                                )}
                                                                            </div>
                                                                        </div>
                                                                        );
                                                                    })()}

                                                                    {visit_detail_tab === "cost" && (() => {
                                                                        const costParts = [
                                                                            ...create_service_bom_parts.filter((p) => p.is_active !== false),
                                                                            ...create_manual_parts,
                                                                        ];
                                                                        // ค่าอะไหล่คิดตามจำนวน "ใช้จริง" (ส่วนที่เบิกเกินจะคืนคลัง จึงไม่คิดเงิน)
                                                                        const partsTotal = costParts.reduce((sum, p) => sum + this.getPartUsedQuantity(p) * (Number(p.price) || 0), 0);
                                                                        const travelExtras = visit.travel_extras || [];
                                                                        const travelBase = Number(visit.travel_cost) || 0;
                                                                        const travelExtrasTotal = travelExtras.reduce((sum, r) => sum + (Number(r.amount) || 0), 0);
                                                                        const otherCosts = visit.other_costs || [];
                                                                        const otherTotal = otherCosts.reduce((sum, r) => sum + (Number(r.amount) || 0), 0);
                                                                        const visitTotal = travelBase + travelExtrasTotal + partsTotal + otherTotal;
                                                                        const canEditOther = this.canEditOtherCost();
                                                                        // อัตราค่าเดินทางที่ล็อกไว้ ณ วันสร้าง visit (ไม่เปลี่ยนตาม config ที่แก้ภายหลัง)
                                                                        const rateSnapshot = visit.travel_allowance_snapshot || null;
                                                                        // แจกแจงที่มาของยอดค่าเดินทาง ใช้แสดงใน tooltip ของช่อง "ค่าเดินทาง (฿)"
                                                                        const travelBreakdown = this.buildTravelCostBreakdown(visit, selectedCustomer);
                                                                        // ยอดที่บันทึกไว้ไม่ตรงกับที่คำนวณได้ = ถูกแก้ด้วยมือภายหลัง
                                                                        const travelCostAdjusted =
                                                                            travelBreakdown.computed != null &&
                                                                            visit.travel_cost != null &&
                                                                            visit.travel_cost !== "" &&
                                                                            Math.abs(Number(visit.travel_cost) - travelBreakdown.computed) > 0.01;
                                                                        return (
                                                                            <div>
                                                                                <div className="d-flex align-items-center text-12 text-secondary mb-3 p-2 rounded-3 bg-light border">
                                                                                    <span className="icon me-2 text-primary">{"\uf044"}</span> {t("travel_parts_cost_hint")}
                                                                                </div>
                                                                                {/* ค่าเดินทาง (มาจากการบันทึกของช่าง) */}
                                                                                <div className="border rounded-3 p-3 mb-3">
                                                                                    <div className="d-flex justify-content-between align-items-center mb-3">
                                                                                        <div className="fw-bold text-dark text-14 d-flex align-items-center">
                                                                                            <span className="icon me-2 text-primary">{"\uf1b9"}</span> {t("travel_cost")}
                                                                                        </div>
                                                                                        <span className="badge bg-light text-secondary border text-10">{t("recorded_by_technician")}</span>
                                                                                    </div>
                                                                                    {rateSnapshot && (
                                                                                        <div className="bg-light border rounded-3 p-2 mb-2 text-12 text-secondary d-flex align-items-start">
                                                                                            <span className="icon me-2 text-primary">{""}</span>
                                                                                            <div>
                                                                                                {t("travel_rate_snapshot_hint")} — {t("payment_model_label")}: {this.formatPaymentModel(rateSnapshot.payment_model)}
                                                                                            </div>
                                                                                        </div>
                                                                                    )}
                                                                                    <div className="row g-2 mb-2">
                                                                                        <div className="col-6">
                                                                                            <label className="form-label text-12 text-secondary mb-1">{t("vehicle_type")}</label>
                                                                                            <select
                                                                                                className="form-select form-select-sm"
                                                                                                value={visit.travel_vehicle || ""}
                                                                                                onChange={(e) => this.handleVisitReportChange("travel_vehicle", e.target.value)}
                                                                                            >
                                                                                                <option value="" disabled>{t("waiting_technician_record")}</option>
                                                                                                <option value="personal_car">{t("personal_car")}</option>
                                                                                                <option value="motorcycle">{t("ta_vehicle_motorcycle")}</option>
                                                                                                <option value="company">{t("company_car")}</option>
                                                                                                <option value="taxi">{t("taxi_grab")}</option>
                                                                                            </select>
                                                                                        </div>
                                                                                        <div className="col-6">
                                                                                            <label className="form-label text-12 text-secondary mb-1 d-flex align-items-center">
                                                                                                {t("travel_cost_baht")}
                                                                                                {/* แจกแจงที่มาของยอด: โมเดลอัตรา พาหนะ ระยะทาง และสูตรที่ใช้คำนวณ */}
                                                                                                <span
                                                                                                    style={{
                                                                                                        position: "relative",
                                                                                                        display: "inline-block",
                                                                                                        marginLeft: "5px",
                                                                                                        cursor: "pointer",
                                                                                                    }}
                                                                                                    onMouseEnter={(e) => {
                                                                                                        const r = e.currentTarget.getBoundingClientRect();
                                                                                                        this.setState({ travel_info_open: true, travel_info_rect: r });
                                                                                                    }}
                                                                                                    onMouseLeave={() => this.setState({ travel_info_open: false, travel_info_rect: null })}
                                                                                                    onClick={(e) => {
                                                                                                        e.stopPropagation();
                                                                                                        const r = e.currentTarget.getBoundingClientRect();
                                                                                                        this.setState((state) => ({
                                                                                                            travel_info_open: !state.travel_info_open,
                                                                                                            travel_info_rect: state.travel_info_open ? null : r,
                                                                                                        }));
                                                                                                    }}
                                                                                                >
                                                                                                    <span className="icon text-secondary" style={{ fontSize: "12px" }}>
                                                                                                        {"\uf05a"}
                                                                                                    </span>
                                                                                                    {travel_info_open && (
                                                                                                        <div
                                                                                                            style={{
                                                                                                                position: "fixed",
                                                                                                                bottom: travel_info_rect ? `${window.innerHeight - travel_info_rect.top + 6}px` : "50%",
                                                                                                                left: travel_info_rect ? `${travel_info_rect.left + travel_info_rect.width / 2}px` : "50%",
                                                                                                                transform: "translateX(-50%)",
                                                                                                                background: "#fff",
                                                                                                                border: "1px solid #dee2e6",
                                                                                                                borderRadius: "8px",
                                                                                                                boxShadow: "0 4px 12px rgba(0,0,0,0.12)",
                                                                                                                padding: "10px 14px",
                                                                                                                zIndex: 9999,
                                                                                                                width: "300px",
                                                                                                                textAlign: "left",
                                                                                                                fontSize: "12px",
                                                                                                                fontWeight: "normal",
                                                                                                                color: "#333",
                                                                                                                whiteSpace: "normal",
                                                                                                            }}
                                                                                                        >
                                                                                                            <div className="fw-bold text-dark mb-2">{t("travel_source_title")}</div>
                                                                                                            {travelBreakdown.rows.map((row) => (
                                                                                                                <div className="d-flex justify-content-between gap-3 mb-1" key={row.label}>
                                                                                                                    <span className="text-secondary">{row.label}</span>
                                                                                                                    <span className="text-dark text-end">{row.value}</span>
                                                                                                                </div>
                                                                                                            ))}
                                                                                                            {travelBreakdown.computed != null && (
                                                                                                                <div className="d-flex justify-content-between gap-3 pt-2 mt-1 border-top fw-bold">
                                                                                                                    <span className="text-dark">{t("travel_source_computed_total")}</span>
                                                                                                                    <span className="text-primary">{this.formatBaht(travelBreakdown.computed)}</span>
                                                                                                                </div>
                                                                                                            )}
                                                                                                            {travelCostAdjusted && (
                                                                                                                <div className="text-warning mt-2">{t("travel_source_manual_adjusted")}</div>
                                                                                                            )}
                                                                                                            {travelBreakdown.notes.map((note) => (
                                                                                                                <div className="text-secondary mt-2" key={note}>{note}</div>
                                                                                                            ))}
                                                                                                        </div>
                                                                                                    )}
                                                                                                </span>
                                                                                            </label>
                                                                                            <input
                                                                                                className="form-control form-control-sm"
                                                                                                value={visit.travel_cost ?? ""}
                                                                                                placeholder={t("waiting_technician_record")}
                                                                                                onChange={(e) => this.handleVisitReportChange("travel_cost", e.target.value)}
                                                                                            />
                                                                                        </div>
                                                                                    </div>
                                                                                    <div className="row g-2 mb-2">
                                                                                        <div className="col-6">
                                                                                            <label className="form-label text-12 text-secondary mb-1">{t("mileage_start_km")}</label>
                                                                                            <input
                                                                                                className="form-control form-control-sm"
                                                                                                value={visit.mileage_start ?? ""}
                                                                                                placeholder={t("waiting_technician_record")}
                                                                                                onChange={(e) => this.handleVisitReportChange("mileage_start", e.target.value)}
                                                                                            />
                                                                                        </div>
                                                                                        <div className="col-6">
                                                                                            <label className="form-label text-12 text-secondary mb-1">{t("mileage_end_km")}</label>
                                                                                            <input
                                                                                                className="form-control form-control-sm"
                                                                                                value={visit.mileage_end ?? ""}
                                                                                                placeholder={t("waiting_technician_record")}
                                                                                                onChange={(e) => this.handleVisitReportChange("mileage_end", e.target.value)}
                                                                                            />
                                                                                        </div>
                                                                                    </div>
                                                                                    {/* เส้นทางที่ช่างเดินทางจริง (บันทึกจาก GPS ของมือถือ) - แสดงผลอย่างเดียว */}
                                                                                    {(visit.travel_distance_km != null ||
                                                                                        visit.start_latitude != null ||
                                                                                        (visit.travel_route || []).length > 0) && (
                                                                                        <div className="border rounded-3 p-2 mb-2 bg-light">
                                                                                            <div className="d-flex justify-content-between align-items-center mb-1">
                                                                                                <span className="text-12 text-secondary fw-bold">{t("gps_route_recorded")}</span>
                                                                                                <span className="badge bg-white text-secondary border text-10">
                                                                                                    {(visit.travel_route || []).length} {t("route_points_unit")}
                                                                                                </span>
                                                                                            </div>
                                                                                            <div className="row g-2 text-12">
                                                                                                <div className="col-12 col-md-4">
                                                                                                    <div className="text-secondary">{t("actual_travel_distance")}</div>
                                                                                                    <div className="fw-bold text-dark">
                                                                                                        {visit.travel_distance_km != null
                                                                                                            ? `${Number(visit.travel_distance_km).toFixed(2)} ${t("km_unit")}`
                                                                                                            : "-"}
                                                                                                    </div>
                                                                                                </div>
                                                                                                <div className="col-6 col-md-4">
                                                                                                    <div className="text-secondary">{t("route_start_point")}</div>
                                                                                                    {visit.start_latitude != null ? (
                                                                                                        <a
                                                                                                            href={`https://www.google.com/maps/search/?api=1&query=${visit.start_latitude},${visit.start_longitude}`}
                                                                                                            target="_blank"
                                                                                                            rel="noreferrer"
                                                                                                        >
                                                                                                            {Number(visit.start_latitude).toFixed(5)}, {Number(visit.start_longitude).toFixed(5)}
                                                                                                        </a>
                                                                                                    ) : (
                                                                                                        <div className="text-secondary">-</div>
                                                                                                    )}
                                                                                                </div>
                                                                                                <div className="col-6 col-md-4">
                                                                                                    <div className="text-secondary">{t("route_end_point")}</div>
                                                                                                    {visit.end_latitude != null ? (
                                                                                                        <a
                                                                                                            href={`https://www.google.com/maps/search/?api=1&query=${visit.end_latitude},${visit.end_longitude}`}
                                                                                                            target="_blank"
                                                                                                            rel="noreferrer"
                                                                                                        >
                                                                                                            {Number(visit.end_latitude).toFixed(5)}, {Number(visit.end_longitude).toFixed(5)}
                                                                                                        </a>
                                                                                                    ) : (
                                                                                                        <div className="text-secondary">-</div>
                                                                                                    )}
                                                                                                </div>
                                                                                            </div>
                                                                                            {(visit.travel_route || []).length >= 2 && (
                                                                                                <button
                                                                                                    type="button"
                                                                                                    className="btn btn-sm btn-outline-primary mt-2"
                                                                                                    onClick={() =>
                                                                                                        this.setState({
                                                                                                            modal_route_map: true,
                                                                                                            modal_route_points: visit.travel_route || [],
                                                                                                            modal_route_distance: visit.travel_distance_km ?? null,
                                                                                                        })
                                                                                                    }
                                                                                                >
                                                                                                    <span className="icon me-1">{""}</span> {t("view_route_on_map")}
                                                                                                </button>
                                                                                            )}
                                                                                        </div>
                                                                                    )}
                                                                                    {/* รูปมาตรวัดไมล์ที่ช่างถ่ายจากมือถือ (เริ่มงาน/จบงาน) - แสดงผลอย่างเดียว */}
                                                                                    {(!!visit.mileage_start_photo || !!visit.mileage_end_photo) && (
                                                                                        <div className="row g-2 mb-2">
                                                                                            {!!visit.mileage_start_photo && (
                                                                                                <div className="col-6">
                                                                                                    <label className="form-label text-12 text-secondary mb-1">{t("mileage_start_photo_label")}</label>
                                                                                                    <a href={visit.mileage_start_photo} target="_blank" rel="noreferrer">
                                                                                                        <img
                                                                                                            src={visit.mileage_start_photo}
                                                                                                            alt=""
                                                                                                            className="rounded-3 border w-100"
                                                                                                            style={{ aspectRatio: "4/3", objectFit: "cover" }}
                                                                                                        />
                                                                                                    </a>
                                                                                                </div>
                                                                                            )}
                                                                                            {!!visit.mileage_end_photo && (
                                                                                                <div className="col-6">
                                                                                                    <label className="form-label text-12 text-secondary mb-1">{t("mileage_end_photo_label")}</label>
                                                                                                    <a href={visit.mileage_end_photo} target="_blank" rel="noreferrer">
                                                                                                        <img
                                                                                                            src={visit.mileage_end_photo}
                                                                                                            alt=""
                                                                                                            className="rounded-3 border w-100"
                                                                                                            style={{ aspectRatio: "4/3", objectFit: "cover" }}
                                                                                                        />
                                                                                                    </a>
                                                                                                </div>
                                                                                            )}
                                                                                        </div>
                                                                                    )}
                                                                                    <label className="form-label text-12 text-secondary mb-1">{t("extra_travel_expense")}</label>
                                                                                    {travelExtras.map((row) => (
                                                                                        <div className="d-flex gap-2 align-items-center mb-2" key={row.uid}>
                                                                                            <select
                                                                                                className="form-select form-select-sm"
                                                                                                value={row.type}
                                                                                                disabled={wo_view_mode}
                                                                                                onChange={(e) => this.updateTravelExtra(row.uid, "type", e.target.value)}
                                                                                            >
                                                                                                <option value="toll">{t("toll_fee")}</option>
                                                                                                <option value="parking">{t("parking_fee")}</option>
                                                                                                <option value="fuel">{t("fuel_fee")}</option>
                                                                                            </select>
                                                                                            <input
                                                                                                className="form-control form-control-sm wpx-100"
                                                                                                placeholder={t("amount")}
                                                                                                value={row.amount}
                                                                                                disabled={wo_view_mode}
                                                                                                onChange={(e) => this.updateTravelExtra(row.uid, "amount", e.target.value)}
                                                                                            />
                                                                                            {!wo_view_mode && (
                                                                                                <span className="icon text-secondary pointer" onClick={() => this.removeTravelExtra(row.uid)}>
                                                                                                    {"\uf00d"}
                                                                                                </span>
                                                                                            )}
                                                                                        </div>
                                                                                    ))}
                                                                                    {!wo_view_mode && (
                                                                                        <button
                                                                                            type="button"
                                                                                            className="btn btn-link btn-sm p-0 text-primary fw-bold text-12 text-decoration-none"
                                                                                            onClick={this.addTravelExtra}
                                                                                        >
                                                                                            + {t("extra_travel_expense")}
                                                                                        </button>
                                                                                    )}
                                                                                </div>
                                                                                {/* ค่าอะไหล่ (ดึงจากแท็บอะไหล่ + ราคาขายอัตโนมัติ) */}
                                                                                <div className="border rounded-3 p-3 mb-3">
                                                                                    <div className="d-flex justify-content-between align-items-center mb-2">
                                                                                        <div className="fw-bold text-dark text-14 d-flex align-items-center">
                                                                                            <span className="icon me-2 text-primary">{"\uf0ad"}</span> {t("parts_cost_from_tab")}
                                                                                        </div>
                                                                                        <span className="text-12 text-success fw-bold">{t("auto_calculated")}</span>
                                                                                    </div>
                                                                                    {costParts.length > 0 ? (
                                                                                        <div className="table-responsive">
                                                                                            <table className="table table-sm align-middle mb-0 text-14">
                                                                                                <thead>
                                                                                                    <tr className="text-secondary text-12">
                                                                                                        <th className="fw-bold">{t("parts")}</th>
                                                                                                        <th className="fw-bold text-center">{t("issues")}</th>
                                                                                                        <th className="fw-bold text-center">{t("actual_used")}</th>
                                                                                                        <th className="fw-bold text-center">
                                                                                                            {t("return_qty")}
                                                                                                            {/* อธิบายว่ายอดคืนนี้ระบบไม่ได้ตัดสต๊อกเอง */}
                                                                                                            <span
                                                                                                                style={{
                                                                                                                    position: "relative",
                                                                                                                    display: "inline-block",
                                                                                                                    marginLeft: "5px",
                                                                                                                    marginBottom: "2px",
                                                                                                                    cursor: "pointer",
                                                                                                                }}
                                                                                                                onMouseEnter={(e) => {
                                                                                                                    const r = e.currentTarget.getBoundingClientRect();
                                                                                                                    this.setState({ return_info_open: true, return_info_rect: r });
                                                                                                                }}
                                                                                                                onMouseLeave={() => this.setState({ return_info_open: false, return_info_rect: null })}
                                                                                                                onClick={(e) => {
                                                                                                                    e.stopPropagation();
                                                                                                                    const r = e.currentTarget.getBoundingClientRect();
                                                                                                                    this.setState((state) => ({
                                                                                                                        return_info_open: !state.return_info_open,
                                                                                                                        return_info_rect: state.return_info_open ? null : r,
                                                                                                                    }));
                                                                                                                }}
                                                                                                            >
                                                                                                                <span className="icon text-secondary" style={{ fontSize: "12px" }}>
                                                                                                                    {"\uf05a"}
                                                                                                                </span>
                                                                                                                {return_info_open && (
                                                                                                                    <div
                                                                                                                        style={{
                                                                                                                            position: "fixed",
                                                                                                                            bottom: return_info_rect ? `${window.innerHeight - return_info_rect.top + 6}px` : "50%",
                                                                                                                            left: return_info_rect ? `${return_info_rect.left + return_info_rect.width / 2}px` : "50%",
                                                                                                                            transform: "translateX(-50%)",
                                                                                                                            background: "#fff",
                                                                                                                            border: "1px solid #dee2e6",
                                                                                                                            borderRadius: "8px",
                                                                                                                            boxShadow: "0 4px 12px rgba(0,0,0,0.12)",
                                                                                                                            padding: "10px 14px",
                                                                                                                            zIndex: 9999,
                                                                                                                            width: "260px",
                                                                                                                            textAlign: "left",
                                                                                                                            fontSize: "12px",
                                                                                                                            fontWeight: "normal",
                                                                                                                            color: "#333",
                                                                                                                            whiteSpace: "normal",
                                                                                                                        }}
                                                                                                                    >
                                                                                                                        {t("return_qty_sap_hint")}
                                                                                                                    </div>
                                                                                                                )}
                                                                                                            </span>
                                                                                                        </th>
                                                                                                        <th className="fw-bold text-end">{t("selling_price_baht")}</th>
                                                                                                        <th className="fw-bold text-end">{t("total_baht")}</th>
                                                                                                    </tr>
                                                                                                </thead>
                                                                                                <tbody>
                                                                                                    {costParts.map((part) => {
                                                                                                        const usedQuantity = this.getPartUsedQuantity(part);
                                                                                                        const returnQuantity = this.getPartReturnQuantity(part);
                                                                                                        return (
                                                                                                            <tr key={part.uid}>
                                                                                                                {/* ชื่ออะไหล่ยาวเกินความกว้างคอลัมน์ ให้ตัดท้ายเป็น ... และดูเต็มได้จาก tooltip */}
                                                                                                                <td className="text-dark" style={{ maxWidth: "200px" }}>
                                                                                                                    <div className="text-truncate" title={part.part_name}>
                                                                                                                        {part.part_name}
                                                                                                                    </div>
                                                                                                                </td>
                                                                                                                <td className="text-center">{formatNumber(Number(part.quantity) || 0)}</td>
                                                                                                                <td className="text-center">{formatNumber(usedQuantity)}</td>
                                                                                                                <td className={`text-center ${returnQuantity > 0 ? "text-warning fw-bold" : ""}`}>{formatNumber(returnQuantity)}</td>
                                                                                                                <td className="text-end">{this.formatBaht(part.price)}</td>
                                                                                                                <td className="text-end fw-bold">{this.formatBaht(usedQuantity * (Number(part.price) || 0))}</td>
                                                                                                            </tr>
                                                                                                        );
                                                                                                    })}
                                                                                                </tbody>
                                                                                                <tfoot>
                                                                                                    <tr className="border-top">
                                                                                                        <td colSpan={5} className="text-end fw-bold text-dark">
                                                                                                            {t("total_parts_cost")}
                                                                                                        </td>
                                                                                                        <td className="text-end fw-bold text-primary">{this.formatBaht(partsTotal)}</td>
                                                                                                    </tr>
                                                                                                </tfoot>
                                                                                            </table>
                                                                                        </div>
                                                                                    ) : (
                                                                                        <div className="border border-dashed rounded-3 p-3 text-secondary text-12 text-center">
                                                                                            {t("no_parts_add_at_parts_tab")}
                                                                                        </div>
                                                                                    )}
                                                                                </div>
                                                                                {/* ค่าใช้จ่ายอื่น ๆ (เฉพาะ admin / super_user เพิ่มได้) */}
                                                                                <div className="border rounded-3 p-3 mb-3">
                                                                                    <div className="fw-bold text-dark text-14 mb-2 d-flex align-items-center">
                                                                                        <span className="icon me-2 text-primary">{"\uf022"}</span> {t("other_costs_admin_addable")}
                                                                                    </div>
                                                                                    {otherCosts.map((row) => (
                                                                                        <div className="d-flex gap-2 align-items-center mb-2" key={row.uid}>
                                                                                            <input
                                                                                                className="form-control form-control-sm"
                                                                                                placeholder={t("items")}
                                                                                                value={row.name}
                                                                                                disabled={!canEditOther || wo_view_mode}
                                                                                                onChange={(e) => this.updateOtherCost(row.uid, "name", e.target.value)}
                                                                                            />
                                                                                            <input
                                                                                                className="form-control form-control-sm wpx-100"
                                                                                                placeholder={t("amount")}
                                                                                                value={row.amount}
                                                                                                disabled={!canEditOther || wo_view_mode}
                                                                                                onChange={(e) => this.updateOtherCost(row.uid, "amount", e.target.value)}
                                                                                            />
                                                                                            <select
                                                                                                className="form-select form-select-sm wpx-150"
                                                                                                value={row.category}
                                                                                                disabled={!canEditOther || wo_view_mode}
                                                                                                onChange={(e) => this.updateOtherCost(row.uid, "category", e.target.value)}
                                                                                            >
                                                                                                <option value="job">{t("job_expense")}</option>
                                                                                                <option value="overhead">Overhead</option>
                                                                                            </select>
                                                                                            {canEditOther && !wo_view_mode && (
                                                                                                <span className="icon text-secondary pointer" onClick={() => this.removeOtherCost(row.uid)}>
                                                                                                    {"\uf00d"}
                                                                                                </span>
                                                                                            )}
                                                                                        </div>
                                                                                    ))}
                                                                                    {canEditOther ? (
                                                                                        !wo_view_mode && (
                                                                                            <button
                                                                                                type="button"
                                                                                                className="btn btn-link btn-sm p-0 text-primary fw-bold text-12 text-decoration-none"
                                                                                                onClick={this.addOtherCost}
                                                                                            >
                                                                                                + {t("admin_add_expense")}
                                                                                            </button>
                                                                                        )
                                                                                    ) : (
                                                                                        <div className="text-12 text-secondary fst-italic">{t("admin_only_can_add_other_costs")}</div>
                                                                                    )}
                                                                                </div>
                                                                                {/* ผลการเข้าเปลี่ยนไส้กรอง (เฉพาะหมวด HHU/HQW) - ไม่สำเร็จ = ไม่นับเป็นวันฐานรอบเปลี่ยนถัดไป */}
                                                                                {this.isFilterChangeVisit(visit) && (() => {
                                                                                    const filterSuccess = visit.filter_change_result === true;
                                                                                    const filterFailed = visit.filter_change_result === false;
                                                                                    // เสร็จสิ้นแล้ว (visit completed หรือ WO อยู่ในโหมดดูอย่างเดียว) ห้ามเปลี่ยนผล
                                                                                    const filterLocked = wo_view_mode || ["completed", "success", "approved", "closed"].includes(this.normalizeStatusKey(visit?.status));
                                                                                    const replacementPeriod = Number(
                                                                                        active_wo?.asset?.replacement_period ??
                                                                                            (Array.isArray(this.state.data_asset) ? this.state.data_asset.find((a) => a.uid === create_asset_id || a.value === create_asset_id)?.replacement_period : null)
                                                                                    );
                                                                                    return (
                                                                                        <div className="border rounded-3 p-3 mb-3" id="filter-change-result">
                                                                                            <div className="fw-bold text-dark text-14 mb-2 d-flex align-items-center">
                                                                                                <span className="icon me-2 text-primary">{"\uf00c"}</span> {t("filter_change_result_title")}
                                                                                            </div>
                                                                                            <div className="d-flex gap-4 mb-2">
                                                                                                <div className="form-check">
                                                                                                    <input
                                                                                                        className="form-check-input"
                                                                                                        type="radio"
                                                                                                        id={`filter_change_success_${idx}`}
                                                                                                        checked={filterSuccess}
                                                                                                        disabled={filterLocked}
                                                                                                        onChange={() => this.handleVisitReportChange("filter_change_result", true)}
                                                                                                    />
                                                                                                    <label className="form-check-label text-13" htmlFor={`filter_change_success_${idx}`}>{t("filter_change_success")}</label>
                                                                                                </div>
                                                                                                <div className="form-check">
                                                                                                    <input
                                                                                                        className="form-check-input"
                                                                                                        type="radio"
                                                                                                        id={`filter_change_failed_${idx}`}
                                                                                                        checked={filterFailed}
                                                                                                        disabled={filterLocked}
                                                                                                        onChange={() => this.handleVisitReportChange("filter_change_result", false)}
                                                                                                    />
                                                                                                    <label className="form-check-label text-13" htmlFor={`filter_change_failed_${idx}`}>{t("filter_change_failed")}</label>
                                                                                                </div>
                                                                                            </div>
                                                                                            {filterSuccess ? (
                                                                                                <div className="text-13 text-secondary">
                                                                                                    <div>{t("filter_change_date")}: <span className="text-dark fw-bold">{this.getFilterChangeDateText(visit)}</span></div>
                                                                                                    <div>
                                                                                                        {t("filter_change_period")}:{" "}
                                                                                                        <span className="text-dark fw-bold">{replacementPeriod > 0 ? `${replacementPeriod} ${t("filter_change_months")}` : "-"}</span>
                                                                                                    </div>
                                                                                                </div>
                                                                                            ) : filterFailed ? (
                                                                                                <div className="text-12 text-secondary">{t("filter_change_failed_hint")}</div>
                                                                                            ) : null}
                                                                                        </div>
                                                                                    );
                                                                                })()}
                                                                                {/* สรุปค่าใช้จ่ายต่อ Visit (ไม่รวมข้าม Visit) */}
                                                                                <div className="border rounded-3 p-3 mb-3 bg-light">
                                                                                    <div className="fw-bold text-dark text-14 mb-2 d-flex align-items-center">
                                                                                        <span className="icon me-2 text-primary">{"\uf15c"}</span> {t("expense_summary_visit")} {idx + 1}
                                                                                    </div>
                                                                                    {[
                                                                                        { label: t("travel_cost"), value: travelBase },
                                                                                        { label: t("travel_extra_cost_label"), value: travelExtrasTotal },
                                                                                        { label: t("parts_cost"), value: partsTotal },
                                                                                        { label: t("other_costs_label"), value: otherTotal },
                                                                                    ].map((row) => (
                                                                                        <div className="d-flex justify-content-between py-1 text-14" key={row.label}>
                                                                                            <span className="text-secondary">{row.label}</span>
                                                                                            <span className="text-dark">{this.formatBaht(row.value)}</span>
                                                                                        </div>
                                                                                    ))}
                                                                                    <div className="d-flex justify-content-between pt-2 mt-1 border-top fw-bold text-14">
                                                                                        <span className="text-dark">{t("total_visit_label")} {idx + 1}</span>
                                                                                        <span className="text-primary">{this.formatBaht(visitTotal)}</span>
                                                                                    </div>
                                                                                </div>
                                                                                {/* ปุ่มปิดการเข้าพื้นที่: กดได้เฉพาะสถานะ visit เป็น close_job (ช่างกดปิดงานแล้ว) */}
                                                                                <button
                                                                                    type="button"
                                                                                    className="btn btn-secondary w-100 fw-bold"
                                                                                    disabled={wo_view_mode || this.normalizeStatusKey(visit?.status) !== "close_job"}
                                                                                    title={t("close_visit_condition_hint")}
                                                                                    onClick={() => this.handleCloseVisit(idx, visit)}
                                                                                >
                                                                                    <span className="icon me-1">{"\uf023"}</span> {t("close_visit")}
                                                                                </button>
                                                                            </div>
                                                                        );
                                                                    })()}
                                                                </div>
                                                            )}
                                                        </div>
                                                    );
                                                })}
                                            </div>
                                        ) : (
                                            <div className="bg-white rounded-2 p-3 border text-secondary text-12">
                                                {t("select_dates_first_hint")}
                                            </div>
                                        )}
                                    </div>
                                </div>

                                {/* Checklist รายการตรวจสอบ — แสดงเฉพาะ WO จาก PM Plan */}
                                {create_inspection_plan_id && (
                                <div className="mb-4">
                                    <h6 className="fw-bold text-dark mb-3 d-flex align-items-center text-16 border-bottom pb-2">
                                        <span className="icon me-2 text-success">{""}</span> {t("checklist_inspection_list")}
                                        <span className="badge ms-2 text-12 fw-semibold px-2 py-1" style={{ backgroundColor: "#FEF3C7", color: "#92400E", border: "1px solid #FDE68A" }}>{t("pm_only")}</span>
                                        <span className="ms-auto text-12 text-secondary fw-normal">{t("checklist_usage_hint")}</span>
                                    </h6>

                                    {/* Template Selector */}
                                    <div className="mb-3">
                                        <Select
                                            className="form-control"
                                            placeholder={`-- ${t("select_checklist_template_placeholder")} --`}
                                            options={data_checklist_templates}
                                            value={create_checklist_template_id}
                                            onChange={(val) => {
                                                const tmpl = data_checklist_templates.find((t) => t.value === val);
                                                if (!tmpl) {
                                                    this.setState({ create_checklist_template_id: "", create_checklist_items: [] });
                                                    return;
                                                }
                                                const items = Array.isArray(tmpl.items) ? tmpl.items : [];
                                                this.setState({
                                                    create_checklist_template_id: val,
                                                    create_checklist_items: items.map((item, i) => ({
                                                        uid: "",
                                                        checklist_item_id: item.uid || "",
                                                        sequence: item.sequence ?? i + 1,
                                                        description: item.description || "",
                                                        input_type: item.input_type || "check",
                                                        is_used: true,
                                                        source: "template",
                                                        is_required: !!item.is_required,
                                                    })),
                                                });
                                            }}
                                            disabled={wo_view_mode}
                                            clearable={true}
                                        />
                                    </div>

                                    {/* Template info banner */}
                                    {create_checklist_template_id && (() => {
                                        const tmpl = data_checklist_templates.find((t) => t.value === create_checklist_template_id);
                                        const templateCount = (tmpl?.items || []).length;
                                        return (
                                            <div className="rounded-3 p-3 mb-3 d-flex align-items-start gap-2" style={{ backgroundColor: "#EFF6FF", border: "1px solid #BFDBFE" }}>
                                                <span className="icon text-secondary mt-1">{""}</span>
                                                <div className="text-14 text-dark">
                                                    {t("checklist_template")}: <strong>{tmpl?.name || "-"}</strong> ({formatNumber(templateCount)} {t("standard_items")}) — {t("template_edit_note_hint")}
                                                </div>
                                            </div>
                                        );
                                    })()}

                                    {/* Checklist Items Table */}
                                    {create_checklist_items.length > 0 && (
                                        <div className="table-responsive mb-3">
                                            <table className="table table-sm align-middle mb-0 text-14">
                                                <thead className="table-light">
                                                    <tr className="text-secondary text-12">
                                                        <th className="fw-bold text-center" style={{ width: 56 }}>{t("use_label")}</th>
                                                        <th className="fw-bold text-center" style={{ width: 40 }}>#</th>
                                                        <th className="fw-bold">{t("checklist_items")}</th>
                                                        <th className="fw-bold" style={{ width: 140 }}>{t("type")}</th>
                                                        <th className="fw-bold" style={{ width: 90 }}>{t("source")}</th>
                                                        {!wo_view_mode && <th style={{ width: 40 }}></th>}
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {create_checklist_items.map((item, idx) => (
                                                        <tr key={item.uid || `ci_${idx}`}>
                                                            <td className="text-center">
                                                                <input
                                                                    type="checkbox"
                                                                    className="form-check-input"
                                                                    style={{ width: 18, height: 18 }}
                                                                    checked={item.is_used !== false}
                                                                    disabled={wo_view_mode}
                                                                    onChange={(e) => {
                                                                        const next = [...create_checklist_items];
                                                                        next[idx] = { ...next[idx], is_used: e.target.checked };
                                                                        this.setState({ create_checklist_items: next });
                                                                    }}
                                                                />
                                                            </td>
                                                            <td className="text-center text-secondary">{idx + 1}</td>
                                                            <td className="fw-semibold text-dark">
                                                                {item.description || "-"}
                                                                {item.is_required && (
                                                                    <span className="text-danger ms-1" title={t("required_label")}>*</span>
                                                                )}
                                                            </td>
                                                            <td className="text-secondary">
                                                                {item.input_type ? typeLabel(item.input_type) : "-"}
                                                                {item.source === "manual" && (
                                                                    <div className="text-11 text-muted">
                                                                        {(isToggle3(item.input_type) || isToggle2(item.input_type)) && (item.label_left || item.label_right)
                                                                            ? `${item.label_left || defaultLabels(item.input_type)[0]} / ${item.label_right || defaultLabels(item.input_type)[1]}`
                                                                            : ""}
                                                                        {(item.input_type === "measurement" || item.input_type === "qty") && item.unit ? `${t("unit")}: ${item.unit}` : ""}
                                                                        {item.input_type === "measurement" && ((item.min !== "" && item.min != null) || (item.max !== "" && item.max != null))
                                                                            ? ` · ${item.min ?? ""} - ${item.max ?? ""}`
                                                                            : ""}
                                                                    </div>
                                                                )}
                                                            </td>
                                                            <td>
                                                                <span
                                                                    className="badge rounded-pill px-2 py-1 text-11 fw-semibold"
                                                                    style={item.source === "manual"
                                                                        ? { backgroundColor: "#ECFDF5", color: "#065F46", border: "1px solid #6EE7B7" }
                                                                        : { backgroundColor: "#EFF6FF", color: "#1D4ED8", border: "1px solid #BFDBFE" }}
                                                                >
                                                                    {item.source === "manual" ? t("manual_label") : t("template")}
                                                                </span>
                                                            </td>
                                                            {!wo_view_mode && (
                                                                <td className="text-center">
                                                                    {item.source === "manual" && (
                                                                        <span
                                                                            className="icon text-danger pointer text-14"
                                                                            title={t("delete")}
                                                                            onClick={async () => {
                                                                                if (!(await alert("", "warning", t("delete_item"), t("confirm_delete_checklist_item"), t("confirm"), t("cancel")))) return;
                                                                                this.setState({ create_checklist_items: create_checklist_items.filter((_, i) => i !== idx) });
                                                                            }}
                                                                        >
                                                                            {""}
                                                                        </span>
                                                                    )}
                                                                </td>
                                                            )}
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            </table>
                                        </div>
                                    )}

                                    {/* Add manual checklist item — single row */}
                                    {!wo_view_mode && (
                                        <div className="border rounded-3 p-3" style={{ borderStyle: "dashed" }}>
                                            <div className="text-13 fw-semibold text-dark mb-2">+ {t("add_checklist_item_once")}</div>
                                            <div className="d-flex gap-2 align-items-center flex-wrap">
                                                <input
                                                    type="text"
                                                    id="new_checklist_description_input"
                                                    className={`form-control form-control-sm text-13 flex-grow-1${new_checklist_errors?.description ? " is-invalid" : ""}`}
                                                    placeholder={t("checklist_item_description_placeholder")}
                                                    value={new_checklist_description}
                                                    onChange={(e) => this.setState({ new_checklist_description: e.target.value, new_checklist_errors: { ...new_checklist_errors, description: false } })}
                                                />
                                                <select
                                                    className="form-select form-select-sm text-13 flex-shrink-0"
                                                    style={{ width: 190 }}
                                                    value={new_checklist_input_type}
                                                    onChange={(e) => {
                                                        const next = e.target.value;
                                                        this.setState({
                                                            new_checklist_input_type: next,
                                                            new_checklist_errors: {},
                                                            new_checklist_label_left: "",
                                                            new_checklist_label_right: "",
                                                            ...(next !== "measurement" && next !== "qty" ? { new_checklist_unit: "" } : {}),
                                                            ...(next !== "measurement" ? { new_checklist_min: "", new_checklist_max: "" } : {}),
                                                        });
                                                    }}
                                                >
                                                    <option value="check">{t("ct_type_toggle3")}</option>
                                                    <option value="checkbox">{t("ct_type_toggle2")}</option>
                                                    <option value="measurement">{t("ct_type_measurement")}</option>
                                                    <option value="text">{t("ct_type_text")}</option>
                                                    <option value="qty">{t("ct_type_qty")}</option>
                                                </select>
                                                {(new_checklist_input_type === "measurement" || new_checklist_input_type === "qty") && (
                                                    <input
                                                        type="text"
                                                        id="new_checklist_unit_input"
                                                        className={`form-control form-control-sm text-center flex-shrink-0${new_checklist_errors?.unit ? " is-invalid" : ""}`}
                                                        style={{ width: 90 }}
                                                        aria-required="true"
                                                        placeholder={t("ct_unit_placeholder")}
                                                        value={new_checklist_unit}
                                                        onChange={(e) => this.setState({ new_checklist_unit: e.target.value, new_checklist_errors: { ...new_checklist_errors, unit: false } })}
                                                    />
                                                )}
                                                {(isToggle3(new_checklist_input_type) || isToggle2(new_checklist_input_type)) && (
                                                    <>
                                                        <span className="text-muted text-13 text-nowrap">{t("ct_side_left")}</span>
                                                        <input
                                                            type="text"
                                                            className="form-control form-control-sm text-center flex-shrink-0"
                                                            style={{ width: 110 }}
                                                            maxLength={LABEL_MAX}
                                                            autoComplete="off"
                                                            placeholder={defaultLabels(new_checklist_input_type)[0]}
                                                            title={t(isToggle3(new_checklist_input_type) ? "ct_label_left_title_red" : "ct_label_left_title_white")}
                                                            value={new_checklist_label_left}
                                                            onChange={(e) => this.setState({ new_checklist_label_left: e.target.value })}
                                                        />
                                                        <span className="text-muted text-13 text-nowrap">{t("ct_side_right")}</span>
                                                        <input
                                                            type="text"
                                                            className="form-control form-control-sm text-center flex-shrink-0"
                                                            style={{ width: 110 }}
                                                            maxLength={LABEL_MAX}
                                                            autoComplete="off"
                                                            placeholder={defaultLabels(new_checklist_input_type)[1]}
                                                            title={t("ct_label_right_title")}
                                                            value={new_checklist_label_right}
                                                            onChange={(e) => this.setState({ new_checklist_label_right: e.target.value })}
                                                        />
                                                    </>
                                                )}
                                                {new_checklist_input_type === "measurement" && (
                                                    <>
                                                        <span className="text-muted text-13 text-nowrap">{t("min_value")}</span>
                                                        <input
                                                            type="number"
                                                            id="new_checklist_min_input"
                                                            className={`form-control form-control-sm text-center flex-shrink-0${new_checklist_errors?.minmax ? " is-invalid" : ""}`}
                                                            style={{ width: 70, borderLeft: "3px solid #10b981" }}
                                                            placeholder="0"
                                                            value={new_checklist_min}
                                                            onChange={(e) => this.setState({ new_checklist_min: e.target.value, new_checklist_errors: { ...new_checklist_errors, minmax: false } })}
                                                        />
                                                        <span className="text-muted text-13 text-nowrap">{t("max_value")}</span>
                                                        <input
                                                            type="number"
                                                            id="new_checklist_max_input"
                                                            className={`form-control form-control-sm text-center flex-shrink-0${new_checklist_errors?.minmax ? " is-invalid" : ""}`}
                                                            style={{ width: 70, borderLeft: "3px solid #ef4444" }}
                                                            placeholder="100"
                                                            value={new_checklist_max}
                                                            onChange={(e) => this.setState({ new_checklist_max: e.target.value, new_checklist_errors: { ...new_checklist_errors, minmax: false } })}
                                                        />
                                                    </>
                                                )}
                                                <label
                                                    className="d-flex align-items-center gap-1 text-13 text-nowrap flex-shrink-0 mb-0"
                                                    style={{ cursor: "pointer" }}
                                                    title={t(isToggle3(new_checklist_input_type) ? "ct_req_tip_toggle3" : isToggle2(new_checklist_input_type) ? "ct_req_tip_toggle2" : "ct_req_tip_other")}
                                                >
                                                    <input
                                                        type="checkbox"
                                                        className="form-check-input mt-0"
                                                        checked={!!new_checklist_required}
                                                        onChange={(e) => this.setState({ new_checklist_required: e.target.checked })}
                                                    />
                                                    {t("required_label")}
                                                </label>
                                                <button
                                                    type="button"
                                                    className="btn btn-primary btn-sm fw-semibold text-13 text-nowrap flex-shrink-0"
                                                    onClick={() => {
                                                        const desc = (new_checklist_description || "").trim();
                                                        const addType = new_checklist_input_type || "check";
                                                        const addUnit = (new_checklist_unit || "").trim();
                                                        const needUnit = (addType === "measurement" || addType === "qty") && !addUnit;
                                                        const badRange = addType === "measurement" && new_checklist_min !== "" && new_checklist_max !== "" && Number(new_checklist_min) > Number(new_checklist_max);
                                                        if (!desc || needUnit || badRange) {
                                                            this.setState({ new_checklist_errors: { description: !desc, unit: needUnit, minmax: badRange } });
                                                            const firstId = !desc ? "new_checklist_description_input" : needUnit ? "new_checklist_unit_input" : "new_checklist_min_input";
                                                            setTimeout(() => {
                                                                const el = document.getElementById(firstId);
                                                                if (el) el.focus();
                                                            }, 0);
                                                            if (desc && needUnit) alert("", "warning", t("warning"), t("ct_err_unit"));
                                                            else if (desc && badRange) alert("", "warning", t("warning"), t("checklist_min_max_invalid"));
                                                            return;
                                                        }
                                                        const isTg = isToggle3(addType) || isToggle2(addType);
                                                        const isMeas = addType === "measurement";
                                                        this.setState({
                                                            create_checklist_items: [
                                                                ...create_checklist_items,
                                                                {
                                                                    uid: "",
                                                                    checklist_item_id: "",
                                                                    sequence: create_checklist_items.length + 1,
                                                                    description: desc,
                                                                    input_type: addType,
                                                                    is_used: true,
                                                                    source: "manual",
                                                                    label_left: isTg ? (new_checklist_label_left || "").trim() : "",
                                                                    label_right: isTg ? (new_checklist_label_right || "").trim() : "",
                                                                    unit: isMeas || addType === "qty" ? addUnit : "",
                                                                    min: isMeas ? new_checklist_min : "",
                                                                    max: isMeas ? new_checklist_max : "",
                                                                    is_required: !!new_checklist_required,
                                                                },
                                                            ],
                                                            new_checklist_description: "",
                                                            new_checklist_unit: "",
                                                            new_checklist_min: "",
                                                            new_checklist_max: "",
                                                            new_checklist_label_left: "",
                                                            new_checklist_label_right: "",
                                                            new_checklist_required: false,
                                                            new_checklist_errors: {},
                                                        });
                                                    }}
                                                >
                                                    + {t("add")}
                                                </button>
                                            </div>
                                        </div>
                                    )}
                                </div>
                                )}

                                {/* หมายเหตุภายใน & ไฟล์แนบ */}
                                <div className="mb-4">
                                    <h6 className="fw-bold text-dark mb-3 d-flex align-items-center text-16 border-bottom pb-2">
                                        <span className="icon me-2 text-danger">{"\uf08d"}</span> {t("internal_remark")}
                                    </h6>
                                    <textarea
                                        className="form-control mb-4"
                                        rows="3"
                                        placeholder={t("internal_remark_placeholder")}
                                        value={create_internal_remark}
                                        onChange={(e) => this.setState({ create_internal_remark: e.target.value })}
                                    ></textarea>

                                    <h6 className="fw-bold text-dark mb-3 d-flex align-items-center text-16 border-bottom pb-2">
                                        <span className="icon me-2 text-secondary">{"\uf0c6"}</span> {t("attachments")}
                                    </h6>
                                    {this.renderAttachmentZone({
                                        images: wo_images,
                                        videos: wo_videos,
                                        documents: wo_documents,
                                        idPrefix: "wo-attach",
                                        disabled: wo_view_mode,
                                        onAdd: this.addWoFiles,
                                        onRemove: this.removeWoFile,
                                    })}
                                </div>
                            </div>
                            {/* Right Column */}
                            <div className="col-lg-5 border-start ps-lg-4 bg-white">
                                {/* ใบขอเบิกอะไหล่เพิ่มเติม (เฉพาะ WO Normal Sales ที่บันทึกแล้ว) อยู่ระดับ WO ไม่ผูก Visit */}
                                {this.isNormalSalesWorkOrder() && this.state.edit_work_order_id && <WoPickingListPanel woUid={this.state.edit_work_order_id} onListsChange={(pl_lists) => this.setState({ pl_lists })} />}
                                {/* เอกสารเบิกอะไหล่ WBS หลายใบ (เฉพาะ WO โครงการ BU05 - component ซ่อนตัวเองถ้าไม่ใช่ WBS WO) */}
                                {!this.isNormalSalesWorkOrder() && this.state.edit_work_order_id && <WoWbsIssuePanel woUid={this.state.edit_work_order_id} />}
                                {selectedVisit ? (
                                    <div key={selectedVisit.visit_date} className="visit-detail-panel">
                                        {/* กำหนดช่าง */}
                                        <div className="mb-4">
                                            <h6 className="fw-bold text-dark mb-3 d-flex align-items-center text-16">
                                                <span className="icon me-2 text-primary">{"\uf044"}</span> {t("assign_technician_visit")} (Visit {selectedVisitIndex + 1})
                                            </h6>

                                            <div
                                                className="bg-primary-light border border-primary rounded-3 p-3 mb-3 d-flex flex-wrap align-items-center gap-2"
                                                style={{ backgroundColor: "#F0F5FF", borderColor: "#CDE0FF" }}
                                            >
                                                <div className="fw-bold text-primary text-14">{t("date")} {format_date(selectedVisit.visit_date, "dd/mm/yyyy", "th")}</div>
                                                <div className="text-secondary text-12">|</div>
                                                <div className="text-secondary text-12">{t("selected_time_label")}: {selectedVisit.time_slot}</div>
                                            </div>

                                            <div className="mb-3">
                                                <div className="d-flex align-items-center justify-content-start gap-3 mb-2">
                                                    <label className="form-label text-dark fw-bold text-13 mb-0">{t("select_technician_for_visit")}</label>
                                                    <span className="badge rounded-pill px-3 py-2 text-primary fw-bold" style={{ backgroundColor: "#DBEAFE" }}>
                                                        {selectedTechnicianNames.length} {t("assigned")}
                                                    </span>
                                                </div>
                                                <div className="border rounded-4 overflow-hidden" style={{ borderColor: "#D8E2F0" }}>
                                                    <div className="px-3 py-2 border-bottom bg-light">
                                                        <span className="icon me-2 text-secondary">{"\uf007"}</span>
                                                        <small className="text-secondary text-12">{t("select_multiple_technicians_hint")}</small>
                                                    </div>
                                                    <div className="px-2 pt-2">
                                                        <input
                                                            type="text"
                                                            className="form-control text-13"
                                                            style={{ height: "36px" }}
                                                            placeholder={t("search_technician_placeholder")}
                                                            value={this.state.visit_technician_search}
                                                            onChange={(e) => this.setState({ visit_technician_search: e.target.value })}
                                                        />
                                                    </div>
                                                    <div className="p-2 d-flex flex-column gap-2" style={{ maxHeight: "150px", overflowY: "auto" }}>
                                                        {filteredTechnicianOptions.length === 0 && (
                                                            <div className="text-center text-secondary text-12 py-2">{t("no_technician_found")}</div>
                                                        )}
                                                        {filteredTechnicianOptions.map((technicianOption) => {
                                                            const technicianId = technicianOption.value;
                                                            const technicianName = technicianOption.label;
                                                            const profile = this.getTechnicianProfile(technicianId);
                                                            const isSelected = selectedTechnicianIds.includes(technicianId);

                                                            return (
                                                                <button
                                                                    key={technicianId}
                                                                    type="button"
                                                                    className="w-100 text-start border rounded-3 p-2 bg-white"
                                                                    style={{
                                                                        borderColor: isSelected ? "#93C5FD" : profile.tone.border,
                                                                        background: isSelected ? "linear-gradient(135deg, #DBEAFE 0%, #EFF6FF 100%)" : "#FFFFFF",
                                                                        boxShadow: isSelected ? "0 6px 16px rgba(37, 99, 235, 0.10)" : "none",
                                                                    }}
                                                                    onClick={wo_view_mode ? undefined : () => this.toggleVisitTechnician(selectedVisitIndex, technicianId)}
                                                                >
                                                                    <div className="d-flex align-items-center justify-content-between gap-3">
                                                                        <div className="d-flex align-items-center gap-3">
                                                                            <div
                                                                                className="rounded-circle text-white d-flex align-items-center justify-content-center fw-bold text-12 flex-shrink-0"
                                                                                style={{ width: "25px", height: "25px", backgroundColor: profile.tone.bg }}
                                                                            >
                                                                                {profile.initials}
                                                                            </div>
                                                                            <div>
                                                                                <div className="d-flex flex-wrap align-items-center gap-2">
                                                                                    <span className="fw-bold text-dark text-14">{[technicianOption.code, technicianName].filter(Boolean).join(" ")}</span>
                                                                                    {profile.recommended && (
                                                                                        <span
                                                                                            className="badge rounded-pill text-10 px-2 py-1 fw-bold"
                                                                                            style={{
                                                                                                backgroundColor: profile.tone.soft,
                                                                                                color: profile.tone.bg,
                                                                                                border: `1px solid ${profile.tone.border}`,
                                                                                            }}
                                                                                        >
                                                                                            {profile.recommendedLabel}
                                                                                        </span>
                                                                                    )}
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                        <span
                                                                            className={`badge rounded-pill px-3 py-2 fw-bold ${isSelected ? "text-white" : "text-primary"}`}
                                                                            style={{ backgroundColor: isSelected ? "#2563EB" : "#EFF6FF" }}
                                                                        >
                                                                            {isSelected ? t("selected_label") : t("select_label")}
                                                                        </span>
                                                                    </div>
                                                                </button>
                                                            );
                                                        })}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        {/* SLA Target */}
                                        <div className="mb-4 bg-light rounded-3 p-3 border">
                                            <h6 className="fw-bold text-dark mb-3 d-flex align-items-center text-14 border-bottom pb-2">
                                                <span className="icon me-2 text-secondary">{"\uf017"}</span> {t("sla_target")}
                                            </h6>
                                            <div className="d-flex justify-content-between mb-2 text-14">
                                                <span className="text-secondary">{t("response_time")}</span>
                                                <span className="text-danger fw-bold">
                                                    {selectedPriorityItem
                                                        ? `${selectedPriorityItem.sla_response_time_start || "-"} ${selectedPriorityItem.sla_response_time_start_unit || ""}`.trim()
                                                        : "-"}
                                                </span>
                                            </div>
                                            <div className="d-flex justify-content-between mb-3 text-14">
                                                <span className="text-secondary">{t("resolution_time")}</span>
                                                <span className="text-danger fw-bold">
                                                    {selectedPriorityItem
                                                        ? `${selectedPriorityItem.sla_response_time_end || "-"} ${selectedPriorityItem.sla_response_time_end_unit || ""}`.trim()
                                                        : "-"}
                                                </span>
                                            </div>
                                            <div className="mb-3 pb-2 border-bottom">
                                                {selectedPriorityItem ? (
                                                    <div
                                                        className="d-inline-flex align-items-center gap-2 px-3 py-1 rounded-3 fw-bold text-14"
                                                        style={{
                                                            backgroundColor: selectedPriorityItem.background_color || "#F3F4F6",
                                                            color: selectedPriorityItem.font_color || "#374151",
                                                        }}
                                                    >
                                                        {selectedPriorityItem.icon && <span className="icon">{selectedPriorityItem.icon}</span>}
                                                        <span>{selectedPriorityItem.name_th || selectedPriorityItem.name_en}</span>
                                                    </div>
                                                ) : (
                                                    <div className="text-secondary text-14">{t("no_priority_selected")}</div>
                                                )}
                                            </div>
                                            <div className="d-flex justify-content-between mb-1 text-14">
                                                <span className="text-secondary">{t("visit_date_label")}</span>
                                                <span className="text-dark">{format_date(selectedVisit.visit_date, "dd/mm/yyyy", "th")}</span>
                                            </div>
                                            <div className="d-flex justify-content-between text-14">
                                                <span className="text-secondary">{t("work_time")}</span>
                                                <span className="text-danger fw-bold">{selectedVisit.time_slot}</span>
                                            </div>
                                        </div>
                                        {/* เบิกอะไหล่ - เปิดเฉพาะงานประกันโครงการ (project_warrantee)
                                            อะไหล่ที่เลือกจากแผงนี้จะไปโผล่ในแท็บอะไหล่ของ visit เหมือนเดิม
                                            งานขายปกติ (normal_sales) รายการอะไหล่มาจากระบบต้นทางอยู่แล้ว จึงไม่ต้องเลือกเอง */}
                                        {isProjectWarranteeProcess && (
                                        <div>
                                            <h6 className="fw-bold text-dark mb-3 d-flex align-items-center text-16">
                                                <span className="icon me-2 text-secondary">{"\uf0ad"}</span> {t("withdraw_parts_visit")} (Visit {selectedVisitIndex + 1})
                                            </h6>

                                            {/* \u0e44\u0e21\u0e48\u0e40\u0e1a\u0e34\u0e01\u0e2d\u0e30\u0e44\u0e2b\u0e25\u0e48 - \u0e15\u0e34\u0e4a\u0e01\u0e44\u0e14\u0e49\u0e40\u0e09\u0e1e\u0e32\u0e30 visit \u0e17\u0e35\u0e48\u0e22\u0e31\u0e07\u0e40\u0e1b\u0e47\u0e19\u0e2a\u0e16\u0e32\u0e19\u0e30 open \u0e40\u0e17\u0e48\u0e32\u0e19\u0e31\u0e49\u0e19 */}
                                            <div className="border rounded-3 p-3 mb-3 bg-white d-flex align-items-center justify-content-between flex-wrap gap-2">
                                                <div className="form-check mb-0 d-flex align-items-center">
                                                    <input
                                                        id={`no-parts-requisition-${selectedVisitIndex}`}
                                                        className="form-check-input pointer me-2"
                                                        type="checkbox"
                                                        checked={noPartsRequisitionActive}
                                                        disabled={noPartsRequisitionDisabled}
                                                        onChange={(e) => this.handleToggleNoPartsRequisition(e.target.checked)}
                                                    />
                                                    <label className="form-check-label fw-bold text-14 pointer mb-0" htmlFor={`no-parts-requisition-${selectedVisitIndex}`}>
                                                        {t("no_parts_requisition")}
                                                    </label>
                                                </div>
                                                {!isSelectedVisitOpen && <span className="text-secondary text-11">{t("no_parts_requisition_open_only_hint")}</span>}
                                            </div>

                                            {/* ยังขึ้นสถานะ assigned ไม่ได้จนกว่าจะเลือกช่าง */}
                                            {assignedRequirementBlockers.length > 0 && (
                                                <div className="border border-warning rounded-3 p-3 mb-3 bg-warning-light">
                                                    <div className="fw-bold text-dark text-13 mb-1">
                                                        <span className="icon me-2 text-warning">{""}</span> {t("assigned_requirements_title")}
                                                    </div>
                                                    <ul className="mb-0 ps-4 text-secondary text-12">
                                                        {assignedRequirementBlockers.map((requirementText) => (
                                                            <li key={requirementText}>{requirementText}</li>
                                                        ))}
                                                    </ul>
                                                </div>
                                            )}

                                            {noPartsRequisitionActive ? (
                                                <div className="border rounded-3 p-3 bg-light text-secondary text-12 mb-3">{t("no_parts_requisition_active_hint")}</div>
                                            ) : (
                                            <>
                                            <div className="border border-purple rounded-3 p-3 mb-3 bg-white" style={{ borderColor: "#E9D5FF" }}>
                                                <div className="text-purple fw-bold text-12 mb-2 d-flex align-items-center">
                                                    <span className="icon me-2">{"\uf466"}</span> {t("step1_select_service_bom")}
                                                </div>
                                                <Select
                                                    className="form-control mb-2"
                                                    options={filteredServiceBOMs}
                                                    value={create_service_bom_id}
                                                    placeholder={filteredServiceBOMs.length > 0 ? t("select_service_bom") : t("service_bom_not_found")}
                                                    onChange={(e) => this.handleServiceBOMChange(e)}
                                                    default={filteredServiceBOMs.length > 0}
                                                    disabled={requisitionLocked}
                                                />
                                            </div>

                                            <div className="text-purple fw-bold text-12 text-uppercase mb-2">{t("from_bom")}: {selectedServiceBOM?.name || selectedServiceBOM?.label || "-"}</div>

                                            {/* Parts List */}
                                            <div className="d-flex flex-column gap-2 mb-4">
                                                {create_service_bom_parts.length > 0 ? (
                                                    // 1 การ์ด = 1 แถว (1 บรรทัดใน BOM) ช่องจำนวนแก้ quantity ของแถวนั้นตรง ๆ
                                                    create_service_bom_parts.map((part) => {
                                                        const isActive = part.is_active !== false;
                                                        // แถวที่เบิก/โอนไปแล้ว = ล็อกตามแท็บอะไหล่ ห้ามแก้จำนวนหรือปิดใช้งาน - เบิกเพิ่มให้ไป "เพิ่มเติมนอก BOM"
                                                        const isGroupLocked = this.isPartUnitLocked(part);
                                                        return (
                                                        <div key={part.uid} className="border rounded-3 p-2 bg-white d-flex align-items-center justify-content-between" style={{ opacity: isActive ? 1 : 0.5 }}>
                                                            <div className="flex-grow-1" style={{ minWidth: 0 }}>
                                                                <div className="fw-bold text-dark text-14 text-truncate" style={{ maxWidth: "280px" }} title={part.part_name}>{part.part_name}</div>
                                                                <div className="text-secondary text-10">{part.part_number}{isActive ? "" : ` · ${t("inactive")}`}</div>
                                                            </div>
                                                            <div className="d-flex align-items-center ms-3 flex-shrink-0">
                                                                <input
                                                                    type="number"
                                                                    min="0"
                                                                    className="form-control form-control-sm text-center"
                                                                    style={{ width: "64px" }}
                                                                    value={part.quantity}
                                                                    disabled={requisitionLocked || isGroupLocked}
                                                                    title={isGroupLocked ? t("part_locked_cannot_delete") : undefined}
                                                                    onChange={(e) => this.handleServiceBOMPartChange(part.uid, e.target.value)}
                                                                />
                                                                <span className="ms-2 text-secondary text-12 fw-bold" style={{ minWidth: "40px" }}>
                                                                    {part.uom_name || "-"}
                                                                </span>
                                                                <div className="form-check form-switch ms-2 mb-0" title={isGroupLocked ? t("part_locked_cannot_delete") : isActive ? t("active") : t("inactive")}>
                                                                    <input className="form-check-input pointer" type="checkbox" checked={isActive} disabled={requisitionLocked || isGroupLocked} onChange={(e) => this.handleSetServiceBOMPartActive(part.uid, e.target.checked)} />
                                                                </div>
                                                            </div>
                                                        </div>
                                                        );
                                                    })
                                                ) : (
                                                    <div className="border rounded-3 p-3 bg-white text-secondary text-12">
                                                        {create_service_bom_id ? t("bom_no_parts") : t("select_bom_to_show_parts")}
                                                    </div>
                                                )}
                                            </div>

                                            <div className="text-warning fw-bold text-12 text-uppercase mb-2">{t("additional_outside_bom")}</div>
                                            {create_manual_parts.length > 0 ? (
                                                <div className="d-flex flex-column gap-2 mb-3">
                                                    {/* 1 การ์ด = 1 แถว อะไหล่ตัวเดิมกดเพิ่มซ้ำได้หลายการ์ด แต่ละการ์ดมีจำนวนและ line_no ของตัวเอง */}
                                                    {create_manual_parts.map((part) => {
                                                        const isGroupLocked = this.isPartUnitLocked(part);
                                                        return (
                                                        <div key={part.uid} className="border rounded-3 p-2 bg-white d-flex align-items-center justify-content-between">
                                                            <div className="flex-grow-1" style={{ minWidth: 0 }}>
                                                                <div className="fw-bold text-dark text-14 text-truncate" style={{ maxWidth: "280px" }} title={part.part_name}>{part.part_name}</div>
                                                                <div className="text-secondary text-10">{part.part_number}</div>
                                                            </div>
                                                            <div className="d-flex align-items-center ms-3 flex-shrink-0">
                                                                <input
                                                                    type="number"
                                                                    min="0"
                                                                    className="form-control form-control-sm text-center"
                                                                    style={{ width: "64px" }}
                                                                    value={part.quantity}
                                                                    disabled={requisitionLocked || isGroupLocked}
                                                                    title={isGroupLocked ? t("part_locked_cannot_delete") : undefined}
                                                                    onChange={(e) => this.handleManualPartChange(part.uid, e.target.value)}
                                                                />
                                                                <span className="ms-2 text-secondary text-12 fw-bold" style={{ minWidth: "40px" }}>
                                                                    {part.uom_name || "-"}
                                                                </span>
                                                                {!requisitionLocked &&
                                                                    (isGroupLocked ? (
                                                                        <span className="icon text-secondary ms-2" title={t("part_locked_cannot_delete")}>
                                                                            {"\uf023"}
                                                                        </span>
                                                                    ) : (
                                                                        <span className="icon text-danger pointer ms-2" onClick={() => this.handleRemoveManualPart(part.uid)}>
                                                                            {"\uf00d"}
                                                                        </span>
                                                                    ))}
                                                            </div>
                                                        </div>
                                                        );
                                                    })}
                                                </div>
                                            ) : (
                                                <div className="border rounded-3 p-3 bg-white text-secondary text-12 mb-3">{t("no_additional_items_outside_bom")}</div>
                                            )}

                                            {/* Add Part Section */}
                                            {!requisitionLocked && (
                                            <div className="border border-secondary rounded-3 p-3 bg-light border-dashed mb-3" style={{ borderStyle: "dashed !important" }}>
                                                <div className="text-dark fw-bold text-12 mb-2 d-flex align-items-center">
                                                    <span className="icon me-2">{"\uf067"}</span> {t("step2_add_additional_parts")}
                                                </div>
                                                <div className="d-flex align-items-stretch gap-2">
                                                    <Select
                                                        className="form-control flex-grow-1"
                                                        options={data_parts}
                                                        value={create_manual_part_id}
                                                        placeholder={t("search_parts_placeholder")}
                                                        onChange={(e) => this.setState({ create_manual_part_id: e })}
                                                    />
                                                    <button
                                                        className="btn btn-primary border fw-bold d-flex align-items-center justify-content-center flex-shrink-0"
                                                        style={{ minWidth: "90px" }}
                                                        onClick={this.handleAddManualPart}
                                                    >
                                                        + {t("add")}
                                                    </button>
                                                </div>
                                            </div>
                                            )}
                                            </>
                                            )}

                                            {/* <div
                                                className="bg-warning-light border border-warning rounded-3 p-2 text-dark text-12 fw-bold d-flex align-items-start"
                                                style={{ backgroundColor: "#FFFBEB" }}
                                            >
                                                <span className="icon text-warning me-2 mt-1">{"\uf071"}</span>
                                                <div>Capacitor 50µF มีสต็อกน้อย (เหลือ 3 ชิ้น) — กรุณาตรวจสอบก่อนมอบหมายงาน</div>
                                            </div> */}
                                        </div>
                                        )}
                                    </div>
                                ) : (
                                    <div className="h-100 d-flex align-items-start">
                                        <div className="bg-light border rounded-4 p-4 text-center text-secondary w-100">
                                            <div className="icon text-primary text-24 mb-3 d-block">{"\uf044"}</div>
                                            <div className="fw-bold text-dark mb-2">{t("select_desired_visit")}</div>
                                            <div className="text-12">{t("select_visit_left_hint")}</div>
                                        </div>
                                    </div>
                                )}
                            </div>
                        </div>
                        </fieldset>
                    </Modal.Body>

                    <Modal.Footer className="bg-white border-top px-4 py-3 d-flex justify-content-between align-items-center">
                        <div className="text-secondary text-14 d-flex align-items-center">
                            {!wo_view_mode && !from_inspection && (this.state.edit_work_order_id ? can("wo.update") : can("wo.create")) && (
                                <button
                                    className="btn btn-danger px-4 py-2 rounded-3 d-flex align-items-center fw-bold shadow-sm"
                                    disabled={this.hasScheduledVisits(visits)}
                                    onClick={() => this.CreateUpdate("rejected")}
                                >
                                    <span className="icon me-2">{"\uf00d"}</span> {t("cancel_wo")}
                                </button>
                            )}
                        </div>
                        <div className="d-flex gap-2">
                            {/* <button className="btn btn-white border px-4 py-2 text-dark rounded-3 fw-bold" onClick={this.closeCreateModal}>
                                {t("close")}
                            </button> */}
                            {!wo_view_mode && (this.state.edit_work_order_id ? can("wo.update") : can("wo.create")) && (
                                <>
                                    {String(create_status || "").toLowerCase() === "draft" && (
                                        <button className="btn btn-white border px-4 py-2 text-primary border-primary rounded-3 fw-bold d-flex align-items-center" onClick={() => this.CreateUpdate("draft")}>
                                            <span className="icon me-2">{"\uf0c7"}</span> {t("save_draft")}
                                        </button>
                                    )}
                                    {from_inspection && String(create_status || "").toLowerCase() === "draft" ? (
                                    <button className="btn btn-primary px-4 py-2 rounded-3 d-flex align-items-center fw-bold shadow-sm" onClick={() => this.CreateUpdate("open")}>
                                        {t("convert_to_wo")}
                                    </button>
                                    ) : (
                                    <>
                                    {work_request_link_dirty && (
                                        <span className="bg-warning-light text-warning border border-warning rounded-3 px-3 d-flex align-items-center fw-bold text-14 text-nowrap">
                                            <span className="icon me-2">{"\uf071"}</span> {t("work_request_link_unsaved")}
                                        </span>
                                    )}
                                    <button
                                        className="btn btn-success px-4 py-2 rounded-3 d-flex align-items-center fw-bold shadow-sm"
                                        disabled={!this.areAllVisitsCompleted(visits)}
                                        onClick={() => this.CreateUpdate("success")}
                                    >
                                        <span className="icon me-2">{"\uf00c"}</span> {t("complete_job")}
                                    </button>
                                    <button
                                        className="btn btn-primary px-4 py-2 rounded-3 d-flex align-items-center fw-bold shadow-sm"
                                        onClick={() => this.CreateUpdate(isEditing ? create_status || "open" : "open")}
                                    >
                                        <span className="icon me-2">{"\uf00c"}</span> {isEditing ? t("save") : t("create_work_order")}
                                    </button>
                                    </>
                                    )}
                                </>
                            )}
                        </div>
                    </Modal.Footer>
                </Modal>

                {/* ===================== MODAL: VIEW WORK ORDER DETAIL ===================== */}
                <Modal size="xl" show={modal_view} onHide={() => this.setState({ modal_view: false })} centered contentClassName="border-0 rounded-4 overflow-hidden shadow-lg bg-light">
                    {/* Header */}
                    <Modal.Header className="bg-white border-bottom px-4 py-3" closeButton>
                        <div className="w-100 pe-3">
                            <div className="d-flex align-items-center justify-content-between mb-3">
                                <div className="d-flex align-items-center gap-3">
                                    <h4 className="fw-bold mb-0 text-dark">{headerWorkOrderNumber}</h4>
                                    <span className="badge rounded-pill fw-bold text-12 px-3 py-1" style={{ backgroundColor: headerPriorityView.backgroundColor, color: headerPriorityView.color }}>
                                        <span className="icon me-1">{"\uf06a"}</span> {headerPriorityView.label}
                                    </span>
                                    <span className={`badge rounded-pill fw-bold text-12 px-3 py-1 border ${this.getWorkOrderStatusBadgeClass(headerWorkOrder?.status || create_status)}`}>
                                        {headerStatusText}
                                    </span>
                                </div>
                            </div>
                            <div className="text-secondary text-12 mb-3">
                                สร้าง: {headerCreatedAtText} <span className="mx-2">|</span> จาก {headerSourceLabel}
                            </div>

                            {/* Pipeline Status */}
                            <div className="d-flex w-100 overflow-auto pb-1" style={{ gap: "2px" }}>
                                <div
                                    className="bg-success text-white px-3 py-2 fw-bold text-12 rounded-start d-flex align-items-center position-relative flex-grow-1 justify-content-center"
                                    style={{ clipPath: "polygon(0% 0%, 95% 0%, 100% 50%, 95% 100%, 0% 100%)" }}
                                >
                                    <span className="icon me-1">{"\uf00c"}</span> WR รับแล้ว
                                </div>
                                <div
                                    className="bg-success text-white px-3 py-2 fw-bold text-12 d-flex align-items-center position-relative flex-grow-1 justify-content-center"
                                    style={{ clipPath: "polygon(0% 0%, 95% 0%, 100% 50%, 95% 100%, 0% 100%, 5% 50%)", marginLeft: "-5px" }}
                                >
                                    <span className="icon me-1">{"\uf00c"}</span> อนุมัติแล้ว
                                </div>
                                <div
                                    className="bg-success text-white px-3 py-2 fw-bold text-12 d-flex align-items-center position-relative flex-grow-1 justify-content-center"
                                    style={{ clipPath: "polygon(0% 0%, 95% 0%, 100% 50%, 95% 100%, 0% 100%, 5% 50%)", marginLeft: "-5px" }}
                                >
                                    <span className="icon me-1">{"\uf00c"}</span> โทรแก้เบื้องต้น
                                </div>
                                <div
                                    className="bg-primary text-white px-3 py-2 fw-bold text-12 d-flex align-items-center position-relative flex-grow-1 justify-content-center"
                                    style={{ clipPath: "polygon(0% 0%, 95% 0%, 100% 50%, 95% 100%, 0% 100%, 5% 50%)", marginLeft: "-5px" }}
                                >
                                    <span className="icon me-1">{"\uf022"}</span> WO เปิดแล้ว
                                </div>
                                <div
                                    className="bg-light text-secondary border px-3 py-2 fw-bold text-12 d-flex align-items-center position-relative flex-grow-1 justify-content-center"
                                    style={{ clipPath: "polygon(0% 0%, 95% 0%, 100% 50%, 95% 100%, 0% 100%, 5% 50%)", marginLeft: "-5px" }}
                                >
                                    <span className="icon me-1">{"\uf0ad"}</span> กำลังดำเนินการ
                                </div>
                                <div
                                    className="bg-light text-secondary border px-3 py-2 fw-bold text-12 rounded-end d-flex align-items-center position-relative flex-grow-1 justify-content-center"
                                    style={{ clipPath: "polygon(0% 0%, 100% 0%, 100% 100%, 0% 100%, 5% 50%)", marginLeft: "-5px" }}
                                >
                                    <span className="icon me-1">{"\uf00c"}</span> ปิดงาน
                                </div>
                            </div>
                        </div>
                    </Modal.Header>

                    <Modal.Body className="p-4" style={{ maxHeight: "70vh", overflowY: "auto" }}>
                        <div className="row g-4">
                            {/* Left Column */}
                            <div className="col-lg-8">
                                <div className="row g-3 mb-4">
                                    {/* Customer Info */}
                                    <div className="col-md-6">
                                        <div className="bg-white rounded-3 p-3 border h-100 shadow-sm">
                                            <div className="text-secondary fw-bold text-12 mb-2 d-flex align-items-center">
                                                <span className="icon me-2 text-14">{"\uf007"}</span> {t("customer_info")}
                                            </div>
                                            <h6 className="fw-bold text-dark mb-1">
                                                {selectedCustomer?.full_name_th || selectedCustomer?.full_name_en || selectedCustomer?.label || "-"}
                                            </h6>
                                            <div className="text-secondary text-14 mb-2">{selectedCustomer?.address || "-"}</div>
                                            <div className="text-dark text-14 d-flex align-items-center mb-1">
                                                <span className="icon me-2 text-secondary">{"\uf095"}</span> {selectedCustomer?.phone || selectedCustomer?.mobile_phone || "-"}
                                            </div>
                                            <div className="text-dark text-14 d-flex align-items-center">
                                                <span className="icon me-2 text-secondary">{"\uf007"}</span>
                                                {selectedCustomerContactName
                                                    ? `${selectedCustomerContactName}${selectedCustomer?.contact_position ? ` (${selectedCustomer.contact_position})` : ""}`
                                                    : "-"}
                                            </div>
                                        </div>
                                    </div>

                                    {/* Asset Info */}
                                    <div className="col-md-6">
                                        <div className="bg-white rounded-3 p-3 border h-100 shadow-sm">
                                            <div className="text-secondary fw-bold text-12 mb-2 d-flex align-items-center">
                                                <span className="icon me-2 text-14">{"\uf013"}</span> {t("asset_info")}
                                            </div>
                                            <h6 className="fw-bold text-dark mb-1">{selectedAsset?.part?.name || selectedAsset?.part_name || "-"}</h6>
                                            <div className="text-secondary text-14 mb-1">
                                                {t("material_group")}: {selectedAsset?.part?.model?.name || selectedAsset?.part?.model_name || "-"}
                                            </div>
                                            <div className="text-secondary text-14 mb-2">
                                                {t("serial_number")}: {selectedAsset?.serial_number || "-"}
                                            </div>
                                            <div className={`text-14 d-flex align-items-center mb-1 fw-bold ${isCustomerWarrantyExpired ? "text-danger" : "text-success"}`}>
                                                <span className="icon me-2">{"\uf3ed"}</span>
                                                {t("customer_warranty")}:{" "}
                                                {customerWarrantyExpireDate
                                                    ? `${isCustomerWarrantyExpired ? t("out_of_warranty") : t("under_warranty")} (${t("warranty_until")} ${format_date(customerWarrantyExpireDate, "dd/mm/yyyy", "th")})`
                                                    : t("no_data")}
                                            </div>
                                            <div className={`text-14 d-flex align-items-center fw-bold ${isVendorWarrantyExpired ? "text-danger" : "text-success"}`}>
                                                <span className="icon me-2">{"\uf3ed"}</span>
                                                {t("vendor_warranty")}:{" "}
                                                {vendorWarrantyExpireDate
                                                    ? `${isVendorWarrantyExpired ? t("out_of_warranty") : t("under_warranty")} (${t("warranty_until")} ${format_date(vendorWarrantyExpireDate, "dd/mm/yyyy", "th")})`
                                                    : t("no_data")}
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                {/* Problem Description */}
                                <div className="bg-white rounded-3 p-4 border mb-4 shadow-sm">
                                    <div className="text-secondary fw-bold text-14 mb-3 d-flex align-items-center border-bottom pb-2">
                                        <span className="icon me-2 text-16">{"\uf022"}</span> อาการแจ้งซ่อม
                                    </div>
                                    <p className="text-dark text-14 mb-4">
                                        Compressor Unit Failure - Complete shutdown. Unit stopped working at 09:00. Error code E-15 displayed. Customer reports unusual noise before shutdown.
                                    </p>
                                    <div className="d-flex align-items-center gap-3">
                                        <span className="text-secondary text-14">ไฟล์แนบ:</span>
                                        <span className="badge bg-light border text-dark fw-normal py-2 px-3 pointer hover-bg-secondary">
                                            <span className="icon me-2 text-secondary">{"\uf03e"}</span> error_photo.jpg
                                        </span>
                                        <span className="badge bg-light border text-dark fw-normal py-2 px-3 pointer hover-bg-secondary">
                                            <span className="icon me-2 text-danger">{"\uf1c1"}</span> error_log.pdf
                                        </span>
                                    </div>
                                </div>

                                {/* Visit History (Job Timeline) */}
                                <div>
                                    <div className="d-flex justify-content-between align-items-center mb-3">
                                        <h5 className="fw-bold text-dark mb-0 d-flex align-items-center">
                                            <span className="icon me-2 text-secondary">{"\uf073"}</span> Visit History (Job Timeline)
                                        </h5>
                                        {/* ปุ่มเรียกเปิด Follow-up Modal */}
                                        <button className="btn btn-outline-primary bg-white btn-sm px-3 fw-bold rounded-pill" onClick={this.openFollowUpModal}>
                                            <span className="icon me-1">{"\uf067"}</span> สร้าง Follow-up Visit
                                        </button>
                                    </div>

                                    {/* Visit 1 */}
                                    <div className="bg-white border rounded-3 p-3 mb-3 d-flex justify-content-between align-items-center pointer shadow-sm hover-bg-light">
                                        <div className="d-flex align-items-center gap-3">
                                            <div className="wpx-35 hpx-35 rounded-circle bg-success text-white d-flex align-items-center justify-content-center fw-bold text-16">1</div>
                                            <div>
                                                <div className="fw-bold text-dark text-16 mb-1">Visit 1 — Initial Inspection</div>
                                                <div className="text-secondary text-12 d-flex align-items-center">
                                                    <span className="icon me-1">{"\uf073"}</span> 8 ม.ค. 2025 <span className="mx-2">|</span>
                                                    <span className="icon me-1 text-warning">{"\uf4fe"}</span> Somchai T.
                                                </div>
                                            </div>
                                        </div>
                                        <div className="d-flex align-items-center gap-3">
                                            <span className="badge bg-success-light text-success border border-success px-3 py-1 text-12 fw-bold">
                                                <span className="icon me-1">{"\uf00c"}</span> เสร็จแล้ว
                                            </span>
                                            <span className="icon text-secondary text-20">{"\uf0da"}</span>
                                        </div>
                                    </div>

                                    {/* Visit 2 (Active) */}
                                    <div className="bg-white border border-primary border-2 rounded-3 p-0 mb-3 shadow-sm overflow-hidden">
                                        <div className="p-3 bg-primary-light d-flex justify-content-between align-items-center border-bottom border-primary" style={{ backgroundColor: "#F0F5FF" }}>
                                            <div className="d-flex align-items-center gap-3">
                                                <div className="wpx-35 hpx-35 rounded-circle bg-primary text-white d-flex align-items-center justify-content-center fw-bold text-16">2</div>
                                                <div>
                                                    <div className="fw-bold text-dark text-16 mb-1">Visit 2 — Compressor Replacement</div>
                                                    <div className="text-secondary text-12 d-flex align-items-center">
                                                        <span className="icon me-1">{"\uf073"}</span> 10 ม.ค. 2025 <span className="mx-2">|</span>
                                                        <span className="icon me-1 text-warning">{"\uf4fe"}</span> Somchai T.
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="d-flex align-items-center gap-3">
                                                <span className="badge bg-primary text-white px-3 py-1 text-12 fw-bold rounded-pill shadow-sm">
                                                    <span className="icon me-1">{"\uf111"}</span> Visit ปัจจุบัน
                                                </span>
                                                <span className="icon text-primary text-20 pointer">{"\uf0d7"}</span>
                                            </div>
                                        </div>

                                        <div className="px-4 pt-3 pb-0 border-bottom bg-white d-flex gap-4 text-14 fw-bold">
                                            <div className="pb-2 text-primary border-bottom border-primary border-3 pointer d-flex align-items-center">
                                                <span className="icon me-2 text-warning">{"\uf4fe"}</span> ช่าง
                                            </div>
                                            <div className="pb-2 text-secondary pointer d-flex align-items-center">
                                                <span className="icon me-2">{"\uf0ad"}</span> อะไหล่
                                            </div>
                                            <div className="pb-2 text-secondary pointer d-flex align-items-center">
                                                <span className="icon me-2">{"\uf044"}</span> รายงาน
                                            </div>
                                            <div className="pb-2 text-secondary pointer d-flex align-items-center">
                                                <span className="icon me-2">{"\uf044"}</span> ค่าใช้จ่าย
                                            </div>
                                        </div>

                                        <div className="p-4 bg-white">
                                            <div className="d-flex justify-content-between align-items-center mb-4 pb-4 border-bottom">
                                                <div className="d-flex align-items-center">
                                                    <div
                                                        className="wpx-40 hpx-40 rounded-circle text-white d-flex align-items-center justify-content-center fw-bold text-16 me-3 shadow-sm"
                                                        style={{ backgroundColor: "#6f42c1" }}
                                                    >
                                                        ST
                                                    </div>
                                                    <div>
                                                        <div className="fw-bold text-dark text-16 mb-1">Somchai T.</div>
                                                        <div className="text-secondary text-12">
                                                            HVAC Specialist • กำลัง <span className="fw-bold text-dark">Pending Assignment</span>
                                                        </div>
                                                    </div>
                                                </div>
                                                <button className="btn btn-outline-secondary bg-white btn-sm px-3 rounded-pill fw-bold text-dark">เปลี่ยนช่าง</button>
                                            </div>

                                            <div className="mb-2">
                                                <label className="form-label fw-bold text-dark text-14">วันเวลานัดหมาย</label>
                                                <div className="position-relative w-50">
                                                    <input type="text" className="form-control" value="10/01/2025, 09:00" readOnly />
                                                    <span className="icon position-absolute top-50 end-0 translate-middle-y me-3 text-secondary">{"\uf073"}</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/* Right Column */}
                            <div className="col-lg-4">
                                {/* SLA Status Card */}
                                <div className="bg-white rounded-3 p-4 border mb-4 shadow-sm">
                                    <div className="text-secondary fw-bold text-12 mb-3 d-flex align-items-center text-uppercase">
                                        <span className="icon me-2 text-14">{"\uf017"}</span> SLA STATUS
                                    </div>

                                    <div className="mb-3">
                                        <div className="d-flex justify-content-between text-14 mb-1">
                                            <span className="text-dark">Response Time</span>
                                            <span className="text-success fw-bold">
                                                <span className="icon me-1">{"\uf00c"}</span> Met (45 นาที)
                                            </span>
                                        </div>
                                    </div>

                                    <div>
                                        <div className="d-flex justify-content-between text-14 mb-2">
                                            <span className="text-dark">Resolution Time</span>
                                            <span className="text-warning fw-bold">
                                                <span className="icon me-1">{"\uf071"}</span> เหลือ 2h
                                            </span>
                                        </div>
                                        <div className="progress hpx-8 bg-light">
                                            <div className="progress-bar bg-warning" role="progressbar" style={{ width: "85%" }}></div>
                                        </div>
                                    </div>
                                </div>

                                {/* Parts Requirement Card */}
                                <div className="bg-white rounded-3 p-4 border mb-4 shadow-sm">
                                    <div className="text-secondary fw-bold text-12 mb-3 d-flex align-items-center text-uppercase">
                                        <span className="icon me-2 text-14">{"\uf0ad"}</span> อะไหล่ที่ต้องการ
                                    </div>
                                    <div className="d-flex flex-column gap-2 text-14">
                                        <div className="d-flex justify-content-between align-items-center border-bottom pb-2">
                                            <span className="text-dark">Compressor Motor 2HP</span>
                                            <span className="badge bg-success text-white px-2 py-1">
                                                <span className="icon me-1">{"\uf00c"}</span> มีสต็อก
                                            </span>
                                        </div>
                                        <div className="d-flex justify-content-between align-items-center border-bottom pb-2">
                                            <span className="text-dark">Refrigerant R-410A (2kg)</span>
                                            <span className="badge bg-success text-white px-2 py-1">
                                                <span className="icon me-1">{"\uf00c"}</span> มีสต็อก
                                            </span>
                                        </div>
                                        <div className="d-flex justify-content-between align-items-center">
                                            <span className="text-dark">Capacitor 50µF</span>
                                            <span className="text-warning fw-bold text-12">
                                                <span className="icon me-1">{"\uf071"}</span> สต็อกน้อย
                                            </span>
                                        </div>
                                    </div>
                                </div>

                                {/* WO Details Card */}
                                <div className="bg-light rounded-3 p-4 border mb-4">
                                    <div className="text-secondary fw-bold text-12 mb-3 d-flex align-items-center text-uppercase">
                                        <span className="icon me-2 text-14">{"\uf05a"}</span> ข้อมูล WO
                                    </div>
                                    <div className="d-flex flex-column gap-2 text-14">
                                        <div className="d-flex justify-content-between">
                                            <span className="text-secondary">ประเภทงาน</span>
                                            <span className="text-dark fw-bold text-end">Corrective Maintenance</span>
                                        </div>
                                        <div className="d-flex justify-content-between">
                                            <span className="text-secondary">{t("priority")}</span>
                                            <span className="badge bg-danger-light text-danger fw-bold border border-danger">Emergency</span>
                                        </div>
                                        <div className="d-flex justify-content-between">
                                            <span className="text-secondary">ช่วงวันที่</span>
                                            <span className="text-dark fw-bold">8–10 ม.ค. 2025</span>
                                        </div>
                                        <div className="d-flex justify-content-between">
                                            <span className="text-secondary">จำนวน Visits</span>
                                            <span className="text-dark fw-bold">2 / 2</span>
                                        </div>
                                        <div className="d-flex justify-content-between">
                                            <span className="text-secondary">จาก WR</span>
                                            <span className="text-primary fw-bold pointer text-decoration-underline">WR-2025-0150</span>
                                        </div>
                                        <div className="d-flex justify-content-between">
                                            <span className="text-secondary">สร้างโดย</span>
                                            <span className="text-dark fw-bold">Admin User</span>
                                        </div>
                                    </div>
                                </div>

                                {/* Internal Notes Card */}
                                <div className="bg-white rounded-3 p-4 border shadow-sm">
                                    <div className="text-secondary fw-bold text-12 mb-3 d-flex align-items-center text-uppercase">
                                        <span className="icon me-2 text-danger text-14">{"\uf08d"}</span> หมายเหตุภายใน
                                    </div>
                                    <p className="text-dark text-14 mb-3">Parts received. Ready for repair. Waiting for technician confirmation.</p>
                                    <textarea className="form-control text-14 bg-light" rows="3" placeholder="เพิ่มหมายเหตุ..."></textarea>
                                </div>
                            </div>
                        </div>
                    </Modal.Body>

                    <Modal.Footer className="bg-white border-top px-4 py-3 d-flex justify-content-between align-items-center">
                        <div className="d-flex gap-2">
                            <button
                                className="btn btn-danger px-4 py-2 rounded-3 fw-bold text-white shadow-sm d-flex align-items-center"
                                style={{ backgroundColor: "#d9534f", borderColor: "#d9534f" }}
                            >
                                <span className="icon me-2">{"\uf05e"}</span> ยกเลิก WO
                            </button>
                            {/* ปุ่มเรียกเปิด Follow-up Modal */}
                            <button className="btn btn-outline-secondary bg-white text-dark px-3 py-2 rounded-3 fw-bold d-flex align-items-center" onClick={this.openFollowUpModal}>
                                <span className="icon me-2 text-primary">{"\uf021"}</span> สร้าง Follow-up Visit
                            </button>
                        </div>

                        <div className="d-flex gap-2">
                            <button className="btn btn-white border px-4 py-2 text-dark rounded-3 fw-bold" onClick={() => this.setState({ modal_view: false })}>
                                ปิด
                            </button>
                            <button className="btn btn-success px-4 py-2 rounded-3 d-flex align-items-center fw-bold shadow-sm" style={{ backgroundColor: "#4caf50", borderColor: "#4caf50" }}>
                                <span className="icon me-2">{"\uf00c"}</span> ปิดงาน (Mark Completed)
                            </button>
                            <button className="btn btn-primary px-4 py-2 rounded-3 d-flex align-items-center fw-bold shadow-sm">
                                <span className="icon me-2">{"\uf0c7"}</span> บันทึกการเปลี่ยนแปลง
                            </button>
                        </div>
                    </Modal.Footer>
                </Modal>

                {/* ===================== MODAL: CREATE FOLLOW-UP VISIT (ใหม่) ===================== */}
                <Modal size="lg" show={modal_followup} onHide={() => this.setState({ modal_followup: false })} centered contentClassName="border-0 rounded-4 overflow-hidden shadow-lg bg-light">
                    <Modal.Header className="bg-white border-bottom px-4 py-3" closeButton>
                        <div className="d-flex align-items-center">
                            <div className="wpx-30 hpx-30 rounded-circle bg-secondary text-white d-flex align-items-center justify-content-center me-2">
                                <span className="icon text-14">{"\uf021"}</span> {/* Sync/Refresh Icon */}
                            </div>
                            <div>
                                <h5 className="fw-bold mb-0 text-dark">สร้าง Follow-up Visit</h5>
                                <div className="text-secondary text-12 mt-1">จะสร้าง Visit 3 ใน Work Order เดิม</div>
                            </div>
                        </div>
                    </Modal.Header>

                    <Modal.Body className="p-4" style={{ maxHeight: "70vh", overflowY: "auto" }}>
                        {/* เชื่อมโยงกับ WO เดิม */}
                        <div className="rounded-3 p-3 mb-4 d-flex justify-content-between align-items-center" style={{ backgroundColor: "#F9F5FF", border: "1px solid #E9D5FF" }}>
                            <div className="d-flex align-items-center">
                                <span className="icon text-primary me-3 text-20" style={{ color: "#6f42c1" }}>
                                    {"\uf0c1"}
                                </span>
                                <div>
                                    <div className="fw-bold text-dark text-14 mb-1">เชื่อมโยงกับ WO เดิม</div>
                                    <div className="text-secondary text-12">
                                        WR: WR-2025-0150 <span className="mx-2">|</span>
                                        WO: WO-20250110-0028 (Visit 2)
                                    </div>
                                </div>
                            </div>
                            <span className="badge rounded-pill fw-bold px-3 py-2 text-12" style={{ backgroundColor: "#6f42c1", color: "#fff" }}>
                                จะเป็น Visit 3
                            </span>
                        </div>

                        {/* เหตุผลในการ Follow-up */}
                        <div className="mb-3">
                            <label className="form-label text-dark fw-bold text-14">
                                เหตุผลในการ Follow-up <span className="text-danger">*</span>
                            </label>
                            <select className="form-select py-2 text-dark" value={fu_reason} onChange={(e) => this.setState({ fu_reason: e.target.value })}>
                                <option value="Parts not available - need to order">Parts not available - need to order</option>
                                <option value="Need more time">Need more time</option>
                                <option value="Customer requested reschedule">Customer requested reschedule</option>
                            </select>
                        </div>

                        <div className="mb-3">
                            <label className="form-label text-dark fw-bold text-14">รายละเอียด Follow-up</label>
                            <textarea className="form-control py-2" rows="3" value={fu_detail} onChange={(e) => this.setState({ fu_detail: e.target.value })}></textarea>
                        </div>

                        <div className="row g-3 mb-4">
                            <div className="col-md-6">
                                <label className="form-label text-dark fw-bold text-14">{t("priority")}</label>
                                <select className="form-select py-2 text-dark" value={fu_priority} onChange={(e) => this.setState({ fu_priority: e.target.value })}>
                                    <option value="Same as original (Emergency)">Same as original (Emergency)</option>
                                    <option value="High">High</option>
                                    <option value="Medium">Medium</option>
                                </select>
                            </div>
                            <div className="col-md-6">
                                <label className="form-label text-dark fw-bold text-14">
                                    วันที่นัดหมาย <span className="text-danger">*</span>
                                </label>
                                <div className="position-relative">
                                    <DatePicker type="th" className="form-control py-2 text-dark" value={fu_date} onChange={(val) => this.setState({ fu_date: val })} />
                                </div>
                            </div>
                        </div>

                        {/* กำหนดช่าง Visit 3 */}
                        <div className="mb-4">
                            <h6 className="fw-bold text-dark mb-3 d-flex align-items-center text-16 border-bottom pb-2">
                                <span className="icon me-2 text-warning">{"\uf4fe"}</span> กำหนดช่าง Visit 3
                            </h6>

                            <div className="text-purple fw-bold text-12 mb-2 d-flex align-items-center">
                                <span className="icon me-1">{"\uf544"}</span> AI แนะนำ (ช่างเดิม + ผู้ช่วย)
                            </div>

                            <div className="d-flex flex-column gap-2 mb-3">
                                <div className="border rounded-3 p-2 d-flex align-items-center justify-content-between pointer" style={{ borderColor: "#6f42c1", backgroundColor: "#F9F5FF" }}>
                                    <div className="d-flex align-items-center">
                                        <div
                                            className="wpx-40 hpx-40 rounded-circle text-white d-flex align-items-center justify-content-center fw-bold text-14 me-3 shadow-sm"
                                            style={{ backgroundColor: "#6f42c1" }}
                                        >
                                            ST
                                        </div>
                                        <div>
                                            <div className="fw-bold text-dark text-14 mb-1">
                                                Somchai T.
                                                <span className="badge text-white rounded-pill text-10 ms-2 px-2" style={{ backgroundColor: "#6f42c1" }}>
                                                    Best Match
                                                </span>
                                                <span className="badge bg-primary-light text-primary border border-primary px-2 py-0 rounded-pill text-10 ms-1">ช่างเดิม</span>
                                            </div>
                                            <div className="text-secondary text-12">HVAC Cert • ว่างอยู่ • 2.5km</div>
                                        </div>
                                    </div>
                                    <div className="wpx-30 hpx-30 rounded-circle bg-primary text-white d-flex align-items-center justify-content-center pointer shadow-sm">
                                        <span className="icon text-14">{"\uf067"}</span>
                                    </div>
                                </div>

                                <div className="border rounded-3 p-2 bg-white d-flex align-items-center justify-content-between pointer hover-bg-light shadow-sm">
                                    <div className="d-flex align-items-center">
                                        <div
                                            className="wpx-40 hpx-40 rounded-circle text-white d-flex align-items-center justify-content-center fw-bold text-14 me-3 shadow-sm"
                                            style={{ backgroundColor: "#fd7e14" }}
                                        >
                                            PK
                                        </div>
                                        <div>
                                            <div className="fw-bold text-dark text-14 mb-1">Prasit K.</div>
                                            <div className="text-secondary text-12">HVAC Cert • ว่างอยู่ • 4.1km</div>
                                        </div>
                                    </div>
                                    <div className="wpx-30 hpx-30 rounded-circle bg-primary text-white d-flex align-items-center justify-content-center pointer shadow-sm">
                                        <span className="icon text-14">{"\uf067"}</span>
                                    </div>
                                </div>
                            </div>

                            <div className="text-center text-secondary text-12 my-3 fst-italic">ยังไม่มีช่างที่เลือก</div>
                        </div>

                        {/* อะไหล่เพิ่มเติม Visit 3 */}
                        <div className="mb-4">
                            <h6 className="fw-bold text-dark mb-3 d-flex align-items-center text-16 border-bottom pb-2">
                                <span className="icon me-2 text-secondary">{"\uf0ad"}</span> อะไหล่เพิ่มเติม Visit 3
                            </h6>

                            <div className="bg-white border rounded-3 p-3 mb-2 shadow-sm d-flex justify-content-between align-items-center">
                                <div className="form-check d-flex align-items-center m-0 p-0">
                                    <input type="checkbox" className="form-check-input me-3 mt-0" defaultChecked style={{ width: "18px", height: "18px" }} />
                                    <label className="form-check-label text-dark fw-bold text-14">Capacitor 50µF (Qty: 1)</label>
                                </div>
                                <span className="text-warning fw-bold text-12 d-flex align-items-center">
                                    <span className="icon me-1 text-14">{"\uf0d1"}</span> กำลังสั่งซื้อ
                                </span>
                            </div>

                            <div className="bg-white border rounded-3 p-3 mb-3 shadow-sm d-flex justify-content-between align-items-center">
                                <div className="form-check d-flex align-items-center m-0 p-0">
                                    <input type="checkbox" className="form-check-input me-3 mt-0" style={{ width: "18px", height: "18px" }} />
                                    <label className="form-check-label text-dark fw-normal text-14">Thermal Overload Relay (Qty: 1)</label>
                                </div>
                                <span className="text-success fw-bold text-12 d-flex align-items-center">
                                    <span className="icon me-1 text-14">{"\uf00c"}</span> มีสต็อก
                                </span>
                            </div>

                            <div className="bg-white border rounded-3 p-3 text-secondary text-14 pointer hover-bg-light shadow-sm">+ เพิ่มอะไหล่เพิ่มเติม</div>
                        </div>

                        {/* คัดลอกข้อมูลลูกค้า */}
                        <div className="bg-white p-3 rounded-3 border shadow-sm">
                            <div className="form-check d-flex align-items-center m-0 p-0">
                                <input
                                    type="checkbox"
                                    className="form-check-input me-3 mt-0"
                                    checked={fu_copy_info}
                                    onChange={(e) => this.setState({ fu_copy_info: e.target.checked })}
                                    style={{ width: "18px", height: "18px" }}
                                />
                                <label className="form-check-label text-dark fw-bold text-14">คัดลอกข้อมูลลูกค้าและสถานที่จาก WO ปัจจุบัน</label>
                            </div>
                        </div>
                    </Modal.Body>

                    <Modal.Footer className="bg-white border-top px-4 py-3 d-flex justify-content-center gap-3">
                        <button className="btn btn-white border px-4 py-2 text-dark rounded-3 fw-bold shadow-sm" onClick={() => this.setState({ modal_followup: false })}>
                            ยกเลิก
                        </button>
                        <button className="btn btn-primary px-4 py-2 rounded-3 d-flex align-items-center fw-bold shadow-sm">
                            <span className="icon me-2">{"\uf021"}</span> สร้าง Follow-up Visit
                        </button>
                    </Modal.Footer>
                </Modal>

                {/* Modal ดูเส้นทางที่ช่างเดินทางจริง - วาด polyline จากจุด GPS ดิบทั้งหมด (ไม่ผ่าน Directions API จึงไม่จำกัดจำนวนจุด) */}
                <Modal
                    size="xl"
                    show={modal_route_map}
                    onHide={() => this.setState({ modal_route_map: false })}
                    centered
                    contentClassName="border-0 rounded-4 overflow-hidden shadow-lg"
                >
                    <Modal.Header className="bg-white border-bottom px-4 py-3">
                        <div>
                            <div className="fw-bold text-dark">{t("gps_route_recorded")}</div>
                            <div className="text-12 text-secondary">
                                {(modal_route_points || []).length} {t("route_points_unit")}
                                {modal_route_distance != null
                                    ? ` · ${t("actual_travel_distance")} ${Number(modal_route_distance).toFixed(2)} ${t("km_unit")}`
                                    : ""}
                            </div>
                        </div>
                    </Modal.Header>
                    <Modal.Body className="p-0">
                        {modal_route_map && <TravelRouteMap points={modal_route_points} />}
                    </Modal.Body>
                </Modal>
            </div>
        );
    }
}
